

(function () {
    'use strict';

    angular.module('KPMES.pages', [
        'ui.router',

        'KPMES.pages.services',
        'KPMES.pages.dashboard',
        'KPMES.pages.user',
        'KPMES.pages.role',
        'KPMES.pages.designation',
        'KPMES.pages.city',
        'KPMES.pages.state',
        'KPMES.pages.company',
        'KPMES.pages.country',
        'KPMES.pages.state',
        'KPMES.pages.area',
        'KPMES.pages.department',
        'KPMES.pages.employee',
        'KPMES.pages.employeeChart',
        'KPMES.pages.test',
        'KPMES.pages.master',
        'KPMES.pages.student',
        'KPMES.pages.location',
        'KPMES.pages.mapping',
        'KPMES.pages.institution',
        'KPMES.pages.studentDetails',
        'KPMES.pages.EducationType',
        'KPMES.pages.questionandAnswer',
        'KPMES.pages.exercise'        

    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
        $urlRouterProvider.otherwise('/login');

        // baSidebarServiceProvider.addStaticItem({
        //   title: 'Pages',
        //   icon: 'ion-document',
        //   subMenu: [{
        //     title: 'Sign In',
        //     fixedHref: 'auth.html',
        //     blank: true
        //   }
        //   , {
        //     title: 'Sign Up',
        //     fixedHref: 'reg.html',
        //     blank: true
        //   }, {
        //     title: 'User Profile',
        //     stateRef: 'profile'
        //   }, {
        //     title: '404 Page',
        //     fixedHref: '404.html',
        //     blank: true
        //   }
        //   ]

        // });
    }
})();
(function () {
  'use strict';

  angular.module('KPMES.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'KPMES.theme.components',
      'KPMES.theme.inputs'
  ]);

})();

(function () {
  'use strict';

  angular.module('KPMES.pages.area',[])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('area', {
        url: '/area',
        templateUrl: 'app/pages/area/area.html',
        title: 'Area',
        controller: 'AreaCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-area-chart'
        },
      });
  }
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.city', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('city', {
        url: '/city',
        templateUrl: 'app/pages/city/City.html',
        title: 'City',
        controller: 'CityCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-building'
        },
      });
  }
})();
(function() {
    'use strict';

    angular.module('KPMES.pages.company', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
         .state('company', {
            url: '/company?type',
            templateUrl: 'app/pages/company/company.html',
            title: 'Institutiton',
            controller: 'CompanyCtrl',
            controllerAs: 'vm',
            
            sidebarMeta: {
                order: 0,
                icon: 'fa fa-globe'
            },
            params:{type:null }
        })
    }
})();




(function () {
  'use strict';

  angular.module('KPMES.pages.country', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('country', {
        url: '/country',
        templateUrl: 'app/pages/country/country.html',
        title: 'Country',
        controller: 'CountryCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-flag-o'
        },
      });
  }
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.dashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard', {
        url: '/home',
        templateUrl: 'app/pages/dashboard/dashboard.html',
        title: 'Home',
        controller: 'DashboardCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-home'
        },
      });
  }
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.department', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('department', {
        url: '/department',
        templateUrl: 'app/pages/department/department.html',
        title: 'Department',
        controller: 'DepartmentCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-industry'
        },
      });
  }
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.designation', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('designation', {
        url: '/designation',
        templateUrl: 'app/pages/designation/Designation.html',
        title: 'Designation',
        controller: 'DesignationCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-cog'
        },
      });
  }
})();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.EducationType', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('EducationType', {
          url: '/educationtype',
          templateUrl: 'app/pages/EducationType/educationType.html',
          title: 'Type of Educational',
          controller: 'EducationTypeCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-cog'
          },
        });
    }
  })();
(function () {
  'use strict';

  angular.module('KPMES.pages.employee', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('employee', {
        url: '/employee',
        templateUrl: 'app/pages/employee/employee.html',
        title: 'Staff Details',
        controller: 'EmployeeCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'icon icons8-Org-Unit'
        },
      });
  }
})();
(function() {
    'use strict';

    angular.module('KPMES.pages.employeeChart', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('employeeChart', {
                url: '/employeeChart',
                templateUrl: 'app/pages/employeeChart/employeeChart.html',
                title: 'Employee Chart',
                controller: 'EmployeeChartCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    order: 0,
                    icon: 'icon icons8-Org-Unit'
                },
            });
    }
})();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.exercise', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('exercise', {
          url: '/exercise',
          templateUrl: 'app/pages/exercise/exercise.html',
          title: 'Exercises',
          controller: 'ExerciseCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-user'
          },
        });
    }
  })();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.institution', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('institution', {
          url: '/institution',
          templateUrl: 'app/pages/institution/institution.html',
          title: 'Institution',
          controller: 'institutionCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-cog'
          },
        });
    }
  })();
(function () {
    'use strict';

    angular.module('KPMES.pages.location', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('tierSetup', {
                url: '/tier-setup',
                templateUrl: 'app/pages/Location/tierSetup/tierSetup.html',
                title: 'Tier Setup',
                controller: 'TierSetupCtrl',
                controllerAs: 'vm',
            }).state('locationSetup', {
                url: '/location-Setup',
                templateUrl: 'app/pages/Location/locationSetup/locationSetup.html',
                title: 'Location setup',
                controller: 'LocationSetupCtrl',
                controllerAs: 'vm'
            });
    }
})();
(function () {
    'use strict';

    angular.module('KPMES.pages.mapping', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('staffMapping', {
                url: '/staffMapping',
                templateUrl: 'app/pages/mapping/staffMapping/staffMapping.html',
                title: 'Staff Mapping',
                controller: 'StaffMappingCtrl',
                controllerAs: 'vm',
            }).state('classMapping', {
                url: '/classMapping',
                templateUrl: 'app/pages/mapping/classRoomMapping/classRoomMapping.html',
                title: 'Class Room Mapping',
                controller: 'ClassRoomMappingCtrl',
                controllerAs: 'vm',
            }).state('timeTableMapping', {
                url: '/timeTableMapping',
                templateUrl: 'app/pages/mapping/timeTableMapping/timeTableMapping.html',
                title: 'Time Table Mapping',
                controller: 'timeTableMappingCtrl',
                controllerAs: 'vm',
            });
    }
})();
(function () {
    'use strict';

    angular.module('KPMES.pages.master', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('classRoom', {
                url: '/classRoom',
                templateUrl: 'app/pages/masters/classRoom/classRoom.html',
                title: 'Standard',
                controller: 'ClassRoomCtrl',
                controllerAs: 'vm',
                sidebarMeta: {
                    order: 0,
                    icon: 'fa fa-flag-o'
                },
            }).state('section', {
                url: '/section',
                templateUrl: 'app/pages/masters/section/section.html',
                title: 'Section',
                controller: 'SectionCtrl',
                controllerAs: 'vm'
            }).state('subject', {
                url: '/subject',
                templateUrl: 'app/pages/masters/subject/subject.html',
                title: 'Subject',
                controller: 'SubjectCtrl',
                controllerAs: 'vm'
            }).state('chapters', {
                url: '/chapters',
                templateUrl: 'app/pages/masters/chapters/chapters.html',
                title: 'Chapters',
                controller: 'ChaptersCtrl',
                controllerAs: 'vm'
            }).state('CreateLinkText', {
                url: '/createlink',
                templateUrl: 'app/pages/masters/CreateLinkText/createlinktext.html',
                title: 'Create Link',
                controller: 'CreateLinkTextCtrl',
                controllerAs: 'vm'
            }).state('unit', {
                url: '/unit',
                templateUrl: 'app/pages/masters/unit/unit.html',
                title: 'Content',
                controller: 'UnitCtrl',
                controllerAs: 'vm'
            }).state('timetable', {
                url: '/timetable',
                templateUrl: 'app/pages/masters/timetable/timetable.html',
                title: 'Content',
                controller: 'TimetableCtrl',
                controllerAs: 'vm'
            }).state('mapvideo', {
                url: '/mapvideo',
                templateUrl: 'app/pages/masters/MapVideos/MapVideos.html',
                title: 'Content',
                controller: 'MapVideosCtrl',
                controllerAs: 'vm'
            }).state('termactivation', {
                url: '/termactivation',
                templateUrl: 'app/pages/masters/TermActivation/TermActivation.html',
                title: 'TermActivation',
                controller: 'TermActivationCtrl',
                controllerAs: 'vm'
            }).state('term', {
                url: '/term',
                templateUrl: 'app/pages/masters/Term/Term.html',
                title: 'Term',
                controller: 'TermCtrl',
                controllerAs: 'vm'
            })
            // .state('exercise', {
            //     url: '/exercise',
            //     templateUrl: 'app/pages/masters/exercise/exercise.html',
            //     title: 'Exercise',
            //     controller: 'ExerciseCtrl',
            //     controllerAs: 'vm'
            // });
    }
})();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.questionandAnswer', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('questionandAnswer', {
          url: '/questionandAnswer',
          templateUrl: 'app/pages/questionandAnswer/question.html',
          title: 'Question And Answer',
          controller: 'QuestionCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-user'
          },
        });
    }
  })();
(function () {
  'use strict';

  angular.module('KPMES.pages.role', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('role', {
        url: '/role-master',
        templateUrl: 'app/pages/role/role.html',
        title: 'Role',
        controller: 'RoleCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-user'
        },
      }).state('roleMenuMapping', {
        url: '/role-menu-mapping',
        templateUrl: 'app/pages/role/roleMenuMapping/roleMenuMapping.html',
        title: 'Role Menu Mapping',
        controller: 'RoleMenuMappingCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 112,
          icon: ''
        },
      });
  }
})();
(function() {
    'use strict';

    angular.module('KPMES.pages.services', []);
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.state', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('state', {
        url: '/state',
        templateUrl: 'app/pages/state/state.html',
        title: 'State',
        controller: 'StateCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-location-arrow'
        },
      });
  }
})();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.student', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('studentRegistration', {
          url: '/studentRegistration',
          templateUrl: 'app/pages/student/studentRegistration/studentRegistration.html',
          title: 'Student',
          controller: 'StudentRegistrationCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-user'
          },
        });
    }
  })();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.studentDetails', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('studentDetails', {
          url: '/studentDetails',
          templateUrl: 'app/pages/studentDetails/studentDetails.html',
          title: 'studentDetails',
          controller: 'studentDetailsCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'icon icons8-Org-Unit'
          },
        });
    }
  })();
(function () {
    'use strict';
  
    angular.module('KPMES.pages.test', [])
      .config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('test', {
          url: '/test',
          templateUrl: 'app/pages/test/test.html',
          title: 'Test',
          controller: 'TestCtrl',
          controllerAs: 'vm',
          sidebarMeta: {
            order: 0,
            icon: 'fa fa-flag-o'
          },
        });
    }
  })();
(function () {
  'use strict';

  angular.module('KPMES.pages.user', [
    'KPMES.pages.user.login',
    'KPMES.pages.user.Register'
  ]).config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('userMenuMapping', {
        url: '/user-menu-mapping',
        templateUrl: 'app/pages/user/userMenuMapping/userMenuMapping.html',
        title: 'User Menu Mapping',
        controller: 'UserMenuMappingCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 122,
          icon: ''
        },
      }).state('createUser', {
        url: '/create-user',
        templateUrl: 'app/pages/user/userCreation/createUser.html',
        title: 'Add User',
        controller: 'CreateUserCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 122,
          icon: ''
        },
      }).state('userPrivilege', {
        url: '/user-privilege',
        templateUrl: 'app/pages/user/userPrivilege/userPrivilege.html',
        title: 'Project Level Privilege',
        controller: 'UserPrivilegeCtrl',
        controllerAs: 'vm'
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.inputs', []);

})();

(function () {
  'use strict';

  angular.module('KPMES.pages.user.login', [])
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/pages/user/login/login.html',
        title: 'Login',
        controller: 'LoginCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-login'
        },
      });
  }
})();
(function () {
  'use strict';

  angular.module('KPMES.pages.user.Register', [])
  .config(routeConfig);

  function routeConfig($stateProvider) {
    $stateProvider
      .state('register', {
        url: '/register',
        templateUrl: 'app/pages/user/register/register.html',
        title: 'Registration',
        controller: 'RegisterCtrl',
        controllerAs: 'vm',
        sidebarMeta: {
          order: 0,
          icon: 'fa fa-login'
        },
      });
  }
})();
'use strict';
// google.load('visualization', '1', {
//     packages: ['orgchart']
// });
// google.setOnLoadCallback(function() {
//     angular.bootstrap(document.body, ['KPMES']);
// });
angular.module('KPMES', [
        'ngAnimate',
        'ui.bootstrap',
        'ui.sortable',
        'ui.router',
        'ui.bootstrap.tpls',
        'ngTouch',
        'toastr',
        'smart-table',
        "xeditable",
        'ui.slimscroll',
        'ngJsTree',
        'angular-progress-button-styles',
        'ngLodash',
        'dialogs.main',
        'ui.select',
        'ui.multiselect',
        'chart.js',
        'ui.tree',
        'ui.grid',
        'ui.grid.grouping',
        'pascalprecht.translate',
        'googlechart',
        //'gm',
        'KPMES.theme',
        'KPMES.pages',
        'ui.toggle',
        'angular.filter',
        'ngclipboard',
        'ui.bootstrap.dropdownToggle',
        'angularSpectrumColorpicker'
    ])
    // .service('authInterceptor',['$q','$state', function ($q, $state) {
    //   var service = this;

    //   service.responseError = function (response) {
    //     if (response.status == 401) {
    //       $rootScope.logout();
    //     }
    //     return $q.reject(response);
    //   };
    // }])
    // .config(['$httpProvider', function ($httpProvi`der) {
    //   $httpProvider.interceptors.push('authInterceptor');
    // }])
    .config(["$locationProvider", "$translateProvider", "dialogsProvider", "$httpProvider", function ($locationProvider, $translateProvider, dialogsProvider, $httpProvider) {
        $httpProvider.interceptors.push('httpRequestInterceptor');
        $httpProvider.interceptors.push(function ($q, $rootScope) {
            return {
                'responseError': function (rejection) {
                    var defer = $q.defer();
                    if (rejection.status === 401) {
                        $rootScope.logout();
                    }
                    defer.reject(rejection);
                    return defer.promise;
                }
            };
        });
        dialogsProvider.useBackdrop('static');
        dialogsProvider.useEscClose(false);
        dialogsProvider.useCopy(false);
        dialogsProvider.setSize('sm');

        $translateProvider.translations('en-US', {
            DIALOGS_ERROR: "Error",
            DIALOGS_ERROR_MSG: "An unknown error has occurred.",
            DIALOGS_CLOSE: "Close",
            DIALOGS_PLEASE_WAIT: "Please wait",
            DIALOGS_PLEASE_WAIT_ELIPS: "Please wait...",
            DIALOGS_PLEASE_WAIT_MSG: "Waiting for the operation to complete.",
            DIALOGS_PERCENT_COMPLETE: "% Completed",
            DIALOGS_NOTIFICATION: "Notification",
            DIALOGS_NOTIFICATION_MSG: "Notification of application Unknown.",
            DIALOGS_CONFIRMATION: "Confirmation",
            DIALOGS_CONFIRMATION_MSG: "Confirmation required.",
            DIALOGS_OK: "Ok",
            DIALOGS_YES: "Yes",
            DIALOGS_NO: "No"
        });

        $translateProvider.preferredLanguage('en-US');
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: true
        });
    }])
    .run(['$rootScope', 'toastr', '$http', '$state', 'AuthenticationService', 'dialogs', '$translate', '$uibModal', 'lodash', '$window', '$timeout',
        function ($rootScope, toastr, $http, $state, AuthenticationService, dialogs, $translate, $uibModal, lodash, $window, $timeout) {

            // $rootScope.endPoint = "http://localhost:61368/";
            // $rootScope.endPoint = "http://192.168.2.202:5500/";
            $rootScope.endPoint = "http://api.ksmartbook.com/";
            //  $rootScope.endPoint = "http://cbseapi.ksmartbook.com/";
            // $rootScope.endPoint = "http://49.207.183.105:7000/"; 
            // $rootScope.endPoint = "http://192.168.2.202/KEducation/";
            // $rootScope.endPoint = "http://192.168.2.202:9100/";
            // $rootScope.isLogin = true;
            // $rootScope.BaseUrl = "http://192.168.2.202:2911/";
            // $rootScope.endPoint = "http://192.168.2.202:8001/";
            // $rootScope.endPoint = "http://192.168.2.202:2500/";
            // $rootScope.endPoint = "http://localhost:1200/";

            $translate.use('en-US');


            
            $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams) {
              
                // $rootScope.previousState = fromState.name;
                // if (!$rootScope.isAuth && toState.name != 'login' && toState.name != 'company') {
                //     // User isn’t authenticated
                //     dialogs.notify('Invalid Access', 'Either your session expired or you are logged out.', {
                //         animation: true,
                //         size: 'sm'
                //     });
                //     $rootScope.logout();
                //     event.preventDefault();
                // } else {
                //     // If user authenticated
                //     // for each state retrive permitted action list of the user.
                //     //$timeout(function() {
                //     $rootScope.menuList = JSON.parse($window.localStorage.getItem('userMenus'));
                //     var menuList = flatten($rootScope.menuList);
                //     $rootScope.ActiveMenu = lodash.head(lodash.filter(menuList, {
                //         'MenuUrl': toState.name
                //     }));
                //     //}, 60);
                // }
            });

            $rootScope.checkPermission = function (actionName) {
                var res = lodash.filter($rootScope.ActiveMenu.MenuAction, {
                    'ActionName': actionName
                })
                if (res.length > 0)
                    return true;
                else
                    return false;
            }

            function flatten(menuList) {
                return lodash.flatMap(menuList, function (menu) {
                    return menu.SubMenuItems.length > 0 ? flatten(menu.SubMenuItems) : menu;
                });
            }

            $rootScope.openSelectCompanyModal = function () {
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'Select Company',
                    ariaDescribedBy: 'Select Company',
                    templateUrl: 'app/pages/user/userModals/selectCompanyModal.html',
                    controller: 'SelectCompanyModalCtrl',
                    controllerAs: 'vm',
                    size: 'md',
                    backdrop: 'static',
                    keyboard: false
                    // resolve: {
                    //   items: function () {
                    //     return $ctrl.items;
                    //   }
                    // }
                });
                modalInstance.result.then(function (selectedItem) {
                    //$ctrl.selected = selectedItem;
                }, function () {
                    //$log.info('Modal dismissed at: ' + new Date());
                });
            }

            $rootScope.logout = function () {
               // AuthenticationService.logout();
                $state.go('login');
            }

            $rootScope.differenceInDays = function (startDate, endDate) {
                return (endDate - startDate) / (1000 * 60 * 60 * 24);
            }

            $rootScope.showToaster = function (type, msg, title) {
                var toastConfig = {
                    "autoDismiss": true,
                    "positionClass": "toast-top-right",
                    "type": "",
                    "timeOut": "3000",
                    "extendedTimeOut": "1000",
                    "allowHtml": true,
                    "closeButton": true,
                    "tapToDismiss": true,
                    "progressBar": false,
                    "newestOnTop": true,
                    "maxOpened": 0,
                    "preventDuplicates": true,
                    "preventOpenDuplicates": true
                };

                switch (type) {
                    case 'error':
                        toastConfig.type = 'error';
                        toastr.error(msg, title, toastConfig);
                        break;
                    case 'info':
                        toastConfig.type = 'error';
                        toastr.info(msg, title, toastConfig);
                        break;
                    case 'success':
                        toastConfig.type = 'success';
                        toastr.success(msg, title, toastConfig);
                        break;
                    case 'warning':
                        toastConfig.type = 'warning';
                        toastr.warning(msg, title, toastConfig);
                        break;
                    default:
                        toastConfig.type = 'info';
                        toastr.info(msg, title, toastConfig);
                        break;
                }
            }
        }
    ])
    /** @ngInject */
    .factory('httpRequestInterceptor', ['$rootScope', function ($rootScope) {
        return {
            request: function (config) {
                config.headers["Token"] = $rootScope.token;
                if ($rootScope.ActiveMenu)
                    config.headers["MenuId"] = $rootScope.ActiveMenu.MenuId;
                config.headers["UserId"] = $rootScope.userId;
                return config;
            }
        };
    }])

    .filter('propsFilter', function () {
        return function (items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function (item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }
                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }
            return out;
        };
    });
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('KPMES.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('KPMES.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

(function () {
  'use strict';

  angular.module('KPMES.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.area')
        .controller('AreaCtrl', AreaCtrl);

    /** @ngInject */
    function AreaCtrl($rootScope, lodash, dialogs, $http, AreaService, CountryService, StateService, CityService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{"value": 5}, {"value": 10}, {"value": 25}, {"value": 50}, {"value": 100}]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function(num) {
          vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        
        vm.AreaList = [];
        $rootScope.isLogin = false;
        vm.getStateListByCountryId = getStateListByCountryId;
        vm.getCityListByStateId = getCityListByStateId;
        //Method
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editArea = editArea;
        vm.removeArea = removeArea;
        vm.SaveArea = SaveArea;
        vm.changeActiveArea = changeActiveArea;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        Init();
        ////////////////

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            AreaService.getAllArea().then(function(res) {
                if (res.status === 200) {
                    vm.AreaList = res.data;
                    $rootScope.isLoading = false;
                    CountryService.getActiveCountry().then(function(res) {
                        if (res.status === 200) {
                            vm.CountryList = res.data;
                           
                        }
                    });
                    
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Area");
                }
            }, function(err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Area");
            });
        }

        function getStateListByCountryId(CountryId, callback) {
            if (CountryId) {
                StateService.GetStateByCountryId(CountryId).then(function(res) {
                    if (res.status === 200) {
                        vm.StateList = res.data;
                        if (vm.StateList.length < 1) {
                            dialogs.notify('Warning', 'No state available for ' + vm.area.selectedCountry.CountryName, { animation: true, size: 'sm' });
                        }
                      
                        if (callback)
                            callback();
                    }
                });
            } else {
                vm.StateList = [];
                vm.area.selectedState = null;


            }
        }

        function getCityListByStateId(StateId, callback) {
            if (StateId) {
                CityService.GetCityByStateId(StateId).then(function(res) {
                    if (res.status === 200) {
                        vm.CityList = res.data;
                        if (vm.CityList.length < 1) {
                            dialogs.notify('Warning', 'No city available for ' + vm.area.selectedState.StateName, { animation: true, size: 'sm' });
                        }
                       
                        if (callback)
                            callback();
                    }
                });
            } else {
                vm.CityList = [];
                vm.area.selectedCity = null;
            }
        }

        function Create() {
            vm.isFormOpen = true;

        }

        function cancel() {
            vm.isFormOpen = false;
            vm.resetForm();
            vm.area = {};
        }

        function resetForm() {
            vm.areaForm.$setUntouched();
        }

        function editArea(area) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.area = angular.copy(area);
            getStateListByCountryId(area.CountryId, function() {

                for (var c in vm.CountryList) {
                    if (vm.CountryList[c].CountryId === area.CountryId) {
                        vm.area.selectedCountry = vm.CountryList[c];
                    }
                }
                for (var c in vm.StateList) {
                    if (vm.StateList[c].StateId === area.StateId) {
                        vm.area.selectedState = vm.StateList[c];
                    }
                }
                getCityListByStateId(area.StateId, function() {
                    for (var c in vm.CityList) {
                        if (vm.CityList[c].CityId === area.CityId) {
                            vm.area.selectedCity = vm.CityList[c];
                        }
                    }
                });
            });

        }

        function removeArea(area) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });

            confirm.result.then(function() {
                AreaService.removeArea(area.AreaId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Area Successfully', "Area");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Area", { animation: true, size: 'sm' });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Delete Area. <br> If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function() {

            })
        }

        function SaveArea(area) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                var area = {
                    CountryId: vm.area.selectedCountry.CountryId,
                    StateId: vm.area.selectedState.StateId,
                    CityId: vm.area.selectedCity.CityId,
                    AreaName: vm.area.AreaName,
                    PinCode: vm.area.Pincode,
                    CreatedBy: loggedUser.UserId
                }
                AreaService.AddArea(area).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Area Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Area Master");
                        vm.isFormOpen = true;
                    }
                   
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            } else {
                var area = {
                    CountryId: vm.area.selectedCountry.CountryId,
                    StateId: vm.area.selectedState.StateId,
                    CityId: vm.area.selectedCity.CityId,
                    AreaName: vm.area.AreaName,
                    
                    AreaId: vm.area.AreaId,
                    PinCode: vm.area.Pincode,
                    ModifiedBy: loggedUser.UserId
                }
                AreaService.EditArea(area).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Area Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Area Master");
                        vm.isFormOpen = true;
                    }
                  
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               

            }
        }

        function changeActiveArea(area) {
            var msg = 'Are sure you want to ' + ((area.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((area.IsActive) ? 'Deactive' : 'Active') + 'Area Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function() {
                AreaService.changeActiveArea(area.AreaId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Area");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Change Status Area", { animation: true, size: 'sm' });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Change Status Area.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function() {

            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.city')
        .controller('CityCtrl', CityCtrl);

    /** @ngInject */
    function CityCtrl($rootScope, lodash, dialogs, $http, CityService, CountryService, StateService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.CityList = {};
        vm.getStateListByCountryId = getStateListByCountryId;
        $rootScope.isLogin = false;
        //Method
        vm.Create = Create;
        vm.cancel = cancel;
        vm.editCity = editCity;
        vm.removeCity = removeCity;
        vm.SaveCity = SaveCity;
        vm.changeActiveCity = changeActiveCity;
        var logggedUser = AuthenticationService.getLoggedUserDetails();
     

        Init();

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            CityService.getAllCity().then(function (res) {
                if (res.status === 200) {
                    vm.CityList = res.data;
                    $rootScope.isLoading = false;
                    var objCountry;
                    CountryService.getActiveCountry(objCountry).then(function (res) {
                        if (res.status === 200) {
                            vm.CountryList = res.data;
                        }
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "City");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "City");
            });
        }

        function getStateListByCountryId(CountryId, callback) {
            if (CountryId) {
                StateService.GetStateByCountryId(CountryId).then(function (res) {
                    if (res.status === 200) {
                        vm.StateList = res.data;
                        if (vm.StateList.length < 1) {
                            dialogs.notify('Warning', 'No state available for ' + vm.city.selectedCountry.CountryName, { animation: true, size: 'sm' });
                        }
                        if (callback)
                            callback();
                    }
                });
            } else {
                vm.StateList = [];
                vm.city.selectedState = null;
            }

        }

        function Create() {
            vm.isFormOpen = true;

        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.city = {};
        }

        function editCity(city) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.city = angular.copy(city);
            getStateListByCountryId(city.CountryId, function () {
                for (var c in vm.CountryList) {
                    if (vm.CountryList[c].CountryId === city.CountryId) {
                        vm.city.selectedCountry = vm.CountryList[c];
                    }
                }
                for (var c in vm.StateList) {
                    if (vm.StateList[c].StateId === city.StateId) {
                        vm.city.selectedState = vm.StateList[c];
                    }
                }
            });

        }

        function removeCity(city) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });

            confirm.result.then(function () {
                CityService.removeCity(city.CityId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete City Successfully', "City");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete City", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete City.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        function SaveCity(city) {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                var city = {
                    CountryId: vm.city.selectedCountry.CountryId,
                    StateId: vm.city.selectedState.StateId,
                    CreatedBy: logggedUser.UserId,
                    CityName: vm.city.CityName
                }
                CityService.AddCity(city).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "City Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "City Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {
                var city = {
                    CountryId: vm.city.selectedCountry.CountryId,
                    StateId: vm.city.selectedState.StateId,
                    ModifiedBy: logggedUser.UserId,
                    CityId: vm.city.CityId,
                    IsActive: vm.city.IsActive,
                    CityName: vm.city.CityName
                }
                CityService.EditCity(city).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "City Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "City Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
        }

        function changeActiveCity(city) {
            var msg = 'Are sure you want to ' + ((city.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((city.IsActive) ? 'Deactive' : 'Active') + 'City Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function () {
                CityService.changeActiveCity(city.CityId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "City");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Change Status City", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Change Status City. If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () { })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.company')
        .controller('CompanyCtrl', CompanyCtrl);

    /** @ngInject */
    function CompanyCtrl($rootScope, lodash, dialogs, $http, CompanyService, CountryService, AuthenticationService,
        StateService, CityService, AreaService, Base64, $scope, $stateParams, $uibModal) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isEditingLogo = false;
        vm.Institution = {};
        vm.Institution.RegAddress = {};
        vm.Institution.CampAddrss = {};
        //  vm.Institution.CampAddrss.selectedArea = {};
        vm.open = false;
        var type = $stateParams.type;

        // if (type == "reg") {
        //     $rootScope.isLogin = true;
        // } else {
        //     $rootScope.isLogin = false;
        // }

        // $rootScope.isLogin = true;
        //Method
        vm.getStateListByCountryId = getStateListByCountryId;
        vm.getCityListByStateId = getCityListByStateId;
        vm.getAreaListByCityId = getAreaListByCityId;
        vm.editLogo = editLogo;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editCompany = editCompany;
        vm.removeCompany = removeCompany;
        vm.SaveCompany = SaveCompany;
        vm.changeActiveCompany = changeActiveCompany;
        vm.Reset = Reset;
        //   vm.getAllLangauges = getAllLangauges;
        // vm.empCom = { EmpAddress: {} };
        // vm.empPer = { EmpAddress: {} }

        vm.LanguageList = [{
            Languagename: "English",
            LanguageId: 1
        },
        {
            Languagename: "Tamil",
            LanguageId: 2

        }
        ];



        // File upload methods
        $scope.photoChanged = photoChanged;
        Init();
        ////////////////



        function pop() {

            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/pages/company/Popup.html',
                controller: 'PopupCtrl',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                   ModelView: vm.Institution
                }
            });
            modalInstance.result.then(function () {
                //$ctrl.selected = selectedItem;
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });

        }


        function editLogo() {
            vm.isEditingLogo = true;
            vm.open = true;
        }


        function photoChanged(event) {
            var reader = new FileReader();
            if (!vm.isEditingLogo) {
                vm.CompanyLogo = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.CompanyLogo);
            } else {
                vm.CompanyLogo = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.CompanyLogo);
                var formData = new FormData();
                formData.append('CompanyLogo', vm.CompanyLogo);
                formData.append('CompanyId', vm.CompanyId);
                CompanyService.updateLogo(formData).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Company Logo changed successfully', "Success");
                        Init();
                    } else {
                        $rootScope.showToaster('error', 'Internal server Error!', "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Internal server Error!', "Error");
                });
            }
        }

        function Init() {
             var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            CompanyService.getAllCompany().then(function (res) {
                if (res.status === 200) {
                    vm.CompanyList = res.data;
                    $rootScope.isLoading = this;
                    var objCountry;
                    CountryService.getActiveCountry(objCountry).then(function (res) {
                        if (res.status === 200) {
                            vm.CountryList = res.data;
                        }
                    });

                } else {
                    $rootScope.isLoading = this;
                    dialogs.error('error', 'Load Failed! Try Again', "Company");
                }
            }, function (err) {
                $rootScope.isLoading = this;
                $rootScope.showToaster('error', 'Error! Try Again', "Company");
            });
            // CompanyService.GetAllLanguages().then(function (res) {
            //     if (res.status === 200) {
            //         vm.LanguageList = res.data;
            //         Init();
            //         vm.isLoading = false;
            //     } else {
            //         $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
            //     }
            // }, function (err) {
            //     $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            // });


            CompanyService.getallTypeofEducational().then(function (res) {
                if (res.status === 200) {
                    vm.EducationList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });



        }

        // function getAllLangauges()
        // {



        // }


        function getStateListByCountryId(CountryId, callback) {
            if (CountryId) {
                StateService.GetStateByCountryId(CountryId).then(function (res) {
                    if (res.status === 200) {
                        vm.StateList = res.data;
                        if (vm.StateList.length < 1) {
                            dialogs.notify('Warning', 'No state available for ' + vm.Institution.selectedCountry.RegAddress.CountryName, {
                                animation: true,
                                size: 'sm'
                            });
                        }
                        if (callback)
                            callback();
                    }
                });
            } else {
                vm.StateList = [];
                vm.company.selectedState = null;
                vm.CityList = [];
                vm.company.selectedCity = null;
            }
        }


        vm.update = function () {
            if (vm.isComAddSameAsPerAdd) {
                vm.Institution.CampAddrss = angular.copy(vm.Institution.RegAddress);
                vm.Institution.CampAddrss.selectedArea.Pincode = angular.copy(vm.Institution.RegAddress.selectedArea.Pincode);

            }
        };

        function getCityListByStateId(StateId, callback) {
            if (StateId) {
                CityService.GetCityByStateId(StateId).then(function (res) {
                    if (res.status === 200) {
                        vm.CityList = res.data;
                        if (vm.CityList.length < 1) {
                            dialogs.notify('Warning', 'No city available for ' + vm.Institution.RegAddress.selectedState.StateName, {
                                animation: true,
                                size: 'sm'
                            });
                        }
                        if (callback)
                            callback();
                    }

                });
            } else {
                vm.CityList = [];
                vm.company.selectedCity = null;
                vm.AreaList = [];
                vm.company.selectedArea = null;
            }
        }

        function getAreaListByCityId(CityId, callback) {
            AreaService.GetAreaByCityId(CityId).then(function (res) {
                if (res.status === 200) {
                    vm.AreaList = res.data;
                    if (vm.AreaList.length < 1) {
                        dialogs.notify('Warning', 'No area available for ' + vm.Institution.RegAddress.selectedCity.CityName, {
                            animation: true,
                            size: 'sm'
                        });
                    }
                    if (callback)
                        callback();
                }
            });
        }

        $scope.imageIsLoaded = function (c) {
            $scope.$apply(function () {
                vm.logoUrl = c.target.result;
            });
        }

        function Create() {
            vm.isFormOpen = true;


        }

        function cancel() {
            vm.isFormOpen = false;
            resetForm();
            vm.Institution = {};
            vm.isEditing = false;
            vm.logoUrl = null;
            vm.CompanyLogo = null;
            angular.element("input[type='file']").val(null);
            Reset();
        }

        function resetForm() {
            vm.InstitutionForm.$setUntouched();
        }

        function editCompany(row) {

            // console.log(JSON.stringify(row));
            vm.open = true;
            vm.isEditing = true;
            vm.isFormOpen = true;
            //  vm.Institution.CampAddrss = angular.copy(vm.Institution.RegAddress);

            vm.Institution.CompanyId = row.CompanyId
            vm.Institution.CompanyName = row.CompanyName
            vm.Institution.DOB = new Date(row.DateofEstablishment)
            vm.Institution.Totallandandarea = row.TotalInsLandandArea
            vm.Institution.ScondayEmail = row.SecondaryEmailId
            vm.Institution.MobileNumber = row.MobileNumber
            vm.Institution.Landlineno = parseInt(row.LandlineNo)
            vm.Institution.principalname = row.NameofThePrincipal
            vm.Institution.Contactno = parseInt(row.principalContactNumber)
            vm.Institution.Admincoordinator = row.AuthorizedAdminCoordinator
            vm.Institution.Contactnumber = parseInt(row.CoordinatorContactNumber)
            vm.Institution.Foundername = row.FounderName
            vm.Institution.NumberofStudents = parseInt(row.NumberofStudents)
            vm.Institution.NumberofTeachingStaff = parseInt(row.NumberofTeachingStaff)
            vm.Institution.NumberofNonTeachingStaff = parseInt(row.NumberofNonTeachingStaff)
            vm.Institution.Websiteurl = row.WebsiteURL
            vm.Institution.PANnumber = row.PANNumber
            vm.Institution.TANnumber = row.TANNumber
            vm.Institution.RegAddress.AddressLine1 = row.RegAddress1
            vm.Institution.RegAddress.AddressLine2 = row.RegAddress2
            vm.Institution.RegAddress.Pincode = row.RegPincode
            vm.Institution.CampAddrss.campusname = row.CampusName
            vm.Institution.CampAddrss.AddressLine1 = row.CampusAdd1
            vm.Institution.CampAddrss.AddressLine2 = row.CampusAdd2


            for (var c in vm.EducationList) {
                if (vm.EducationList[c].EducationId === row.EducationId) {
                    vm.Institution.selectedEducation = vm.EducationList[c];
                }
            }

            for (var c in vm.LanguageList) {
                if (vm.LanguageList[c].LanguageId === row.LanguageId) {
                    vm.Institution.Selectedlanguage = vm.LanguageList[c];
                }
            }

            getStateListByCountryId(row.CountryId, function () {


                for (var c in vm.CountryList) {
                    if (vm.CountryList[c].CountryId === row.CountryId) {
                        vm.Institution.RegAddress.selectedCountry = vm.CountryList[c];
                    }
                }
                for (var c in vm.StateList) {
                    if (vm.StateList[c].StateId === row.StateId) {
                        vm.Institution.RegAddress.selectedState = vm.StateList[c];
                    }
                }
                getCityListByStateId(row.StateId, function () {
                    for (var c in vm.CityList) {
                        if (vm.CityList[c].CityId === row.CityId) {
                            vm.Institution.RegAddress.selectedCity = vm.CityList[c];
                        }
                    }
                });
                getAreaListByCityId(row.CityId, function () {
                    for (var c in vm.AreaList) {
                        if (vm.AreaList[c].AreaId === row.AreaId) {
                            vm.Institution.RegAddress.selectedArea = vm.AreaList[c];
                        }
                    }
                });
            });

        }

        function removeCompany(Institution) {

            var confirm = dialogs.confirm('Confirm',
                'Are you sure want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                CompanyService.removeCompany(Institution.CompanyId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Company Successfully', "Company");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Company", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Company. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }
        function Generateotp() {
            var mobileno = vm.Institution.MobileNumber;

            var mob = mobileno.toString();
            CompanyService.Generateotp(mob).then(function (res) {
                if (res.data.IsSuccess === true) {
                    $rootScope.showToaster('success', res.data.Message, "Company Master");

                } else {
                    $rootScope.showToaster('error', res.data.Message, "Company Master");
                    vm.isFormOpen = true;
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });
        }

        function OTPVerify()
        {
           var mobileno = vm.Institution.MobileNumber;
            CompanyService.OTPVerify(mob).then(function (res) {
                if (res.data.IsSuccess === true) {
                    $rootScope.showToaster('success', res.data.Message, "Company Master");

                } else {
                    $rootScope.showToaster('error', res.data.Message, "Company Master");
                    vm.isFormOpen = true;
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });
        }

        function SaveCompany(Institution) {
            pop()
            Generateotp()
            


            var logggedUser = AuthenticationService.getLoggedUserDetails();
            vm.getStateByCountryId = function (selectedCountry) {
                selectedCountry.CountryId = vm.selectedCountry.CountryId;
            }
            vm.getCityByStateId = function (selectedState) {
                selectedState.StateId = vm.selectedState.StateId;
            }
            vm.getAreaByCityId = function (selectedCity) {
                selectedCity.CityId = vm.selectedCity.CityId;
            }

            //  Institution.CountryId = vm.Institution.RegAddress.selectedCountry.CountryId;
            Institution.CompanyName = vm.Institution.CompanyName;
            Institution.StateId = vm.Institution.RegAddress.selectedState.StateId;
            Institution.CityId = vm.Institution.RegAddress.selectedCity.CityId;
            Institution.AreaId = vm.Institution.RegAddress.selectedArea.AreaId;
            Institution.DateofEstablishment = vm.Institution.DOB;
            Institution.TotalInsLandandArea = vm.Institution.Totallandandarea;
            Institution.PrimaryEmailId = vm.Institution.PrimaryEmail;
            Institution.SecondaryEmailId = vm.Institution.ScondayEmail;
            Institution.LandlineNo = vm.Institution.Landlineno;
            Institution.NameofThePrincipal = vm.Institution.principalname;
            Institution.principalContactNumber = vm.Institution.Contactno;
            Institution.MobileNumber = vm.Institution.MobileNumber;
            Institution.AuthorizedAdminCoordinator = vm.Institution.Admincoordinator;
            Institution.CoordinatorContactNumber = vm.Institution.Contactnumber;
           // Institution.PreferedLanguage = vm.Institution.Selectedlanguage.Language;
            Institution.FounderName = vm.Institution.Foundername;

            Institution.WebsiteURL = vm.Institution.Websiteurl;
            Institution.PANNumber = vm.Institution.PANnumber;
            Institution.TANNumber = vm.Institution.TANnumber;
            Institution.RegAddress1 = vm.Institution.RegAddress.AddressLine1;
            Institution.RegAddress2 = vm.Institution.RegAddress.AddressLine2;
            Institution.RegPincode = vm.Institution.RegAddress.pincode;
            Institution.EducationId = vm.Institution.selectedEducation.EducationId;
            Institution.NumberofStudents = vm.Institution.NumberofStudents;
            Institution.NumberofTeachingStaff = vm.Institution.NumberofTeachingStaff;
            Institution.NumberofNonTeachingStaff = vm.Institution.NumberofNonTeachingStaff;

            var campus = {};

            campus["CampusName"] = vm.Institution.CampAddrss.campusname;
            campus["CampusAdd1"] = vm.Institution.CampAddrss.AddressLine1;
            campus["CampusAdd2"] = vm.Institution.CampAddrss.AddressLine2;
            campus["Pincode"] = vm.Institution.CampAddrss.selectedArea.Pincode;
            campus["CountryId"] = vm.Institution.CampAddrss.selectedCountry.CountryId;
            campus["CityId"] = vm.Institution.CampAddrss.selectedCity.CityId;
            campus["StateId"] = vm.Institution.CampAddrss.selectedState.StateId;
            campus["AreaId"] = vm.Institution.CampAddrss.selectedArea.AreaId;
            campus["IsSameAddress"] = (!vm.isComAddSameAsPerAdd) ? false : true;


            Institution.CampusDetails = campus;





            // console.log(JSON.stringify(Institution));
            // return;    

            // if (vm.Institution.selectedParent === null || vm.Institution.selectedParent === undefined)
            //     company.ParentCompany = 0;


            // else
            //     company.ParentCompany = vm.company.selectedParent.CompanyId;

            // company.OrganizationLevelId = vm.company.selectedOrganization.OrganizationLevelId;



            if (!vm.isEditing) {
                // File Upload
                // var file = vm.company.CompanyLogo;
                // vm.company.CompanyLogo = "";
                Institution.CreatedBy = logggedUser.UserId;
                var formData = new FormData();
                formData.append("data", JSON.stringify(Institution));
                //formData.append("CompanyLogo", vm.CompanyLogo);

                CompanyService.AddCompany(formData, $http).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Company Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Company Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            } else {
                Institution.ModifiedBy = logggedUser.UserId;
                CompanyService.EditCompany(Institution).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Company Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Company Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");

                });

            }
            pop()
        }

        function changeActiveCompany(company) {
            var msg = 'Are sure you want to ' + ((company.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((company.IsActive) ? 'Deactive' : 'Active') + 'Company Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                CompanyService.changeActiveCompany(company.CompanyId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Company");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Company", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Company.  If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }


        function Reset() {
            vm.Institution.CompanyName = null;
            vm.Institution.DOB = null;
            vm.Institution.Totallandandarea = null;
            vm.Institution.PrimaryEmail = null;
            vm.Institution.ScondayEmail = null;
            vm.Institution.Landlineno = null;
            vm.Institution.principalname = null;
            vm.Institution.Contactno = null;
            vm.Institution.Admincoordinator = null;
            vm.Institution.Contactnumber = null;
            vm.Institution.selectedEducation = null;
            vm.Institution.Foundername = null;
            vm.Institution.Selectedlanguage = null;
            vm.Institution.selectedParent = null;
            vm.Institution.RegAddress.AddressLine1 = null;
            vm.Institution.RegAddress.AddressLine2 = null;
            vm.Institution.RegAddress.selectedCountry = null;
            vm.Institution.RegAddress.selectedState = null;
            vm.Institution.RegAddress.selectedCity = null;
            vm.Institution.RegAddress.selectedArea = null;
            vm.Institution.RegAddress.pincode = null;
            vm.Institution.CampAddrss.campusname = null;
            vm.Institution.CampAddrss.AddressLine1 = null;
            vm.Institution.CampAddrss.AddressLine2 = null;
            vm.Institution.CampAddrss.selectedCountry = null;
            vm.Institution.CampAddrss.selectedState = null;
            vm.Institution.CampAddrss.selectedCity = null;
            vm.Institution.CampAddrss.selectedArea = null;
            vm.Institution.CampAddrss.pincode = null;
            vm.Institution.Websiteurl = null;
            vm.Institution.PANnumber = null;
            vm.Institution.TANnumber = null;
            vm.Institution.NumberofStudents = null;
            vm.Institution.NumberofTeachingStaff = null;
            vm.Institution.NumberofNonTeachingStaff = null;
        }

        // Datepicker code 
        vm.today = function () {
            vm.dt = new Date();
        };
        vm.today();

        vm.clear = function () {
            vm.dt = null;
        };

        vm.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };

        vm.dateOptions = {
            dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.toggleMin = function () {
            vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
            vm.dateOptions.minDate = vm.inlineOptions.minDate;
        };

        vm.toggleMin();

        vm.open1 = function () {
            vm.popup1.opened = true;
        };

        vm.open2 = function () {
            vm.popup2.opened = true;
            var today = new Date();
            // var minAge = 18;

            // vm.options = {
            //     maxDate: new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate())
            // }

        };

        vm.open3 = function () {
            vm.popup3.opened = true;
        };

        vm.open4 = function () {
            vm.popup4.opened = true;
        };

        vm.setDate = function (year, month, day) {
            vm.dt = new Date(year, month, day);
        };

        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];

        vm.popup1 = {
            opened: false
        };

        vm.popup2 = {
            opened: false
        };
        vm.popup3 = {
            opened: false
        };

        vm.popup4 = {
            opened: false
        };


        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        vm.events = [{
            date: tomorrow,
            status: 'full'
        }, {
            date: afterTomorrow,
            status: 'partially'
        }];

        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                for (var i = 0; i < vm.events.length; i++) {
                    var currentDay = new Date(vm.events[i].date).setHours(0, 0, 0, 0);

                    if (dayToCheck === currentDay) {
                        return vm.events[i].status;
                    }
                }
            }
            return '';
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.company')
        .controller('PopupCtrl', PopupCtrl);

    /** @ngInject */
    function PopupCtrl($http, $state, $location, $window, $rootScope, lodash, $uibModalInstance, dialogs, ModelView, CompanyService) {
        var vm = this;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }
       var res = ModelView;

        vm.payment = function () {
            debugger;
            $state.go('insPayment');
            $uibModalInstance.dismiss('cancel');

        }


        vm.payment = function (){

            var mobile =  ModelView.MobileNumber;
            var otp = vm.popup.VerifyOTP

            CompanyService.OTPVerify(otp, mobile).then(function (res) {
                console.log("resssss"+JSON.stringify(res));
                if (res.status === 200) {
                    debugger
                    if (res.data === true) {
                        $rootScope.showToaster('success', res.data.Message, "Success");

                    }
                    else{
                        $rootScope.showToaster('error', 'This is incorrect OTP', "Error");

                    }
               vm.cancel();
                   
                   // Init();
                } 
            }, function (err) {
                $rootScope.showToaster('error', 'Internal server Error!', "Error");
            });

        
    }



    }
})(); 
(function() {
    'use strict';

    angular
        .module('KPMES.pages.country')
        .controller('CountryCtrl', CountryCtrl);

    /** @ngInject */
    function CountryCtrl($http, $rootScope, lodash, dialogs, CountryService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
       // Pagination code
        vm.rowCountOptions = [{"value": 5}, {"value": 10}, {"value": 25}, {"value": 50}, {"value": 100}]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function(num) {
          vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
       
        vm.CountryList = [];
        $rootScope.isLogin = false;
        //Method
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editCountry = editCountry;
        vm.SaveCountryNew=SaveCountryNew;
        vm.changeActiveCountry = changeActiveCountry;
        // vm.removeCountry = removeCountry;
       vm.NewremoveCountry= NewremoveCountry;
        vm.SaveCountry = SaveCountry;
        var logggedUser = AuthenticationService.getLoggedUserDetails();
     

        Init();

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            // CountryService.getAllCountry($http, $rootScope).then(function(res) {
            //     if (res.status === 200) {
            //         vm.CountryList = res.data;
            //         vm.isLoading = false;
            //     } else {
            //         $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
            //     }
            // }, function(err) {
            //     $rootScope.showToaster('error', 'Error! Try Again', "Country");
            // });

               CountryService.GetAllCountry_ByProc($http, $rootScope).then(function(res) {
                if (res.status === 200) {
                    vm.CountryList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function(err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;

        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            resetForm();
            vm.country = {};
        }

        function resetForm() {
            // vm.CountryForm.$setUntouched();
        }

        function editCountry(country) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            // vm.oldCountry = country.CountryName;

            vm.country = angular.copy(country);

        }

        function changeActiveCountry(country) {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            var msg = 'Are sure you want to ' + ((country.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((country.IsActive) ? 'Deactive' : 'Active') + 'Country Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function() {
                var inActive = {
                    CountryId: country.CountryId,
                    ModifiedBy: logggedUser.UserId
                }
                CountryService.changeActiveCountry(inActive).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Country");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Deactive Country", { animation: true, size: 'sm' });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Deactive Country.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function() {

            })
        }

        // function removeCountry(country) {
        //     var confirm = dialogs.confirm('Confirm',
        //         'Are sure you want to delete current row.', { animation: true, size: 'sm' });

        //     confirm.result.then(function() {
        //         CountryService.removeCountry(country.CountryId).then(function(res) {
        //             if (res.status === 200) {
        //                 $rootScope.showToaster('success', 'Delete Country Successfully', "Country");
        //                 Init();
        //             } else {
        //                 $rootScope.showToaster('error', "Can't Delete Country", { animation: true, size: 'sm' });
        //             }
        //         }, function(err) {
        //             $rootScope.showToaster('error', "Can't Delete Country.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
        //         });
        //     }, function() {

        //     })
        // }
        function NewremoveCountry(country) {
        var inputdata ={
            CountryId:country.CountryId,
            CountryName:'',
            CountryCode:'',
            CurrencyName:'',
            CurrencyCode:'',
            CurrencySymbol:'',
            CreatedBy:0,
            Process:'Delete'
        }

        var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });

            confirm.result.then(function() {
                CountryService.SaveDeleteCountryMaster(inputdata).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Country Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Country", { animation: true, size: 'sm' });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Delete Country.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function() {

            })

    }

        function SaveCountryNew(country){
            var icountryId = 0;

            if(vm.isEditing)
            icountryId = vm.country.CountryId;
            
            var inputdata ={
                CountryId:icountryId,
                CountryName:country.CountryName,
                CountryCode:country.CountryCode,
                CurrencyName:country.CurrencyName,
                CurrencyCode:country.CurrencyCode,
                CurrencySymbol:country.CurrencySymbol,
                CreatedBy:logggedUser.UserId,
                Process:'Save'
            }

            CountryService.SaveDeleteCountryMaster(inputdata).then(function(res) {
                if (res.data.IsSuccess === true) {
                    $rootScope.showToaster('success', res.data.Message, "Country Master");
                    Init();
                    vm.isFormOpen = false;
                    cancel();
                } else {
                    $rootScope.showToaster('error', res.data.Message, "Country Master");
                    vm.isFormOpen = true;
                }
              
            }, function(err) {
                $rootScope.showToaster("Something error...try again");
            });

        }

        function SaveCountry(country) {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                var country = {                
                    CreatedBy: logggedUser.UserId,
                    CountryCode: vm.country.CountryCode,
                    CountryName: vm.country.CountryName,
                }
                // CountryService.AddCountry(country).then(function(res) {
                //     if (res.data.IsSuccess === true) {
                //         $rootScope.showToaster('success', res.data.Message, "Country Master");
                //         Init();
                //         vm.isFormOpen = false;
                //         cancel();
                //     } else {
                //         $rootScope.showToaster('error', res.data.Message, "Country Master");
                //         vm.isFormOpen = true;
                //     }
                  
                // }, function(err) {
                //     $rootScope.showToaster("Something error...try again");
                // });

                CountryService.SaveDeleteCountryMaster(country).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Country Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Country Master");
                        vm.isFormOpen = true;
                    }
                  
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            } else {
                // if (vm.country.CountryName !== vm.oldCountryName && vm.country.CountryCode !== vm.oldCountryCode) {
                var country = {
                    ModifiedBy: logggedUser.UserId,
                    CountryCode: vm.country.CountryCode,
                    CountryName: vm.country.CountryName,
                    CountryId: vm.country.CountryId,
                    IsActive: vm.country.IsActive
                }
                CountryService.EditCountry(country).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Country Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Country Master");
                        vm.isFormOpen = true;
                    }
                    
                }, function(err) {
                    $rootScope.showToaster("Something error...try again", { animation: true, size: 'sm' });
                });               
                
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.dashboard')
        .controller('DashboardCtrl', DashboardCtrl);

    /** @ngInject */
    function DashboardCtrl($rootScope, $scope, lodash, dialogs, baConfig, $element, layoutPaths, baSidebarService) {
        var vm = this;
        $rootScope.isLogin = false;

        // Properties
       
        // Methods
        
    
        activate();

        ////////////////

       

        function activate() {            
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.department')
        .controller('DepartmentCtrl', DepartmentCtrl);

    /** @ngInject */
    function DepartmentCtrl($rootScope, lodash, dialogs, $http, DepartmentServices, CompanyService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination codes
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.DepartmentList = [];
        vm.dept = {};
        $rootScope.isLogin = false;
        var logggedUser = AuthenticationService.getLoggedUserDetails();
        var CompanyId = logggedUser.SelectedCompany.CompanyId;

        //Methods
        vm.companyChanged = companyChanged;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.CheckDepartmentCode = CheckDepartmentCode;
        vm.EditDepartment = EditDepartment;
        vm.removeDepartment = removeDepartment;
        vm.changeActiveDepartment = changeActiveDepartment;
        vm.SaveDepartment = SaveDepartment;
        vm.isCheck = false;

        ///////////////
        Init();

        function Init() {
            DepartmentServices.getAllDepartments(CompanyId).then(function (res) {
                if (res.status === 200) {
                    vm.DepartmentList = res.data;
                    $rootScope.isLoading = false;
                    CompanyService.getSubCompByCompId(CompanyId).then(function (res) {
                        if (res.status === 200) {
                            vm.CompanyList = res.data;
                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Company Master");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Company Master");
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Department");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Department");
            });
        }

        function companyChanged() {
            var obj = {
                CompanyId: vm.dept.selectedCompany.CompanyId,
                UserCompanyId: logggedUser.Company.CompanyId
            };
            DepartmentServices.getDepOfParentCompanies(obj).then(function (res) {
                if (res.status === 200)
                    vm.DepartmentActiveList = res.data;
                else
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Department");
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Department");
            });
        }

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.code = true;

        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            resetForm();
            vm.dept = {};
        }
        function resetForm() {
            vm.departmentForm.$setUntouched();
        }

        function CheckDepartmentCode() {
            DepartmentServices.CheckCode(vm.dept.Code).then(function (res) {
                if (res.data.IsSuccess === true) {
                    vm.CheckCodeList = res.data;
                    if (vm.CheckCodeList.length < 1) {
                        vm.isCheck = true;
                    }
                    else {
                        vm.isCheck = false;
                    }
                } else {
                    $rootScope.showToaster('error', res.data.Message, "Department Master");
                    vm.isFormOpen = true;
                }

            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });
        }

        function EditDepartment(dept) {
            vm.code = false;
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.dept = angular.copy(dept);

            if (dept.ParentId === 0)
                vm.isNoParent = false;

            for (var c in vm.CompanyList) {
                if (vm.CompanyList[c].CompanyId === dept.CompanyId) {
                    vm.dept.selectedCompany = vm.CompanyList[c];
                }
            }
            for (var d in vm.DepartmentList) {
                if (vm.DepartmentList[d].DepartmentId === dept.ParentId) {
                    vm.dept.selectedParent = vm.DepartmentList[d];
                }
            }

        }
        function removeDepartment(dept) {
            // CreatedBy = logggedUser.UserId;
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            confirm.result.then(function () {

                DepartmentServices.removeDepartment(dept.DepartmentId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Department Successfully', "Department");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Parent Department", { animation: true, size: 'sm' });
                    }

                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Parent Department. <br> If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })

        }
        function SaveDepartment(dept) {
            dept.CompanyId = vm.dept.selectedCompany.CompanyId;
            //  dept.CompanyId = vm.dept.selectedCompany.CompanyId;
            if (vm.dept.selectedParent === null || vm.dept.selectedParent === undefined)
                // if ( vm.DepartmentActiveList >= 0)
                dept.ParentId = 0;
            else
                dept.ParentId = vm.dept.selectedParent.DepartmentId;

            if (!vm.isEditing) {
                dept.CreatedBy = logggedUser.UserId;
                DepartmentServices.AddDepartment(dept).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Department Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Department Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {
                dept.ModifiedBy = logggedUser.UserId;
                DepartmentServices.EditDepartment(dept).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Department Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Department Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
        }

        function changeActiveDepartment(dept) {
            var msg = 'Are sure you want to ' + ((dept.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((dept.IsActive) ? 'Deactive' : 'Active') + 'Department Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function () {
                DepartmentServices.changeActiveDepartment(dept.DepartmentId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Department");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Department", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Department. <br> If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.designation')
        .controller('DesignationCtrl', DesignationCtrl);

    /** @ngInject */
    function DesignationCtrl($rootScope, lodash, dialogs, $http, DesignationService, DepartmentServices, AuthenticationService, CompanyService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.DesignationList = [];
        vm.desig = {};
        var loggedUser = AuthenticationService.getLoggedUserDetails();
        $rootScope.isLogin = false;
        // Methods
        vm.departmentSelectionChanged = departmentSelectionChanged;
        vm.getDepartmentListByCompanyId = getDepartmentListByCompanyId;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editDesignation = editDesignation;
        vm.removeDesignation = removeDesignation;
        vm.SaveDesignation = SaveDesignation;
        vm.changeActiveDesignation = changeActiveDesignation;~

        Init();
        //////////////////

        function Init() {

            DesignationService.getAllDesignation(loggedUser.SelectedCompany.CompanyId).then(function (res) {
                if (res.status === 200) {
                    vm.DesignationList = res.data;
                    $rootScope.isLoading = false;
                    //vm.DesignationActiveList = lodash.filter(vm.DesignationList, { 'IsActive': true });                   
                    CompanyService.getSubCompByCompId(loggedUser.SelectedCompany.CompanyId).then(function (res) {
                        if (res.status === 200) {
                            vm.CompanyList = res.data;
                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Company Master");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Company Master");
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Designation");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Designation");
            });
        }

        function getDepartmentListByCompanyId(CompanyId, callback) {
            DepartmentServices.GetDepartmentByCompanyId(CompanyId).then(function (res) {
                if (res.status === 200) {
                    vm.DepartmentList = res.data;
                    if (vm.DepartmentList.length < 1) {
                        dialogs.notify('Warning', 'No department available for ' + vm.desig.selectedCompany.CompanyName, {
                            animation: true,
                            size: 'sm'
                        });
                    }

                    // Temp solution 
                    if (callback)
                        callback();
                }
            });
        }

        function departmentSelectionChanged(ParentId, callback) {
            DesignationService.getRepToDesig(vm.desig.selectedDepartment.DepartmentId).then(function (res) {
                if (res.status === 200) {
                    vm.DesignationActiveList = res.data;
                    if (vm.DesignationActiveList.length < 1) {
                        dialogs.notify('Warning', 'No department available for ' + vm.desig.selectedDepartment.ParentName, {
                            animation: true,
                            size: 'sm'
                        });
                    }
                    // Temp solution 
                    if (callback)
                        callback();
                }
            });
        }

        // function departmentSelectionChanged() {
        //     var obj = {
        //         DepartmentId: vm.desig.selectedDepartment.DepartmentId
        //     };
        //     DepartmentServices.GetDesigByDepId(obj).then(function(res) {
        //         if (res.status === 200)
        //             vm.DesignationActiveList = res.data;
        //         else
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Department");
        //     }, function(err) {
        //         $rootScope.showToaster('error', 'Error! Try Again', "Department");
        //     });
        // }

        function Create() {
            vm.code = true;
            vm.isFormOpen = true;
            vm.desig = {};

        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            resetForm();
            vm.desig = {};
        }

        function resetForm() {
            vm.desigForm.$setUntouched();
        }

        function editDesignation(desig) {
            vm.code = false;
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.desig = angular.copy(desig);
            if (desig.Superior === 0)
                vm.isNoSuperior = false;

            for (var c in vm.CompanyList) {
                if (vm.CompanyList[c].CompanyId === desig.CompanyId) {
                    vm.desig.selectedCompany = vm.CompanyList[c];
                }
            }
            getDepartmentListByCompanyId(desig.CompanyId, function () {
                for (var d in vm.DepartmentList) {
                    if (vm.DepartmentList[d].DepartmentId === desig.DepartmentId) {
                        vm.desig.selectedDepartment = vm.DepartmentList[d];
                    }
                }

                for (var d in vm.DesignationList) {
                    if (vm.DesignationList[d].DesignationId === desig.Superior) {
                        vm.desig.selectedSuperior = vm.DesignationList[d];
                    }
                }

            });
        }

        function removeDesignation(desig) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                DesignationService.removeDesignation(desig.DesignationId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete  Successfully', "Designation");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Designation", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Designation. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }

        function SaveDesignation(desig) {
            // CreatedBy = loggedUser.UserId;
            debugger;
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            vm.getDepartmentListByCompanyId = function (selectedCompany) {
                selectedCompany.CompanyId = vm.selectedCompany.CompanyId;
            }
            desig.CompanyId = vm.desig.selectedCompany.CompanyId;
            desig.DepartmentId = vm.desig.selectedDepartment.DepartmentId;

            desig.Superior = (vm.desig.selectedSuperior) ? vm.desig.selectedSuperior.DesignationId : desig.Superior = 0;

            if (!vm.isEditing) {
                desig.CreatedBy = loggedUser.UserId;
                DesignationService.AddDesignation(desig).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Designation Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Designation Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {
                desig.ModifiedBy = loggedUser.UserId;
                DesignationService.EditDesignation(desig).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Designation Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Designation Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
        }

        function changeActiveDesignation(desig) {
            var msg = 'Are sure you want to ' + ((desig.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((desig.IsActive) ? 'Deactive' : 'Active') + 'Designation Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                DesignationService.changeActiveDesignation(desig.DesignationId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Designation");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Designation", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Designation. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages')
        .directive('setFocus', function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind('click', function () {                        
                        var input = document.querySelector('#' + attrs.setFocus);
                        alert(input.id);
                        debugger;
                        input.focus();
                    })
                }
            }
        })
        .directive('customOnChange', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    var onChangeHandler = scope.$eval(attrs.customOnChange);
                    element.bind('change', onChangeHandler);
                }
            };
        })
        .directive('validFile', function () {
            return {
                require: 'ngModel',
                link: function (scope, el, attrs, ngModel) {
                    //change event is fired when file is selected
                    el.bind('change', function () {
                        scope.$apply(function () {
                            ngModel.$setViewValue(el.val());
                            ngModel.$render();
                        })
                    })
                }
            }
        })
        .directive('onlyDigits', function () {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: function (scope, element, attrs, modelCtrl) {
                    modelCtrl.$parsers.push(function (inputValue) {
                        if (inputValue == undefined) return '';
                        var transformedInput = inputValue.replace(/[^0-9]/g, '');
                        if (transformedInput !== inputValue) {
                            modelCtrl.$setViewValue(transformedInput);
                            modelCtrl.$render();
                        }
                        return transformedInput;
                    });
                }
            };
        })

        .directive("compareTo", function () {
            return {
                require: "ngModel",
                scope: {
                    otherModelValue: "=compareTo"
                },
                link: function (scope, element, attributes, ngModel) {

                    ngModel.$validators.compareTo = function (modelValue) {
                        return modelValue == scope.otherModelValue;
                    };

                    scope.$watch("otherModelValue", function () {
                        ngModel.$validate();
                    });
                }
            };
        })

        .directive('validNumber', function () {
            return {
                require: '?ngModel',
                link: function (scope, element, attrs, ngModelCtrl) {
                    if (!ngModelCtrl) {
                        return;
                    }

                    ngModelCtrl.$parsers.push(function (val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9\.]/g, '');
                        if (val !== clean) {
                            ngModelCtrl.$setViewValue(clean);
                            ngModelCtrl.$render();
                        }
                        return clean;
                    });

                    element.bind('keypress', function (event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                }
            };
        })
        .directive('myMaxlength', ['$compile', '$log', function ($compile, $log) {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    attrs.$set("ngTrim", "false");
                    var maxlength = parseInt(attrs.myMaxlength, 10);
                    ctrl.$parsers.push(function (value) {
                        $log.info("In parser function value = [" + value + "].");
                        if (value.length > maxlength) {
                            $log.info("The value [" + value + "] is too long!");
                            value = value.substr(0, maxlength);
                            ctrl.$setViewValue(value);
                            ctrl.$render();
                            $log.info("The value is now truncated as [" + value + "].");
                        }
                        return value;
                    });
                }
            };
        }])

        .directive('numbersOnly', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, modelCtrl) {
                    modelCtrl.$parsers.push(function (inputValue) {
                        // this next if is necessary for when using ng-required on your input. 
                        // In such cases, when a letter is typed first, this parser will be called
                        // again, and the 2nd time, the value will be undefined
                        if (inputValue == undefined) return ''
                        var transformedInput = inputValue.replace(/[^0-9]/g, '');
                        if (transformedInput != inputValue) {
                            modelCtrl.$setViewValue(transformedInput);
                            modelCtrl.$render();
                        }

                        return transformedInput;
                    });
                }
            };
        })


        .directive('rowSelect', function () {
            return {
                require: '^stTable',
                template: '<input type="checkbox">',
                scope: {
                    row: '=rowSelect'
                },
                link: function (scope, element, attr, ctrl) {

                    element.bind('click', function (evt) {

                        scope.$apply(function () {

                            ctrl.select(scope.row, 'multiple');

                        });

                    });

                    scope.$watch('row.isSelected', function (newValue) {

                        if (newValue === true) {

                            element.parent().addClass('st-selected');
                            element.find('input').attr('checked', true);

                        } else {

                            element.parent().removeClass('st-selected');
                            element.find('input').attr('checked', false);

                        }
                    });
                }
            };
        })

        .directive('rowSelectAll', function () {

            return {
                require: '^stTable',
                template: '<input type="checkbox">',
                scope: {
                    all: '=rowSelectAll',
                    selected: '='
                },
                link: function (scope, element, attr) {

                    scope.isAllSelected = false;

                    element.bind('click', function (evt) {

                        scope.$apply(function () {

                            scope.all.forEach(function (val) {

                                val.isSelected = scope.isAllSelected;

                            });

                        });

                    })

                    // .directive('dynamicUrl', function () {
                    //     return {
                    //         restrict: 'A',
                    //         link: function postLink(scope, element, attr) {
                    //             element.attr('src', attr.dynamicUrlSrc);
                    //         }
                    //     };
                    // })
                    .filter('trusted', function ($sce) {
                        return function (url) {
                            return $sce.trustAsResourceUrl(url);
                        }
                    })
                    .filter("trustUrl", ['$sce', function ($sce) {
                        return function (recordingUrl) {
                            return $sce.trustAsResourceUrl(recordingUrl);
                        };
                    }])

                    .directive('myDirectory', ['$parse', function ($parse) {
                        function link(scope, element, attrs) {
                            var model = $parse(attrs.myDirectory);
                            element.on('change', function (event) {
                                scope.data = []; //Clear shared scope in case user reqret on the selection
                                model(scope, {
                                    file: event.target.files
                                });
            
                            });
                        };
                        return {
                            link: link
                        }
                    }]);

                    scope.$watchCollection('selected', function (newVal) {

                        var s = newVal.length;
                        var a = scope.all.length;

                        if ((s == a) && s > 0 && a > 0) {

                            element.find('input').attr('checked', true);
                            scope.isAllSelected = false;

                        } else {

                            element.find('input').attr('checked', false);
                            scope.isAllSelected = true;

                        }

                    });


                    
                }
            };
        });

})();
(function () {
    'use strict';

    // angular
    //     .module('KPMES.pages')
    angular.module('ui.multiselect', []);
    angular.module('ui.multiselect')
        .factory('optionParser', ['$parse', function ($parse) {
       
            var TYPEAHEAD_REGEXP = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;

            return {
                parse: function (input) {

                    var match = input.match(TYPEAHEAD_REGEXP), modelMapper, viewMapper, source;
                    if (!match) {
                        throw new Error(
                            "Expected typeahead specification in form of '_modelValue_ (as _label_)? for _item_ in _collection_'" +
                            " but got '" + input + "'.");
                    }

                    return {
                        itemName: match[3],
                        source: $parse(match[4]),
                        viewMapper: $parse(match[2] || match[1]),
                        modelMapper: $parse(match[1])
                    };
                }
            };
        }])

        .directive('multiselect', ['$parse', '$document', '$compile', 'optionParser',

            function ($parse, $document, $compile, optionParser) {
                return {
                    restrict: 'E',
                    require: 'ngModel',
                    link: function (originalScope, element, attrs, modelCtrl) {

                        var exp = attrs.options,
                            parsedResult = optionParser.parse(exp),
                            isMultiple = attrs.multiple ? true : false,
                            required = false,
                            scope = originalScope.$new(),
                            changeHandler = attrs.change || angular.noop;

                        scope.items = [];
                        scope.header = 'Select';
                        scope.multiple = isMultiple;
                        scope.disabled = false;
                        scope.valid = validModel;


                        originalScope.$on('$destroy', function () {
                            scope.$destroy();
                        });

                        var popUpEl = angular.element('<multiselect-popup></multiselect-popup>');

                        //required validator
                        if (attrs.required || attrs.ngRequired) {
                            required = true;
                        }
                        attrs.$observe('required', function (newVal) {
                            required = newVal;
                        });

                        //watch disabled state
                        scope.$watch(function () {
                            return $parse(attrs.disabled)(originalScope);
                        }, function (newVal) {
                            scope.disabled = newVal;
                        });

                        //watch single/multiple state for dynamically change single to multiple
                        scope.$watch(function () {
                            return $parse(attrs.multiple)(originalScope);
                        }, function (newVal) {
                            isMultiple = newVal || false;
                        });

                        //watch option changes for options that are populated dynamically
                        scope.$watch(function () {
                            return parsedResult.source(originalScope);
                        }, function (newVal) {
                            if (angular.isDefined(newVal))
                                parseModel();
                        });

                        //watch model change
                        scope.$watch(function () {
                            return modelCtrl.$modelValue;
                        }, function (newVal, oldVal) {
                            //when directive initialize, newVal usually undefined. Also, if model value already set in the controller
                            //for preselected list then we need to mark checked in our scope item. But we don't want to do this every time
                            //model changes. We need to do this only if it is done outside directive scope, from controller, for example.
                            if (angular.isDefined(newVal)) {
                                markChecked(newVal);
                                scope.$eval(changeHandler);
                            }
                            getHeaderText();
                            modelCtrl.$setValidity('required', scope.valid());
                        }, true);

                        function parseModel() {
                            scope.items.length = 0;
                            var model = parsedResult.source(originalScope);
                            for (var i = 0; i < model.length; i++) {
                                var local = {};
                                local[parsedResult.itemName] = model[i];
                                scope.items.push({
                                    label: parsedResult.viewMapper(local),
                                    model: model[i],
                                    checked: false
                                });
                            }
                        }

                        parseModel();

                        element.append($compile(popUpEl)(scope));

                        function getHeaderText() {
                            if (!modelCtrl.$modelValue || !modelCtrl.$modelValue.length) return scope.header = 'Select';
                            if (isMultiple) {
                                scope.header = modelCtrl.$modelValue.length + ' ' + 'selected';
                            } else {
                                var local = {};
                                local[parsedResult.itemName] = modelCtrl.$modelValue;
                                scope.header = parsedResult.viewMapper(local);
                            }
                        }

                        function validModel() {
                            if (!required) return true;
                            var value = modelCtrl.$modelValue;
                            return (angular.isArray(value) && value.length > 0) || (!angular.isArray(value) && value != null);
                        };

                        function selectSingle(item) {
                            if (item.checked) {
                                scope.uncheckAll();
                            } else {
                                scope.uncheckAll();
                                item.checked = !item.checked;
                            }
                            setModelValue(false);
                        }

                        function selectMultiple(item) {                             
                            item.checked = !item.checked;
                            setModelValue(true);
                        }

                        function setModelValue(isMultiple) {
                            var value;
                            if (isMultiple) {
                                value = [];
                                angular.forEach(scope.items, function (item) {
                                    if (item.checked) value.push(item.model);
                                })
                            } else {
                                angular.forEach(scope.items, function (item) {
                                    if (item.checked) {
                                        value = item.model;
                                        return false;
                                    }
                                })
                            }
                            modelCtrl.$setViewValue(value);
                        }

                        function markChecked(newVal) {
                            if (!angular.isArray(newVal)) {
                                angular.forEach(scope.items, function (item) {
                                    if (angular.equals(item.model, newVal)) {
                                        item.checked = true;
                                        return false;
                                    }
                                });
                            } else {
                                angular.forEach(newVal, function (i) {
                                    angular.forEach(scope.items, function (item) {
                                        if (angular.equals(item.model, i)) {
                                            item.checked = true;
                                        }
                                    });
                                });
                            }
                        }

                        scope.checkAll = function () {
                            if (!isMultiple) return;
                            angular.forEach(scope.items, function (item) {
                                item.checked = true;
                            });
                            setModelValue(true);
                        };

                        scope.uncheckAll = function () {
                            angular.forEach(scope.items, function (item) {
                                item.checked = false;
                            });
                            setModelValue(true);
                        };

                        scope.select = function (item) {
                            if (isMultiple === false) {
                                selectSingle(item);
                                scope.toggleSelect();
                            } else {
                                selectMultiple(item);
                            }
                        }
                    }
                };
            }])

        .directive('multiselectPopup', ['$document', function ($document) {
            return {
                restrict: 'E',
                scope: false,
                replace: true,
                templateUrl: 'app/pages/directives/multiselect.tmpl.html',
                link: function (scope, element, attrs) {

                    scope.isVisible = false;

                    scope.toggleSelect = function () {
                        if (element.hasClass('open')) {
                            element.removeClass('open');
                            $document.unbind('click', clickHandler);
                        } else {
                            element.addClass('open');
                            scope.focus();
                            $document.bind('click', clickHandler);
                        }
                    };

                    function clickHandler(event) {
                        if (elementMatchesAnyInArray(event.target, element.find(event.target.tagName)))
                            return;
                        element.removeClass('open');
                        $document.unbind('click', clickHandler);
                        scope.$digest();
                    }

                    scope.focus = function focus() {
                        var searchBox = element.find('input')[0];
                        searchBox.focus();
                    }

                    var elementMatchesAnyInArray = function (element, elementArray) {
                        for (var i = 0; i < elementArray.length; i++)
                            if (element == elementArray[i])
                                return true;
                        return false;
                    }
                }
            }
        }])
})();

(function () {
    'use strict';

    angular
        .module('KPMES.pages.employee')
        .controller('EmployeeCtrl', EmployeeCtrl);
    /** @ngInject */
    function EmployeeCtrl($http, $rootScope, lodash, dialogs, EmployeeService, DepartmentServices, DesignationService, AuthenticationService, $scope, $timeout) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;

        vm.isReporingToRequried = false;
        vm.EmployeeList = [];
        vm.EmployeeExperienceList = [];
        vm.EmployeeAcademicList = [];
        vm.LanguageSpokenList = [];
        vm.AreaofExpertiseList = [];
        // vm.EmployeeDocumentList = [];
        $rootScope.isLogin = false;
        var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
    //  var loggedUser = AuthenticationService.getLoggedUserDetails();
        vm.isComAddSameAsPerAdd = false;
        vm.emp = {};
        vm.empCom = { EmpAddress: {} };
        vm.empPer = { EmpAddress: {} };
        vm.checkErr = false;
        vm.errMessage = '';
        vm.isEditingProPic = false;
        vm.GotoAcademicDetails =GotoAcademicDetails;
        vm.AcademicDetailsDetails = false;
        vm.ExperienceDetails = false;
        vm.AreaExpertiseDetails = false;
        vm.LanguagesSpokenDetails = false;
        vm.GotoAccountDetails = GotoAccountDetails;
        vm.EmployeeAccountDetails = false;
        vm.GotoAreaandlanguagedetails = GotoAreaandlanguagedetails;
        
        //vm.EmployeeAccountDetails = EmployeeAccountDetails;

        // Methods
        vm.GetDesignationByDepartmentId = GetDesignationByDepartmentId;
        // vm.GetDepartmentByCompanyId = GetDepartmentByCompanyId;
        vm.getReportingToList = getReportingToList;
        vm.editProPic = editProPic;

        // File upload methods
        $scope.photoChanged = photoChanged;
        $scope.getGraduationFiles = getGraduationFiles;

        vm.ProficiencyList = [{
            ProficiencyName: "International",
            ProficiencyId:1,
        }, { ProficiencyName: "National",ProficiencyId:2, }, { ProficiencyName: "State",ProficiencyId:3, }, { ProficiencyName: "District",ProficiencyId:4, }, { ProficiencyName: "Zone",ProficiencyId:5, }

        ];


        Init();
        ////////////////////

        function editProPic() {
            vm.isEditingProPic = true;
        }

        function photoChanged(event) {

            var reader = new FileReader();
            if (!vm.isEditingProPic) {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
            } else {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
                var formData = new FormData();
                formData.append('profilePic', vm.empProfilePic);
                formData.append('employeeId', vm.empId);
                EmployeeService.updateProfilePic(formData).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Profile picture changed succussfully', "Success");
                        Init();
                    } else {
                        $rootScope.showToaster('error', 'Internal server Error!', "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Internal server Error!', "Error");
                });
            }
        
        }       

        function GotoAcademicDetails()
        {
          
                vm.AcademicDetailsDetails = true;
                vm.ExperienceDetails = true;    
            
        }

        function GotoAreaandlanguagedetails()
        {
            vm.AreaExpertiseDetails = true;
            vm.LanguagesSpokenDetails = true;
        }
        function GotoAccountDetails()
        {
            vm.EmployeeAccountDetails = true;
           
            
        }

        function getGraduationFiles(event) {

            if (event)
                vm.empGraduationDocs = event.target.files;
        }

        $scope.imageIsLoaded = function (e) {
            $scope.$apply(function () {
                vm.profilePicUrl = e.target.result;
            });
        }

        function Init() {
            var objGetEmpDTO = {
                ActionBy: $rootScope.loggedUserId
            }
            //var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            // vm.emp.Gender = false;
            // vm.emp.MaritalStatus = false;
            EmployeeService.getAllEmployees(CompanyId).then(function (res) {
                if (res.status === 200) {
                    vm.EmployeeList = res.data;
                    $rootScope.isLoading = false;
                    DepartmentServices.GetDepartmentByCompanyId(CompanyId).then(function (res) {
                        if (res.status === 200) {
                            vm.DepartmentList = res.data;
                        }
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });
        }

        function getReportingToList(callback) {
            var desigId = vm.emp.selectedDesignation.Superior;

            if (desigId) {
                EmployeeService.getAllCompanyEmployees(desigId).then(function (res) {
                    if (res.status === 200) {
                        vm.ReportingtoList = res.data;
                        vm.isReporingToRequried = true;
                        if (callback)
                            callback();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Employee");
                });
            } else {
                vm.isReporingToRequried == false;
            }
        }
        vm.AddBankandPersonalDetails = function()
        {

            var obj = {
                CompanyId: CompanyId,
                EmployeeId: vm.empId,
                AccountNo: vm.student.AccountNo,
                NameofTheBank: vm.student.BankName,
                Branch:vm.student.Branch,
                IFSCcode:vm.student.IFSCCode,
                MICRcode:vm.student.MICRCode
                
            }
            EmployeeService.addNewEmpBankInfo(obj).then(function (res){
                if (res.status === 200) {
                    $rootScope.showToaster("success", "Bank details added successfully", "Success");
                   // getAllEmpExperienceDetails(vm.empId);
                    vm.student = {};
                } else {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                }
            }, function (err) {
                $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
            });
        }

        vm.AddBankandPersonalDetails = function()
        {

            var obj = {
                CompanyId: CompanyId,
                EmployeeId: vm.empId,
                AccountNo: vm.student.AccountNo,
                NameofTheBank: vm.student.BankName,
                Branch:vm.student.Branch,
                IFSCcode:vm.student.IFSCCode,
                MICRcode:vm.student.MICRCode,
                BloodGroup:vm.student.BloodGroup,
                AadhaarCardNo:vm.student.Aadhaarcardno,
                PhysicallyHandicapped:vm.student.Aadhaarcardno,
                Eligible:vm.student.Physicallyhandicapted,
                Participatesports:vm.student.Participate,
                ProficiencyId:vm.student.Proficiency.ProficiencyId,
                
            }


            var bankdetails = {
                AccountNo: vm.student.AccountNo,
                NameofTheBank: vm.student.BankName,
                Branch:vm.student.Branch,
                IFSCcode:vm.student.IFSCCode,
                MICRcode:vm.student.MICRCode,
            }


            var personaldetails = {
                BloodGroup:vm.student.BloodGroup,
                AadhaarCardNo:vm.student.Aadhaarcardno,
                PhysicallyHandicapped:vm.student.Aadhaarcardno,
                Eligible:vm.student.Physicallyhandicapted,
                Participatesports:vm.student.Participate,
                ProficiencyId:vm.student.Proficiency.ProficiencyId,
            }
        
            EmployeeService.addNewEmpBankInfo(obj).then(function (res){
                if (res.status === 200) {
                    $rootScope.showToaster("success", "Bank details added successfully", "Success");
                     vm.student = {};
                } else {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                }
            }, function (err) {
                $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
            });
        }
        vm.AddStaffAreasofExpertise = function()
        {
            var obj = {

                CompanyId: CompanyId,
                EmployeeId: vm.empId,
               // TeachingChoice:vm.Areas.Teachingchoice1,
               SubjectField1:vm.Areas.Subject1,
               SubjectField2:vm.Areas.Subject2,
               SubjectField3:vm.Areas.Subject3,
                Level1:vm.Areas.Level1,
                Level2:vm.Areas.Level2,
                Level3:vm.Areas.Level3,


            }
            EmployeeService.addNewStaffAreasofExpertise(obj).then(function (res) {
                if (res.status === 200) {
                    $rootScope.showToaster("success", "AreaofExpertise details added successfully", "Success");
                    //getAllEmpExperienceDetails(vm.empId);
                    //vm.emp2 = {};
                } else {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                }
            }, function (err) {
                $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
            });
        }
        vm.AddStaffLanguageSpoken = function()
        {
            var obj = {

                CompanyId: CompanyId,
                EmployeeId: vm.empId,
               // TeachingChoice:vm.Areas.Teachingchoice1,
               Language:vm.Language.Language1,
               Proficiency:vm.Language.Proficiency1,

            }

            EmployeeService.addNewStaffLanguageInfo(obj).then(function (res) {
                if (res.status === 200) {
                    $rootScope.showToaster("success", "Experience detail added successfully", "Success");
                    //getAllEmpExperienceDetails(vm.empId);
                    //vm.emp2 = {};
                } else {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                }
            }, function (err) {
                $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
            });
        }

        vm.AddEmployeeExperience = function () {
            var obj = {
                CompanyId: CompanyId,
                EmployeeId: vm.empId,
                Organization: vm.emp2.Organization,
                Department: vm.emp2.Department,
                Designation: vm.emp2.Designation,
                FromDate: vm.emp2.FromDate,
                ToDate: vm.emp2.ToDate,
                YearsofExperience: vm.emp2.YearsofExperience,
                Remarks: vm.emp2.Remarks
            }
            EmployeeService.addNewEmpExperience(obj).then(function (res) {
                if (res.status === 200) {
                    $rootScope.showToaster("success", "Experience detail added successfully", "Success");
                    getAllEmpExperienceDetails(vm.empId);
                    vm.emp2 = {};
                } else {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                }
            }, function (err) {
                $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
            });
        }

        vm.RemoveEmployeeExp = function (expId) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            confirm.result.then(function () {
                EmployeeService.removeEmpExpInfo(expId).then(function (res) {
                    if (res.status === 200 && res.data) {
                        $rootScope.showToaster('success', 'Experience detail deleted successfully.', "Success");
                        getAllEmpExperienceDetails(vm.empId);
                    } else {
                        $rootScope.showToaster('error', "Something wrong, Try again!", "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Something wrong, Try again!", "Error");
                });
            });
        }

        vm.AddEmployeeAcademic = function (empacademic) {
            var bool = false;
            if (vm.EmployeeAcademicList && (vm.emp1.Graduation == '10' || vm.emp1.Graduation == '12')) {
                for (var i = 0; i < vm.EmployeeAcademicList.length; i++) {
                    if (vm.EmployeeAcademicList[i]["Graduation"] == vm.emp1.Graduation) {
                        bool = true;
                    }
                }
            }

            if (!bool) {

                var obj = {
                    CompanyId: CompanyId,
                    EmployeeId: vm.empId,
                    Graduation: vm.emp1.Graduation,
                    Degree: vm.emp1.Degree,
                    Specialization: vm.emp1.Specialization,
                    University: vm.emp1.University,
                    Percentage: vm.emp1.Percentage,
                    YearofPassing: vm.emp1.YearsofPassing,
                    Remarks: vm.emp1.Remarks
                };
                var formData = new FormData();
                for (var i in vm.empGraduationDocs) {
                    formData.append('file' + i, vm.empGraduationDocs[i]);
                }

                formData.append('data', JSON.stringify(obj));
                EmployeeService.addNewEmpAcademicInfo(formData).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster("success", "Academic detail added successfully", "Success");
                        getAllEmpAcademicDetails(vm.empId);
                        vm.empGraduationDocs = null;
                        vm.emp1 = {};
                    } else {
                        $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster("error", "Something wrong, Try Again!", "Error");
                });
            } else {
                $rootScope.showToaster("error", "That detail already exist!", "Error");
            }
        }

        vm.RemoveEmployeeAcademic = function (row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            confirm.result.then(function () {
                EmployeeService.removeEmpAcademyInfo(row.AcademyId).then(function (res) {
                    if (res.status === 200 && res.data) {
                        $rootScope.showToaster('success', 'Academic detail deleted successfully.', "Success");
                        getAllEmpAcademicDetails(vm.empId);
                    } else {
                        $rootScope.showToaster('error', "Something wrong, Try again!", "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Something wrong, Try again!", "Error");
                });
            });
        }

        vm.checkErr = function (startDate, endDate) {
            vm.errMessage = '';
            if (startDate > endDate) {
                vm.errMessage = 'End Date should be greate than start date';
                vm.emp2.ToDate = '';
                return false;
            } else {
                vm.emp2.YearsofExperience = '';
                var Years = (endDate.getYear() - startDate.getYear());
                var Months = endDate.getMonth() - startDate.getMonth();

                var totalmonths = (Years * 12) + Months;
                var totalexp = (totalmonths / 12);
                vm.emp2.YearsofExperience = totalexp;
                return true;
            }

        }

        function GetDesignationByDepartmentId(DepartmentId, callback) {
            vm.DesignationList = null;

            DesignationService.GetDesigByDepId(DepartmentId).then(function (res) {
                if (res.status === 200) {
                    vm.DesignationList = res.data;
                    if (callback)
                        callback();
                }
            });
        }

        function getAllEmpAcademicDetails(empId) {
            EmployeeService.getAllEmpAcademyInfo(empId).then(function (res) {
                if (res.status === 200) {
                    vm.EmployeeAcademicList = res.data;
                } else {
                    vm.EmployeeAcademicList = [];
                }
            }, function (err) {
                vm.EmployeeAcademicList = [];
            });
        }

        function getAllEmpExperienceDetails(empId) {
            EmployeeService.getAllEmpExpInfo(empId).then(function (res) {
                if (res.status === 200) {
                    vm.EmployeeExperienceList = res.data;
                } else {
                    vm.EmployeeExperienceList = [];
                }
            }, function (err) {
                vm.EmployeeExperienceList = [];
            });
        }

        function getAllAreaofExpertiseDetails(AreaExpertiseId){
            EmployeeService.getAllAreaofExpertiseInfo(AreaExpertiseId).then (function(res){
                if(res.status ===200){
                    vm.AreaofExpertiseList = res.data;
                }
                else{
                    vm.AreaofExpertiseList =[];
                }
                },function(err){
                    vm.AreaofExpertiseList =[];

                });
            }

            function getAllLanguageDetails(StaffLanguagespokenId){
                EmployeeService.getAllLanguageListInfo(StaffLanguagespokenId).then (function(res){
                    if(res.status ===200){
                        vm.LanguageSpokenList = res.data;
                    }
                    else{
                        vm.LanguageSpokenList =[];
                    }
                    },function(err){
                        vm.LanguageSpokenList =[];
    
                    });
                }

        

        vm.Create = function () {
            vm.isFormOpen = true;
        }

        vm.cancel = function () {
            vm.isFormOpen = false;
            vm.resetForm();
            vm.emp = {};
            vm.emp1 = {};
            vm.emp2 = {};
            vm.empCom = { EmpAddress: {} };
            vm.empPer = { EmpAddress: {} }
            vm.empProfilePic = null;
            vm.profilePicUrl = null;
            vm.isComAddSameAsPerAdd = false;
            vm.emp.selectedDepartment = null;
            vm.emp.selectedDesignation = null;
            vm.emp.selectedReportingTo = null;
            vm.isEditing = false;
            vm.isReporingToRequried = false;
            Init();
        }

        vm.update = function () {
            if (vm.isComAddSameAsPerAdd) {
                vm.empCom.EmpAddress = angular.copy(vm.empPer.EmpAddress);
            } else {
                vm.empCom.EmpAddress = {};
            }
        };

        vm.resetForm = function () {
            vm.EmployeeForm.$setUntouched();
        }

        vm.EditEmployee = function (emp) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.emp = angular.copy(emp);
            vm.emp.DOJ = new Date(emp.DOJ);
            vm.emp.DOB = new Date(emp.DOB);
            vm.empId = emp.EmployeeId;
            vm.emp.BloodGroup = emp.BloodGroup;
            //'/EmployeeProfilePictures/' +
            vm.emp.staffdetails = (emp.StaffDetails == true) ? '0' : '1' 
            vm.empProfilePic = vm.profilePicUrl = $rootScope.endPoint +  emp.ProfilePhoto;
            vm.empPer.EmpAddress.Address1 = emp.EmpAddress.PerAddress1;
            vm.empCom.EmpAddress.Address1 = emp.EmpAddress.CommAddress1;
            vm.empPer.EmpAddress.Address2 = emp.EmpAddress.PerAddress2;
            vm.empCom.EmpAddress.Address2 = emp.EmpAddress.CommAddress2;
            vm.empPer.EmpAddress.Area = emp.EmpAddress.PerArea;
            vm.empCom.EmpAddress.Area = emp.EmpAddress.CommArea;
            vm.empPer.EmpAddress.City = emp.EmpAddress.PerCity;
            vm.empCom.EmpAddress.City = emp.EmpAddress.CommCity;
            vm.empPer.EmpAddress.State = emp.EmpAddress.PerState;
            vm.empCom.EmpAddress.State = emp.EmpAddress.CommState;
            vm.empPer.EmpAddress.Country = emp.EmpAddress.PerCountry;
            vm.empCom.EmpAddress.Country = emp.EmpAddress.CommCountry;
            vm.empPer.EmpAddress.PinCode = emp.EmpAddress.PerPincode;
            vm.empCom.EmpAddress.PinCode = emp.EmpAddress.CommPincode;
            vm.empPer.EmpAddress.EmailId = emp.EmpAddress.PerEmailId;
            vm.empCom.EmpAddress.EmailId = emp.EmpAddress.CommEmailId;
            vm.empPer.EmpAddress.MobileNo = parseInt(emp.EmpAddress.PerMobile);
            vm.empCom.EmpAddress.MobileNo = parseInt(emp.EmpAddress.CommMobile);
            vm.empPer.EmpAddress.LandlineNo = parseInt(emp.EmpAddress.PerLandline);
            vm.empCom.EmpAddress.LandlineNo = parseInt(emp.EmpAddress.CommLandline);
            vm.EmployeeAcademicList = emp.EmpAcademy;
            vm.EmployeeExperienceList = emp.EmpExperience;


            for (var d in vm.DepartmentList) {
                if (vm.DepartmentList[d].DepartmentId === emp.DepartmentId) {
                    vm.emp.selectedDepartment = vm.DepartmentList[d];
                }
            }

            GetDesignationByDepartmentId(emp.DepartmentId, function () {
                for (var d in vm.DesignationList) {
                    if (vm.DesignationList[d].DesignationId === emp.DesignationId) {
                        vm.emp.selectedDesignation = vm.DesignationList[d];
                    }
                }
                getReportingToList(function () {

                    for (var d in vm.ReportingtoList) {
                        if (vm.ReportingtoList[d].EmployeeId === emp.ReportingTo) {
                            vm.emp.selectedReportingTo = vm.ReportingtoList[d];
                        }
                    }
                });
                vm.emp.ModifiedBy = $rootScope.loggedUserId;
            });
        }

        vm.RemoveEmployee = function (emp) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current Employee.', { animation: true, size: 'sm' });
            confirm.result.then(function () {
                EmployeeService.RemoveEmployee(emp.EmployeeId).then(function (res) {
                    if (res.data) {
                        $rootScope.showToaster('success', 'Employee deleted successfully', "Employee Master");
                        Init();
                    } else {
                        $rootScope.showToaster("Employee Removal Status", "Dependent Employee Cannot be deleted");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Employee Master");
                });
            }, function () { });
        }

        vm.changeActiveEmployee = function (emp) {
            var msg = 'Are sure you want to ' + ((emp.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((emp.IsActive) ? 'Deactive' : 'Active') + 'Employee Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function () {
                EmployeeService.changeActiveEmployee(emp.EmployeeId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "Employee");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't InActive Employee", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't InActive Employee. If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        vm.SaveEmployee = function (emp) {
            emp.CompanyId = CompanyId;
            emp.DepartmentId = vm.emp.selectedDepartment.DepartmentId;
            emp.DesignationId = vm.emp.selectedDesignation.DesignationId;

            if (vm.emp.selectedReportingTo === null || vm.emp.selectedReportingTo === undefined)
                emp.ReportingTo = 0;
            else
                emp.ReportingTo = vm.emp.selectedReportingTo.EmployeeId;

            emp.Gender = vm.emp.Gender;
            emp.MaritalStatus = vm.emp.MaritalStatus;
            // emp.Teaching = (emp.Teaching == ("T" || undefined) ? false:true),
            // emp.NonTeaching =(emp.NonTeaching == ("NT"|| undefined) ? false:true),
            // emp.Teaching = vm.emp.Teaching,
            // emp.NonTeaching = vm.emp.addNewEmpAcademicInfo,
            emp.KpostId = vm.emp.KpostId;
          //  vm.emp.CreatedBy = $rootScope.loggedUserId;
         

            

            // emp.ReportingTo = vm.emp.selectedReportingTo.EmployeeId;
            emp.EmpAcademy = vm.EmployeeAcademicList;
            emp.EmpExperience = vm.EmployeeExperienceList;
            emp.AreaofExpertiseList = vm.AreaofExpertiseList;
            emp.LanguageSpokenList = vm.LanguageSpokenList;


            emp.EmpAddress = {};
            emp.EmpAddress.PerAddress1 = vm.empPer.EmpAddress.Address1;
            emp.EmpAddress.CommAddress1 = vm.empCom.EmpAddress.Address1;
            emp.EmpAddress.PerAddress2 = vm.empPer.EmpAddress.Address2;
            emp.EmpAddress.CommAddress2 = vm.empCom.EmpAddress.Address2;
            emp.EmpAddress.PerArea = vm.empPer.EmpAddress.Area;
            emp.EmpAddress.CommArea = vm.empCom.EmpAddress.Area;
            emp.EmpAddress.PerCity = vm.empPer.EmpAddress.City;
            emp.EmpAddress.CommCity = vm.empCom.EmpAddress.City;
            emp.EmpAddress.PerState = vm.empPer.EmpAddress.State;
            emp.EmpAddress.CommState = vm.empCom.EmpAddress.State;
            emp.EmpAddress.PerCountry = vm.empPer.EmpAddress.Country;
            emp.EmpAddress.CommCountry = vm.empCom.EmpAddress.Country;
            emp.EmpAddress.PerPincode = vm.empPer.EmpAddress.PinCode;
            emp.EmpAddress.CommPincode = vm.empCom.EmpAddress.PinCode;
            emp.EmpAddress.PerEmailId = vm.empPer.EmpAddress.EmailId;
            emp.EmpAddress.CommEmailId = vm.empCom.EmpAddress.EmailId;
            emp.EmpAddress.PerMobile = vm.empPer.EmpAddress.MobileNo;
            emp.EmpAddress.CommMobile = vm.empCom.EmpAddress.MobileNo;
            emp.EmpAddress.PerLandline = vm.empPer.EmpAddress.LandlineNo;
            emp.EmpAddress.CommLandline = vm.empCom.EmpAddress.LandlineNo;
          //  emp.staffdetails  = parseInt(vm.emp.staffdetails);
          debugger
             emp.staffdetails = (emp.staffdetails == 1) ? true : false
           

            var formData = new FormData();
            formData.append('data', JSON.stringify(emp));
            formData.append('profilePic', vm.empProfilePic);
            console.log("FORMDATA==>"+ JSON.stringify(emp));
            return;
            if (!vm.isEditing) {
                EmployeeService.AddEmployee(formData).then(function (res) {
                    $rootScope.showToaster('success', 'Employee added successfully', "success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.isReporingToRequried = false;
            } else {
                EmployeeService.EditEmployee(emp).then(function (res) {
                    $rootScope.showToaster('success', 'Employee updated successfully', "Success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.emp = {};
                vm.emp1 = {};
            }
        }

        vm.RemoveEmployee = function (emp) {
            EmployeeService.RemoveEmployee(emp.EmployeeId).then(function (res) {
                $rootScope.showToaster('success', 'Employee deleted successfully', "Employee Master");
                Init();
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });
        }

        // Datepicker code 
        vm.today = function () {
            vm.dt = new Date();
        };
        vm.today();

        vm.clear = function () {
            vm.dt = null;
        };

        vm.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };

        vm.dateOptions = {
            dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.toggleMin = function () {
            vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
            vm.dateOptions.minDate = vm.inlineOptions.minDate;
        };

        vm.toggleMin();

        vm.open1 = function () {
            vm.popup1.opened = true;
        };

        vm.open2 = function () {
            vm.popup2.opened = true;
            var today = new Date();
            var minAge = 18;

            vm.options = {
                maxDate: new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate())
            }

        };

        vm.open3 = function () {
            vm.popup3.opened = true;
        };

        vm.open4 = function () {
            vm.popup4.opened = true;
        };

        vm.setDate = function (year, month, day) {
            vm.dt = new Date(year, month, day);
        };

        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];

        vm.popup1 = {
            opened: false
        };

        vm.popup2 = {
            opened: false
        };
        vm.popup3 = {
            opened: false
        };

        vm.popup4 = {
            opened: false
        };


        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        vm.events = [{
            date: tomorrow,
            status: 'full'
        }, {
            date: afterTomorrow,
            status: 'partially'
        }];

        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                for (var i = 0; i < vm.events.length; i++) {
                    var currentDay = new Date(vm.events[i].date).setHours(0, 0, 0, 0);

                    if (dayToCheck === currentDay) {
                        return vm.events[i].status;
                    }
                }
            }
            return '';
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.employeeChart')
        .controller('EmployeeChartCtrl', EmployeeChartCtrl);

    function EmployeeChartCtrl($http, $rootScope,$scope, lodash, dialogs, EmployeeChartService, DepartmentServices, DesignationService) {
        var vm = this;
        vm.noOfRows = "10";
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        $rootScope.isLogin = false;
        vm.convertImage = convertImage;
       
        Init();
        function convertImage()
        {           
            var chartView = document.getElementById('chartView');
            var imageView = document.getElementById('imageView');
            html2canvas(chartView, {
                onrendered: function(canvas) {
                    imageView.appendChild(canvas);
                }
              });
        }
          function Init() {

            EmployeeChartService.getEmployeesChart().then(function (res) {
                if (res.status === 200) {
                    //vm.chart = JSON.parse(res.data);
                    vm.chart = {
                        type: "OrgChart",
                        data: JSON.parse(res.data),
                        options: {allowHtml:true,allowCollapse:true}
                    };

                    vm.isLoading = false;

                }
                else {
                    dialogs.error('error', 'Load Failed! Try Again', "Area");
                }
            },
                function (err) {
                    dialogs.error('error', 'Error! Try Again', "Area");
                });
        }

         // Create the chart.
         var chart = new google.visualization.OrgChart(document.getElementById('chartView'));
               
         // selection
         google.visualization.events.addListener(chart, 'select', function () {
           // get the row of the node clicked
           var selection = chart.getSelection();
           var row = selection[0].row;
           // get a list of all collapsed nodes
           var collapsed = chart.getCollapsedNodes();
           // if the node is collapsed, we want to expand it
           // if it is not collapsed, we want to collapse it
           var collapse = (collapsed.indexOf(row) == -1);
           chart.collapse(row, collapse);
           // clear the selection so the next click will work properly
           chart.setSelection();
                 });
              

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.exercise')
        .controller('ExerciseCtrl', ExerciseCtrl);

    /** @ngInject */
    function ExerciseCtrl($http, $rootScope, lodash, dialogs,ClassRoomService, ChapterService, SectionService, SubjectService, UnitService,ExerciseService,AuthenticationService) {
        var vm = this;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.editExecise = editExecise;
        vm.removeExercise = removeExercise;
        vm.SaveExercise = SaveExercise;
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
        vm.getUnitByChapters = getUnitByChapters;
        vm.exercise = {};
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;            

            ExerciseService.GetAllExercise().then(function(res) {
                if (res.status === 200) {
                    vm.ExerciseList = res.data;
                    ClassRoomService.GetAllClassRoom().then(function (res) {
                        if (res.status === 200) {
                            vm.ClassRoomList = res.data;

                    // console.log("vm.ClassRoomList"+JSON.stringify(vm.ClassRoomList))
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Exercise");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Exercise");
            });
        } else {
            $rootScope.showToaster('error', 'Load Failed! Try Again', "Exercise");
        }
    }, function (err) {
        $rootScope.showToaster('error', 'Error! Try Again', "Exercise");
    });
}



        


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.exercise.selectedSection = null;
                vm.SectionList = [];
                vm.exercise.selectedSubject = null;
                vm.SubjectList = [];
                vm.exercise.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.exercise.selectedSection = null;
                vm.SectionList = [];
                vm.exercise.selectedSubject = null;
                vm.SubjectList = [];
                vm.exercise.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.exercise.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.exercise.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.exercise.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }

                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.exercise.selectedChapter = null;
                vm.ChapterList = [];
            }
        }
        function getUnitByChapters(ClassId, SectionId, SubjectId,ChapterId, callBack) {
            if (ChapterId) {
                vm.exercise.selectedUnit = null;
                vm.UnitList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId,
                    ChapterId: ChapterId
                }
                UnitService.GetAllUnitByChapter(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.UnitList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.exercise.selectedChapter = null;
                vm.UnitList = [];
            }
        }



        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.exercise = {};
        }

        function resetForm() {
            vm.ExerciseForm.$setUntouched();
        }

        function editExecise(exercise) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.exercise = angular.copy(exercise);

            
            for (var i in vm.ClassRoomList) {
            // vm.exercise = angular.copy(exercise);
                if (vm.ClassRoomList[i].ClassId === exercise.ClassId) {
                    vm.exercise.selectedClassRoom = vm.ClassRoomList[i]
                }
            }


            getSectionByClass(exercise.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === exercise.SectionId) {
                        vm.exercise.selectedSection = vm.SectionList[i];
                    }
                }
            });

            getSubjectBySection(exercise.ClassId, exercise.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === exercise.SubjectId) {
                        vm.exercise.selectedSubject = vm.SubjectList[i]
                    }
                }
            });


            getChapterBySubject(exercise.ClassId, exercise.SectionId, exercise.SubjectId, function () {
                for (var i in vm.ChapterList) {
                    if (vm.ChapterList[i].ChapterId === exercise.ChapterId) {
                        vm.exercise.selectedChapter = vm.ChapterList[i]
                    }
                }
            });
            getUnitByChapters(exercise.ClassId, exercise.SectionId, exercise.SubjectId,exercise.ChapterId, function () {
                for (var i in vm.UnitList) {
                    if (vm.UnitList[i].UnitId === exercise.UnitId) {
                        vm.exercise.selectedUnit = vm.UnitList[i]
                    }
                }
            });

           

        }

 

        function removeExercise(exercise) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function() {
                ExerciseService.removeExercise(exercise.ExerciseId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Exercise Successfully', "Exercise");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Exercise", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Delete Exercise. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function() {

            })
        }

        function SaveExercise() {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                var exercise = { 
                    ClassId:vm.exercise.selectedClassRoom.ClassId,
                    SectionId:vm.exercise.selectedSection.SectionId,
                    SubjectId:vm.exercise.selectedSubject.SubjectId,
                    ChapterId:vm.exercise.selectedChapter.ChapterId,
                    UnitId: vm.exercise.selectedUnit.UnitId,
                    ExerciseName:vm.exercise.ExerciseName,
                    CreatedBy: logggedUser.UserId
                }
                ExerciseService.SaveExercise(exercise).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Exercise Name");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Exercise Name");
                        vm.isFormOpen = true;
                    }
                  
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            } else {
                var exercise = {
                    ExerciseId: vm.exercise.ExerciseId,
                    ClassId:vm.exercise.selectedClassRoom.ClassId,
                    SectionId:vm.exercise.selectedSection.SectionId,
                    SubjectId:vm.exercise.selectedSubject.SubjectId,
                    ChapterId:vm.exercise.selectedChapter.ChapterId,
                    UnitId: vm.exercise.selectedUnit.UnitId,
                    ExerciseName:vm.exercise.ExerciseName,
                    IsActive:vm.exercise.IsActive,
                    ModifiedBy:logggedUser.UserId
                }
                ExerciseService.updateExercise(exercise).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "State Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "State Master");
                        vm.isFormOpen = true;
                    }                   
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.institution')
        .controller('institutionCtrl', institutionCtrl);

    /** @ngInject */
    function institutionCtrl($rootScope, lodash, dialogs, $http, DepartmentServices, CompanyService, AuthenticationService) {
        var vm = this;
        // Pagination code
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.DesignationList = [];
        vm.desig = {};
        var loggedUser = AuthenticationService.getLoggedUserDetails();
        $rootScope.isLogin = false;
        // Methods

        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.getAllEducationalSyllabus = getAllEducationalSyllabus;
        vm.getAllMediumInstruction = getAllMediumInstruction;
        vm.getAllEducationalSystem = getAllEducationalSystem;
        vm.SaveInstitution = SaveInstitution;
      //  var type = $stateParams.type;

        // if (type == "Ins") {
        //     $rootScope.isLogin = true;
        // } else {
        //     $rootScope.isLogin = false;
        // }



        Init();
        //////////////////

        function Init() {

            
            CompanyService.getAllInstitutionIns(InstitutionInsId).then(function (res) {
                if (res.status === 200) {
                    vm.InstitutionInsList = res.data;
                    //getAllEducationalSyllabus();

                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });


            // CompanyService.getAllEduInstitutionName().then(function (res) {
            //     if (res.status === 200) {
            //         vm.InstitutionNameList = res.data;
            //         // getAllEducationalSyllabus();


            //         vm.isLoading = false;
            //     } else {
            //         $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
            //     }
            // }, function (err) {
            //     $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            // });


            CompanyService.getAllInstitutionFund().then(function (res) {
                if (res.status === 200) {
                    vm.InstitutionFundList = res.data;
                    getAllEducationalSyllabus();

                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });

            
            CompanyService.getallTypeofEducational().then(function (res) {
                if (res.status === 200) {
                    vm.EducationList = res.data;
                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });

            
        }


        function getAllEducationalSyllabus() {


            CompanyService.getAllEducationalSyllabus().then(function (res) {
                if (res.status === 200) {
                    vm.EduSyllabusList = res.data;
                    getAllMediumInstruction();


                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });
        }


        function getAllMediumInstruction() {


            CompanyService.getAllMediumInstruction().then(function (res) {
                if (res.status === 200) {
                    vm.MediumList = res.data;
                    getAllEducationalSystem();


                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });
        }
        function getAllEducationalSystem() {
            CompanyService.getAllEducationalSystem().then(function (res) {
                if (res.status === 200) {
                    vm.EducationsystemList = res.data;
                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Employee");
            });
        }

        function SaveInstitution(InstitutionIns) {

            // console.log(JSON.stringify(InstitutionIns));

            // console.log(JSON.stringify(vm.EduSyllabusList));
               var logggedUser = AuthenticationService.getLoggedUserDetails();
                InstitutionIns.InsFundedId = vm.InstitutionIns.selectedInstitutionFund.InsFundedId,
                InstitutionIns.EduSyllabusId = vm.InstitutionIns.selectedEducationalSyllabus.EduSyllabusId,
                InstitutionIns.EduSystemId = vm.InstitutionIns.selectedMedium.MediumId,
                InstitutionIns.MediumId = vm.InstitutionIns.selectedEdusystem.EduSystemId,
                InstitutionIns.EducationId  = vm.InstitutionIns.selectedInstitutionname.EducationId
                

            if (!vm.isEditing) {
                InstitutionIns.CreatedBy = logggedUser.UserId;
                CompanyService.AddInstitutionInsitiation(InstitutionIns).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Department Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Department Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {
                dept.ModifiedBy = logggedUser.UserId;
                DepartmentServices.EditDepartment(dept).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Department Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Department Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
        }


        function Create() {
            vm.code = true;
            vm.isFormOpen = true;


        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            resetForm();
            // vm.InstitutionIns.selectedInstitutionFund = null;
            // vm.InstitutionIns.selectedEducationalSyllabus = null;
            // vm.InstitutionIns.selectedMedium = null;
            // vm.InstitutionIns.selectedEdusystem = null;

        }

        function resetForm() {
            vm.InstitutionInsForm.$setUntouched();
        }
    }
})();
// import { LOADIPHLPAPI } from "dns";

(function () {
    'use strict';

    angular
        .module('KPMES.pages.questionandAnswer')
        .controller('QuestionCtrl', QuestionCtrl);

    /** @ngInject */
    function QuestionCtrl($http, $rootScope, lodash, dialogs, ClassRoomService, ChapterService, SectionService, SubjectService, UnitService, QuestionService, AuthenticationService) {
        var vm = this;
        // Pagination code
        vm.rowCountOptions = [{ "value": 2 }, { "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.editQuestion = editQuestion;
        vm.removeQuestion = removeQuestion;
        vm.SaveQuestion = SaveQuestion;
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
        vm.getUnitByChapters = getUnitByChapters;
        vm.GetAllExerciseByUnit = GetAllExerciseByUnit;
        vm.SavetheOptions = SavetheOptions;
        vm.question = {};
        vm.QuestionTypesList = [];
        var logggedUser = AuthenticationService.getLoggedUserDetails();



        Init()
        function Init() {

            vm.OptionsList = [];
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;

            QuestionService.GetAllQuestionandAnswer().then(function (res) {
                if (res.status === 200) {
                    vm.QuestionList = res.data;

                    //LoadDropDownValues('Class');
                   
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Exercise");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Exercise");
            });


            ClassRoomService.GetAllClassRoom().then(function (res1) {
                if (res1.status === 200) {
                    vm.ClassRoomList = res1.data;
                    QuestionService.GetAllQuestionTypes().then(function (res2) {
                        if (res2.status === 200) {
                            vm.QuestionTypesList = res2.data;

                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Exercise");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Exercise");
                    });

                    // console.log("vm.ClassRoomList"+JSON.stringify(vm.ClassRoomList))
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Exercise");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Exercise");
            });

        }


        // function LoadDropDownValues(LoadFor) {
        //     if (LoadFor == 'Class') {
        //         vm.ClassList = [];

        //         var inputdata = {
        //             "SelectFor": LoadFor
        //         }


        //     }
        //     else if (LoadFor == 'Section') {
        //         var inputdata = {
        //             "ClassId":vm.question.selectedClassRoom.Id,
        //             "SelectFor": LoadFor
        //         }
        //     }
        // }

        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.question.selectedSection = null;
                vm.SectionList = [];
                vm.question.selectedSubject = null;
                vm.SubjectList = [];
                vm.question.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.question.selectedSection = null;
                vm.SectionList = [];
                vm.question.selectedSubject = null;
                vm.SubjectList = [];
                vm.question.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.question.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.question.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.question.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }

                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.question.selectedChapter = null;
                vm.ChapterList = [];
            }
        }
        function getUnitByChapters(ClassId, SectionId, SubjectId, ChapterId, callBack) {
            if (ChapterId) {
                vm.question.selectedUnit = null;
                vm.UnitList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId,
                    ChapterId: ChapterId
                }
                UnitService.GetAllUnitByChapter(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.UnitList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.question.selectedChapter = null;
                vm.UnitList = [];
            }
        }

        function GetAllExerciseByUnit(ChapterId, callBack) {
            if (ChapterId) {
                vm.question.selectedExercise = null;
                vm.ExerciseList = [];

                var obj = {
                    // ClassId: ClassId,
                    // SectionId: SectionId,
                    // SubjectId: SubjectId,
                    ChapterId: ChapterId,
                    // UnitId: UnitId
                }

                QuestionService.GetAllExerciseByUnit(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ExerciseList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.question.selectedUnit = null;
                vm.ExerciseList = [];
            }
        }



        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.question = {};
        }

        function resetForm() {
            vm.QuestionForm.$setUntouched();
        }

        function editQuestion(question) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.question = angular.copy(question);
            if (vm.question.Options != "")
                vm.OptionsList = JSON.parse(vm.question.Options);
            vm.question.Options = null;


            for (var i in vm.ClassRoomList) {

                if (vm.ClassRoomList[i].ClassId === question.ClassId) {
                    vm.question.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            for (var i in vm.QuestionTypesList) {
                if (vm.QuestionTypesList[i].QuestionTypeId === question.QuestionTypeId) {
                    vm.question.selectedQuestionTypes = vm.QuestionTypesList[i]
                }
            }

            for (var i in vm.OptionsList) {
                if (vm.OptionsList[i].Value === question.CorrectAnswer) {
                    vm.question.selectedCorrectOption = vm.OptionsList[i]
                }
            }


            getSectionByClass(question.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === question.SectionId) {
                        vm.question.selectedSection = vm.SectionList[i];
                    }
                }
            });

            getSubjectBySection(question.ClassId, question.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === question.SubjectId) {
                        vm.question.selectedSubject = vm.SubjectList[i]
                    }
                }
            });


            getChapterBySubject(question.ClassId, question.SectionId, question.SubjectId, function () {
                for (var i in vm.ChapterList) {
                    if (vm.ChapterList[i].ChapterId === question.ChapterId) {
                        vm.question.selectedChapter = vm.ChapterList[i]
                    }
                }
            });
            getUnitByChapters(question.ClassId, question.SectionId, question.SubjectId, question.ChapterId, function () {
                for (var i in vm.UnitList) {
                    if (vm.UnitList[i].UnitId === question.UnitId) {
                        vm.question.selectedUnit = vm.UnitList[i]
                    }
                }
            });

            GetAllExerciseByUnit(question.ClassId, question.SectionId, question.SubjectId, question.ChapterId, question.UnitId, function () {
                for (var i in vm.ExerciseList) {
                    if (vm.ExerciseList[i].ExerciseId === question.ExerciseId) {
                        vm.question.selectedExercise = vm.ExerciseList[i]
                    }
                }
            });

        }



        function removeQuestion(question) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function () {
                QuestionService.removeQuestion(question.QuestionId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Exercise Successfully', "Exercise");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Exercise", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Exercise. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }



        function SavetheOptions() {
            if (vm.question.Options != undefined || vm.question.Options != null || vm.question.Options != '') {
                var tmp = { 'Value': vm.question.Options }

                vm.OptionsList.push(tmp);

                // vm.OptionsList = angular.toJson(tmp);
                vm.question.Options = null;
            }


        }


        function SaveQuestion() {
debugger
            var iOptions = null;
            var iCorrectAnswer = null;

            if (vm.question.selectedQuestionTypes.QuestionTypes == 'CheckBox' || vm.question.selectedQuestionTypes.QuestionTypes == 'RadioButton') {
                iOptions = JSON.stringify(vm.OptionsList);
                iCorrectAnswer = vm.question.selectedCorrectOption.Value;
            }
            else {
                var val = [{ 'Value': vm.question.CorrectAnswer }]
                iOptions = JSON.stringify(val);
                iCorrectAnswer = vm.question.CorrectAnswer;
            }



            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                debugger
                var question = {
                    // ClassId: vm.question.selectedClassRoom.ClassId,
                    // SectionId: vm.question.selectedSection.SectionId,
                    // SubjectId: vm.question.selectedSubject.SubjectId,
                    // ChapterId: vm.question.selectedChapter.ChapterId,
                    // UnitId: vm.question.selectedUnit.UnitId,
                    ExerciseId: vm.question.selectedExercise.ExerciseId,
                    Questions: vm.question.Questions,
                    Options: iOptions,
                    QuestionTypeId: vm.question.selectedQuestionTypes.QuestionTypeId,
                    CorrectAnswer: iCorrectAnswer,
                    // QuestionNumber: vm.question.QuestionNumber,
                    CreatedBy: logggedUser.UserId
                }
                
                QuestionService.SaveQuestion(question).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Exercise Name");
                        Init();
                        vm.isFormOpen = false;
                        cancel();

                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Exercise Name");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {

                var iOptions = null;
                var iCorrectAnswer = null;

                if (vm.question.selectedQuestionTypes.QuestionTypes == 'CheckBox' || vm.question.selectedQuestionTypes.QuestionTypes == 'RadioButton') {
                    iOptions = JSON.stringify(vm.OptionsList);
                    iCorrectAnswer = vm.question.selectedCorrectOption.Value;
                }
                else {
                    iCorrectAnswer = vm.question.CorrectAnswer;
                }
                var question = {
                    QuestionId: vm.question.QuestionId,
                    ClassId: vm.question.selectedClassRoom.ClassId,
                    SectionId: vm.question.selectedSection.SectionId,
                    SubjectId: vm.question.selectedSubject.SubjectId,
                    ChapterId: vm.question.selectedChapter.ChapterId,
                    UnitId: vm.question.selectedUnit.UnitId,
                    ExerciseId: vm.question.selectedExercise.ExerciseId,
                    Questions: vm.question.Questions,
                    Options: iOptions,
                    QuestionTypeId: vm.question.selectedQuestionTypes.QuestionTypeId,
                    CorrectAnswer: iCorrectAnswer,
                    QuestionNumber: vm.question.QuestionNumber,
                    IsActive: vm.question.IsActive,
                    ModifiedBy: logggedUser.UserId
                }
                QuestionService.updateQuestionandAnswer(question).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "State Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "State Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.role')
        .controller('RoleCtrl', RoleCtrl);

    /** @ngInject */
    function RoleCtrl($http, $rootScope, lodash, dialogs, RoleService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code

        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;

        vm.RoleList = [];
        vm.role = {};
        $rootScope.isLogin = false;
        //METHODS
        vm.changeActiveRole = changeActiveRole;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editRole = editRole;
        vm.removeRole = removeRole;
        vm.SaveRole = SaveRole;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        Init();

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            RoleService.getAllRole().then(function (res) {
                if (res.status === 200) {
                    vm.RoleList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Role");
            });
        }

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.role.CreatedBy = "1";
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            resetForm();
            vm.role = {};
        }
        function resetForm() {
            vm.roleForm.$setUntouched();
        }

        function editRole(role) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.role = angular.copy(role);
            for (var c in vm.OrganizationList) {
                if (vm.OrganizationList[c].OrganizationLevelId === role.OrganizationLevelId) {
                    vm.role.selectedOrganization = vm.OrganizationList[c];
                }
            }

        }
        function removeRole(role) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });

            confirm.result.then(function () {
                RoleService.removeRole(role.RoleId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete Role Successfully', "Role");
                        Init();
                    } else {
                        dialogs.error('error', "Can't Delete ROle", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    dialogs.error('error', "Can't Delete Role. <br> If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        function SaveRole(role) {
            debugger
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            //role.OrganizationLevelId = vm.role.selectedOrganization.OrganizationLevelId;
            if (!vm.isEditing) {
                role.CreatedBy = logggedUser.UserId;
                RoleService.AddRole(role).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Role Master");
                        cancel();
                        Init();
                        vm.isFormOpen = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Role Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            } else {
                role.ModifiedBy = logggedUser.UserId;
                RoleService.EditRole(role).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Role Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Role Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again", { animation: true, size: 'sm' });
                });

            }
        }

        function changeActiveRole(role) {
            var msg = 'Are sure you want to ' + ((role.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((role.IsActive) ? 'Deactive' : 'Active') + 'Role Successfully.'
            var confirm = dialogs.confirm('Confirm',
                msg, { animation: true, size: 'sm' });

            confirm.result.then(function () {
                RoleService.changeActiveRole(role.RoleId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Active Role Successfully', "Role");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Active Role", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Active Role.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.services')
        .service('AuthenticationService', AuthenticationService);

    AuthenticationService.inject = ['Base64', '$http', '$window', '$rootScope', 'dialogs'];

    function AuthenticationService(Base64, $http, $window, $rootScope, dialogs) {
        var isAuth = false;
        var token = "";
        var userId = 0;
        var userName = "";
        var loggedUser = {};

        this.login = login;
        this.logout = logout;
        this.getLoggedUserDetails = getLoggedUserDetails;
        this.setLoggedUserDetails = setLoggedUserDetails;

        Init();
        ////////////////
        function Init() {
            $rootScope.isAuth = isAuth = $window.sessionStorage.getItem('isAuth') || $window.localStorage.getItem('isAuth');
            $rootScope.token = token = $window.sessionStorage.getItem('token') || $window.localStorage.getItem('token');
            $rootScope.userId = userId = $window.sessionStorage.getItem('userId') || $window.localStorage.getItem('userId');
            loggedUser = JSON.parse($window.sessionStorage.getItem('loggedUserDetails')) || JSON.parse($window.localStorage.getItem('loggedUserDetails'));
            $rootScope.userName = userName = (loggedUser) ? loggedUser.FirstName : "";
            if (loggedUser) {
                $rootScope.selectedCompanyName = (loggedUser.SelectedCompany !== null && loggedUser.SelectedCompany !== undefined) ?
                    loggedUser.SelectedCompany.CompanyName : "";
            }
        }

        function login(username, password, callback) {
            var authdata = Base64.encode(username + ':' + password);

            $http.defaults.headers.common.Authorization = 'Basic ' + authdata;
           // debugger;
            $http.post($rootScope.endPoint + 'login')
                .then(function(response) {
                   // debugger;
                    $rootScope.token = token = response.headers("Token");
                    $rootScope.userId = userId = response.headers("UserId");
                    $rootScope.isAuth = isAuth = true;

                    $window.sessionStorage.setItem("token", token);
                    $window.sessionStorage.setItem("isAuth", isAuth);
                    $window.sessionStorage.setItem("userId", userId);

                    $window.localStorage.setItem("token", token);
                    $window.localStorage.setItem("isAuth", isAuth);
                    $window.localStorage.setItem("userId", userId);
                    callback(response);
                }, function(err) {
                    callback(err);
                })
        }

        function logout() {
            debugger;
            $rootScope.token = token = "";
            $rootScope.isAuth = isAuth = false;
            $rootScope.userId = userId = 0;

            $window.sessionStorage.clear();
            $window.localStorage.clear();
        }

        function getLoggedUserDetails() {
            return loggedUser;
        }

        function setLoggedUserDetails(userDetails) {
            loggedUser = userDetails;
            $rootScope.userName = loggedUser.FirstName;

            if (loggedUser.SelectedCompany !== null && loggedUser.SelectedCompany !== undefined)
                $rootScope.selectedCompanyName = loggedUser.SelectedCompany.CompanyName;
            else
                $rootScope.selectedCompanyName = null;

            $window.sessionStorage.setItem("loggedUserDetails", JSON.stringify(userDetails));
            $window.localStorage.setItem("loggedUserDetails", JSON.stringify(userDetails));
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.services')
        .factory('Base64', function() {
            /* jshint ignore:start */

            var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

            return {
                encode: function(input) {
                    var output = "";
                    var chr1, chr2, chr3 = "";
                    var enc1, enc2, enc3, enc4 = "";
                    var i = 0;

                    do {
                        chr1 = input.charCodeAt(i++);
                        chr2 = input.charCodeAt(i++);
                        chr3 = input.charCodeAt(i++);

                        enc1 = chr1 >> 2;
                        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                        enc4 = chr3 & 63;

                        if (isNaN(chr2)) {
                            enc3 = enc4 = 64;
                        } else if (isNaN(chr3)) {
                            enc4 = 64;
                        }

                        output = output +
                            keyStr.charAt(enc1) +
                            keyStr.charAt(enc2) +
                            keyStr.charAt(enc3) +
                            keyStr.charAt(enc4);
                        chr1 = chr2 = chr3 = "";
                        enc1 = enc2 = enc3 = enc4 = "";
                    } while (i < input.length);

                    return output;
                },

                decode: function(input) {
                    var output = "";
                    var chr1, chr2, chr3 = "";
                    var enc1, enc2, enc3, enc4 = "";
                    var i = 0;

                    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
                    var base64test = /[^A-Za-z0-9\+\/\=]/g;
                    if (base64test.exec(input)) {
                        window.alert("There were invalid base64 characters in the input text.\n" +
                            "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                            "Expect errors in decoding.");
                    }
                    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

                    do {
                        enc1 = keyStr.indexOf(input.charAt(i++));
                        enc2 = keyStr.indexOf(input.charAt(i++));
                        enc3 = keyStr.indexOf(input.charAt(i++));
                        enc4 = keyStr.indexOf(input.charAt(i++));

                        chr1 = (enc1 << 2) | (enc2 >> 4);
                        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                        chr3 = ((enc3 & 3) << 6) | enc4;

                        output = output + String.fromCharCode(chr1);

                        if (enc3 != 64) {
                            output = output + String.fromCharCode(chr2);
                        }
                        if (enc4 != 64) {
                            output = output + String.fromCharCode(chr3);
                        }

                        chr1 = chr2 = chr3 = "";
                        enc1 = enc2 = enc3 = enc4 = "";

                    } while (i < input.length);

                    return output;
                }
            };
        })
})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.company')
        .service('CompanyService', CompanyService);

    CompanyService.$inject = ['$http', '$rootScope'];

    function CompanyService($http, $rootScope) {
        this.AddCompany = AddCompany;
        this.EditCompany = EditCompany;
        this.removeCompany = removeCompany;
        this.getAllCompany = getAllCompany;
        this.getActiveCompany = getActiveCompany;
        this.getAllOwnerShip = getAllOwnerShip;
        this.getAllBusiness = getAllBusiness;
        this.changeActiveCompany = changeActiveCompany;
        this.getSubCompByCompId = getSubCompByCompId;
        this.updateLogo = updateLogo;
        this.getCompanyByOrgId=getCompanyByOrgId;
        this.getallTypeofEducational = getallTypeofEducational;
        this.getAllInstitutionFund = getAllInstitutionFund;
        this.getAllEducationalSyllabus = getAllEducationalSyllabus;
        this.getAllMediumInstruction = getAllMediumInstruction;
        this.getAllEducationalSystem = getAllEducationalSystem;
        this.AddInstitutionInsitiation = AddInstitutionInsitiation;
        this.getAllEduInstitutionName = getAllEduInstitutionName;
       // this.GetAllLanguages = GetAllLanguages;
        this.GetAllRefVideos = GetAllRefVideos;
        this.getAllInstitutionIns = getAllInstitutionIns; 

        this.Generateotp = Generateotp;
        this.OTPVerify = OTPVerify;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function updateLogo(data) {
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Company/uploadLogo/', data, config);
        }

        function getAllCompany(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Company/AllCompany', config);
        }

        function Generateotp(Mobileno){
            return $http.get($rootScope.endPoint + 'Company/generatesms/'+Mobileno,  config);
        }
        function OTPVerify(OtpValue, MobileNo)
        {

           // console.log($rootScope.endPoint + 'Company/VerifyOTP/'+OtpValue+ '/'+MobileNo);
 

            return $http.get($rootScope.endPoint + 'Company/VerifyOTP/'+OtpValue+ '/'+MobileNo,  config); 
        }
       

        function getallTypeofEducational() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllTypeofEducation', config);
        }

        function getAllInstitutionFund() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllInstitutionFund', config);
        }
        function getAllEducationalSyllabus() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllEducationalSyllabus', config);
        }
        function getAllMediumInstruction() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllMediumInstruction', config);
        }
        function getAllEducationalSystem() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllEducationalSystem', config);
        }
        // function GetAllLanguages() {
        //     return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllLanguages', config);
        // }
        function GetAllRefVideos() {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllRefVideos', config);
        }
    


        // function getAllEduInstitutionName() {
        //     return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllEduInstitutionName', config);
        // }

        function getAllEduInstitutionName(CompanyId) {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/GetAllEducationalSystem/' + CompanyId, config);
        }
        
        function getAllInstitutionIns(InstitutionInsId) {
            return $http.get($rootScope.endPoint + 'InstitutionRegistration/getAllInstitutionIns/' + InstitutionInsId, config);
        }


        function getAllOwnerShip(objOwner) {
            return $http.get($rootScope.endPoint + 'Company/AllOwnerShip', config);
        }

        function getAllBusiness(objBusiness) {
            return $http.get($rootScope.endPoint + 'Company/AllNatureOfBusiness', config);
        }

        function getActiveCompany() {
            return $http.get($rootScope.endPoint + 'Company/GetActiveCompanyById', config);
        }

        function getCompanyByOrgId(id) {
            return $http.get($rootScope.endPoint + 'Company/GetByOrgId/'+ id, config);
        }


        function AddCompany(company) {
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Company/Create', company, config);
        }

        function AddInstitutionInsitiation(InstitutionIns) {
         
            return $http.post($rootScope.endPoint + 'InstitutionRegistration/Create', InstitutionIns, config);
        }

        function EditCompany(company) {
            return $http.put($rootScope.endPoint + 'Company/Modify', company,{}, config);
        }

        function removeCompany(id) {
            return $http.delete($rootScope.endPoint + 'Company/Delete/' + id, config);
        }

        function changeActiveCompany(id) {
            return $http.post($rootScope.endPoint + 'Company/ChangeActive/' + id, {}, config);
        }

        function getSubCompByCompId(companyId) {
            // config.headers["Token"] = $rootScope.token;

            // return $http.get($rootScope.endPoint + 'Company/GetSubCompByCompId/' + companyId, config);
            return $http.get($rootScope.endPoint + 'Company/GetSubCompByCompId/' + companyId);
        }
    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.department')
        .service('DepartmentServices', DepartmentServices);

    DepartmentServices.$inject = ['$http', '$rootScope'];

    function DepartmentServices($http, $rootScope) {
        this.AddDepartment = AddDepartment;
        this.EditDepartment = EditDepartment;
        this.removeDepartment = removeDepartment;
        this.getAllDepartments = getAllDepartments;
        this.getDepartmentById = getDepartmentById;
        this.getCompanyById = getCompanyById;
        this.getActiveDepartments = getActiveDepartments;
        this.changeActiveDepartment = changeActiveDepartment;
        this.GetDepartmentByCompanyId = GetDepartmentByCompanyId;
        this.getDepOfParentCompanies = getDepOfParentCompanies;
        this.CheckCode = CheckCode;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllDepartments(CompanyId) {
            return $http.get($rootScope.endPoint + 'Department/AllDepartments/' + CompanyId, config);
        }

        function getActiveDepartments(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Department/GetActiveDepartments', config);
        }

        function getCompanyById(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Company/GetById', config);
        }

        function getDepartmentById(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Department/GetById', config);
        }

        function CheckCode(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Department/CheckCode', config);
        }

        function AddDepartment(Department) {
            return $http.post($rootScope.endPoint + 'Department/Create', Department, {}, config);
        }

        function EditDepartment(Department) {
            return $http.put($rootScope.endPoint + 'Department/Modify', Department, config);
        }

        function removeDepartment(id) {
            return $http.delete($rootScope.endPoint + 'Department/Delete/' + id, config);
        }

        function GetDepartmentByCompanyId(id) {
            return $http.get($rootScope.endPoint + 'Department/GetDepartmentByCompanyId/' + id, config);
        }

        function changeActiveDepartment(id) {
            return $http.post($rootScope.endPoint + 'Department/ChangeActive/' + id, {}, config);
        }

        function getDepOfParentCompanies(obj) {
            return $http.post($rootScope.endPoint + 'Department/GetDepOfParentCompanies', obj, {}, config);
        }
    }

})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.designation')
        .service('DesignationService', DesignationService);

    DesignationService.$inject = ['$http', '$rootScope'];

    function DesignationService($http, $rootScope) {
        //this.GetDesinationbyDepartmentid = GetDesinationbyDepartmentid;
        this.AddDesignation = AddDesignation;
        this.EditDesignation = EditDesignation;
        this.removeDesignation = removeDesignation;
        this.getAllDesignation = getAllDesignation;        
        // this.getReportingDesignation = getReportingDesignation;
        //  this.getAllDepartment = getAllDepartment;
        // this.getAllRoleById = getAllRoleById;
        this.changeActiveDesignation = changeActiveDesignation;
        this.GetDesigByDepId = GetDesigByDepId;
        this.getRepToDesig = getRepToDesig;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        // function getReportingDesignation(DesignationId) {
        //     return $http.get($rootScope.endPoint + 'Designation/GetDesigByDepId/' + DesignationId);
        // }

        // function GetDesinationbyDepartmentid(departmentid) {
        //     return $http.get($rootScope.endPoint + 'Designation/GetDesignationbyId/' + departmentid);
        // }

        function GetDesigByDepId(id) {
            return $http.get($rootScope.endPoint + 'Designation/GetDesigByDepId/' + id, config);
        }

        function getAllDesignation(companyId) {
            return $http.get($rootScope.endPoint + 'Designation/AllDesignations/' + companyId, config);
        }

        function getRepToDesig(depId) {
            return $http.get($rootScope.endPoint + 'Designation/getRepToDesig/' + depId, config);
        }

        function AddDesignation(Designation) {
            return $http.post($rootScope.endPoint + 'Designation/Create', Designation, config);
        }

        function EditDesignation(Designation) {
            return $http.put($rootScope.endPoint + 'Designation/Modify', Designation, config);
        }

        function removeDesignation(id) {
            return $http.delete($rootScope.endPoint + 'Designation/Delete/' + id, config);
        }

        function changeActiveDesignation(id) {
            return $http.post($rootScope.endPoint + 'Designation/ChangeActive/' + id, {}, config);
        }
    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.employee')
        .service('EmployeeService', EmployeeService);

    EmployeeService.$inject = ['$http', '$rootScope'];

    function EmployeeService($http, $rootScope) {
        this.AddEmployee = AddEmployee;
        this.EditEmployee = EditEmployee;
        this.RemoveEmployee = RemoveEmployee;
        this.changeActiveEmployee = changeActiveEmployee;
        this.getAllEmployees = getAllEmployees;
        this.getAllCompanyEmployees = getAllCompanyEmployees;
        this.UploadFiles = UploadFiles;
        this.updateProfilePic = updateProfilePic;
        this.getAllEmpAcademyInfo = getAllEmpAcademyInfo;
        this.addNewEmpAcademicInfo = addNewEmpAcademicInfo;
        this.removeEmpAcademyInfo = removeEmpAcademyInfo;
        this.getAllEmpExpInfo = getAllEmpExpInfo;
        this.getAllAreaofExpertiseInfo = getAllAreaofExpertiseInfo;
        this.getAllLanguageListInfo = getAllLanguageListInfo;
        this.addNewEmpExperience = addNewEmpExperience;
        this.removeEmpExpInfo = removeEmpExpInfo;
        this.addNewEmpBankInfo = addNewEmpBankInfo;
        this.removeEmpBankInfo = removeEmpBankInfo;
        this.addNewStaffAreasofExpertise = addNewStaffAreasofExpertise;
        this.addNewStaffLanguageInfo = addNewStaffLanguageInfo;
        this.removeNewStaffAreasofExpertise = removeNewStaffAreasofExpertise;
        this.GetEmpwithUserAc=GetEmpwithUserAc;
        this.addNewEmpPersonalInfo = addNewEmpPersonalInfo;
        this.getAllEmployeeList = getAllEmployeeList;

        //////////////////

        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function updateProfilePic(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Employee/uploadProfilePic/', data, config);
        }

        function getAllEmployees(CompanyId) {
            return $http.get($rootScope.endPoint + 'Employee/AllEmployees/' + CompanyId, config);
        }

        function getAllEmployeeList(CompanyId) {
            debugger
            return $http.get($rootScope.endPoint + 'Employee/GetAllEmployee/' + CompanyId, config);
        }

        function getAllCompanyEmployees(DesignationId) {
            return $http.get($rootScope.endPoint + 'Employee/AllCompanyEmployees/' + DesignationId, config);
        }

        function AddEmployee(emp) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Employee/createDoc', emp, config);
        }

        function EditEmployee(employee) {
            return $http.put($rootScope.endPoint + 'Employee/Modify', employee, config);
        }

        function GetEmpwithUserAc(id) {
            return $http.get($rootScope.endPoint + 'Employee/GetEmpWithUserAcc/'+id, config);
        }
        function RemoveEmployee(EmployeeId) {
            return $http.delete($rootScope.endPoint + 'Employee/Delete/' + EmployeeId, config);
        }

        function changeActiveEmployee(EmployeeId) {
            return $http.post($rootScope.endPoint + 'Employee/ChangeActive/' + EmployeeId, {}, config);
        }

        function UploadFiles($scope, $http, $rootScope, data) {
            var config = {
                headers: {
                    'Content-Type': undefined
                }
            };
            return $http.post($rootScope.endpoint + 'api/variableupload/upload/', data, config);
        }

        function getEmployeesChart(CompanyId) {
            return $http.get($rootScope.endPoint + 'EmployeeChart/View/' + CompanyId, config);
        }

        function getAllEmpAcademyInfo(empId) {
            return $http.get($rootScope.endPoint + 'EmployeeAcademy/getAllEmpAcademicInfo/' + empId, config);
        }

        function addNewEmpAcademicInfo(data) {
            var config = {
                headers: {
                    'Content-Type': undefined
                }
            };
            return $http.post($rootScope.endPoint + 'EmployeeAcademy/createEmpAcademyInfo/', data, config);
        }

        function removeEmpAcademyInfo(id) {
            return $http.delete($rootScope.endPoint + 'EmployeeAcademy/removeEmpAcademyInfo/' + id, config);
        }

        function getAllEmpExpInfo(empId) {
            return $http.get($rootScope.endPoint + 'EmpExperience/getAllEmpExpInfo/' + empId, config);
        }
        
        function getAllAreaofExpertiseInfo(AreaExpertiseId) {
            return $http.get($rootScope.endPoint + 'EmpExperience/getAllAreaofExpertiseInfo/' + empId, config);
        }


           
        function getAllLanguageListInfo(StaffLanguagespokenId) {
            return $http.get($rootScope.endPoint + 'StaffLanguageSpoken/getAllLanguageListInfo/' + empId, config);
        }


        function addNewEmpExperience(data) {
            return $http.post($rootScope.endPoint + 'EmpExperience/createEmpExpInfo', data, config);
        }   

        function removeEmpExpInfo(id) {
            return $http.delete($rootScope.endPoint + 'EmpExperience/removeEmpExpInfo/' + id, config);
        }

        function addNewEmpBankInfo(data) {
            return $http.post($rootScope.endPoint + 'StaffBankDetails/CreateStaffBankDetails', data, config);
        }
        function addNewEmpPersonalInfo(data) {
            return $http.post($rootScope.endPoint + 'StaffPersonalDetails/addNewEmpPersonalInfo', data, config);
        }

        function removeEmpBankInfo(id) {
            return $http.delete($rootScope.endPoint + 'StaffBankDetails/RemoveStaffBankDetails/' + id, config);
        }

        function addNewStaffAreasofExpertise(data) {
            return $http.post($rootScope.endPoint + 'StaffAreasofExpertise/createStaffAreasofExpertise', data, config);
        }
        
        function addNewStaffLanguageInfo(data) {
            return $http.post($rootScope.endPoint + 'StaffLanguageSpoken/createStaffLanguageSpoken', data, config);
        }

        function removeNewStaffAreasofExpertise(id) {
            return $http.delete($rootScope.endPoint + 'StaffAreasofExpertise/removeStaffAreasofExpertise/' + id, config);
        }
    }
})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.employeeChart')
        .service('EmployeeChartService', EmployeeChartService);

    EmployeeChartService.$inject = ['$http', '$rootScope'];

    function EmployeeChartService($http, $rootScope) {
        // this.AddEmployee = AddEmployee;
        // this.EditEmployee = EditEmployee;
        // this.RemoveEmployee = RemoveEmployee;
        // this.getAllEmployees = getAllEmployees;
        //  this.GetDepartmentByCompanyId = GetDepartmentByCompanyId;
        //  this.GetDesignationByDepartmentId = GetDesignationByDepartmentId;

        this.getEmployeesChart = getEmployeesChart;
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getEmployeesChart(){
            return $http.get($rootScope.endPoint + 'EmployeeChart/View/', config);
        }

      
    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.exercise')
        .service('ExerciseService', ExerciseService);

        ExerciseService.$inject = ['$http', '$rootScope'];

    function ExerciseService($http, $rootScope) {
         this.GetAllExercise = GetAllExercise;
         this.SaveExercise = SaveExercise;
         this.updateExercise = updateExercise;
         this.removeExercise = removeExercise;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function GetAllExercise() {
            return $http.get($rootScope.endPoint + 'ExerciseMaster/GetAllExercise' , config);
            
        }

        function SaveExercise(obj) {
            return $http.post($rootScope.endPoint + 'ExerciseMaster/CreateExercise', obj,  config);
        }


        function updateExercise(obj) {
            return $http.put($rootScope.endPoint + 'ExerciseMaster/ModifyExercise', obj,  config);
        }


        function removeExercise(id) {
            return $http.delete($rootScope.endPoint + 'ExerciseMaster/Delete/' + id, config);
        }

    }



})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.location')
        .service('LocationSetupService', LocationSetupService);

    LocationSetupService.$inject = ['$http', '$rootScope'];

    function LocationSetupService($http, $rootScope) {
        this.AddLocationSetup = AddLocationSetup;
        this.EditLocationSetup = EditLocationSetup;
        this.removeLocationSetup = removeLocationSetup;
        this.getAllLocationSetup = getAllLocationSetup;
        this.getAllLocationSetupById = getAllLocationSetupById;
        this.getAllLocationMaster = getAllLocationMaster;
        this.getLocationByBoQIoca = getLocationByBoQIoca;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }


        function getLocationByBoQIoca(obj) {
            return $http.post($rootScope.endPoint + 'LocationSetup/getLocationByBoq', obj, config);
        }

        function getAllLocationSetup() {
            return $http.get($rootScope.endPoint + 'LocationSetup/AllLocationSetup', config);
        }

        function getAllLocationSetupById(id) {
            return $http.get($rootScope.endPoint + 'LocationSetup/GetLocationsetupId/' + id, config);
        }

        function AddLocationSetup(location) {
            return $http.post($rootScope.endPoint + 'LocationSetup/Create', location, config);
        }

        function EditLocationSetup(location) {
            return $http.put($rootScope.endPoint + 'LocationSetup/Modify', location, config);
        }

        function removeLocationSetup(id) {
            return $http.delete($rootScope.endPoint + 'LocationSetup/Delete/' + id, config);
        }

        function getAllLocationMaster(location) {
            return $http.post($rootScope.endPoint + 'LocationSetup/AllLocationMaster', location, config);
        }
    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.questionandAnswer')
        .service('QuestionService', QuestionService);

    QuestionService.$inject = ['$http', '$rootScope'];

    function QuestionService($http, $rootScope) {
        this.GetAllQuestion = GetAllQuestion;
        this.SaveQuestion = SaveQuestion;
        this.updateQuestion = updateQuestion;
        this.removeQuestion = removeQuestion;
        this.GetAllExerciseByUnit = GetAllExerciseByUnit;
        this.GetAllQuestionandAnswer = GetAllQuestionandAnswer;
        this.updateQuestionandAnswer = updateQuestionandAnswer;
        this.GetAllQuestionTypes = GetAllQuestionTypes;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function GetAllQuestion() {
            // return $http.get($rootScope.endPoint + '' , config);
            // return $http.delete($rootScope.endPoint + 'Question/Delete/' + id, config);
            return $http.get($rootScope.endPoint + 'ExerciseMaster/GetAllExercise', config);

        }
        function GetAllQuestionandAnswer() {

            return $http.get($rootScope.endPoint + 'Question/AllQuestionandAnswer', config);

        }

        function SaveQuestion(obj) {
            return $http.post($rootScope.endPoint + 'Question/SaveQuestion', obj, config);
        }


        function updateQuestion(obj) {
            return $http.put($rootScope.endPoint + 'Question/ModifyExercise', obj, config);
        }

        function updateQuestionandAnswer(obj) {
            return $http.put($rootScope.endPoint + 'Question/UpdateQuestionandAnswer', obj, config);
        }



        function removeQuestion(id) {
            return $http.delete($rootScope.endPoint + 'Question/Delete/' + id, config);
        }

        function GetAllExerciseByUnit(obj) {
            return $http.post($rootScope.endPoint + 'Question/GetAllExerciseByUnit', obj, config);
        }

        function GetAllQuestionTypes() {
            return $http.get($rootScope.endPoint + 'Question/GetAllQuestionTypes', config);
        }

    }



})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.role')
        .service('RoleService', RoleService);

    RoleService.$inject = ['$rootScope', '$http'];

    function RoleService($rootScope, $http) {
        this.AddRole = AddRole;
        this.EditRole = EditRole;
        this.removeRole = removeRole;
        this.getAllRole = getAllRole;
        this.getRoleMenuMapping = getRoleMenuMapping;
        this.saveRoleMenuMapping = saveRoleMenuMapping;
        this.changeActiveRole = changeActiveRole;
        this.GetActiveRole = GetActiveRole;
        // this.getAllRoleById = getAllRoleById;

        /////////////

        function getConfig() {
            return {
                headers: {
                    "Token": $rootScope.token
                }
            }
        }

        function getAllRole() {
            debugger;
            return $http.get($rootScope.endPoint + 'Role/AllRoles', getConfig());
        }

        function getRoleMenuMapping(roleId) {
            return $http.get($rootScope.endPoint + 'RoleMenuMapping/GetMenuMappingByRoleId/' + roleId, getConfig());
        }

        function saveRoleMenuMapping(roleId, menuList) {
            return $http.post($rootScope.endPoint + 'RoleMenuMapping/Save/' + roleId, menuList, getConfig());
        }

        // function getAllRoleById($scope, $rootScope, $http, objGetEmpDTO) {
        //     return $http.get($rootScope.endPoint + 'Role/GetById');
        // }

        function AddRole(role) {
            return $http.post($rootScope.endPoint + 'Role/Create', role, getConfig());
        }

        function EditRole(role) {
            return $http.put($rootScope.endPoint + 'Role/Modify', role, getConfig());
        }

        function removeRole(id) {
            return $http.delete($rootScope.endPoint + 'Role/Delete/' + id, getConfig());
        }
        function changeActiveRole(id) {
            return $http.post($rootScope.endPoint + 'Role/ChangeActive/' + id, {}, getConfig());
        }
        function GetActiveRole() {
            return $http.get($rootScope.endPoint + 'Role/GetActiveRole', getConfig());
        }
    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.student')
        .service('StudentService', StudentService);

    StudentService.$inject = ['$http', '$rootScope'];

    function StudentService($http, $rootScope) {
        this.getAllStudent = getAllStudent;
        this.SaveStudent = SaveStudent;
        this.updateProfilePic = updateProfilePic;
        this.UpdateUnit = UpdateUnit;
        this.removeStudent = removeStudent;
        this. getStudentLoginDetails  = getStudentLoginDetails;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllStudent() {
            return $http.get($rootScope.endPoint + 'Studnet/GetAllStudent', config);
        }

        function getStudentLoginDetails() {
            return $http.get($rootScope.endPoint + 'StudentLoginDetails/getStudentLoginDetails', config);
        }

    

    
        function UpdateUnit(obj) {
            return $http.put($rootScope.endPoint + 'Studnet/UpdateStudentMaster', obj, config);
        }

        function SaveStudent(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Studnet/SaveStudentMaster', data, config);
        }

        function updateProfilePic(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Studnet/uploadProfilePic', data, config);
        }

        function removeStudent(id) {
            return $http.delete($rootScope.endPoint + 'Studnet/Delete/' + id, config);
        }

    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.location')
        .service('TierSetupService', TierSetupService);

    TierSetupService.$inject = ['$http', '$rootScope'];

    function TierSetupService($http, $rootScope) {
        this.AddTierSetup = AddTierSetup;
        this.updateTierSetup = updateTierSetup;
        this.removeTierSetup = removeTierSetup;
        this.getAllTierSetup = getAllTierSetup;
        this.getTierByBoQIoca = getTierByBoQIoca;


        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getTierByBoQIoca(obj) {
            return $http.post($rootScope.endPoint + 'TierSetup/GetTierByBoQIoca', obj, config);
        }

        function getAllTierSetup(LocationId) {
            return $http.get($rootScope.endPoint + 'TierSetup/AllTierMaster/' + LocationId, config);
        }

        function AddTierSetup(tier) {
            return $http.post($rootScope.endPoint + 'TierSetup/Create', tier, config);
        }

        function updateTierSetup(tier) {
            return $http.put($rootScope.endPoint + 'TierSetup/Modify', tier, config);
        }

        function removeTierSetup(id) {
            return $http.delete($rootScope.endPoint + 'TierSetup/Delete/' + id, config);
        }

        function ShowTestReport(CompanyId) {
            return $http.post($rootScope.endPoint + 'TierSetup/ShowReport/', + CompanyId, config);
        }
    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.services')
        .service('UserService', UserService);

    UserService.$inject = ['$http', '$rootScope'];

    function UserService($http, $rootScope) {
        this.getAllUsers = getAllUsers;
        this.getUserMenuMapping = getUserMenuMapping;
        this.saveUserMenuMapping = saveUserMenuMapping;
        this.getUserCompanies = getUserCompanies;
        this.getUserById = getUserById;
        this.UpdateSelectedCompany = UpdateSelectedCompany;
        this.checkUserEmail = checkUserEmail;
        this.checkUsername = checkUsername;
        this.createUser = createUser;
        this.getUsersByCompanyId = getUsersByCompanyId;
        this.removeUser = removeUser;
        this.UpdateUser = Edituser;
        this.CheckUserAccount=CheckUserAccount;
        this.getAllApprovedContractor=getAllApprovedContractor;
        this.createUserContractor = createUserContractor;

        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }
        /////////////

        function getUserById(userId) {
            return $http.get($rootScope.endPoint + 'User/GetUserById/' + userId);
        }

        function getAllApprovedContractor(userId) {
            return $http.get($rootScope.endPoint + 'User/GetApproveContractor/' + userId,config);
        }


        function getAllUsers() {
            return $http.get($rootScope.endPoint + 'User/AllUsers');
        }

        function getUsersByCompanyId(compId) {
            return $http.get($rootScope.endPoint + 'User/GetUsersByCompId/' + compId);
        }

        function getUserCompanies(userId) {
            return $http.get($rootScope.endPoint + 'User/GetUserCompanies/' + userId);
        }

        function getUserMenuMapping(userId) {
            return $http.get($rootScope.endPoint + 'UserMenuMapping/GetMenuMappingByUserId/' + userId, config);
        }

        function saveUserMenuMapping(userId, menuList) {
            return $http.post($rootScope.endPoint + 'UserMenuMapping/Save/' + userId, menuList, config);
        }

        function UpdateSelectedCompany(userDtlObj) {
            return $http.post($rootScope.endPoint + 'User/UpdateSelectedCompany', userDtlObj, config);
        }

        function Edituser(user) {
            return $http.put($rootScope.endPoint + 'User/Modify', user, config);
        }

        function createUser(user) {
            return $http.post($rootScope.endPoint + 'User/Create', user, config);
        }

        function createUserContractor(user) {
            return $http.post($rootScope.endPoint + 'User/CreateContractor', user, config);
        }

        function removeUser(id) {
            return $http.delete($rootScope.endPoint + 'User/Delete/' + id, config);
        }

        function CheckUserAccount(user) {
            return $http.post($rootScope.endPoint + 'User/CheckUserAccount', user, config);
        }

        function checkUserEmail(email) {
            var obj = {
                EmailId: email
            }
            return $http.post($rootScope.endPoint + 'User/CheckUserEmailId', obj, config);
        }

        function checkUsername(username) {
            var obj = {
                Username: username
            }
            return $http.post($rootScope.endPoint + 'User/CheckUsername', obj, config);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.state')
        .controller('StateCtrl', StateCtrl);

    /** @ngInject */
    function StateCtrl($http, $rootScope, lodash, dialogs, StateService, CountryService, $scope, AuthenticationService) {

        var vm = this;
        $rootScope.isLoading = true;
         // Pagination code
         vm.rowCountOptions = [{"value": 5}, {"value": 10}, {"value": 25}, {"value": 50}, {"value": 100}]
         vm.noOfRows = vm.rowCountOptions[1];
 
         vm.currentPage = 1;
         vm.rembemberCurrentPage = function(num) {
           vm.currentPage = num;
         }
         // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.stateList = [];
        $rootScope.isLogin = false;
        //Method
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
        vm.editState = editState;
        vm.changeActiveState = changeActiveState;
        vm.removeState = removeState;
        vm.SaveState = SaveState;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        Init();

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            StateService.getAllState($http, $rootScope).then(function(res) {
                if (res.status === 200) {
                    vm.StateList = res.data;
                    $rootScope.isLoading = false;
                    CountryService.getActiveCountry().then(function(res) {
                        if (res.status === 200) {
                            vm.CountryList = res.data; 
                        }
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "State");
                }
            }, function(err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "State");
                // dialogs.error('error', 'Error! Try Again', "State");
            });
        }

        function Create() {
            vm.isFormOpen = true;
        }

        function cancel() {
            vm.isFormOpen = false;
            vm.resetForm();
            vm.state = {};
        }

        function resetForm() {
            vm.stateForm.$setUntouched();
        }

        function editState(state) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.state = angular.copy(state);
            for (var c in vm.CountryList) {
                if (vm.CountryList[c].CountryId === state.CountryId) {
                    vm.state.selectedCountry = vm.CountryList[c];
                }
            }
            //console.log("check"+vm.state.selectedCountry);

        }

        function changeActiveState(state) {
            var msg = 'Are sure you want to ' + ((state.IsActive) ? 'Deactive' : 'Active') + ' current row.'
            var msg2 = ((state.IsActive) ? 'Deactive' : 'Active') + 'State Successfully.'
            var confirm = dialogs.confirm('Confirm', msg, { animation: true, size: 'sm' });

            confirm.result.then(function() {
                StateService.changeActiveState(state.StateId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', msg2, "State");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Change Status State", { animation: true, size: 'sm' });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Change Status State.If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function() {

            })
        }

        function removeState(state) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function() {
                StateService.removeState(state.StateId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete State Successfully', "State");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete State", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Delete State. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function() {

            })
        }

        function SaveState() {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                var state = {
                    CountryId: vm.state.selectedCountry.CountryId,
                    StateName: vm.state.StateName,
                    CreatedBy: logggedUser.UserId
                }
                StateService.AddState(state).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "State Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "State Master");
                        vm.isFormOpen = true;
                    }
                  
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            } else {
                var state = {
                    CountryId: vm.state.selectedCountry.CountryId,
                    StateName: vm.state.StateName,
                    StateId: vm.state.StateId,
                    IsActive: vm.state.IsActive,
                    ModifiedBy: logggedUser.UserId
                }
                StateService.EditState(state).then(function(res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "State Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "State Master");
                        vm.isFormOpen = true;
                    }                   
                }, function(err) {
                    $rootScope.showToaster("Something error...try again");
                });
               
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.studentDetails')
        .controller('studentDetailsCtrl', studentDetailsCtrl);

    /** @ngInject */
    function studentDetailsCtrl($rootScope, lodash, dialogs, $http, CompanyService, CountryService, AuthenticationService,
        StateService, CityService, AreaService, Base64, $scope) {
        var vm = this;
        // Pagination code
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.isEditingLogo = false;
        vm.open = false;
        $rootScope.isLogin = false;
        //Method
      
        vm.Create = Create;
        vm.cancel = cancel;
        vm.resetForm = resetForm;
   
        // vm.BloodGroupList = [{
        //     BloodGroupName: "O+",
        //           },
        // {
        //     BloodGroupName: "O-",
        //          },{BloodGroupName:"A+",},{BloodGroupName:"A-",},{BloodGroupName:"B+",},{BloodGroupName:"B-",},{BloodGroupName:"AB+",},{BloodGroupName:"AB-"}
        // ];

        vm.ProficiencyList = [{
            ProficiencyName : "International",
        },{ProficiencyName:"National",},{ProficiencyName:"State",},{ProficiencyName:"District",},{ProficiencyName:"Zone"}

        ];



       
        Init();
        ////////////////



        function Init() {
        }
         
   
        function Create() {
            vm.isFormOpen = true;
            // vm.company.CreatedBy = "1";

        }

        function cancel() {
            vm.isFormOpen = false;
            vm.resetForm();
            vm.Account = {};
            vm.isEditing = false;
          
            angular.element("input[type='file']").val(null);
            vm.Reset();
        }

        function resetForm() {
            vm.companyForm.$setUntouched();
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.test')
        .controller('TestCtrl', TestCtrl);

    /** @ngInject */
    function TestCtrl($http, $rootScope, lodash, dialogs) {
    }
})(); 
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('KPMES.theme')

  

    .directive('myDirectory', ['$parse', function ($parse) {
           function link(scope, element, attrs) {
               var model = $parse(attrs.myDirectory);
               element.on('change', function (event) {
                   scope.data = [];    //Clear shared scope in case user reqret on the selection
                   model(scope, { file: event.target.files });

               });
           };
           return {
               link: link
           }
       }])
       .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('KPMES.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.location')
        .controller('LocationSetupCtrl', LocationSetupCtrl);

    /** @ngInject */
    function LocationSetupCtrl($rootScope, lodash, dialogs, $http, LocationSetupService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code

        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.TierList = [];
        $rootScope.isLogin = false;
        //Method
        vm.addNewTier = addNewTier;
        vm.removeTier = removeTier;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.removeLocationSetup = removeLocationSetup;
        vm.editLocationSetup = editLocationSetup;
        vm.SaveLocationSetup = SaveLocationSetup;
       // var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
       var CompanyId = AuthenticationService.getLoggedUserDetails();
        Init();

        //Load Grid
        function Init() {
            LocationSetupService.getAllLocationSetup().then(function (res) {
                if (res.status === 200) {
                    vm.LocationSetupList = res.data;
                    $rootScope.isLoading = false;
                    vm.tierNameList = [];
                    lodash.forEach(vm.LocationSetupList, function (loc) {
                        loc.Tiers = JSON.parse(loc.Tiers);
                        lodash.forEach(lodash.keys(loc.Tiers), function (key) {
                            if (!lodash.includes(vm.tierNameList, key))
                                vm.tierNameList.push(key);
                        });
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "LocationSetup");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "LocationSetup");
            });
        }


        vm.tiers = [];

        function addNewTier() {

            var newItemNo = (vm.tiers).length + 1;
            vm.tiers.push({
                id: newItemNo,
                tierName: vm.location.Tier
            });
            vm.location.Tier = '';
        };

        function removeTier(item) {
            vm.tiers.splice(item, 1);
        };

        function Create() {
            vm.isFormOpen = true;
        }

        function cancel() {
            vm.isFormOpen = false;
            vm.location = {};
            vm.tiers = [];
        }

        function editLocationSetup(location) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.location = angular.copy(location);


            for (var c in vm.CompanyList) {
                if (vm.CompanyList[c].CompanyId === location.CompanyId) {
                    vm.location.selectedCompany = vm.CompanyList[c];
                }
            }



            vm.tiers = [];
            lodash.forIn(location.Tiers, function (tierValue, tier) {
                var newItemNo = (vm.tiers).length + 1;
                vm.tiers.push({
                    id: newItemNo,
                    tierName: tierValue
                });
            })
        }

        function removeLocationSetup(location) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                LocationSetupService.removeLocationSetup(location.LocationId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete  Successfully', "Location Setup");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete LocationSetup", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                });
            }, function () {

            })
        }

        function SaveLocationSetup(location) {
            var tierList = {};
            for (var i in vm.tiers) {
                tierList['Tier' + (parseInt(i) + 1)] = vm.tiers[i].tierName;
            }

            location.Tiers = JSON.stringify(tierList);
            if (!vm.isEditing) {
                LocationSetupService.AddLocationSetup(location).then(function (res) {
                    $rootScope.showToaster('success', 'Added  Successfully', "Location Setup Master");
                    Init();
                    vm.isFormOpen = false;
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again");
                });
                cancel();
            } else {
                LocationSetupService.EditLocationSetup(location).then(function (res) {
                    $rootScope.showToaster('success', 'Updated  Successfully', "Location Setup Master");
                    Init();
                    vm.isFormOpen = false;
                    vm.isEditing = false;
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again");
                });
                cancel();
            }
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.location')
        .controller('TierSetupCtrl', TierSetupCtrl);

    /** @ngInject */
    function TierSetupCtrl($scope, $rootScope, lodash, dialogs, $http, LocationSetupService, TierSetupService,
        AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code

        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.TierSetupList = [];
        $rootScope.isLogin = false;
        vm.getTiersByLocationId = getTiersByLocationId;
        vm.filterTiers = filterTiers;
        vm.saveNewTierValue = saveNewTierValue;
        vm.cancelAdding = cancelAdding;
        vm.updateTierValue = updateTierValue;
        vm.removeTierSetup = removeTierSetup;

        var loggedUser = AuthenticationService.getLoggedUserDetails();
       // var CompanyId = loggedUser.SelectedCompany.CompanyId;
        Init();

        ///////////////////////////

        function Init() {
            var loc = {

            }
            LocationSetupService.getAllLocationMaster(loc).then(function (res) {
                if (res.status === 200) {
                    vm.LocationList = res.data;
                    $rootScope.isLoading = false;
                //     if (callback)
                //     {   //  callback();
                //     }
                  
                // } else {
                //     $rootScope.showToaster('error', 'Load Failed! Try Again', "Location ");
                 }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Location ");
            });
        }


        function filterTiers(tier) {
            var isClearingTier = (tier.selectedTierValue === null || tier.selectedTierValue === undefined);
            var nextTier = "Tier" + (getTierNo(tier.TierType) + 1);
            vm.currentTier = vm.tierObj[nextTier];
            if (!isClearingTier)
                vm.TierSetupList = lodash.filter(vm.allTierData, { 'TierName': vm.currentTier, 'ParentTierId': tier.selectedTierValue.TierId });
            lodash.forEach(vm.tierList, function (t) {
                if (t.TierType === nextTier) {
                    if (!isClearingTier)
                        t.Values = vm.TierSetupList;
                    t.selectedTierValue = null;
                }
                var tierNoToCheck = ((isClearingTier) ? getTierNo(tier.TierType) : getTierNo(nextTier));
                if (getTierNo(t.TierType) > tierNoToCheck) {
                    t.Values = [],
                        t.selectedTierValue = null;
                }
            });

            if (isClearingTier) {
                if (getTierNo(tier.TierType) === 1)
                    vm.TierSetupList = lodash.filter(vm.allTierData, { 'TierName': vm.tierObj['Tier1'], 'ParentTierId': 0 });
            }
        }

        function getTierNo(tierString) {
            return parseInt(tierString.substring(4));
        }

        function getTiersByLocationId(LocationId, callback) {
            vm.tierObj = JSON.parse(vm.tier.selectedLocation.Tiers);
            vm.currentTier = vm.tierObj.Tier1;

            TierSetupService.getAllTierSetup(LocationId).then(function (res) {
                if (res.status === 200) {
                    vm.allTierData = res.data;
                    vm.tierList = [];
                    for (var properties in vm.tierObj) {
                        var temp = {
                            TierName: vm.tierObj[properties],
                            IsAdding: false,
                            TierType: properties
                        }
                        if (properties === 'Tier1') {
                            temp.Values = lodash.filter(vm.allTierData, { 'TierName': vm.tierObj[properties] });
                        }
                        vm.tierList.push(temp)
                    }
                    if (callback)
                        callback();
                    vm.TierSetupList = lodash.filter(vm.allTierData, { 'TierName': vm.currentTier });
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Tier Setup");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Tier Setup");
            });
        }

        function saveNewTierValue(tier) {
            var oldTierSelection = [];
            tier.IsAdding = ((!(tier.IsAdding) || tier.IsAdding === undefined) ? true : false);
            vm.isAddingTier = true;
            if (!tier.IsAdding) {
                var obj = {
                    LocationId: vm.tier.selectedLocation.LocationId,
                    ParentTierId: 0,
                    TierValue: tier.TierValue,
                    TierName: tier.TierName,
                    CreatedBy: loggedUser.UserId
                }
                if (getTierNo(tier.TierType) === 1) {
                    obj.ParentTierId = 0;
                } else {
                    var parentTier = lodash.find(vm.tierList, function (t) {
                        return t.TierType === "Tier" + (getTierNo(tier.TierType) - 1);
                    }).selectedTierValue;

                    if (parentTier === null || parentTier === undefined) {
                        $rootScope.showToaster('error', "You have to select a parent tier", "ERROR!");
                        vm.isFormOpen = false;
                        vm.isAddingTier = false;
                        tier.TierValue = undefined;
                        return;
                    } else {
                        obj.ParentTierId = parentTier.TierId;
                    }
                    oldTierSelection = vm.tierList;
                }

                TierSetupService.AddTierSetup(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        getTiersByLocationId(vm.tier.selectedLocation.LocationId, function () {
                            lodash.forEach(oldTierSelection, function (oldTier) {
                                lodash.forEach(vm.tierList, function (tier) {
                                    if (oldTier.TierType === tier.TierType && oldTier.selectedTierValue) {
                                        tier.selectedTierValue = oldTier.selectedTierValue;
                                        if (tier)
                                            filterTiers(tier);
                                    }
                                })
                            })
                            filterTiers()
                        });
                        $rootScope.showToaster('success', res.data.Message, "Tier Value");
                        vm.isFormOpen = false;
                        vm.isAddingTier = false;
                        tier.TierValue = undefined;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Tier Value");
                        tier.IsAdding = !tier.IsAdding;
                    }
                    //Init();
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
                // lodash.forEach(vm.tierList, function (t) {
                //     t.isHideForm = false;
                // });
            } else {
                var tierNoToCheck = getTierNo(tier.TierType);

                var nextTier = "Tier" + (getTierNo(tier.TierType) + 1);
                var currentTier = lodash.find(vm.tierList, { 'TierType': tier.TierType });
                vm.TierSetupList = currentTier.Values; // lodash.filter(vm.allTierData, { 'TierName': tier.TierName });
                lodash.forEach(vm.tierList, function (t) {
                    if (getTierNo(t.TierType) > tierNoToCheck) {
                        t.isHideForm = true;
                    }
                });
            }
        }

        function updateTierValue(tierToUpdate) {

            var obj = {
                "TierId": tierToUpdate.TierId,
                "LocationId": tierToUpdate.LocationId,
                "TierValue": tierToUpdate.TierValue,
                "TierName": tierToUpdate.TierName,
                "IsActive": tierToUpdate.IsActive,
                "ModifiedBy": loggedUser.UserId
            }
            TierSetupService.updateTierSetup(obj).then(function (res) {
                if (res.status === 200, res.data.IsSuccess) {

                    $rootScope.showToaster('success', res.data.Message, "Success");
                    tierToUpdate.isEdit = false;
                } else {
                    $rootScope.showToaster('error', res.data.Message, "ERROR!");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Cannot connect to server', 'ERROR!');
            });
        }

        function removeTierSetup(tierToRemove) {
            debugger;
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            var oldTierSelection = vm.tierList;
            confirm.result.then(function () {
                TierSetupService.removeTierSetup(tierToRemove.TierId).then(function (res) {
                    if (res.status === 200 && res.data.IsSuccess) {
                        $rootScope.showToaster('success', res.data.Message, "Success");
                        getTiersByLocationId(vm.tier.selectedLocation.LocationId, function () {
                            lodash.forEach(oldTierSelection, function (oldTier) {
                                lodash.forEach(vm.tierList, function (tier) {
                                    if (oldTier.TierType === tier.TierType && oldTier.selectedTierValue) {
                                        tier.selectedTierValue = oldTier.selectedTierValue;
                                        if (tier)
                                            filterTiers(tier);
                                    }
                                })
                            })
                            filterTiers()
                        });
                    } else if (!res.data.IsSuccess) {
                        $rootScope.showToaster('error', res.data.Message, "ERROR!");
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "ERROR!");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Cannot connect to server', 'ERROR!');
                });
            });
        }

        function cancelAdding(tier) {
            tier.TierValue = undefined;
            tier.IsAdding = false;
            vm.isAddingTier = false;
            lodash.forEach(vm.tierList, function (t) {
                t.isHideForm = false;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.mapping')
        .controller('ClassRoomMappingCtrl', ClassRoomMappingCtrl);

    /** @ngInject */
    function ClassRoomMappingCtrl($http, $filter, $rootScope, lodash, dialogs, MappingService, TierSetupService, LocationSetupService, ClassRoomService, SectionService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        
        vm.Create = Create;
        vm.cancel = cancel;
        vm.class = {};
        vm.getTiersByLocationId = getTiersByLocationId;
        vm.filterTiers = filterTiers;
        vm.staff = {};
        vm.getSectionByClass = getSectionByClass;
        vm.Saveclass = Saveclass;
        vm.editclass = editclass;
        vm.removeClass = removeClass;
       // var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
       var CompanyId = AuthenticationService.getLoggedUserDetails();
        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.class = {};
        }

        Init()
        function Init() {
            var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            
            MappingService.GetAllClassMap().then(function (res) {
                if (res.status === 200) {
                    vm.AllclassMapList = res.data;
                    $rootScope.isLoading = false;
                    for (var i in vm.AllclassMapList) {
                      //  vm.AllclassMapList[i].ClassMapTierList = JSON.parse(vm.AllclassMapList[i].TierList);
                    }

                    ClassRoomService.GetAllClassRoom().then(function (res) {
                        if (res.status === 200) {
                                vm.ClassRoomList = res.data;
                            LocationSetupService.getAllLocationSetup().then(function (res) {
                                if (res.status === 200) {
                                    vm.LocationSetupList = res.data;
                                    vm.tierNameList = [];
                                    lodash.forEach(vm.LocationSetupList, function (loc) {
                                        loc.Tiers = JSON.parse(loc.Tiers);
                                        lodash.forEach(lodash.keys(loc.Tiers), function (key) {
                                            if (!lodash.includes(vm.tierNameList, key))
                                                vm.tierNameList.push(key);
                                        });
                                    });
                                   
                                } else {
                                    $rootScope.showToaster('error', 'Load Failed! Try Again', "LocationSetup");
                                }
                            }, function (err) {
                                $rootScope.showToaster('error', 'Error! Try Again', "LocationSetup");
                            });
                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Class Mapping");
                    });
                   
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Class Mapping");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Class Mapping");
            });

        }


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.staff.selectedSection = null;
                vm.SectionList
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.staff.selectedSection = null;
                vm.SectionList
            }
        }

        function getMaxTier(tierArr) {
            var maxTier = tierArr[0];
            lodash.forEach(tierArr, function (t) {
                if (getTierNo(t) > getTierNo(maxTier))
                    maxTier = t;
            });
            return maxTier;
        }

        function getTierNo(tierString) {
            return parseInt(tierString.substring(4));
        }
        function getTiersByLocationId(LocationId, callback) {
            clearTierSelection();
            if (LocationId) {
                vm.tierObj = vm.class.selectedLocation.Tiers;
                var tierArr = lodash.keys(vm.tierObj);
                vm.maxTier = getMaxTier(tierArr);
                vm.currentTier = vm.tierObj.Tier1;
                TierSetupService.getAllTierSetup(LocationId).then(function (res) {
                    if (res.status === 200) {
                        debugger;
                        vm.allTierData = res.data;
                        vm.tierList = [];
                        for (var properties in vm.tierObj) {
                            var temp = {
                                TierName: vm.tierObj[properties],
                                IsAdding: false,
                                TierType: properties
                            }
                            if (properties === 'Tier1') {
                                temp.Values = lodash.filter(vm.allTierData, {
                                    'TierName': vm.tierObj[properties]
                                });
                            }
                            vm.tierList.push(temp)
                        }
                        vm.TierSetupList = lodash.filter(vm.allTierData, {
                            'TierName': vm.currentTier
                        });
                        //loadPowByLocation();

                      
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Tier Setup");
                    }
                    if (callback)
                        callback();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Tier Setup");
                });
            } else {

            }

        }
        function clearTierSelection() {
            lodash.forEach(vm.tierList, function (tier) {
                tier.selectedTierValue = null;
                // tier.Values = [];
            })
        }

        function filterTiers(tier) {
            if (tier.selectedTierValue) {
                var tempTier = "Tier" + (parseInt(tier.TierType.substring(4)) + 1);
                vm.currentTier = vm.tierObj[tempTier];
                vm.TierSetupList = lodash.filter(vm.allTierData, {
                    'TierName': vm.currentTier,
                    'ParentTierId': tier.selectedTierValue.TierId
                });
                lodash.forEach(vm.tierList, function (t) {
                    if (t.TierType === tempTier) {
                        t.Values = vm.TierSetupList;
                    }
                });
                if (tier.TierType === vm.maxTier)
                    vm.Lastid = tier.selectedTierValue.TierId;
                vm.tiers = {}
            }
            else {
                clearTierSelection();
            }
        }

        function Saveclass() {
            var obj = {
                ClassId: vm.class.selectedClassRoom.ClassId,
                SectionId: vm.class.selectedSection.SectionId,
                LocationId: vm.class.selectedLocation.LocationId,
                LastTierId: vm.Lastid,
                CreatedBy: 1,
                Process: 'Save'
            }
            if (!vm.isEditing) {
                MappingService.SaveClassRoomMap(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Class Room Mapping");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Class Room Mapping");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.class = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Class Room Mapping");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
            else {
                obj.MapClassId = vm.class.MapClassId
                SectionService.SaveSection(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Section Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Section Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.class = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Section Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        function editclass(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.class.MapClassId = angular.copy(row.MapClassId)

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.class.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.class.selectedSection = vm.SectionList[i]
                    }
                }
            });


            for (var i in vm.LocationSetupList) {
                if (vm.LocationSetupList[i].LocationId === row.LocationId) {
                    vm.class.selectedLocation = vm.LocationSetupList[i]
                }
            }

            getTiersByLocationId(row.LocationId, function () {

            })
        }

        function removeClass(row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                MappingService.SaveClassRoomMap(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Class Room Mapping");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Class Room Mapping", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Class Room Mapping.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }




    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.mapping')
        .controller('StaffMappingCtrl', StaffMappingCtrl);

    /** @ngInject */
    function StaffMappingCtrl($http, $filter, $rootScope, lodash, dialogs, MappingService, EmployeeService, ClassRoomService, SectionService, SubjectService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        
        vm.isEditing = false;
        //vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.staff = {};
        vm.staffMapList = [];
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.editStaff = editStaff;
        var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
       //var CompanyId = AuthenticationService.getLoggedUserDetails();
        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.staff = {};
            vm.staffMapList = [];
        }

        Init()
        function Init() {
            MappingService.GetAllStaffMap().then(function (res) {
                if (res.status === 200) {
                    vm.AllStaffMapList = res.data;
                    $rootScope.isLoading = false;
                    EmployeeService.getAllEmployeeList(CompanyId).then(function (res) {
                        if (res.status === 200) {
                            vm.EmployeeList = res.data;
                            ClassRoomService.GetAllClassRoom().then(function (res) {
                                if (res.status === 200) {
                                    vm.ClassRoomList = res.data;
                                } else {
                                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Staff Master");
                                }
                            }, function (err) {
                                $rootScope.showToaster('error', 'Error! Try Again', "Staff Master");
                            });
                           // vm.isLoading = false;
                         } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Employee");
                     });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Staff Master");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Staff Master");
            });


        }


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.staff.selectedSection = null;
                vm.SectionList
                vm.staff.selectedSubject = null;
                vm.SubjectList = [];
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Staff Master");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Staff Master");
                });
            }
            else {
                vm.staff.selectedSection = null;
                vm.SectionList
                vm.staff.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
      
        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.staff.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Staff Master");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Staff Master");
                });
            }
            else {
                vm.staff.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        vm.AddStaff = function () {

            var obj = {
                FirstName: vm.staff.selectedStaff.FirstName,
                EmployeeId: vm.staff.selectedStaff.EmployeeId,
                ClassName: vm.staff.selectedClassRoom.ClassName,
                ClassId: vm.staff.selectedClassRoom.ClassId,
                SectionName: vm.staff.selectedSection.SectionName,
                SectionId: vm.staff.selectedSection.SectionId,
                SubjectName: vm.staff.selectedSubject.SubjectName,
                SubjectId: vm.staff.selectedSubject.SubjectId
            }
            vm.staffMapList.push(obj);
        }

        vm.RemoveStaff = function (item) {
            var index = vm.staffMapList.indexOf(item);
            vm.staffMapList.splice(index, 1);
        }

        vm.SaveStaff = function () {
            if (!vm.isEditing) {
                var Arr = [];
                for (var i in vm.staffMapList) {
                    Arr.push({
                        EmployeeId: vm.staffMapList[i].EmployeeId,
                        ClassId: vm.staffMapList[i].ClassId,
                        SectionId: vm.staffMapList[i].SectionId,
                        SubjectId: vm.staffMapList[i].SubjectId,
                        CreatedBy: 1
                    });
                }

                var obj = {
                    StaffMappingList: JSON.stringify(Arr),
                    Process: 'Save'
                }
                MappingService.SaveStaff(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        $rootScope.showToaster('success', res.data.Message, "Staff Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Staff Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                var obj = {
                    MapStaffId: vm.staff.MapStaffId,
                    EmployeeId: vm.staff.selectedStaff.EmployeeId,
                    ClassId: vm.staff.selectedClassRoom.ClassId,
                    SectionId: vm.staff.selectedSection.SectionId,
                    SubjectId: vm.staff.selectedSubject.SubjectId,
                    CreatedBy: 1,
                    Process: 'Save'
                }
                MappingService.UpdateStaffMap(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Staff Map Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Staff Map Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Staff Map Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }


        }

        vm.RemoveStaffMap = function (row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                MappingService.UpdateStaffMap(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Staff Map Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Staff Map", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Staff Map.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        function editStaff(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.staff.MapStaffId = angular.copy(row.MapStaffId)
            for (var i in vm.EmployeeList) {
                if (vm.EmployeeList[i].EmployeeId === row.EmployeeId) {
                    vm.staff.selectedStaff = vm.EmployeeList[i]
                }
            }

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.staff.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.staff.selectedSection = vm.SectionList[i]
                    }
                }
            });

            getSubjectBySection(row.ClassId, row.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                        vm.staff.selectedSubject = vm.SubjectList[i]
                    }
                }
            });
        }

    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.mapping')
        .controller('timeTableMappingCtrl', timeTableMappingCtrl);

    /** @ngInject */
    function timeTableMappingCtrl($http, $filter, $rootScope, lodash, dialogs, MappingService, EmployeeService, ClassRoomService, SectionService, SubjectService, AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = this;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.GetClassTeacher = GetClassTeacher;
        vm.timeTable = {};
        vm.isTecCheck = false;
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.SavetimeTable = SavetimeTable;
        vm.edittimeTable = edittimeTable;
       var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
       var CompanyId = AuthenticationService.getLoggedUserDetails();
        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.timeTable = {};
        }

        vm.PeriodList = [{ Id: 1, Period: "1st Period" },
        { Id: 2, Period: "2nd Period" },
        { Id: 3, Period: "3rd Period" },
        { Id: 4, Period: "4th Period" },
        { Id: 5, Period: "5th Period" },
        { Id: 6, Period: "6th Period" },
        { Id: 7, Period: "7th Period" },
        { Id: 8, Period: "8th Period" },]

        Init()
        function Init() {
            var CompanyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            MappingService.GetAllTimeTableMap().then(function (res) {
                if (res.status === 200) {
                    vm.AllStaffTimeTableList = res.data;
                    $rootScope.isLoading = this;
                    for (var i in vm.AllStaffTimeTableList) {
                        for (var j in vm.PeriodList) {
                            if (vm.AllStaffTimeTableList[i].Period === vm.PeriodList[j].Id) {
                                vm.AllStaffTimeTableList[i].PeriodName = vm.PeriodList[j].Period
                            }
                        }
                    }
                    EmployeeService.getAllEmployees(CompanyId).then(function (res) {
                        if (res.status === 200) {
                            vm.EmployeeList = res.data;
                            ClassRoomService.GetAllClassRoom().then(function (res) {
                                if (res.status === 200) {
                                    vm.ClassRoomList = res.data;
                                } else {
                                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                                }
                            }, function (err) {
                                $rootScope.showToaster('error', 'Error! Try Again', "Country");
                            });
                           
                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Employee");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Employee");
                    });
                } else {
                    $rootScope.isLoading = this;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = this;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }

        vm.DayList = [{ Id: 1, Day: "Monday" },
        { Id: 2, Day: "Tuesday" },
        { Id: 3, Day: "Wednesday" },
        { Id: 4, Day: "Thursaday" },
        { Id: 5, Day: "Friday" },
        { Id: 6, Day: "Saturday" },]


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.timeTable.selectedSection = null;
                vm.SectionList
                vm.timeTable.selectedSubject = null;
                vm.SubjectList = [];
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.timeTable.selectedSection = null;
                vm.SectionList
                vm.timeTable.selectedSubject = null;
                vm.SubjectList = [];
            }
        }

        function GetClassTeacher() {
            var arr2 = vm.EmployeeList;
            debugger;
            var arr1 = vm.AllStaffTimeTableList;
            //  Compare Two array
            angular.forEach(arr1, function (value1, key1) {
                angular.forEach(arr2, function (value2, key2) {
                    if (value1.ClassTeacherId === value2.EmployeeId) {
                        arr2.splice(key2, 1);
                        vm.isTecCheck = true;
                    }
                });
            })
            vm.ClassTeacherList = arr2;
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.timeTable.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.timeTable.selectedSubject = null;
                vm.SubjectList = [];
            }
            GetClassTeacher();
        }

        function SavetimeTable() {              
            var obj = {
                ClassId: vm.timeTable.selectedClassRoom.ClassId,
                SectionId: vm.timeTable.selectedSection.SectionId,
                ClassTeacherId: vm.timeTable.selectedClassTeacher.EmployeeId,
                SubjectTeacherId: vm.timeTable.selectedSubjectTeacher.EmployeeId,
                SubjectId: vm.timeTable.selectedSubject.SubjectId,
                Day: vm.timeTable.selectedDay.Day,
                Period: vm.timeTable.selectedPeriod.Id,
                CreatedBy: 1,
                Process: 'Save'
            }
            if (!vm.isEditing) {
                MappingService.SaveTimeTableMap(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Time Table Mapping");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Time Table Mapping");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.timeTable = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Time Table Mapping");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                obj.MapTimeTableId = vm.timeTable.MapTimeTableId
                MappingService.SaveTimeTableMap(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Time Table Mapping");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Time Table Mapping");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.timeTable = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Time Table Mapping");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }

        }


        vm.RemoveTimeTableMap = function (row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                MappingService.SaveTimeTableMap(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Time Table Mapping");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Time Table Mapping", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Time Table Mapping.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        function edittimeTable(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.timeTable.MapTimeTableId = angular.copy(row.MapTimeTableId)
            for (var i in vm.EmployeeList) {
                if (vm.EmployeeList[i].EmployeeId === row.ClassTeacherId) {
                    vm.timeTable.selectedClassTeacher = vm.EmployeeList[i]
                }
            }

            for (var i in vm.EmployeeList) {
                if (vm.EmployeeList[i].EmployeeId === row.SubjectTeacherId) {
                    vm.timeTable.selectedSubjectTeacher = vm.EmployeeList[i]
                }
            }

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.timeTable.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.timeTable.selectedSection = vm.SectionList[i]
                    }
                }
            });

            getSubjectBySection(row.ClassId, row.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                        vm.timeTable.selectedSubject = vm.SubjectList[i]
                    }
                }
            });

            for (var i in vm.DayList) {
                if (vm.DayList[i].Day == row.Day) {
                    vm.timeTable.selectedDay = vm.DayList[i]
                }
            }

            for (var i in vm.PeriodList) {
                if (vm.PeriodList[i].Id === row.Period) {
                    vm.timeTable.selectedPeriod = vm.PeriodList[i]
                }
            }
        }

    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('ChaptersCtrl', ChaptersCtrl);

    /** @ngInject */
    function ChaptersCtrl($http, $rootScope, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService,AuthenticationService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading=true;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.chapters = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.SaveChapter = SaveChapter;
        vm.editChapter = editChapter;
        vm.removeChapter = removeChapter;
        vm.IsTermAvailable = false;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.chapters = {};
        }

        Init()
        function Init() {
            
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            getAllChapters();
            getAllTerms();
        }

        function getAllChapters(){
            ChapterService.GetAllChapters().then(function (res) {
                if (res.status === 200) {
                    debugger
                    vm.ChapterList = res.data;
                    $rootScope.isLoading=false;
                    ClassRoomService.GetAllClassRoom().then(function (res) {
                        if (res.status === 200) {
                            vm.ClassRoomList = res.data;
                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Country");
                    });
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        function getAllTerms(){
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
        }

        function getSectionByClass(obj, callBack) {
            debugger
            var ClassId = obj.ClassId;
            if(obj.IsTermAvailable == 1){
                vm.IsTermAvailable = true;
            }
            else{
                vm.IsTermAvailable = false;
            }
            debugger
            if (ClassId) {
                vm.chapters.selectedSection = null;
                vm.SectionList = [];
                vm.chapters.selectedSubject = null;
                vm.SubjectList = [];
                vm.chapters.ChapterName = "";
                vm.chapters.ChapterCode = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                       console.log(vm.SectionList);
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.chapters.selectedSection = null;
                vm.SectionList = [];
                vm.chapters.selectedSubject = null;
                vm.SubjectList = [];
                vm.chapters.ChapterName = "";
                vm.chapters.ChapterCode = "";
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.chapters.selectedSubject = null;
                vm.SubjectList = [];
                vm.chapters.ChapterName = "";
                vm.chapters.ChapterCode = "";
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.chapters.selectedSubject = null;
                vm.SubjectList = [];
                vm.chapters.ChapterName = "";
                vm.chapters.ChapterCode = "";
            }
        }

        function SaveChapter(chapters) {
            debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var chap;
            if(vm.IsTermAvailable){
                chap = vm.chapters.selectedTerm.TermId;
            }
            else {
                chap = 0;
            }
            var obj = {
                ClassId: vm.chapters.selectedClassRoom.ClassId,
                SectionId: vm.chapters.selectedSection.SectionId,
                SubjectId: vm.chapters.selectedSubject.SubjectId,
                ChapterName: chapters.ChapterName,
                ChapterCode: chapters.ChapterCode,
                CreatedBy: loggedUser.UserId,
                Process: 'Save',
                TermId:chap
            }
            if (!vm.isEditing) {
                ChapterService.SaveChapter(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Chapter Master");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Chapter Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Chapter Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                obj.ModifiedBy = loggedUser.UserId;
                obj.ChapterId = chapters.ChapterId
                ChapterService.SaveChapter(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Chapter Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Chapter Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Chapter Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        function editChapter(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId == row.ClassId) {
                    vm.chapters.selectedClassRoom = vm.ClassRoomList[i]
                }
            }
            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.chapters.selectedSection = vm.SectionList[i]
                    }
                }
            });
            getSubjectBySection(row.ClassId, row.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                        vm.chapters.selectedSubject = vm.SubjectList[i]
                    }
                }
            });
            vm.chapters.ChapterName = angular.copy(row.ChapterName);
            vm.chapters.ChapterCode = angular.copy(row.ChapterCode);
            vm.chapters.ChapterId = angular.copy(row.ChapterId);
        }

        function removeChapter(row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                ChapterService.SaveChapter(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Chapter Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Chapter", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Chapter.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('ClassRoomCtrl', ClassRoomCtrl);

    /** @ngInject */
    function ClassRoomCtrl($http, $rootScope, lodash, dialogs, ClassRoomService,AuthenticationService) {
        var vm = this;
        // Pagination code
      $rootScope.isLoading = true;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.editClass = editClass;
        vm.removeClass = removeClass;
        vm.SaveClassRoom = SaveClassRoom;
        vm.ClassRoom = {};
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.ClassRoom = {};
        }

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
            
        }

        function SaveClassRoom(ClassRoom) {
            //debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                ClassRoom.CreatedBy = loggedUser.UserId;
                ClassRoom.Process = 'Save';
                ClassRoom.IsTermAvailable = ClassRoom.IsTermAvailable == true ? 1:0 ;
                ClassRoomService.SaveClassRoom(ClassRoom).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Class Room Master");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Class Room Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Class Room Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                ClassRoom.ModifiedBy = loggedUser.UserId;
                ClassRoom.Process = 'Save';
                ClassRoom.IsTermAvailable = ClassRoom.IsTermAvailable == true ? 1:0 ;
                ClassRoomService.SaveClassRoom(ClassRoom).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Class Room Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Class Room Master");
                        Init();
                        vm.isFormOpen = false;
                        vm.isEditing = false;
                        cancel();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Class Room Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        function editClass(row) {
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.ClassRoom = angular.copy(row);
            vm.ClassRoom.IsTermAvailable = row.IsTermAvailable == 1 ? true : false;
            vm.isEditing = true;
        }

        function removeClass(row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                ClassRoomService.SaveClassRoom(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Class Room Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Class Room", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Class Room.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }





    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('CreateLinkTextCtrl', CreateLinkTextCtrl);

    /** @ngInject */
    function CreateLinkTextCtrl($http, $scope, $rootScope, $sce, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService, UnitService,AuthenticationService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = true;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];
        vm.radioDisable = false;
        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.unit = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
        vm.getUnitByChapters = getUnitByChapters;
        vm.SaveUnitLink = SaveUnitLink;
         vm.RemoveUnitLink = RemoveUnitLink;
     
        //vm.editChapter = editChapter;
        // vm.removeUnit = removeUnit;
        vm.SaveDocument = SaveDocument;
        vm.removeFile = removeFile;
        vm.editLinkUnit = editLinkUnit;
        vm.SaveUploadLinks = SaveUploadLinks;
        vm.DocList = [];
        var arr = [];
        vm.VideoLinks = [];
        var logggedUser = AuthenticationService.getLoggedUserDetails();
        vm.setPathIds = setPathIds;
        // vm.LinksUpdate = LinksUpdate;
        //debugger
       // vm.Type = 'P';

        vm.VideoLinksList = [{
            Refname: "ReferenceLink",
            RefTypeId: 1
        },
        {
            Refname: "Most Popular Link",
            RefTypeId: 2
        },
        {
            Refname: "Suggesstion Teacher Video Link",
            RefTypeId: 3


        }
        ];
        vm.FileTypeList = [
        //     {
        //     FileTypeName: "Image",
        //     FileTypeId: 1
        // },
        {
            FileTypeName: "Video",
            FileTypeId: 2
        }]

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.ShowCreateBtn = true;
            vm.ShowUpdateBtn = false;
            vm.CreateLinkunit = {};
            vm.radioDisable = false;
            //debugger
            vm.Type = 'P';
        
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.unit = {};
            // vm.DocList = {};
            //debugger
            vm.Type = '';
            vm.videoList = {};
            vm.radioDisable = false;
            $rootScope.PathIds = {};
        }

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            GetAllLinks();
           
        }

        function GetAllLinks(){
            var EmployeeId = AuthenticationService.getLoggedUserDetails().UserId;
            UnitService.GetAllLinkUnits(EmployeeId).then(function (res) {
                if (res.status === 200) {
                    vm.UnitLinkList = res.data;
                    $rootScope.isLoading = false;
                    //console.log("vm.UnitLinkList >> "+JSON.stringify(vm.UnitLinkList))
                    GetAllClassRoom();
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        function GetAllClassRoom(){
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;

                   // console.log("vm.ClassRoomList"+JSON.stringify(vm.ClassRoomList))
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Unit");
            });
        }
  

        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.CreateLinkunit.selectedSection = null;
                vm.SectionList = [];
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateLinkunit.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.CreateLinkunit.selectedSection = null;
                vm.SectionList = [];
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateLinkunit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }


        function getAllTerms(){
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                        getAllTerms();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.CreateLinkunit.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }

                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }


        $scope.fileChanged = function (event) {
            //debugger
            if (event)
                vm.selectedFile = event.target.files[0];  
        }

        function SaveDocument() {
            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile)
            formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
            formData.append('RelatedImageandVideoName',vm.unit.RelatedImageandVideoName)
            formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
            formData.append('SectionName', vm.unit.selectedSection.SectionName)
            formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
            formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)


            UnitService.SaveDoc(formData).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    vm.DocList.push(res.data.result)
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }

         function SaveUploadLinks(){
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile)
            formData.append('UnitId', vm.CreateLinkunit.selectedUnit.UnitId)
            formData.append('ReferenceName', vm.CreateLinkunit.LinksWord)
            formData.append('ClassId', vm.CreateLinkunit.selectedClassRoom.ClassId)
            formData.append('SectionId', vm.CreateLinkunit.selectedSection.SectionId)
            formData.append('SubjectId', vm.CreateLinkunit.selectedSubject.SubjectId)
            formData.append('ChapterId', vm.CreateLinkunit.selectedChapter.ChapterId)
            formData.append('UploadTypeId', vm.CreateLinkunit.selectedFileType.FileTypeId)
            formData.append('UserId', loggedUser.UserId)

            UnitService.SaveUploadedDocs(formData).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    Init();
                    vm.isFormOpen = false;
                    cancel();
                    vm.section = {};
                    vm.DocList = [];
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });        
        }

        function getUnitByChapters(ClassId, SectionId, SubjectId,ChapterId, callBack) {
            if (ChapterId) {
                vm.CreateLinkunit.selectedUnit = null;
                vm.UnitList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId,
                    ChapterId: ChapterId
                }
                UnitService.GetAllUnitByChapter(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.UnitList = res.data;
                      
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedChapter = null;
                vm.UnitList = [];
            }
        }
        
        function setPathIds(){
            $rootScope.PathIds = {};
            $rootScope.PathIds = {
                ClassId : vm.CreateLinkunit.selectedClassRoom.ClassId,
                SectionId : vm.CreateLinkunit.selectedSection.SectionId,
                SubjectId : vm.CreateLinkunit.selectedSubject.SubjectId,
                ChapterId : vm.CreateLinkunit.selectedChapter.ChapterId,
                UnitId: vm.CreateLinkunit.selectedUnit.UnitId,
                Type:"LinkFile"
            }
        }

        function editLinkUnit(row) {
            debugger
            
            vm.CreateLinkunit = {};
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            
            if(row.UploadTypeId == 3){
                vm.Type = "P";
            }
            else{
                vm.Type = "A";
            }
            vm.CreateLinkunit.selectedFileType = row.UploadTypeId; 
            vm.CreateLinkunit.LinksWord = angular.copy(row.LinksWord);
            vm.ShowCreateBtn = false;
            vm.ShowUpdateBtn = true;
           vm.UpdateTextLinkId = row.TextLinkId;
           vm.radioDisable = true;

        //    document.getElementById("inlineRadio2").disabled = true;

           // vm.Type = angular.copy(row.UnitType);
            vm.CreateLinkunit = angular.copy(row);

           // console.log("vm.isEditing  on edit button click"+vm.isEditing)

            //console.log("row======>>>>>>>"+JSON.stringify(row));
           //vm.CreateLinkunit.UnitId = angular.copy(row.UnitId);
         //  vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
            //vm.CreateLinkunit = (row.PostContentFile != undefined) ? angular.copy(JSON.parse(row.PostContentFile)) : null;
            //vm.CreateLinkunit.FileTypeId = (row.FileTypeId != undefined) ? angular.copy(row.FileTypeId);
            $rootScope.ButtonTypeIdCount = row.ButtonTypeId;
            //vm.CreateLinkunit.TextLinkId = angular.copy(row.TextLinkId);
               vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
               vm.CreateLinkunit.LinksWord = angular.copy(row.LinksWord);

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.CreateLinkunit.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            

            for (var i in vm.FileTypeList) {
                if (vm.FileTypeList[i].FileTypeId === row.UploadTypeId) {
                    vm.CreateLinkunit.selectedFileType = vm.FileTypeList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.CreateLinkunit.selectedSection = vm.SectionList[i];

                        getSubjectBySection(row.ClassId, row.SectionId, function () {
                            for (var i in vm.SubjectList) {
                                if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                                    vm.CreateLinkunit.selectedSubject = vm.SubjectList[i];

                                    getChapterBySubject(row.ClassId, row.SectionId, row.SubjectId, function () {
                                        for (var i in vm.ChapterList) {
                                            if (vm.ChapterList[i].ChapterId === row.ChapterId) {
                                                vm.CreateLinkunit.selectedChapter = vm.ChapterList[i];

                                                getUnitByChapters(row.ClassId, row.SectionId, row.SubjectId,row.ChapterId, function () {
                                                    for (var i in vm.UnitList) {
                                                        if (vm.UnitList[i].UnitId === row.UnitId) {
                                                            vm.CreateLinkunit.selectedUnit = vm.UnitList[i];
                                                            setPathIds();                                                            
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    });

                                }
                            }
                        });

                    }
                }
            });
            vm.CreateLinkunit.UnitName = angular.copy(row.UnitName);           
        }


        vm.LinksUpdate = function(){
            //debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var details = {
                UnitId:vm.CreateLinkunit.selectedUnit.UnitId,
                LinksWord:vm.CreateLinkunit.LinksWord,
                TextLinkId:vm.UpdateTextLinkId,
                CreatedBy:loggedUser.UserId
            }
            UnitService.LinksUpdate(details).then(function(res){
                if (res.status === 200) {
                    if(res.data){
                        $rootScope.showToaster('success', res.data.Message, "Update Successfully");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                    }
                    else{
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Update Faild");
                    }
                    
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Update Faild");
                }
            })
        }

       

        function SaveUnitLink(CreateLinkunit) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            debugger;

            var obj = {
                ClassId : vm.CreateLinkunit.selectedClassRoom.ClassId,
                SectionId : vm.CreateLinkunit.selectedSection.SectionId,
                SubjectId : vm.CreateLinkunit.selectedSubject.SubjectId,
                ChapterId : vm.CreateLinkunit.selectedChapter.ChapterId,
                UnitId: vm.CreateLinkunit.selectedUnit.UnitId,
                PostContent: CreateLinkunit.PostContent,
                LinksWord :vm.CreateLinkunit.LinksWord,
                CreatedBy: loggedUser.UserId,
                UploadTypeId: 3
            }

            if (!vm.isEditing) {
                UnitService.SaveUnitLink(obj).then(function (res) {
                   // console.log("res =====>>>>>>>>>"+JSON.stringify(res))
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Create a Link Inserted Successfully");
                        // if (res.data.Code === 1)
                        //     $rootScope.showToaster('success', res.data.Message, "Unit Master");
                        // if (res.data.Code != 1)
                        //     $rootScope.showToaster('warning', res.data.Message, "Unit Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];

                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Create a Link");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                obj.ModifiedBy = loggedUser.UserId;
                obj.UnitId = CreateLinkunit.UnitId
                obj.TextLinkId = CreateLinkunit.TextLinkId;
                obj.LinkHtmlPath = CreateLinkunit.LinkHtmlPath;
               
               // console.log("vm.CreateLinkunit"+JSON.stringify(CreateLinkunit))
               // console.log("obj"+JSON.stringify(obj))
                UnitService.UpdateUnitLink(obj).then(function (res) {
                    console.log("res"+JSON.stringify(res));
                    if (res.data.IsSuccess === true) {
                       
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Unit Link Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Unit Link Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Unit Link Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }




        // $scope.fileChanged = function (event) {
        //     if (event)
        //         vm.selectedFile = event.target.files[0];
        // }

        // function SaveDocument() {
        //     var formData = new FormData();
        //     formData.append('Attachment', vm.selectedFile)
        //     formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
        //     formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
        //     formData.append('SectionName', vm.unit.selectedSection.SectionName)
        //     formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
        //     formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)
        //     formData.append('ReferenceLink', vm.unit.ReferenceLinkName)


        //     UnitService.SaveDoc(formData).then(function (res) {
        //         if (res.data.msgText === 'Success!') {
        //             $rootScope.showToaster('success', res.data.Message, "File Upload");
        //             vm.DocList.push(res.data.result)
        //         } else {
        //             $rootScope.showToaster('error', res.data.Message, "File Upload");
        //         }
        //     }, function (err) {
        //         $rootScope.showToaster("Something error...try again");
        //     });

        // }

        function SaveVideoLinks() {
            var obj = {
                RefTypeId: vm.unit.ReferenceLinkName,

            }

            UnitService.SaveVideoLinks(obj).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    vm.VideoLinks.push(res.data.result)
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }

        function removeFile(row) {
            //debugger;
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });
            confirm.result.then(function () {
                UnitService.RemoveDoc(row.FileUrl).then(function (res) {
                    if (res.data.msgText === 'Success!') {
                        var index = vm.DocList.indexOf(row);
                        vm.DocList.splice(index, 1);
                        $rootScope.showToaster('success', 'Deleted Successfully', "File Upload");
                    } else {
                        $rootScope.showToaster('error', 'Failed!', "File Upload");
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            });
        }

          
        function RemoveUnitLink(row) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function() {
                UnitService.RemoveUnitLink(row.TextLinkId).then(function(res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Create a Link Deleted Successfully');
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Create a Link", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't Delete CreateLink. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function() {

            })
        }



        vm.OpenWindow = function (HtmlPath) {
            window.open($rootScope.endPoint + 'UploadedDocuments/PostcontentDoc/' + HtmlPath);
        }

        vm.removeLinkUnit = function (obj){
            debugger

            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });
            confirm.result.then(function() {

                var value = {
                    TextLinkId : obj.TextLinkId,
                    LinkHtmlPath : obj.LinkHtmlPath
                }

            UnitService.RemoveTextLink(value).then(function(res){
                console.log("vm.removeLinkUnit result >>>"+JSON.stringify(res.data))
                if (res.status === 200) {
                    $rootScope.showToaster('success', 'Remove Link Successfully');
                    Init();
                } else {
                    $rootScope.showToaster('error', "Can't Delete Link", {
                        animation: true,
                        size: 'sm'
                    });
                }
            },function(err) {
                $rootScope.showToaster('error', "Can't Delete Link. If its not a parent contact your Admin", {
                    animation: true,
                    size: 'sm'
                });
            });
        }, function() {            
            })
        }

        


    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('ExerciseCtrl', ExerciseCtrl);

    /** @ngInject */
    function ExerciseCtrl($http, $rootScope, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService,AuthenticationService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading=false;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = false;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.chapters = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
       // vm.SaveChapter = SaveChapter;
        // vm.editChapter = editChapter;
        // vm.removeChapter = removeChapter;

        var logggedUser = AuthenticationService.getLoggedUserDetails();

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.chapters = {};
        }

        Init()
        function Init() {

            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            getClassRoom();
            // getAllChapters();
           // getAllTerms();
        }

        // function getAllChapters(){
        //     ChapterService.GetAllChapters().then(function (res) {
        //         if (res.status === 200) {
        //             debugger
        //             vm.ChapterList = res.data;
        //             $rootScope.isLoading=false;
                
        //         } else {
        //             $rootScope.isLoading=false;
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //         }
        //     }, function (err) {
        //         $rootScope.isLoading=false;
        //         $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //     });
        // }

        function getClassRoom(){
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;

                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.unit.selectedSection = null;
                vm.SectionList = [];
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                vm.unit.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedSection = null;
                vm.SectionList = [];
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                        getAllTerms();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }
                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }


        // function getAllTerms(){
        //     ChapterService.GetAllTerms().then(function (res) {
        //         if (res.status === 200) {
        //             vm.TermsList = res.data;
        //         } else {
        //             $rootScope.isLoading=false;
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
        //         }
        //     }, function (err) {
        //         $rootScope.isLoading=false;
        //         $rootScope.showToaster('error', 'Error! Try Again', "Terms");
        //     });
        // }

        // function getSectionByClass(ClassId, callBack) {
        //     if (ClassId) {
        //         vm.chapters.selectedSection = null;
        //         vm.SectionList = [];
        //         vm.chapters.selectedSubject = null;
        //         vm.SubjectList = [];
        //         vm.chapters.ChapterName = "";
        //         vm.chapters.ChapterCode = "";
        //         SectionService.GetAllSectionByClass(ClassId).then(function (res) {
        //             if (res.status === 200) {
        //                 vm.SectionList = res.data;
        //             } else {
        //                 $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //             }
        //             if (callBack)
        //                 callBack();
        //         }, function (err) {
        //             $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //         });
        //     }
        //     else {
        //         vm.chapters.selectedSection = null;
        //         vm.SectionList = [];
        //         vm.chapters.selectedSubject = null;
        //         vm.SubjectList = [];
        //         vm.chapters.ChapterName = "";
        //         vm.chapters.ChapterCode = "";
        //     }
        // }

        // function getSubjectBySection(ClassId, SectionId, callBack) {
        //     if (SectionId) {
        //         vm.chapters.selectedSubject = null;
        //         vm.SubjectList = [];
        //         vm.chapters.ChapterName = "";
        //         vm.chapters.ChapterCode = "";
        //         var obj = {
        //             ClassId: ClassId,
        //             SectionId: SectionId
        //         }
        //         SubjectService.getAllSubjectBySection(obj).then(function (res) {
        //             if (res.status === 200) {
        //                 vm.SubjectList = res.data;
        //             } else {
        //                 $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //             }
        //             if (callBack)
        //                 callBack();
        //         }, function (err) {
        //             $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //         });
        //     }
        //     else {
        //         vm.chapters.selectedSubject = null;
        //         vm.SubjectList = [];
        //         vm.chapters.ChapterName = "";
        //         vm.chapters.ChapterCode = "";
        //     }
        // }

        // function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
        //     if (SubjectId) {
        //         vm.unit.selectedChapter = null;
        //         vm.ChapterList = [];

        //         var obj = {
        //             ClassId: ClassId,
        //             SectionId: SectionId,
        //             SubjectId: SubjectId
        //         }
        //         ChapterService.GetAllChapterBySubject(obj).then(function (res) {
        //             if (res.status === 200) {
        //                 vm.ChapterList = res.data;
        //             } else {
        //                 $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //             }
        //             if (callBack)
        //                 callBack();
        //         }, function (err) {
        //             $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //         });
        //     }
        //     else {
        //         vm.unit.selectedChapter = null;
        //         vm.ChapterList = [];
        //     }
        // }

        // function SaveChapter(chapters) {
        //     debugger
        //     var loggedUser = AuthenticationService.getLoggedUserDetails();
        //     var obj = {
        //         ClassId: vm.chapters.selectedClassRoom.ClassId,
        //         SectionId: vm.chapters.selectedSection.SectionId,
        //         SubjectId: vm.chapters.selectedSubject.SubjectId,
        //         ChapterName: chapters.ChapterName,
        //         ChapterCode: chapters.ChapterCode,
        //         CreatedBy: loggedUser.UserId,
        //         Process: 'Save',
        //         TermId:vm.chapters.selectedTerm.TermId
        //     }
        //     if (!vm.isEditing) {
        //         ChapterService.SaveChapter(obj).then(function (res) {
        //             if (res.data.IsSuccess === true) {
        //                 if (res.data.Code === 1)
        //                     $rootScope.showToaster('success', res.data.Message, "Chapter Master");
        //                 if (res.data.Code != 1)
        //                     $rootScope.showToaster('warning', res.data.Message, "Chapter Master");
        //                 Init();
        //                 vm.isFormOpen = false;
        //                 cancel();
        //                 vm.section = {};
        //             } else {
        //                 $rootScope.showToaster('error', res.data.Message, "Chapter Master");
        //                 vm.isFormOpen = true;
        //             }
        //         }, function (err) {
        //             $rootScope.showToaster("Something error...try again");
        //         });
        //     }
        //     else {
        //         obj.ModifiedBy = loggedUser.UserId;
        //         obj.ChapterId = chapters.ChapterId
        //         ChapterService.SaveChapter(obj).then(function (res) {
        //             if (res.data.IsSuccess === true) {
        //                 if (res.data.Code === 3)
        //                     $rootScope.showToaster('success', res.data.Message, "Chapter Master");
        //                 if (res.data.Code != 3)
        //                     $rootScope.showToaster('warning', res.data.Message, "Chapter Master");
        //                 Init();
        //                 vm.isFormOpen = false;
        //                 cancel();
        //                 vm.section = {};
        //                 vm.isEditing = false;
        //             } else {
        //                 $rootScope.showToaster('error', res.data.Message, "Chapter Master");
        //                 vm.isFormOpen = true;
        //             }
        //         }, function (err) {
        //             $rootScope.showToaster("Something error...try again");
        //         });
        //     }
        // }

        // function editChapter(row) {
        //     vm.isEditing = true;
        //     vm.isFormOpen = true;
        //     vm.isTableOpen = false;
        //     for (var i in vm.ClassRoomList) {
        //         if (vm.ClassRoomList[i].ClassId == row.ClassId) {
        //             vm.chapters.selectedClassRoom = vm.ClassRoomList[i]
        //         }
        //     }
        //     getSectionByClass(row.ClassId, function () {
        //         for (var i in vm.SectionList) {
        //             if (vm.SectionList[i].SectionId === row.SectionId) {
        //                 vm.chapters.selectedSection = vm.SectionList[i]
        //             }
        //         }
        //     });
        //     getSubjectBySection(row.ClassId, row.SectionId, function () {
        //         for (var i in vm.SubjectList) {
        //             if (vm.SubjectList[i].SubjectId === row.SubjectId) {
        //                 vm.chapters.selectedSubject = vm.SubjectList[i]
        //             }
        //         }
        //     });
        //     vm.chapters.ChapterName = angular.copy(row.ChapterName);
        //     vm.chapters.ChapterCode = angular.copy(row.ChapterCode);
        //     vm.chapters.ChapterId = angular.copy(row.ChapterId);
        // }

        // function removeChapter(row) {
        //     var confirm = dialogs.confirm('Confirm',
        //         'Are sure you want to delete current row.', { animation: true, size: 'sm' });
        //     row.Process = 'Delete'
        //     confirm.result.then(function () {
        //         ChapterService.SaveChapter(row).then(function (res) {
        //             if (res.status === 200) {
        //                 $rootScope.showToaster('success', res.data.Message, "Chapter Master");
        //                 Init();
        //             } else {
        //                 $rootScope.showToaster('error', "Can't Delete Chapter", { animation: true, size: 'sm' });
        //             }
        //         }, function (err) {
        //             $rootScope.showToaster('error', "Can't Delete Chapter.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
        //         });
        //     }, function () {

        //     })
        // }

    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('MapVideosCtrl', MapVideosCtrl);

    /** @ngInject */
    function MapVideosCtrl($http, $scope, $rootScope, $sce, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService, UnitService, AuthenticationService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = true;
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.unit = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
        vm.getUnitByChapters = getUnitByChapters;
        vm.SaveUnitLink = SaveUnitLink;
        vm.RemoveUnitLink = RemoveUnitLink;
        //vm.editChapter = editChapter;
        // vm.removeUnit = removeUnit;
        vm.SaveDocument = SaveDocument;
        vm.removeFile = removeFile;
        vm.editLinkUnit = editLinkUnit;
        vm.SaveUploadLinks = SaveUploadLinks;
        vm.DocList = [];
        var arr = [];
        vm.VideoLinks = [];
        var logggedUser = AuthenticationService.getLoggedUserDetails();
        vm.showMapVideoForm = false;
       


        vm.VideoLinksList = [{
                VideoTypename: "Reference Videos",
                VideoTypeId: 1
            },
            {
                VideoTypename: "Teacher Suggested Videos",
                VideoTypeId: 2
            },
            {
                VideoTypename: "Most Popular Videos",
                VideoTypeId: 3
            },
            {
                VideoTypename: "Related Videos",
                VideoTypeId: 4
            }
        ];


        vm.SaveVideoLinksUnit = SaveVideoLinksUnit;
        vm.GetVideoLinksByUnitId = GetVideoLinksByUnitId;
        vm.DeleteVideoLink = DeleteVideoLink;
        // vm.GetTitleName = GetTitleName;

        function GetVideoLinksByUnitId(unitid){
            //debugger
            vm.showMapVideoForm = true;
            UnitService.GetAllLinksByUnitId(unitid).then(function (res) {
                if (res.status === 200) {
                    vm.AllVideoLinksList = res.data;
                    //console.log("vm.AllVideoLinksList"+JSON.stringify(vm.AllVideoLinksList));
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Get Video Link List");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Get Video Link List");
            });

            UnitService.GetTitleName(unitid).then(function (res) {
                if (res.status === 200) {
                    vm.AllTitleNameList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Video Link");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Video Link");
            });

        }
        
        function SaveVideoLinksUnit(unit) {
            //debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var objUnit = {
                // VideoTypeId: vm.mapvideo.selectedVideoType.VideoTypeId,
                // TitleName: vm.mapvideo.TitleName,
                // Links: vm.mapvideo.Links,
                // CreatedBy: loggedUser.UserId,
                // UnitId: vm.CreateLinkunit.selectedUnit.UnitId,


                UnitId :vm.CreateLinkunit.selectedUnit.UnitId,
                VideoTypeId:vm.mapvideo.selectedVideoType.VideoTypeId,
                TextLinkId:vm.mapvideo.TitleName.TextLinkId,
                CreatedBy:loggedUser.UserId
            }

            UnitService.SaveVideoLinksUnit(objUnit).then(function (res) {
                if (res.status === 200) {
                    
                     GetVideoLinksByUnitId(vm.CreateLinkunit.selectedUnit.UnitId);
                     vm.CreateLinkunit.selectedUnit="";
                     vm.mapvideo = [];
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Video Link");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Video Link");
            });
        }

        function DeleteVideoLink(data){
            //debugger;
            UnitService.DeleteVideoLink(data.LinksId).then(function (res) {

                if (res.status === 200) {
                    vm.mapvideo = [];
                     GetVideoLinksByUnitId(vm.CreateLinkunit.selectedUnit.UnitId);
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Video Link");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Video Link");
            });
        }

        // function GetTitleName(param){
        //     debugger
         
            
        // }

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.CreateLinkunit = {};
        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.unit = {};
            // vm.DocList = {};
            vm.Type = {};
            vm.videoList = {};
        }

        Init()

        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            GetAllLinks();
        }

        function GetAllLinks() {
            var EmployeeId = AuthenticationService.getLoggedUserDetails().UserId;
            UnitService.GetAllLinkUnits(EmployeeId).then(function (res) {
                if (res.status === 200) {
                    vm.UnitLinkList = res.data;
                    GetAllClassRoom();
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        function GetAllClassRoom() {
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;
                    $rootScope.isLoading = false;
                    // console.log("vm.ClassRoomList"+JSON.stringify(vm.ClassRoomList))
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Unit");
            });
        }


        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.CreateLinkunit.selectedSection = null;
                vm.SectionList = [];
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateLinkunit.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            } else {
                vm.CreateLinkunit.selectedSection = null;
                vm.SectionList = [];
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateLinkunit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            } else {
                vm.CreateLinkunit.selectedSubject = null;
                vm.SubjectList = [];
            }
        }

        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.CreateLinkunit.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }

                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            } else {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }


        $scope.fileChanged = function (event) {
            //debugger
            if (event)
                vm.selectedFile = event.target.files[0];
        }

        function SaveDocument() {
            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile)
            formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
            formData.append('RelatedImageandVideoName', vm.unit.RelatedImageandVideoName)
            formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
            formData.append('SectionName', vm.unit.selectedSection.SectionName)
            formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
            formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)


            UnitService.SaveDoc(formData).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    vm.DocList.push(res.data.result)
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }

        function SaveUploadLinks() {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile)
            formData.append('UnitId', vm.CreateLinkunit.selectedUnit.UnitId)
            formData.append('ReferenceName', vm.CreateLinkunit.ReferenceName)
            formData.append('ClassName', vm.CreateLinkunit.selectedClassRoom.ClassName)
            formData.append('SectionName', vm.CreateLinkunit.selectedSection.SectionName)
            formData.append('SubjectName', vm.CreateLinkunit.selectedSubject.SubjectName)
            formData.append('ChapterName', vm.CreateLinkunit.selectedChapter.ChapterName)
            formData.append('UploadTypeId', vm.CreateLinkunit.selectedFileType.FileTypeId)
            formData.append('UserId', loggedUser.UserId)

            UnitService.SaveUploadedDocs(formData).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    Init();
                    vm.isFormOpen = false;
                    cancel();
                    vm.section = {};
                    vm.DocList = [];
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }


        function getUnitByChapters(ClassId, SectionId, SubjectId, ChapterId, callBack) {
            if (ChapterId) {
                vm.CreateLinkunit.selectedUnit = null;
                vm.UnitList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId,
                    ChapterId: ChapterId
                }
                UnitService.GetAllUnitByChapter(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.UnitList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            } else {
                vm.unit.selectedChapter = null;
                vm.UnitList = [];
            }
        }

        function editLinkUnit(row) {
            vm.CreateLinkunit = {};
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.Type = angular.copy(row.UnitType);
            vm.CreateLinkunit = angular.copy(row);

            // console.log("vm.isEditing  on edit button click"+vm.isEditing)

            //console.log("row======>>>>>>>"+JSON.stringify(row));
            //vm.CreateLinkunit.UnitId = angular.copy(row.UnitId);
            //  vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
            //vm.CreateLinkunit = (row.PostContentFile != undefined) ? angular.copy(JSON.parse(row.PostContentFile)) : null;
            //vm.CreateLinkunit.FileTypeId = (row.FileTypeId != undefined) ? angular.copy(row.FileTypeId);
            $rootScope.ButtonTypeIdCount = row.ButtonTypeId;
            //vm.CreateLinkunit.TextLinkId = angular.copy(row.TextLinkId);
            vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
            vm.CreateLinkunit.LinksWord = angular.copy(row.LinksWord);

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.CreateLinkunit.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.CreateLinkunit.selectedSection = vm.SectionList[i];
                    }
                }
            });

            getSubjectBySection(row.ClassId, row.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                        vm.CreateLinkunit.selectedSubject = vm.SubjectList[i]
                    }
                }
            });


            getChapterBySubject(row.ClassId, row.SectionId, row.SubjectId, function () {
                for (var i in vm.ChapterList) {
                    if (vm.ChapterList[i].ChapterId === row.ChapterId) {
                        vm.CreateLinkunit.selectedChapter = vm.ChapterList[i]
                    }
                }
            });
            getUnitByChapters(row.ClassId, row.SectionId, row.SubjectId, row.ChapterId, function () {
                for (var i in vm.UnitList) {
                    if (vm.UnitList[i].UnitId === row.UnitId) {
                        vm.CreateLinkunit.selectedUnit = vm.UnitList[i]
                    }
                }
            });
            vm.CreateLinkunit.UnitName = angular.copy(row.UnitName);
        }

        function SaveUnitLink(CreateLinkunit) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            // debugger;

            var obj = {

                UnitId: vm.CreateLinkunit.selectedUnit.UnitId,
                PostContent: CreateLinkunit.PostContent,
                LinksWord: vm.CreateLinkunit.LinksWord,
                CreatedBy: loggedUser.UserId,
                UploadTypeId: 3
            }

            if (!vm.isEditing) {

                UnitService.SaveUnitLink(obj).then(function (res) {
                    // console.log("res =====>>>>>>>>>"+JSON.stringify(res))
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Create a Link Inserted Successfully");
                        // if (res.data.Code === 1)
                        //     $rootScope.showToaster('success', res.data.Message, "Unit Master");
                        // if (res.data.Code != 1)
                        //     $rootScope.showToaster('warning', res.data.Message, "Unit Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];

                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Create a Link");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            } else {
                obj.ModifiedBy = loggedUser.UserId;
                obj.UnitId = CreateLinkunit.UnitId
                obj.TextLinkId = CreateLinkunit.TextLinkId;

                // console.log("vm.CreateLinkunit"+JSON.stringify(CreateLinkunit))
                // console.log("obj"+JSON.stringify(obj))
                UnitService.UpdateUnitLink(obj).then(function (res) {
                    console.log("res" + JSON.stringify(res));
                    if (res.data.IsSuccess === true) {

                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Unit Link Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Unit Link Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Unit Link Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }




        // $scope.fileChanged = function (event) {
        //     if (event)
        //         vm.selectedFile = event.target.files[0];
        // }

        // function SaveDocument() {
        //     var formData = new FormData();
        //     formData.append('Attachment', vm.selectedFile)
        //     formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
        //     formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
        //     formData.append('SectionName', vm.unit.selectedSection.SectionName)
        //     formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
        //     formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)
        //     formData.append('ReferenceLink', vm.unit.ReferenceLinkName)


        //     UnitService.SaveDoc(formData).then(function (res) {
        //         if (res.data.msgText === 'Success!') {
        //             $rootScope.showToaster('success', res.data.Message, "File Upload");
        //             vm.DocList.push(res.data.result)
        //         } else {
        //             $rootScope.showToaster('error', res.data.Message, "File Upload");
        //         }
        //     }, function (err) {
        //         $rootScope.showToaster("Something error...try again");
        //     });

        // }

        function SaveVideoLinks() {
            var obj = {
                RefTypeId: vm.unit.ReferenceLinkName,

            }

            UnitService.SaveVideoLinks(obj).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    vm.VideoLinks.push(res.data.result)
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }

        function removeFile(row) {
            //debugger;
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });
            confirm.result.then(function () {
                UnitService.RemoveDoc(row.FileUrl).then(function (res) {
                    if (res.data.msgText === 'Success!') {
                        var index = vm.DocList.indexOf(row);
                        vm.DocList.splice(index, 1);
                        $rootScope.showToaster('success', 'Deleted Successfully', "File Upload");
                    } else {
                        $rootScope.showToaster('error', 'Failed!', "File Upload");
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            });
        }


        function RemoveUnitLink(row) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function () {
                UnitService.RemoveUnitLink(row.TextLinkId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Create a Link Deleted Successfully');
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Create a Link", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete CreateLink. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }



        vm.OpenWindow = function (HtmlPath) {
            window.open($rootScope.endPoint + 'UploadedDocuments/PostcontentDoc/' + HtmlPath);
        }



    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('SectionCtrl', SectionCtrl);

    /** @ngInject */
    function SectionCtrl($http, $rootScope, lodash, dialogs, SectionService, ClassRoomService,AuthenticationService) {
        var vm = this;
        $rootScope.isLoading=true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.section = {};
        vm.Create = Create;
        vm.cancel = cancel;
        vm.SaveSection = SaveSection;
        vm.editSection = editSection;
        vm.removeSection = removeSection;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.section = {};
        }

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
            SectionService.GetAllSection().then(function (res) {
                if (res.status === 200) {
                    vm.SectionList = res.data;
                    $rootScope.isLoading=false;
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
            
        }

        function editSection(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.section = angular.copy(row);
            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId = row.ClassId) {
                    vm.section.selectedClassRoom = vm.ClassRoomList[i]
                }
            }
        }



        function SaveSection(section) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            var obj = {
                ClassId: vm.section.selectedClassRoom.ClassId,
                SectionName: section.SectionName,
                SectionCode: section.SectionCode,
                Process: 'Save',
                CreatedBy: loggedUser.UserId
            }
            if (!vm.isEditing) {
                SectionService.SaveSection(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Section Master");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Section Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Section Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });

            }
            else {
                obj.ModifiedBy = loggedUser.UserId;
                obj.SectionId = vm.section.SectionId
                SectionService.SaveSection(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Section Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Section Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Section Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        function removeSection(row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                SectionService.SaveSection(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Section Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Section", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Section.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('SubjectCtrl', SubjectCtrl);

    /** @ngInject */
    function SubjectCtrl($http, $rootScope, $scope, lodash, dialogs, ClassRoomService, SectionService, SubjectService,AuthenticationService,ChapterService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = false;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = false;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.subject = {};
        vm.getSectionByClass = getSectionByClass;
        vm.SaveSubject = SaveSubject;
        vm.editSubject = editSubject;
        vm.removeSubject = removeSubject;
        vm.editProPic = editProPic;
        vm.isEditingProPic = false;
        $scope.photoChanged = photoChanged;
        var formData = new FormData();
        
        var logggedUser = AuthenticationService.getLoggedUserDetails();


        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.subject = {};
        }


        function editProPic() {
            vm.isEditingProPic = true;
        }
        $scope.imageIsLoaded = function (e) {
            $scope.$apply(function () {
                vm.profilePicUrl = e.target.result;
            });
        }




        function photoChanged(event) {
            var reader = new FileReader();
            if (!vm.isEditingProPic) {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
            } else {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
                var formData = new FormData();
                formData.append('profilePic', vm.empProfilePic);
                formData.append('SubjectId', vm.subject.SubjectId);
                SubjectService.UpdateProfilePic(formData).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Subject picture changed succussfully', "Success");
                        Init();
                    } else {
                        $rootScope.showToaster('error', 'Internal server Error!', "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Internal server Error!', "Error");
                });
            }
        }
        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            getAllSubject();
            getAllStandard();
            // getAllTerms();
        }


        function getAllSubject(){
            SubjectService.GetAllSubject().then(function (res) {
                if (res.status === 200) {
                    vm.SubjectList = res.data;
               
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }

        function getAllStandard(){
                 ClassRoomService.GetAllClassRoom().then(function (res) {
                        if (res.status === 200) {
                    
                            vm.ClassRoomList = res.data;
                            $rootScope.isLoading = false;
                        } else {
                            $rootScope.isLoading = false;
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                        }
                    }, function (err) {
                        $rootScope.isLoading = false;
                        $rootScope.showToaster('error', 'Error! Try Again', "Country");
                    });
        }


        function getSectionByClass(Class, callBack) {
           // debugger
            vm.subject.selectedSection = null;
            vm.subject.selectedTerm = null;
                vm.SectionList = [];
            vm.subject.SubjectName = "";
            vm.subject.SubjectCode = "";
            SectionService.GetAllSectionByClass(Class.ClassId).then(function (res) {
                if (res.status === 200) {
                    vm.SectionList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
                if (callBack)
                    callBack();
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        vm.SaveSubject1 = function (subject){
            debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            if(vm.isEditing){
                var obj = {
                    ClassId: vm.subject.selectedClassRoom.ClassId,
                    SectionId: vm.subject.selectedSection.SectionId,
                    SubjectName: vm.subject.SubjectName,
                    SubjectCode: vm.subject.SubjectCode,
                    Process: 'Save',
                    CreatedBy: loggedUser.UserId,
                    SectionName:vm.subject.SectionName,
                    ClassName:vm.subject.ClassName,
                    SubjectId:vm.subject.SubjectId
                }
            }
            else{
                var obj = {
                    ClassId: vm.subject.selectedClassRoom.ClassId,
                    SectionId: vm.subject.selectedSection.SectionId,
                    SubjectName: vm.subject.SubjectName,
                    SubjectCode: vm.subject.SubjectCode,
                    Process: 'Save',
                    CreatedBy: loggedUser.UserId,
                    SectionName:vm.subject.SectionName,
                    ClassName:vm.subject.ClassName
                }
            }
           


            SubjectService.SaveSubject(obj).then(function (res) {
                $rootScope.showToaster('success', 'Subejct added successfully', "success");
                Init();
                vm.cancel();
            }, function (err) {
                $rootScope.showToaster('error', "Something error...try again", "Error");
            });
            vm.isLoading = false;
            vm.isReporingToRequried = false;
        }


        function SaveSubject(subject) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();

            var formData = new FormData();
            // if(vm.subject.selectedClassRoom.IsTermAvailable == 1){
            //     var obj = {
            //         ClassId: vm.subject.selectedClassRoom.ClassId,
            //         SectionId: vm.subject.selectedSection.SectionId,
            //         SubjectName: vm.subject.SubjectName,
            //         SubjectCode: vm.subject.SubjectCode,
            //         Process: 'Save',
            //         CreatedBy: loggedUser.UserId,
            //         SectionName:vm.subject.SectionName,
            //         ClassName:vm.subject.ClassName,
            //         TermId:subject.selectedTerm.TermId
            //     }
            // }

            // else if(vm.subject.selectedClassRoom.IsTermAvailable == 0){
                
            // }

            var obj = {
                ClassId: vm.subject.selectedClassRoom.ClassId,
                SectionId: vm.subject.selectedSection.SectionId,
                SubjectName: vm.subject.SubjectName,
                SubjectCode: vm.subject.SubjectCode,
                Process: 'Save',
                CreatedBy: loggedUser.UserId,
                SectionName:vm.subject.SectionName,
                ClassName:vm.subject.ClassName,
                // TermId:0
            }

            
            
            formData.append('profilePic', vm.empProfilePic);
            formData.append('data', JSON.stringify(obj));
            
            if (!vm.isEditing) {
                SubjectService.SaveSubject(formData).then(function (res) {
                    $rootScope.showToaster('success', 'Subejct added successfully', "success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.isLoading = false;
                vm.isReporingToRequried = false;
            } else {
                SubjectService.EditEmployee(emp).then(function (res) {
                    $rootScope.showToaster('success', 'Subject updated successfully', "Success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.emp = {};
                vm.emp1 = {};
                vm.isLoading = false;
            }
            
            if (!vm.isEditing) {
                SubjectService.SaveSubject(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Subject Master");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Subject Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Subject Master");
                        vm.isFormOpen = true;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                
                obj.SubjectId = subject.SubjectId;
                SubjectService.SaveSubject(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Subject Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Subject Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Subject Master");
                        vm.isFormOpen = true;
                        vm.isEditing = false;
                    }

                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        function editSubject(row) {
            console.log(JSON.stringify(row))
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.subject.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.subject.selectedSection = vm.SectionList[i]
                    }
                }
            });

            // for(var i in vm.TermsList){
            //     if(vm.TermsList[i].TermId == row.TermId){
            //         vm.subject.selectedTerm = vm.TermsList[i]
            //     }
            // }
            vm.subject.SubjectName = angular.copy(row.SubjectName);
            vm.subject.SubjectCode = angular.copy(row.SubjectCode);
            vm.subject.SubjectId = angular.copy(row.SubjectId);
            
            
            //vm.empProfilePic = vm.profilePicUrl = $rootScope.endPoint + row.PhotoUrl;
        }

        function removeSubject(row) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                SubjectService.SaveSubject(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Subject Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Subject", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Subject.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }

        function getAllTerms(){
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
        }







    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('TermCtrl', TermCtrl);

    /** @ngInject */
    function TermCtrl($http, $rootScope, $scope, lodash, dialogs, ClassRoomService, SectionService, SubjectService, AuthenticationService, ChapterService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = false;
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = false;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.subject = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.SaveSubject = SaveSubject;
        vm.editSubject = editSubject;
        vm.removeSubject = removeSubject;
        vm.editProPic = editProPic;
        vm.isEditingProPic = false;
        $scope.photoChanged = photoChanged;
        var formData = new FormData();

        var logggedUser = AuthenticationService.getLoggedUserDetails();


        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }

        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.subject = {};
        }


        function editProPic() {
            vm.isEditingProPic = true;
        }
        $scope.imageIsLoaded = function (e) {
            $scope.$apply(function () {
                vm.profilePicUrl = e.target.result;
            });
        }

        function photoChanged(event) {
            var reader = new FileReader();
            if (!vm.isEditingProPic) {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
            } else {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
                var formData = new FormData();
                formData.append('profilePic', vm.empProfilePic);
                // formData.append('SubjectId', vm.subject.SubjectId);
                // SubjectService.UpdateProfilePic(formData).then(function (res) {
                //     if (res.status === 200) {
                //         $rootScope.showToaster('success', 'Subject picture changed succussfully', "Success");
                //         Init();
                //     } else {
                //         $rootScope.showToaster('error', 'Internal server Error!', "Error");
                //     }
                // }, function (err) {
                //     $rootScope.showToaster('error', 'Internal server Error!', "Error");
                // });
            }
        }
        Init()

        function Init() {
            vm.IsTermAvailable = false;
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            //getAllSubject();
            getAllTermImg();
            getAllStandard();
            getAllTerms();
        }


        // function getAllSubject(){
        //     SubjectService.GetAllSubject().then(function (res) {
        //         if (res.status === 200) {
        //             vm.SubjectList = res.data;

        //         } else {
        //             $rootScope.isLoading = false;
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //         }
        //     }, function (err) {
        //         $rootScope.isLoading = false;
        //         $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //     });
        // }

        function getAllTermImg() {
            SubjectService.GetAllTermImg().then(function (res) {
                if (res.status === 200) {
                    vm.TermImgList = res.data;
                    console.log(JSON.stringify(vm.TermImgList));
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.showToaster('error', "Something error...try again", "Error");
            });
        }

        function getAllStandard() {
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {

                    vm.ClassRoomList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }


        function getSectionByClass(Class, callBack) {
            debugger

            if(Class.IsTermAvailable == 1){
                vm.IsTermAvailable = true;
                vm.subject.selectedTerm = null;
            }
            else{
                vm.IsTermAvailable = false;
            }

            vm.subject.selectedSection = null;
            vm.subject.selectedSubject = null;
            
            vm.SectionList = [];
            vm.subject.SubjectName = "";
            vm.subject.SubjectCode = "";
            SectionService.GetAllSectionByClass(Class.ClassId).then(function (res) {
                if (res.status === 200) {
                    vm.SectionList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
                if (callBack)
                    callBack();
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
           // debugger;
            if (SectionId) {
                vm.subject.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                        // getAllTerms();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            } else {
                vm.subject.selectedSubject = null;
                vm.SubjectList = [];
            }
        }


        // vm.SaveSubject1 = function (subject){
        //     debugger
        //     var loggedUser = AuthenticationService.getLoggedUserDetails();

        //     var obj = {
        //         ClassId: vm.subject.selectedClassRoom.ClassId,
        //         SectionId: vm.subject.selectedSection.SectionId,
        //         SubjectName: vm.subject.SubjectName,
        //         SubjectCode: vm.subject.SubjectCode,
        //         Process: 'Save',
        //         CreatedBy: loggedUser.UserId,
        //         SectionName:vm.subject.SectionName,
        //         ClassName:vm.subject.ClassName
        //     }


        //     SubjectService.SaveSubject(obj).then(function (res) {
        //         $rootScope.showToaster('success', 'Subejct added successfully', "success");
        //         Init();
        //         vm.cancel();
        //     }, function (err) {
        //         $rootScope.showToaster('error', "Something error...try again", "Error");
        //     });
        //     vm.isLoading = false;
        //     vm.isReporingToRequried = false;
        // }


        function SaveSubject(subject) {
            debugger
            var loggedUser = AuthenticationService.getLoggedUserDetails();

            var formData = new FormData();


            var term;
            if(vm.IsTermAvailable){
                term = subject.selectedTerm.TermId;
            }
            else {
                term = 0;
            }

          debugger
            var obj = {
                SubjectId: vm.subject.selectedSubject.SubjectId,
                TermId: term,
                CreatedBy: loggedUser.UserId
            }

            formData.append('profilePic', vm.empProfilePic);
            formData.append('data', JSON.stringify(obj));

            if (!vm.isEditing) {
                SubjectService.SaveTermImg(formData).then(function (res) {
                    $rootScope.showToaster('success', 'Subejct added successfully', "success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.isLoading = false;
                vm.isReporingToRequried = false;
            } else {
                SubjectService.EditEmployee(emp).then(function (res) {
                    $rootScope.showToaster('success', 'Subject updated successfully', "Success");
                    Init();
                    vm.cancel();
                }, function (err) {
                    $rootScope.showToaster('error', "Something error...try again", "Error");
                });
                vm.emp = {};
                vm.emp1 = {};
                vm.isLoading = false;
            }

            // if (!vm.isEditing) {
            //     SubjectService.SaveSubject(obj).then(function (res) {
            //         if (res.data.IsSuccess === true) {
            //             if (res.data.Code === 1)
            //                 $rootScope.showToaster('success', res.data.Message, "Subject Master");
            //             if (res.data.Code != 1)
            //                 $rootScope.showToaster('warning', res.data.Message, "Subject Master");
            //             Init();
            //             vm.isFormOpen = false;
            //             cancel();
            //             vm.section = {};
            //         } else {
            //             $rootScope.showToaster('error', res.data.Message, "Subject Master");
            //             vm.isFormOpen = true;
            //         }

            //     }, function (err) {
            //         $rootScope.showToaster("Something error...try again");
            //     });
            // } else {

            //     obj.SubjectId = subject.SubjectId;
            //     SubjectService.SaveSubject(obj).then(function (res) {
            //         if (res.data.IsSuccess === true) {
            //             if (res.data.Code === 3)
            //                 $rootScope.showToaster('success', res.data.Message, "Subject Master");
            //             if (res.data.Code != 3)
            //                 $rootScope.showToaster('warning', res.data.Message, "Subject Master");
            //             Init();
            //             vm.isFormOpen = false;
            //             cancel();
            //             vm.section = {};
            //             vm.isEditing = false;
            //         } else {
            //             $rootScope.showToaster('error', res.data.Message, "Subject Master");
            //             vm.isFormOpen = true;
            //             vm.isEditing = false;
            //         }

            //     }, function (err) {
            //         $rootScope.showToaster("Something error...try again");
            //     });
            // }
        }

        function editSubject(row) {
            debugger
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.subject.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.subject.selectedSection = vm.SectionList[i]
                    }
                }
            });

            // for(var i in vm.TermsList){
            //     if(vm.TermsList[i].TermId == row.TermId){
            //         vm.subject.selectedTerm = vm.TermsList[i]
            //     }
            // }
            vm.subject.SubjectName = angular.copy(row.SubjectName);
            vm.subject.SubjectCode = angular.copy(row.SubjectCode);
            vm.subject.SubjectId = angular.copy(row.SubjectId);


            //vm.empProfilePic = vm.profilePicUrl = $rootScope.endPoint + row.PhotoUrl;
        }

        function removeSubject(row) {
            debugger
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });
            row.Process = 'Delete'
            confirm.result.then(function () {
                SubjectService.SaveSubject(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Subject Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Subject", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Subject.  If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }

        function getAllTerms() {
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
        }







    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('TermActivationCtrl', TermActivationCtrl);

    /** @ngInject */
    function TermActivationCtrl($http, $rootScope, $scope, lodash, dialogs,AuthenticationService,ChapterService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = true;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
      
        vm.isLoading = true;
       
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            getAllTerms();
            
        }


        function getAllTerms(){
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                    getSelectedTerm();
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
            $rootScope.isLoading = false;
        }

        function getSelectedTerm(){
            ChapterService.GetSelectedTerm().then(function (res) {
                if (res.status === 200) {
                   // debugger
                    vm.SelectTerm = res.data;

                    for(var i in vm.TermsList){
                        if(vm.TermsList[i].TermId ==  vm.SelectTerm[0].TermId){
                            vm.selectedTerm = vm.TermsList[i];
                            vm.currentTerm = vm.TermsList[i].TermName;
                        }
                    }

                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Selected Term");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Selected Term");
            });
            $rootScope.isLoading = false;
        }

        vm.saveTermActivity = function(id){
//debugger
            var data = {
                TermId : id.TermId,
                UserId : logggedUser.UserId
            }

            ChapterService.SaveTermActivity(data).then(function(res){
                if(res.data.IsSuccess == true){
                    getSelectedTerm();
                    $rootScope.showToaster('success', res.data.Message, "Term Activity");
                }
                else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Term Activity");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Term Activity");
            });
        }

        // function getSectionByClass(ClassId, callBack) {
        //     vm.subject.selectedSection = null,
        //         vm.SectionList = [];
        //     vm.subject.SubjectName = "";
        //     vm.subject.SubjectCode = "";
        //     SectionService.GetAllSectionByClass(ClassId).then(function (res) {
        //         if (res.status === 200) {
        //             vm.SectionList = res.data;
        //         } else {
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //         }
        //         if (callBack)
        //             callBack();
        //     }, function (err) {
        //         $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //     });
        // }

        // function SaveSubject(subject) {
        //     var loggedUser = AuthenticationService.getLoggedUserDetails();

        //     var formData = new FormData();
        //     var obj = {
        //         ClassId: vm.subject.selectedClassRoom.ClassId,
        //         SectionId: vm.subject.selectedSection.SectionId,
        //         SubjectName: vm.subject.SubjectName,
        //         SubjectCode: vm.subject.SubjectCode,
        //         Process: 'Save',
        //         CreatedBy: loggedUser.UserId,
        //         SectionName:vm.subject.SectionName,
        //         ClassName:vm.subject.ClassName
        //     }
        //     formData.append('profilePic', vm.empProfilePic);
        //     formData.append('data', JSON.stringify(obj));
            
        //     if (!vm.isEditing) {
        //         SubjectService.SaveSubject(formData).then(function (res) {
        //             $rootScope.showToaster('success', 'Subejct added successfully', "success");
        //             Init();
        //             vm.cancel();
        //         }, function (err) {
        //             $rootScope.showToaster('error', "Something error...try again", "Error");
        //         });
        //         vm.isLoading = false;
        //         vm.isReporingToRequried = false;
        //     } else {
        //         SubjectService.EditEmployee(emp).then(function (res) {
        //             $rootScope.showToaster('success', 'Subject updated successfully', "Success");
        //             Init();
        //             vm.cancel();
        //         }, function (err) {
        //             $rootScope.showToaster('error', "Something error...try again", "Error");
        //         });
        //         vm.emp = {};
        //         vm.emp1 = {};
        //         vm.isLoading = false;
        //     }
            
        //     if (!vm.isEditing) {
        //         SubjectService.SaveSubject(obj).then(function (res) {
        //             if (res.data.IsSuccess === true) {
        //                 if (res.data.Code === 1)
        //                     $rootScope.showToaster('success', res.data.Message, "Subject Master");
        //                 if (res.data.Code != 1)
        //                     $rootScope.showToaster('warning', res.data.Message, "Subject Master");
        //                 Init();
        //                 vm.isFormOpen = false;
        //                 cancel();
        //                 vm.section = {};
        //             } else {
        //                 $rootScope.showToaster('error', res.data.Message, "Subject Master");
        //                 vm.isFormOpen = true;
        //             }

        //         }, function (err) {
        //             $rootScope.showToaster("Something error...try again");
        //         });
        //     }
        //     else {
                
        //         obj.SubjectId = subject.SubjectId;
        //         SubjectService.SaveSubject(obj).then(function (res) {
        //             if (res.data.IsSuccess === true) {
        //                 if (res.data.Code === 3)
        //                     $rootScope.showToaster('success', res.data.Message, "Subject Master");
        //                 if (res.data.Code != 3)
        //                     $rootScope.showToaster('warning', res.data.Message, "Subject Master");
        //                 Init();
        //                 vm.isFormOpen = false;
        //                 cancel();
        //                 vm.section = {};
        //                 vm.isEditing = false;
        //             } else {
        //                 $rootScope.showToaster('error', res.data.Message, "Subject Master");
        //                 vm.isFormOpen = true;
        //                 vm.isEditing = false;
        //             }

        //         }, function (err) {
        //             $rootScope.showToaster("Something error...try again");
        //         });
        //     }
        // }

        // function editSubject(row) {
        //     vm.isEditing = true;
        //     vm.isFormOpen = true;
        //     vm.isTableOpen = false;
        //     for (var i in vm.ClassRoomList) {
        //         if (vm.ClassRoomList[i].ClassId === row.ClassId) {
        //             vm.subject.selectedClassRoom = vm.ClassRoomList[i]
        //         }
        //     }
        //     getSectionByClass(row.ClassId, function () {
        //         for (var i in vm.SectionList) {
        //             if (vm.SectionList[i].SectionId === row.SectionId) {
        //                 vm.subject.selectedSection = vm.SectionList[i]
        //             }
        //         }
        //     });
        //     vm.subject.SubjectName = angular.copy(row.SubjectName);
        //     vm.subject.SubjectCode = angular.copy(row.SubjectCode);
        //     vm.subject.SubjectId = angular.copy(row.SubjectId);
            
        //     vm.empProfilePic = vm.profilePicUrl = $rootScope.endPoint + row.PhotoUrl;
        // }

        // function removeSubject(row) {
        //     var confirm = dialogs.confirm('Confirm',
        //         'Are sure you want to delete current row.', { animation: true, size: 'sm' });
        //     row.Process = 'Delete'
        //     confirm.result.then(function () {
        //         SubjectService.SaveSubject(row).then(function (res) {
        //             if (res.status === 200) {
        //                 $rootScope.showToaster('success', res.data.Message, "Subject Master");
        //                 Init();
        //             } else {
        //                 $rootScope.showToaster('error', "Can't Delete Subject", { animation: true, size: 'sm' });
        //             }
        //         }, function (err) {
        //             $rootScope.showToaster('error', "Can't Delete Subject.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
        //         });
        //     }, function () {

        //     })
        // }







    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('TimetableCtrl', TimetableCtrl);

    /** @ngInject */
    function TimetableCtrl($http, $scope,$filter, $rootScope, $sce, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService, UnitService,AuthenticationService) {
        var vm = this;
        // Pagination code
        $rootScope.isLoading = true;
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];
        vm.radioDisable = false;
        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.unit = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
        vm.getUnitByChapters = getUnitByChapters;
        //vm.editChapter = editChapter;
        // vm.removeUnit = removeUnit;
        // vm.SaveDocument = SaveDocument;
        // vm.removeFile = removeFile;
        vm.editLinkUnit = editLinkUnit;
        // vm.SaveUploadLinks = SaveUploadLinks;
        // vm.DocList = [];
        // var arr = [];
        // vm.VideoLinks = [];
        var logggedUser = AuthenticationService.getLoggedUserDetails();
        vm.SaveTimeTable = SaveTimeTable;
        // vm.LinksUpdate = LinksUpdate;
        //debugger
       // vm.Type = 'P';
       vm.TimetableList;
       vm.GetTimeTable = GetTimeTable


        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.ShowCreateBtn = true;
            vm.ShowUpdateBtn = false;
            vm.CreateLinkunit = {};
            vm.radioDisable = false;
            //debugger
            vm.Type = 'P';
        }
        function cancel() {
            // vm.isFormOpen = false;
            // vm.isEditing = false;
            // vm.unit = {};
            // // vm.DocList = {};
            // //debugger
            // vm.Type = '';
            // vm.videoList = {};
            // vm.radioDisable = false;

            vm.CreateTimeTable = null;
        }

        Init()
        function Init() {
            //  GetTimeTable();
            //  GetAllLinks();
            // vm.isEditing = false;
            // vm.isFormOpen = true;
            // vm.isTableOpen = false;
            // vm.ShowCreateBtn = true;
            // vm.ShowUpdateBtn = false;
            // vm.radioDisable = false;
            //debugger
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            GetAllClassRoom();
            ClassRoomService.GetClasstimings(companyId).then(function (res) {
                if (res.status === 200) {
                    vm.Classtiming = res.data;
                    console.log(vm.Classtiming);
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Class Timing");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Class Timing");
            });

            ClassRoomService.GetLocation(companyId).then(function (res) {
                if (res.status === 200) {
                    vm.Location = res.data;
                    console.log(vm.Location);
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Location");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Location");
            });

        }

        vm.open1 = function () {
            vm.popup1.opened = true;
            // GetTimeTable();
        };


        vm.popup1 = {
            opened: false
        };

        function GetTimeTable(){
            var obj = {
                ClassId:vm.CreateTimeTable.selectedClassRoom.ClassId,
                SectionId:vm.CreateTimeTable.selectedSection.SectionId,
                TimeTableDate:$filter('date')(vm.CreateTimeTable.date, 'yyyy-MM-dd')
            }
            ClassRoomService.GetTimeTable(obj).then(function (res) {
                if (res.status === 200) {
                     vm.TimetableList = res.data;
                     console.log(res);
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Get TimeTable");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Get TimeTable");
            })
        }

        // function GetAllLinks(){
        //     var EmployeeId = AuthenticationService.getLoggedUserDetails().UserId;
        //     UnitService.GetAllLinkUnits(EmployeeId).then(function (res) {
        //         if (res.status === 200) {
        //             vm.UnitLinkList = res.data;
        //             $rootScope.isLoading = false;
        //             //console.log("vm.UnitLinkList >> "+JSON.stringify(vm.UnitLinkList))
        //             GetAllClassRoom();
        //         } else {
        //             $rootScope.isLoading = false;
        //             $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
        //         }
        //     }, function (err) {
        //         $rootScope.isLoading = false;
        //         $rootScope.showToaster('error', 'Error! Try Again', "Country");
        //     });
        // }


        function GetAllClassRoom(){
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;

                   // console.log("vm.ClassRoomList"+JSON.stringify(vm.ClassRoomList))
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Unit");
            });
        }
  

        function  SaveTimeTable(timetale){
            console.log(JSON.stringify(timetale))
            debugger
            // var loggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                
                var obj = {
                    ClassId:timetale.selectedClassRoom.ClassId,
                    SectionId:timetale.selectedSection.SectionId,
                    TimeTableDate:$filter('date')(timetale.date, 'yyyy-MM-dd'),
                    ClassTimingsId:timetale.selectedTime.ClassTimingsId,
                    SubjectId:timetale.selectedSubject.SubjectId,
                    ChapterId:timetale.selectedChapter.ChapterId,
                    UnitId:timetale.selectedSession.UnitId,
                    EmployeeId:timetale.selectedTeacher.StaffId,
                    LocationId:timetale.selectedLocation.LocationId,
                    CreatedBy:logggedUser.UserId
                }            
                
                ClassRoomService.CreateTimeTable(obj).then(function (res) {
                    console.log(res)
                    if (res.data === true) {
                        $rootScope.showToaster('success', res.data.Message, "TimeTable Master");
                        // if (res.data.Code === 1)
                        //     $rootScope.showToaster('success', res.data.Message, "TimeTable Master");
                        // if (res.data.Code != 1)
                        //     $rootScope.showToaster('warning', res.data.Message, "TimeTable Master");
                        // Init();
                        // vm.isFormOpen = false;
                        // cancel();
                        vm.CreateTimeTable.selectedTime = null;
                        vm.CreateTimeTable.selectedSubject = null;
                        vm.CreateTimeTable.selectedChapter = null;
                        vm.CreateTimeTable.selectedSession = null;
                        vm.CreateTimeTable.selectedTeacher = null;
                        vm.CreateTimeTable.selectedLocation = null;
                        GetTimeTable();
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "TimeTable Master");
                        vm.isFormOpen = true;
                    }    
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }           
        }

        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.CreateTimeTable.selectedSection = null;
                vm.SectionList = [];
                vm.CreateTimeTable.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateTimeTable.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.CreateTimeTable.selectedSection = null;
                vm.SectionList = [];
                vm.CreateTimeTable.selectedSubject = null;
                vm.SubjectList = [];
                vm.CreateTimeTable.selectedChapter = null;
                vm.ChapterList = [];
            }
        }


        function getAllTerms(){
            ChapterService.GetAllTerms().then(function (res) {
                if (res.status === 200) {
                    vm.TermsList = res.data;
                } else {
                    $rootScope.isLoading=false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
                }
            }, function (err) {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Error! Try Again', "Terms");
            });
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.CreateTimeTable.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                        getAllTerms();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.CreateTimeTable.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.CreateTimeTable.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }

                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });

                ClassRoomService.GetStafflist(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.TeachersList = res.data;
                        console.log(vm.TeachersList);
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Teacher");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Teacher");
                });


            }
            else {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
                vm.TeachersList = [];
            }
        }


        // $scope.fileChanged = function (event) {
        //     //debugger
        //     if (event)
        //         vm.selectedFile = event.target.files[0];  
        // }

        // function SaveDocument() {
        //     var formData = new FormData();
        //     formData.append('Attachment', vm.selectedFile)
        //     formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
        //     formData.append('RelatedImageandVideoName',vm.unit.RelatedImageandVideoName)
        //     formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
        //     formData.append('SectionName', vm.unit.selectedSection.SectionName)
        //     formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
        //     formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)


        //     UnitService.SaveDoc(formData).then(function (res) {
        //         if (res.data.msgText === 'Success!') {
        //             $rootScope.showToaster('success', res.data.Message, "File Upload");
        //             vm.DocList.push(res.data.result)
        //         } else {
        //             $rootScope.showToaster('error', res.data.Message, "File Upload");
        //         }
        //     }, function (err) {
        //         $rootScope.showToaster("Something error...try again");
        //     });

        // }

        //  function SaveUploadLinks(){
        //     var loggedUser = AuthenticationService.getLoggedUserDetails();
        //     var formData = new FormData();
        //     formData.append('Attachment', vm.selectedFile)
        //     formData.append('UnitId', vm.CreateLinkunit.selectedUnit.UnitId)
        //     formData.append('ReferenceName', vm.CreateLinkunit.LinksWord)
        //     formData.append('ClassName', vm.CreateLinkunit.selectedClassRoom.ClassName)
        //     formData.append('SectionName', vm.CreateLinkunit.selectedSection.SectionName)
        //     formData.append('SubjectName', vm.CreateLinkunit.selectedSubject.SubjectName)
        //     formData.append('ChapterName', vm.CreateLinkunit.selectedChapter.ChapterName)
        //     formData.append('UploadTypeId', vm.CreateLinkunit.selectedFileType.FileTypeId)
        //     formData.append('UserId', loggedUser.UserId)

        //     UnitService.SaveUploadedDocs(formData).then(function (res) {
        //         if (res.data.msgText === 'Success!') {
        //             $rootScope.showToaster('success', res.data.Message, "File Upload");
        //             Init();
        //             vm.isFormOpen = false;
        //             cancel();
        //             vm.section = {};
        //             vm.DocList = [];
        //         } else {
        //             $rootScope.showToaster('error', res.data.Message, "File Upload");
        //         }
        //     }, function (err) {
        //         $rootScope.showToaster("Something error...try again");
        //     });
        
        // }


        function getUnitByChapters(ClassId, SectionId, SubjectId,ChapterId, callBack) {
            if (ChapterId) {
                vm.CreateTimeTable.selectedUnit = null;
                vm.UnitList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId,
                    ChapterId: ChapterId
                }
                UnitService.GetAllUnitByChapter(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.UnitList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedChapter = null;
                vm.UnitList = [];
            }
        }

        function editLinkUnit(row) {
            //debugger
            
            vm.CreateLinkunit = {};
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            
            if(row.UploadTypeId == 3){
                vm.Type = "P";
            }
            else{
                vm.Type = "A";
            }
            vm.CreateLinkunit.selectedFileType = row.UploadTypeId; 
            vm.CreateLinkunit.LinksWord = angular.copy(row.LinksWord);
            vm.ShowCreateBtn = false;
            vm.ShowUpdateBtn = true;
           vm.UpdateTextLinkId = row.TextLinkId;
           vm.radioDisable = true;

        //    document.getElementById("inlineRadio2").disabled = true;

           // vm.Type = angular.copy(row.UnitType);
            vm.CreateLinkunit = angular.copy(row);

           // console.log("vm.isEditing  on edit button click"+vm.isEditing)

            //console.log("row======>>>>>>>"+JSON.stringify(row));
           //vm.CreateLinkunit.UnitId = angular.copy(row.UnitId);
         //  vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
            //vm.CreateLinkunit = (row.PostContentFile != undefined) ? angular.copy(JSON.parse(row.PostContentFile)) : null;
            //vm.CreateLinkunit.FileTypeId = (row.FileTypeId != undefined) ? angular.copy(row.FileTypeId);
            $rootScope.ButtonTypeIdCount = row.ButtonTypeId;
            //vm.CreateLinkunit.TextLinkId = angular.copy(row.TextLinkId);
               vm.CreateLinkunit.PostContent = angular.copy(row.PostContent);
               vm.CreateLinkunit.LinksWord = angular.copy(row.LinksWord);

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.CreateLinkunit.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.CreateLinkunit.selectedSection = vm.SectionList[i];
                    }
                }
            });

            for (var i in vm.FileTypeList) {
                if (vm.FileTypeList[i].FileTypeId === row.UploadTypeId) {
                    vm.CreateLinkunit.selectedFileType = vm.FileTypeList[i]
                }
            }

            getSubjectBySection(row.ClassId, row.SectionId, function () {
                for (var i in vm.SubjectList) {
                    if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                        vm.CreateLinkunit.selectedSubject = vm.SubjectList[i]
                    }
                }
            });


            getChapterBySubject(row.ClassId, row.SectionId, row.SubjectId, function () {
                for (var i in vm.ChapterList) {
                    if (vm.ChapterList[i].ChapterId === row.ChapterId) {
                        vm.CreateLinkunit.selectedChapter = vm.ChapterList[i]
                    }
                }
            });
            getUnitByChapters(row.ClassId, row.SectionId, row.SubjectId,row.ChapterId, function () {
                for (var i in vm.UnitList) {
                    if (vm.UnitList[i].UnitId === row.UnitId) {
                        vm.CreateLinkunit.selectedUnit = vm.UnitList[i]
                    }
                }
            });
            vm.CreateLinkunit.UnitName = angular.copy(row.UnitName);
        }


       
    




        // $scope.fileChanged = function (event) {
        //     if (event)
        //         vm.selectedFile = event.target.files[0];
        // }

        // function SaveDocument() {
        //     var formData = new FormData();
        //     formData.append('Attachment', vm.selectedFile)
        //     formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
        //     formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
        //     formData.append('SectionName', vm.unit.selectedSection.SectionName)
        //     formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
        //     formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)
        //     formData.append('ReferenceLink', vm.unit.ReferenceLinkName)


        //     UnitService.SaveDoc(formData).then(function (res) {
        //         if (res.data.msgText === 'Success!') {
        //             $rootScope.showToaster('success', res.data.Message, "File Upload");
        //             vm.DocList.push(res.data.result)
        //         } else {
        //             $rootScope.showToaster('error', res.data.Message, "File Upload");
        //         }
        //     }, function (err) {
        //         $rootScope.showToaster("Something error...try again");
        //     });

        // }



          




        vm.removeTimetable = function (obj){
            debugger

            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });
            confirm.result.then(function() {
                ClassRoomService.DeleteTimetable(obj.TimeTableId).then(function(res){
                console.log("DeleteTimetable result >>>"+JSON.stringify(res.data))
                if (res.status === 200) {
                    $rootScope.showToaster('success', 'Remove Timetable Successfully');
                    GetTimeTable();
                } else {
                    $rootScope.showToaster('error', "Can't Delete Timetable", {
                        animation: true,
                        size: 'sm'
                    });
                }
            },function(err) {
                $rootScope.showToaster('error', "Can't Delete Timetable. If its not a parent contact your Admin", {
                    animation: true,
                    size: 'sm'
                });
            });
        }, function() {            
            })
        }

        


    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.master')
        .controller('UnitCtrl', UnitCtrl);

    /** @ngInject */
    function UnitCtrl($http, $scope, $rootScope, $sce, lodash, dialogs, ChapterService, ClassRoomService, SectionService, SubjectService, UnitService,AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isLoading = true;
        vm.Create = Create;
        vm.cancel = cancel;
        vm.unit = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getSubjectBySection = getSubjectBySection;
        vm.getChapterBySubject = getChapterBySubject;
      //  vm.getUnitByChapter  = getUnitByChapter;
        vm.SaveUnit = SaveUnit;
        vm.SaveVideoLinksUnit = SaveVideoLinksUnit;

        //vm.editChapter = editChapter;
        // vm.removeUnit = removeUnit;
        vm.SaveDocument = SaveDocument;
        vm.removeFile = removeFile;
        vm.editUnit = editUnit;
        vm.editLinks = editLinks;
        vm.DocList = [];
        var arr = [];
        vm.VideoLinks = [];
        vm.VideoLinksUnitList = [];
        vm.RemovevideoLinks = RemovevideoLinks;
        vm.GetAllVideoLinksUnit = GetAllVideoLinksUnit;
        vm.setPathIds = setPathIds;
     
        var logggedUser = AuthenticationService.getLoggedUserDetails();


        vm.VideoLinksList = [{
            VideoTypename: "Reference Videos",
            VideoTypeId: 1
        },
        {
            VideoTypename: "Teacher Suggested Videos",
            VideoTypeId: 2
        },
        {
            VideoTypename: "Most Popular Videos",
            VideoTypeId: 3
        },
        {
            VideoTypename: "Related Videos",
            VideoTypeId: 4
        }];
        
        vm.FileTypeList = [{
            FileTypeName: "Image",
            FileTypeId: 1
        },
        {
            FileTypeName: "Video",
            FileTypeId: 2
        }
    //     ,
    //     {

    //         FileTypeName: "Reference Video Link",
    //         FileTypeId: 3
    //     },
    //     {
    //         FileTypeName: "Suggesstion Teacher Video Link",
    //         FileTypeId: 4
    //     },
    //     {
    //         FileTypeName: "Most Popular Link",
    //         FileTypeId: 5
    // }
]

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.unit = {};
            vm.Type = {};
            vm.videoList = {};
            $rootScope.PathIds = {};
        }

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            var EmployeeId = AuthenticationService.getLoggedUserDetails().RefId;
            UnitService.GetAllUnits(EmployeeId).then(function (res) {
                if (res.status === 200) {
                    vm.UnitList = res.data;
                    $rootScope.isLoading = false;
                    ClassRoomService.GetAllClassRoom().then(function (res) {
                        if (res.status === 200) {
                            vm.ClassRoomList = res.data;

                        } else {
                            $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Unit");
                    });
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Error! Try Again', "Country");
            });
  
       }


       function getAllTerms(){
        ChapterService.GetAllTerms().then(function (res) {
            if (res.status === 200) {
                vm.TermsList = res.data;
            } else {
                $rootScope.isLoading=false;
                $rootScope.showToaster('error', 'Load Failed! Try Again', "Terms");
            }
        }, function (err) {
            $rootScope.isLoading=false;
            $rootScope.showToaster('error', 'Error! Try Again', "Terms");
        });
    }
        
        function GetAllVideoLinksUnit(){
    
            var UnitId = 18;
        
        UnitService.GetAllVideoLinksUnit().then(function (res) {
            if (res.status === 200) {
                vm.VideoLinksUnitList = res.data;
                console.log(vm.videoList);
            } else {
                $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
            }
        }, function (err) {
            $rootScope.showToaster('error', 'Error! Try Again', "Country");
        });
    }

             // Obj.PostContent = "<html><head><meta charset =\"utf-8\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE = edge\"> <meta name=\"viewport\" content=\"width = device - width, initial - scale = 1\"> </head>" + Obj.PostContent + "</html>";
        // GetFileList();
        // function GetFileList() {
        //     vm.VideoList = []; vm.ImageList = [];

        //     var UnitId = 104;
        //     UnitService.GetFileList(UnitId).then(function (response) {
        //         if (response.data != undefined) {
        //             debugger
        //             vm.Url = response.data;
        //           var FileLists =  JSON.parse(vm.Url[0].PostContentFile);
        //             for (var i in FileLists) {
        //                 if(FileLists[i].FileTypeId == 1 ){
        //                     vm.ImageList.push(FileLists[i].FilePath);
        //                 }else{
        //                     vm.VideoList.push(FileLists[i].FilePath);
        //                 }

        //             }


        //         }
        //         console.log(vm.videoList);
        //     })
        // }
    

        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                vm.unit.selectedSection = null;
                vm.SectionList = [];
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                vm.unit.UnitName = "";
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedSection = null;
                vm.SectionList = [];
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function getSubjectBySection(ClassId, SectionId, callBack) {
            if (SectionId) {
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId
                }
                SubjectService.getAllSubjectBySection(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.SubjectList = res.data;
                        getAllTerms();
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedSubject = null;
                vm.SubjectList = [];
            }
        }
        function getChapterBySubject(ClassId, SectionId, SubjectId, callBack) {
            if (SubjectId) {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];

                var obj = {
                    ClassId: ClassId,
                    SectionId: SectionId,
                    SubjectId: SubjectId
                }
                ChapterService.GetAllChapterBySubject(obj).then(function (res) {
                    if (res.status === 200) {
                        vm.ChapterList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
                vm.unit.selectedChapter = null;
                vm.ChapterList = [];
            }
        }

        function setPathIds(){
            $rootScope.PathIds = {};
            $rootScope.PathIds = {
                ClassId : vm.unit.selectedClassRoom.ClassId,
                SectionId : vm.unit.selectedSection.SectionId,
                SubjectId : vm.unit.selectedSubject.SubjectId,
                ChapterId : vm.unit.selectedChapter.ChapterId,
                UnitId: 0,
                Type:"ContentFile"
            }
        }
       
        
        function editUnit(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.Type = angular.copy(row.UnitType);
            vm.unit.UnitId = angular.copy(row.UnitId);
            vm.unit.PostContent = angular.copy(row.PostContent);
            // vm.DocList = angular.copy(JSON.parse(row.PostContentFile));
            vm.unit.FileTypeId = angular.copy(row.FileTypeId);
            $rootScope.ButtonTypeIdCount = row.ButtonTypeId;

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.unit.selectedClassRoom = vm.ClassRoomList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.unit.selectedSection = vm.SectionList[i];

                        getSubjectBySection(row.ClassId, row.SectionId, function () {
                            for (var i in vm.SubjectList) {
                                if (vm.SubjectList[i].SubjectId === row.SubjectId) {
                                    vm.unit.selectedSubject = vm.SubjectList[i];

                                    getChapterBySubject(row.ClassId, row.SectionId, row.SubjectId, function () {
                                        for (var i in vm.ChapterList) {
                                            if (vm.ChapterList[i].ChapterId === row.ChapterId) {
                                                vm.unit.selectedChapter = vm.ChapterList[i];
                                                setPathIds();
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    }
                }
            });

            



            
            vm.unit.UnitName = angular.copy(row.UnitName);
            vm.VideoLinksUnitList = [];
            console.log("vm.DocList >>> "+JSON.stringify(vm.DocList));
           
          //  GetAllVideoLinksUnit();
        }

     
     
        function editLinks(row) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.unit.TitleName = row.TitleName
            vm.unit.Links = row.Links

            for (var i in vm.VideoLinksList) {
                if (vm.VideoLinksList[i].VideoTypeId === row.VideoTypeId) {
                    vm.unit.selectedVideoType = vm.VideoLinksList[i]
                }
            }

        }

        function SaveUnit(unit) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            debugger;
         //   var logggedUser = AuthenticationService.getLoggedUserDetails();

            var obj = {
                ClassId: vm.unit.selectedClassRoom.ClassId,
                SectionId: vm.unit.selectedSection.SectionId,
                SubjectId: vm.unit.selectedSubject.SubjectId,
                ChapterId: vm.unit.selectedChapter.ChapterId,
                UnitName: unit.UnitName,
                UnitType: vm.Type,
                PostContentFile: JSON.stringify(vm.DocList),
                PostContent: unit.PostContent,
                ButtonTypeId: $rootScope.ButtonTypeIdCount,
                UnitVideoLinkEntities: vm.VideoLinksUnitList,
                CreatedBy: loggedUser.UserId,
                Process: 'Save'
            }

            if (!vm.isEditing) {
                UnitService.SaveUnit(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1){

                            vm.VideoLinksUnitList = [];
                            $rootScope.showToaster('success', res.data.Message, "Unit Master");
                           
                        }
                            
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Unit Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];
                        vm.VideoLinksUnitList = [];
                        
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Unit Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {
                obj.ModifiedBy = loggedUser.UserId;
                obj.UnitId = unit.UnitId
                UnitService.SaveUnit(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Unit Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Unit Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.section = {};
                        vm.DocList = [];
                        vm.isEditing = false;
                        
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Unit Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }


        function SaveVideoLinksUnit(unit) {


            //console.log("unit"+JSON.stringify(unit));
            var objUnit = {
                VideoTypeId: vm.unit.selectedVideoType.VideoTypeId,
                TitleName: vm.unit.TitleName,
                Links: vm.unit.Links,
                // UnitId: 18,
                CreatedBy: 1,
                UnitId: vm.unit.UnitId,
                //  PostContent: unit.PostContent,

            }
            vm.VideoLinksUnitList.push(objUnit);
          //  console.log("objUnit"+JSON.stringify(objUnit));

         //  console.log("vm.VideoLinksUnitList"+JSON.stringify(vm.VideoLinksUnitList));
            objUnit = {};
            vm.unit.selectedVideoType = " ";
            vm.unit.TitleName = " ";
            vm.unit.Links = " ";
        }

    
        vm.removeUnit = function (row) {
           // debugger
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', { animation: true, size: 'sm' });
            row.Process = 'Delete'
            confirm.result.then(function () {
                UnitService.SaveUnit(row).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', res.data.Message, "Unit Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Content", { animation: true, size: 'sm' });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Content.  If its not a parent contact your Admin", { animation: true, size: 'sm' });
                });
            }, function () {

            })
        }


        vm.CopyFiles = function () {
            $rootScope.ClassId = vm.unit.selectedClassRoom.ClassId;
            $rootScope.SectionId = vm.unit.selectedSection.SectionId;
            $rootScope.SubjectId = vm.unit.selectedSubject.SubjectId;
            $rootScope.ChapterId = vm.unit.selectedChapter.ChapterId;
            $rootScope.UnitName = vm.unit.UnitName;
            $rootScope.Type = vm.unit.Type;
            $rootScope.PostContent = vm.unit.PostContent;
            ButtonTypeId: $rootScope.ButtonTypeIdCount;

        }


        $scope.fileChanged = function (event) {
           // debugger
            if (event)
                vm.selectedFile = event.target.files[0];  
        }

        function SaveDocument() {
            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile)
            formData.append('FileTypeId', vm.unit.selectedFileType.FileTypeId)
            formData.append('RelatedImageandVideoName',vm.unit.RelatedImageandVideoName)
            formData.append('ClassName', vm.unit.selectedClassRoom.ClassName)
            formData.append('SectionName', vm.unit.selectedSection.SectionName)
            formData.append('SubjectName', vm.unit.selectedSubject.SubjectName)
            formData.append('ChapterName', vm.unit.selectedChapter.ChapterName)


            UnitService.SaveDoc(formData).then(function (res) {
                if (res.data.msgText === 'Success!') {
                    $rootScope.showToaster('success', res.data.Message, "File Upload");
                    vm.DocList.push(res.data.result)
                } else {
                    $rootScope.showToaster('error', res.data.Message, "File Upload");
                }
            }, function (err) {
                $rootScope.showToaster("Something error...try again");
            });

        }


        function removeFile(row) {
           // debugger;
            
            console.log("1111"+JSON.stringify(row))
            var details = {
                FileTypeId : row.FileTypeId,
                FileName : row.RelatedImageandVideoName,
                UnitId : vm.unit.UnitId
            };
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });
            confirm.result.then(function () {
                UnitService.RemoveDoc(details).then(function (res) {
                    if (res.data === true) {
                        var index = vm.DocList.indexOf(row);
                        vm.DocList.splice(index, 1);
                        $rootScope.showToaster('success', 'Deleted Successfully', "File Upload");
                    } else {
                        $rootScope.showToaster('error', 'Failed!', "File Upload");
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            });
        }


        function RemovevideoLinks(row) {
           // debugger;
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });
            confirm.result.then(function () {
                UnitService.RemovevideoLinks(row.LinksId).then(function (res) {
                    if (res.data.msgText === 'Success!') {
                        var index = vm.VideoLinksUnitList.indexOf(row);
                        vm.VideoLinksUnitList.splice(index, 1);
                        $rootScope.showToaster('success', 'Deleted Successfully', "Links Video");
                    } else {
                        $rootScope.showToaster('error', 'Failed!', "LinksVideo");
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            });
        }


     

        vm.OpenWindow = function (HtmlPath) {
            window.open($rootScope.endPoint + 'UploadedDocuments/PostcontentDoc/' + HtmlPath);


            //   $scope.OpenWindow=function(){

            //     $scope.test=$scope.htmlContent;
            //     $scope.res = $scope.test.split("#cla#").join("<input type='button' class='btncla cla' value='Clarify' ng-click='popuptest()'/>")

            //     $scope.popup=1;

            //     }
            //     $scope.clearcon=function(){
            //         $scope.htmlContent="";

            //     }
            //      $scope.popuptest=function(){
            //        alert("testing");

            //     }
            //     $scope.cal=function(){
            //         alert("jhhjhj");


            //     }
        }


        // Obj.PostContent = "<html><head><meta charset =\"utf-8\"><meta http-equiv=\"X-UA-Compatible\" content=\"IE = edge\"> <meta name=\"viewport\" content=\"width = device - width, initial - scale = 1\"> </head>" + Obj.PostContent + "</html>";
        // GetFileList();
        // function GetFileList() {
        //     vm.VideoList = []; vm.ImageList = [];

        //     var UnitId = 104;
        //     UnitService.GetFileList(UnitId).then(function (response) {
        //         if (response.data != undefined) {
        //             debugger
        //             vm.Url = response.data;
        //           var FileLists =  JSON.parse(vm.Url[0].PostContentFile);
        //             for (var i in FileLists) {
        //                 if(FileLists[i].FileTypeId == 1 ){
        //                     vm.ImageList.push(FileLists[i].FilePath);
        //                 }else{
        //                     vm.VideoList.push(FileLists[i].FilePath);
        //                 }

        //             }


        //         }
        //         console.log(vm.videoList);
        //     })
        // }

        // function edit() {
        //     /// TS 
        //     school = [
        //         "Student1" = { "Name": "Aruna", "Id": 1 },
        //         "Student2" = { "Name": "Vignesh", "Id": 2 },               
        //     ]

        //     this.Name = this.school.Student1.Name
        //     this.Id = this.school.Student1.Id

        //      //// HTML 
        //        [(ngModel)] = "Name"
        //         [(ngModel)] = "Id"
        //        }



    }
})(); 
(function () {
    'use strict';

    angular
        .module('KPMES.pages.user')
        .controller('unitmodalCtrl', unitmodalCtrl);

    /** @ngInject */
    function unitmodalCtrl($scope, $rootScope, lodash, items, AuthenticationService, UnitService, $uibModalInstance, $state) {
        var vm = this;

        // methods
        vm.ThumbNail = items;
        vm.closeModal = closeModal;
        vm.companySelectionChanged = companySelectionChanged;
        vm.saveFile = saveFile;
        vm.upload =true;
        vm.CloseModalWindow = CloseModalWindow;

        Init();

        ////////////////

        function Init() {
            // vm.isLoading = true;
            // UserService.getUserCompanies($rootScope.userId).then(function (res) {
            //     if (res.status === 200) {
            //         vm.CompanyList = res.data;
            //         var loggedUser = AuthenticationService.getLoggedUserDetails();
            //         if (loggedUser.SelectedCompany) {
            //             vm.selectedCompany = loggedUser.SelectedCompany;
            //         }
            //         vm.isLoading = false;
            //     } else {
            //         $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
            //         vm.isLoading = false;
            //     }
            // }, function (err) {
            //     $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
            //     vm.isLoading = false;
            // });
        }

        $scope.fileChanged = function (event) {
            //debugger

            if (event)
                vm.selectedFile = "";
            vm.selectedFile = event.target.files[0];
        }


        $scope.ThumbNail = function (event) {
           // console.log("event" + JSON.stringify(event))
           // debugger
            if (event)
                vm.ThumbNailImage = "";
            vm.ThumbNailImage = event.target.files[0];
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function companySelectionChanged() {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            loggedUser.SelectedCompany = vm.selectedCompany;
            AuthenticationService.setLoggedUserDetails(loggedUser);
        }

        function saveFile() {
            debugger;
            vm.isLoading = true;

            var formData = new FormData();
            formData.append('Attachment', vm.selectedFile);
            formData.append('ThumbNail', vm.ThumbNailImage);
            formData.append('PathIds',JSON.stringify( $rootScope.PathIds));
            

            UnitService.SaveUnitModalFile(formData).then(
                function (res) {
                //    console.log("response from server" + $rootScope.endPoint + JSON.stringify(res.data));
                    var result = res.data;
                    vm.isLoading = false;

                    $rootScope.ThumbNailImage = $rootScope.endPoint + result.ThumbNailPath;
                    $rootScope.ImageUrl = $rootScope.endPoint + result.FilePathName;
                    vm.upload = false;
                    if (res.status === 200) {
                        if (!res.data){
                            vm.upload = true;
                            vm.isLoading = false;
                            $rootScope.showToaster('error', 'Something wrong, Contact Admin.', "Role");
                        }  
                    } else {
                        $rootScope.showToaster('error', 'Internal Server Error! Try Again', "Role");
                        vm.upload = true;
                        vm.isLoading = false;
                    }
                }, function (err) {
                    vm.upload = true;
                    vm.isLoading = false;
                    $rootScope.showToaster('error', "Can't connect the server! Try Again", "Role");
                }
            )

            // $uibModalInstance.close();
        }

        vm.ok = function () {
            $uibModalInstance.close();
        }

        function CloseModalWindow() {
           // $uibModalInstance.close();

            $uibModalInstance.dismiss('cancel');
           
        }
    }
})();   
(function () {
    'use strict';

    angular
        .module('KPMES.pages.user')
        .controller('multipleuplaodCtrl', multipleuplaodCtrl);

    /** @ngInject */
    function multipleuplaodCtrl($scope,$rootScope, lodash, AuthenticationService, UnitService, $uibModalInstance, $state) {
        var vm = this;

        // methods
        vm.closeModal = closeModal;
        vm.companySelectionChanged = companySelectionChanged;
        vm.saveFile = saveFile;
        vm.CloseModalWindow = CloseModalWindow;
       
        vm.Multiplelist = [{
            MultiplefileName: "Images",
            MutilplefileId: 1
        },
        {
            MultiplefileName: "Videos",
            MutilplefileId: 2
        },
        {
            MultiplefileName:"synonyms",
            MutilplefileId:3
        }];


        Init();

        ////////////////

        function Init() {
            // vm.isLoading = true;
            // UserService.getUserCompanies($rootScope.userId).then(function (res) {
            //     if (res.status === 200) {
            //         vm.CompanyList = res.data;
            //         var loggedUser = AuthenticationService.getLoggedUserDetails();
            //         if (loggedUser.SelectedCompany) {
            //             vm.selectedCompany = loggedUser.SelectedCompany;
            //         }
            //         vm.isLoading = false;
            //     } else {
            //         $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
            //         vm.isLoading = false;
            //     }
            // }, function (err) {
            //     $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
            //     vm.isLoading = false;
            // });
        }

        vm.selectedFile = [];
        vm.details = [];
        $scope.AddMultiFile = function (event) {
            debugger
            var fileId = vm.Multiple.selectedFile.MutilplefileId;
            if (event){
                vm.selectedFile.push(event.target.files[0]);
                var res = {
                    Name : event.target.files[0].name,
                    Size : event.target.files[0].size,
                    FileId: fileId
                }
                vm.details.push(res);
            }  

            console.log("Details ==>"+JSON.stringify(vm.details))
        }


        $scope.ThumbNail = function (event) {
            console.log("event"+JSON.stringify(event))
            debugger
            if (event)
                vm.ThumbNailImage = "";
                vm.ThumbNailImage = event.target.files[0];
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function companySelectionChanged() {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            loggedUser.SelectedCompany = vm.selectedCompany;
            AuthenticationService.setLoggedUserDetails(loggedUser);
        }

        $scope.getFiles = function (file) {
            angular.forEach(file, function (value, key) {
                var fileDetails = {
                    FileName: value.name,
                    FileLength: value.size,
                }
                var imgarr = ["png", "jpeg", "jpg"];
                var namesplit = (value.name).split(".")[1];

                var result = !!(imgarr.indexOf(namesplit) + 1);
                if (result) {
                    $scope.formdata.append(key, value);
                    $scope.data.push(fileDetails);
                }
            });

            var productDetails = {
                ProudctCode: vm.ParentData.ProductCode,
                VariableId: vm.ParentData.ItemOfProductId,
                FileType: "Products"
            }
            $scope.formdata.append("productDetails", JSON.stringify(productDetails));
            $scope.formdata.append("datas", JSON.stringify($scope.data));

            $scope.countFiles = $scope.data.length == 0 ? '' : $scope.data.length + ' files selected';
            $scope.$apply();

        };
       
        function saveFile() {

            var formData = new FormData();
            
            formData.append('Attachment', vm.selectedFile);
            formData.append('Details', JSON.stringify(vm.details));

            UnitService.SaveMultipleFileuploads(formData).then(
                function(res) {

                    var result = res.data;
                    $rootScope.ThumbNailImage = $rootScope.endPoint+ result.ThumbNailPath;
                    $rootScope.ImageUrl = $rootScope.endPoint+ result.FilePathName;
                    if(res.status === 200) {
                        if(!res.data)
                            $rootScope.showToaster('error', 'Something wrong, Contact Admin.', "Role");
                    } else {
                        $rootScope.showToaster('error', 'Internal Server Error! Try Again', "Role");
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't connect the server! Try Again", "Role");
                }
            )

           // $uibModalInstance.close();
        }

        vm.ok = function(){
            $uibModalInstance.close();
        }

        function  CloseModalWindow() 
        {
        //  $uibModalInstance.close();
         $uibModalInstance.dismiss('cancel');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.role')
        .controller('RoleMenuMappingCtrl', RoleMenuMappingCtrl);

    /** @ngInject */
    function RoleMenuMappingCtrl($scope,$rootScope, $state, $http, lodash, dialogs, RoleService) {
        var vm = this;
        $rootScope.isLogin = false;
        $rootScope.isLoading = true;

        // Properties
        vm.errorList = [];
        // Methods
        vm.getRoleMenuMapping = getRoleMenuMapping;
        vm.selectMenu = selectMenu;
        vm.saveRoleMenuMapping = saveRoleMenuMapping;     
        vm.select = select; 

        init();
        ////////////////

        vm.collapseAll = function () {
            $scope.$broadcast('angular-ui-tree:collapse-all');
        };

        vm.expandAll = function () {
            $scope.$broadcast('angular-ui-tree:expand-all');
        };
        //////

       function select()
        {           
            
        };
        //////
    
        function init() {
            RoleService.getAllRole().then(function (res) {
                if (res.status === 200) {
                    vm.RoleList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Try Again', "Role");
            });
        }

        function getRoleMenuMapping() {
            vm.isLoading = true;
            vm.selectedMenu = {};
            RoleService.getRoleMenuMapping(vm.selectedRole.RoleId).then(function (res) {
                if (res.status === 200) {
                    vm.menuList = res.data;
                    // logic
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Try Again', "Role");
            })
        }

        function selectMenu(menu) {
            vm.selectedMenu = menu;
        }

        function saveRoleMenuMapping() {
            RoleService.saveRoleMenuMapping(vm.selectedRole.RoleId, vm.menuList).then(function (res) {
                if (res.status === 200 && res.data) {
                    $rootScope.showToaster('success', 'Mapping Successfully Saved', "Role");
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Try Again', "Role");
            })
        }
    }
})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.area')
        .service('AreaService', AreaService);

    AreaService.$inject = ['$http', '$rootScope'];

    function AreaService($http, $rootScope) {
        this.AddArea = AddArea;
        this.EditArea = EditArea;
        this.removeArea = removeArea;
        this.getAllArea = getAllArea;
        this.GetAreaByCityId = GetAreaByCityId;
        this.getAllAreaById = getAllAreaById;
        this.changeActiveArea = changeActiveArea;

        /////////////

        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllArea(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Area/AllArea', config);
        }

        function GetAreaByCityId(id) {
            return $http.get($rootScope.endPoint + 'Area/GetAreaByCityId/' + id, config);
        }

        function getAllAreaById(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Area/GetById', config);
        }

        function AddArea(area) {
            return $http.post($rootScope.endPoint + 'Area/Create', area, config);
        }

        function EditArea(area) {
            return $http.put($rootScope.endPoint + 'Area/Modify', area, config);
        }
        
        function removeArea(id) {
            return $http.delete($rootScope.endPoint + 'Area/Delete/' + id, config);
        }
            function changeActiveArea(id) {
                return $http.post($rootScope.endPoint + 'Area/ChangeActive/' + id, {}, config);
            }
    }

})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.city')
        .service('CityService', CityService);

    CityService.$inject = ['$http', '$rootScope'];

    function CityService($http, $rootScope) {
        this.AddCity = AddCity;
        this.EditCity = EditCity;
        this.removeCity = removeCity;
        this.getAllCity = getAllCity;
        this.getCityById = getCityById;
        this.GetCityByStateId = GetCityByStateId;
        this.changeActiveCity = changeActiveCity;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllCity(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'City/AllCity', config);
        }

        function getCityById(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'City/GetCityId/', config);
        }

        function AddCity(city) {
            return $http.post($rootScope.endPoint + 'City/Create', city, config);
        }

        function EditCity(city) {
            return $http.put($rootScope.endPoint + 'City/Modify', city, config);
        }

        function removeCity(id) {
            return $http.delete($rootScope.endPoint + 'City/Delete/' + id, config);
        }

        function GetCityByStateId(id) {
            return $http.get($rootScope.endPoint + 'City/GetCityByStateId/' + id, config);
        }
        function changeActiveCity(id) {
            return $http.post($rootScope.endPoint + 'City/ChangeActive/' + id, {}, config);
        }
    }

})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.country')
        .service('CountryService', CountryService);

    CountryService.$inject = ['$http', '$rootScope'];

    function CountryService($http, $rootScope) {
        this.AddCountry = AddCountry;
        this.EditCountry = EditCountry;
        this.removeCountry = removeCountry;
        this.getAllCountry = getAllCountry;
        this.getCountryById = getCountryById;
        this.getActiveCountry = getActiveCountry;
        this.changeActiveCountry = changeActiveCountry;
        this.GetAllCountry_ByProc = GetAllCountry_ByProc;
        this.SaveDeleteCountryMaster = SaveDeleteCountryMaster;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllCountry(objCountry) {
            return $http.get($rootScope.endPoint + 'Country/AllCountry', config);
        }

        function getActiveCountry(objCountry) {
            return $http.get($rootScope.endPoint + 'Country/GetActiveCountryById', config);
        }

        function AddCountry(Country) {
            return $http.post($rootScope.endPoint + 'Country/Create', Country, config);
        }

        function EditCountry(Country) {
            return $http.put($rootScope.endPoint + 'Country/Modify', Country, config);
        }

        function removeCountry(id) {
            return $http.delete($rootScope.endPoint + 'Country/Delete/' + id, config);
        }

        function getCountryById(objCountry) {
            return $http.delete($rootScope.endPoint + 'Country/GetById/', config);
        }

        function changeActiveCountry(objCountry) {
            return $http.post($rootScope.endPoint + 'Country/ChangeActive', objCountry, config);
        }

        function changeActiveCountry(objCountry) {
            return $http.post($rootScope.endPoint + 'Country/ChangeActive', objCountry, config);
        }

        function GetAllCountry_ByProc() {
            return $http.post($rootScope.endPoint + 'Country/GetAllCountry_ByProc',  config);
        }

        function SaveDeleteCountryMaster(objCountry) {
            return $http.post($rootScope.endPoint + 'Country/SaveDeleteCountryMaster', objCountry, config);
        }

    }



})();
(function() {

    'use strict';

    angular
        .module('KPMES.pages.state')
        .service('StateService', StateService);

    StateService.$inject = ['$http', '$rootScope'];

    function StateService($http, $rootScope) {
        this.AddState = AddState;
        this.EditState = EditState;
        this.removeState = removeState;
        this.getAllState = getAllState;
        this.getAllCountry = getAllCountry;
        this.getStateById = getStateById;
        this.GetStateByCountryId = GetStateByCountryId;
        this.changeActiveState = changeActiveState;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function getAllState(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'State/AllState', config);
        }

        function getAllCountry(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'Country/AllCountry', config);
        }

        function getStateById(objGetEmpDTO) {
            return $http.get($rootScope.endPoint + 'State/GetStateId/', config);
        }

        function AddState(state) {
            return $http.post($rootScope.endPoint + 'State/Create', state, config);
        }

        function EditState(state) {
            return $http.put($rootScope.endPoint + 'State/Modify', state, config);
        }

        function removeState(id) {
            return $http.delete($rootScope.endPoint + 'State/Delete/' + id, config);
        }

        function GetStateByCountryId(id) {
            return $http.get($rootScope.endPoint + 'State/GetStateByCountryId/' + id, config);
        }
        function changeActiveState(id) {
            return $http.post($rootScope.endPoint + 'State/ChangeActive/' + id, {}, config);
        }
    }

})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.mapping')
        .service('MappingService', MappingService);

    MappingService.$inject = ['$http', '$rootScope'];

    function MappingService($http, $rootScope) {
        this.SaveStaff = SaveStaff;
        this.GetAllStaffMap = GetAllStaffMap;
        this.GetStaffMapByDetails = GetStaffMapByDetails;
        this.UpdateStaffMap = UpdateStaffMap;
        this.SaveClassRoomMap = SaveClassRoomMap;
        this.GetAllClassMap = GetAllClassMap;
        this.SaveTimeTableMap = SaveTimeTableMap;
        this.GetAllTimeTableMap = GetAllTimeTableMap;


        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }


        function SaveStaff(obj) {
            return $http.post($rootScope.endPoint + 'MapStaff/SaveDeleteMapStaff', obj, {}, config);
        }

        function SaveClassRoomMap(obj) {
            return $http.post($rootScope.endPoint + 'MapClass/SaveDeleteMapStaff', obj, {}, config);
        }

        function SaveTimeTableMap(obj) {
            return $http.post($rootScope.endPoint + 'MapTimeTable/SaveDeleteMapTimeTable', obj, {}, config);
        }

        function UpdateStaffMap(obj) {
            return $http.post($rootScope.endPoint + 'MapStaff/UpdateMapStaff', obj, {}, config);
        }

        function GetStaffMapByDetails(obj) {
            return $http.post($rootScope.endPoint + 'MapStaff/SaveDeleteMapStaff', obj, {}, config);
        }

        function GetAllStaffMap() {
            return $http.get($rootScope.endPoint + 'MapStaff/GetAllMapStaff', config);
        }

        function GetAllClassMap() {
            return $http.get($rootScope.endPoint + 'MapClass/GetAllMapClass', config);
        }

        function GetAllTimeTableMap() {
            return $http.get($rootScope.endPoint + 'MapTimeTable/GetAllMapTimeTable', config);
        }

    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.master')
        .service('ChapterService', ChapterService);

    ChapterService.$inject = ['$http', '$rootScope'];

    function ChapterService($http, $rootScope) {
        this.GetAllChapters = GetAllChapters;
        this.SaveChapter = SaveChapter;
        this.GetAllChapterBySubject = GetAllChapterBySubject;
        this.GetAllStudentChapters = GetAllStudentChapters;
        this.GetAllTerms = GetAllTerms;
        this.SaveTermActivity = SaveTermActivity;
        this.GetSelectedTerm = GetSelectedTerm;
        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function GetAllChapters() {
            return $http.get($rootScope.endPoint + 'Chapter/GetAllChapter', config);
        }

        function GetAllStudentChapters(Id) {
            return $http.get($rootScope.endPoint + 'Chapter/GetAllStudentChapter/' + Id, config);
        }


        function SaveChapter(obj) {
            return $http.post($rootScope.endPoint + 'Chapter/SaveDeleteChaptertMaster', obj, {}, config);
        }

        function GetAllChapterBySubject(obj) {
            return $http.post($rootScope.endPoint + 'Chapter/GetAllChapterBySubject', obj, config);
        }

        function GetAllTerms() {
            return $http.get($rootScope.endPoint + 'Chapter/GetAllTerms', config);
        }

        function SaveTermActivity(obj){
            return $http.post($rootScope.endPoint + 'Chapter/saveTermActivity', obj, config)
        }

        function GetSelectedTerm() {
            return $http.get($rootScope.endPoint + 'Chapter/GetSelectedTerm', config);
        }
        


    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.master')
        .service('ClassRoomService', ClassRoomService);

    ClassRoomService.$inject = ['$http', '$rootScope'];

    function ClassRoomService($http, $rootScope) {
        this.GetAllClassRoom = GetAllClassRoom;
        this.SaveClassRoom = SaveClassRoom;
        this.GetClasstimings = GetClasstimings;
        this.GetLocation = GetLocation;
        this.GetStafflist = GetStafflist;
        this.CreateTimeTable = CreateTimeTable;
        this.GetTimeTable = GetTimeTable;
        this.DeleteTimetable = DeleteTimetable;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function GetAllClassRoom() {
            return $http.get($rootScope.endPoint + 'Class/GetAllClass_ByProc', config);
        }

        function SaveClassRoom(obj) {
            return $http.post($rootScope.endPoint + 'Class/SaveDeleteClassMaster', obj, {}, config);
        }

        function GetClasstimings(id) {
            return $http.get($rootScope.endPoint + 'timetable/classtimings/' + id , config);
        }

        function GetLocation(id) {
            return $http.get($rootScope.endPoint + 'timetable/location/' + id , config);
        }

        function GetStafflist(obj) {
            return $http.post($rootScope.endPoint + 'timetable/stafflist', obj, {}, config);
        }


        function CreateTimeTable(obj) {
            debugger
            return $http.post($rootScope.endPoint + 'timetable/create', obj, {}, config);
        }


        // function GetTimeTable(obj) {
        //     return $http.get($rootScope.endPoint + 'timetable/details/' + obj.ClassId + '/'+ obj.SectionId + '/'+ obj.TimeTableDate , config);
        // }

        function GetTimeTable(obj) {
            debugger
            return $http.post($rootScope.endPoint + 'timetable/details', obj, {}, config);
        }


        function DeleteTimetable(id) {
            return $http.get($rootScope.endPoint + 'timetable/delete/' + id , config);
        }



    }



})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.master')
        .service('SectionService', SectionService);

    SectionService.$inject = ['$http', '$rootScope'];

    function SectionService($http, $rootScope) {
        this.GetAllSection = GetAllSection;
        this.SaveSection = SaveSection;
        this.GetAllSectionByClass = GetAllSectionByClass;

        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function GetAllSection() {
            return $http.get($rootScope.endPoint + 'Section/GetAllSection', config);
        }

        function GetAllSectionByClass(Id) {
            return $http.get($rootScope.endPoint + 'Section/GetAllSection_ByClassId/' + Id, config);
        }

        function SaveSection(obj) {
            return $http.post($rootScope.endPoint + 'Section/SaveDeleteSectionMaster', obj, {}, config);
        }

    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.master')
        .service('SubjectService', SubjectService);

    SubjectService.$inject = ['$http', '$rootScope'];

    function SubjectService($http, $rootScope) {
        this.GetAllSubject = GetAllSubject;
        this.SaveSubject = SaveSubject;
        this.getAllSubjectBySection = getAllSubjectBySection;
        this.getallStudentSubject = getallStudentSubject;        
        this.UpdateProfilePic = UpdateProfilePic;
        this.SaveTermImg = SaveTermImg;
        this.GetAllTermImg = GetAllTermImg;
        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }
        
      

        function GetAllSubject() {
            return $http.get($rootScope.endPoint + 'Subject/GetAllSubject', config);
        }
        function getallStudentSubject() {
            return $http.get($rootScope.endPoint + 'Subject/GetAllStudentSubject/'+ SectionId+ '/'+ ClassId , config);
        }

        function SaveSubject(obj) {
            debugger;
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
           // config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Subject/SaveDeleteSubjectMaster2', obj, config);
        }

        function getAllSubjectBySection(obj) {           
            return $http.post($rootScope.endPoint + 'Subject/GetAllSubject_BySectionId', obj, {}, config);
        }

       
        function UpdateProfilePic(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Subject/uploadProfilePic', data, config);
        }

        function SaveTermImg(obj) {
            debugger;
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Subject/SaveTermImg', obj, config);
        }

        function GetAllTermImg() {
            return $http.get($rootScope.endPoint + 'Subject/GetAllTermImg', config);
        }

    }
})();
(function () {

    'use strict';

    angular
        .module('KPMES.pages.master')
        .service('UnitService', UnitService);

    UnitService.$inject = ['$http', '$rootScope'];

    function UnitService($http, $rootScope) {
        this.SaveDoc = SaveDoc;
        this.RemoveDoc = RemoveDoc;
        this.GetAllUnits = GetAllUnits;
        this.GetAllLinkUnits = GetAllLinkUnits;
        this.SaveUnit = SaveUnit;
        this.GetFileList = GetFileList;
        this.SaveVideoLinks = SaveVideoLinks;
        this.SaveUnitModalFile = SaveUnitModalFile;
        this.SaveMultipleFileuploads = SaveMultipleFileuploads;
        this.SaveUnitLink = SaveUnitLink;
        this.GetAllUnitByChapter =GetAllUnitByChapter;
        this.RemoveUnitLink = RemoveUnitLink;
        this.SaveVideoLinksUnit = SaveVideoLinksUnit;
        this.GetAllVideoLinksUnit = GetAllVideoLinksUnit;
        this.RemovevideoLinks = RemovevideoLinks;
        this.GetLinkVideoInEdit = GetLinkVideoInEdit;
        this.UpdateUnitLink = UpdateUnitLink;
        this.SaveUploadedDocs = SaveUploadedDocs;
        this.GetAllLinksByUnitId = GetAllLinksByUnitId;
        this.DeleteVideoLink = DeleteVideoLink;
        this.GetTitleName = GetTitleName;
        this.LinksUpdate = LinksUpdate;
        this.RemoveTextLink = RemoveTextLink;
     
        /////////////
        var config = {
            headers: {
                "Token": $rootScope.token
            }
        }

        function SaveDoc(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Unit/PostContentAttachment', data, config);
        }

        function SaveUploadedDocs(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Unit/LinksFileAttachment', data, config);
        }
        function SaveVideoLinksUnit(obj){
            debugger
            return $http.post($rootScope.endPoint + 'Unit/SaveVideoLinksUnit', obj, config);
        }
        function SaveVideoLinks(obj){
            return $http.post($rootScope.endPoint + 'Unit/SaveVideoLinks', obj, config);
        }


        function RemoveDoc(FileUrl) {
            return $http.post($rootScope.endPoint + 'Unit/removeDocument' , FileUrl, {}, config);
        }

        function RemovevideoLinks(id) {
            return $http.delete($rootScope.endPoint + 'Unit/DeleteLinksVideo/' + id, config);
        }



        function SaveUnit(obj) {
            debugger
            return $http.post($rootScope.endPoint + 'Unit/SaveDeleteUnitMaster', obj, {}, config);
        }

        function SaveUnitLink(obj) {
            return $http.post($rootScope.endPoint + 'Unit/SaveLinkMaster', obj, {}, config);
        }

        function UpdateUnitLink(obj) {
            return $http.post($rootScope.endPoint + 'Unit/UpdateLinkMaster', obj, {}, config);
        }

        function GetAllUnits(EmployeeId) {
            return $http.get($rootScope.endPoint + 'Unit/GetAllUnits/'+ EmployeeId, config);
        }

        function GetAllLinkUnits(EmployeeId) {
            return $http.get($rootScope.endPoint + 'Unit/GetAllLinksUnits/'+ EmployeeId, config);
        }

        function GetAllVideoLinksUnit(){
            return $http.get($rootScope.endPoint + 'Unit/GetAllVideoLinksUnit', config);
        }
           
        function GetLinkVideoInEdit(UnitId) {
            return $http.get($rootScope.endPoint + 'Unit/GetAllEditLinkVideo/'+ UnitId, config);
        }


        
        function GetFileList(UnitId) {
            return $http.get($rootScope.endPoint + 'Unit/GetFileList/'+ UnitId, config);
        }
        function SaveUnitModalFile(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Unit/create', data, config);
        }

        function SaveMultipleFileuploads(data) {
            var config = {
                headers: {
                    "Token": $rootScope.token
                }
            }
            config.headers["Content-Type"] = undefined;
            return $http.post($rootScope.endPoint + 'Unit/multifileupload', data, config);
        }
        function GetAllUnitByChapter(obj) {
            return $http.post($rootScope.endPoint + 'Unit/GetUnitByChapter', obj, config);
        }

        function RemoveUnitLink(id) {
            return $http.delete($rootScope.endPoint + 'Unit/DeleteLinkUnit/' + id, config);
        }

        function GetAllLinksByUnitId(id){
            return $http.get($rootScope.endPoint + 'Unit/GetAllVideoLinksByUnitId/'+id, config);
        }

        function DeleteVideoLink(id){
            return $http.get($rootScope.endPoint+'Unit/deletevideolink/'+id, config);
        }

       function GetTitleName(id){
            return $http.get($rootScope.endPoint+'Unit/getreferancename/'+id , config);
       }

       function LinksUpdate(obj) {
        return $http.post($rootScope.endPoint + 'Unit/linksupdate', obj, config);
        }

        function RemoveTextLink(obj) {
            return $http.post($rootScope.endPoint + 'Unit/removetextlink', obj, config);
            }

    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.student')
        .controller('StudentRegistrationCtrl', StudentRegistrationCtrl);

    /** @ngInject */
    function StudentRegistrationCtrl($filter, $http, $scope, $rootScope, lodash, dialogs, StudentService, CountryService, StateService, CityService, AreaService, ClassRoomService, SectionService, UnitService,AuthenticationService) {
        var vm = this;
        $rootScope.isLoading = true;
        // Pagination code
        vm.rowCountOptions = [{ "value": 5 }, { "value": 10 }, { "value": 25 }, { "value": 50 }, { "value": 100 }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        vm.isFormOpen = false;
        vm.isEditing = false;
        vm.isEditing1 = false;
        vm.bankDetails = false;

        $scope.photoChanged = photoChanged;
        vm.isEditingProPic = false;
        vm.editProPic = editProPic;

        vm.SaveStudent = SaveStudent;
        vm.Create = Create;
        vm.GotoStudentAccountDetails = GotoStudentAccountDetails;
        vm.cancel = cancel;
        vm.student = {};
        vm.getSectionByClass = getSectionByClass;
        vm.getStateListByCountryId = getStateListByCountryId;
        vm.getCityByStateId = getCityByStateId;
        vm.getAreaByCityId = getAreaByCityId;
        vm.removeStudent = removeStudent;
        vm.editStudent = editStudent;
        var logggedUser = AuthenticationService.getLoggedUserDetails();

        function Create() {
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
        }
        function cancel() {
            vm.isFormOpen = false;
            vm.isEditing = false;
            vm.student = {};
        }
        function GotoStudentAccountDetails() {
            vm.bankDetails = true;

        }

        function editProPic() {
            vm.isEditingProPic = true;
        }
        $scope.imageIsLoaded = function (e) {
            $scope.$apply(function () {
                vm.profilePicUrl = e.target.result;
            });
        }

        vm.ProficiencyList = [{
            ProficiencyName: "International",
            ProficiencyId: 1,
        }, { ProficiencyName: "National", ProficiencyId: 2, }, { ProficiencyName: "State", ProficiencyId: 3, }, { ProficiencyName: "District", ProficiencyId: 4, }, { ProficiencyName: "Zone", ProficiencyId: 5, }

        ];

        function photoChanged(event) {
            var reader = new FileReader();
            if (!vm.isEditingProPic) {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
            } else {
                vm.empProfilePic = event.target.files[0];
                reader.onload = $scope.imageIsLoaded;
                reader.readAsDataURL(vm.empProfilePic);
                var formData = new FormData();
                formData.append('profilePic', vm.empProfilePic);
                formData.append('studentId', vm.student.StudentId);
                StudentService.updateProfilePic(formData).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Profile picture changed succussfully', "Success");
                        Init();
                    } else {
                        $rootScope.showToaster('error', 'Internal server Error!', "Error");
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Internal server Error!', "Error");
                });
            }
        }

        Init()
        function Init() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            StudentService.getAllStudent().then(function (res) {
                if (res.status === 200) {
                    vm.StudentList = res.data;
                    $rootScope.isLoading = false;
                    LoadClass();
                }
            });
        }

        function LoadClass() {
            ClassRoomService.GetAllClassRoom().then(function (res) {
                if (res.status === 200) {
                    vm.ClassRoomList = res.data;
                    var objCountry;
                    CountryService.getActiveCountry(objCountry).then(function (res) {
                        if (res.status === 200) {
                            vm.CountryList = res.data;
                        }
                    });
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Units");
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Unit");
            });

        }
        function getSectionByClass(ClassId, callBack) {
            if (ClassId) {
                SectionService.GetAllSectionByClass(ClassId).then(function (res) {
                    if (res.status === 200) {
                        vm.SectionList = res.data;
                    } else {
                        $rootScope.showToaster('error', 'Load Failed! Try Again', "Country");
                    }
                    if (callBack)
                        callBack();
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Country");
                });
            }
            else {
            }
        }

        function getStateListByCountryId(CountryId, callback) {
            if (CountryId) {
                StateService.GetStateByCountryId(CountryId).then(function (res) {
                    if (res.status === 200) {
                        vm.StateList = res.data;
                        if (vm.StateList.length < 1) {
                            dialogs.notify('Warning', 'No state available for ' + vm.city.selectedCountry.CountryName, { animation: true, size: 'sm' });
                        }
                        if (callback)
                            callback();
                    }
                });
            } else {
            }
        }

        function getCityByStateId(StateId, callBack) {
            CityService.GetCityByStateId(StateId).then(function (res) {
                if (res.status === 200) {
                    vm.CityList = res.data;
                    if (vm.CityList.length < 1) {
                        dialogs.notify('Warning', 'No city available for ' + vm.project.selectedState.StateName, {
                            animation: true,
                            size: 'sm'
                        });
                    } else {
                        if (callBack) {
                            callBack();
                        }
                    }
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Project Type Master");
            });
        }

        function getAreaByCityId(CityId, callBack) {
            AreaService.GetAreaByCityId(CityId).then(function (res) {
                if (res.status === 200) {
                    vm.AreaList = res.data;
                    if (vm.AreaList.length < 1) {
                        dialogs.notify('Warning', 'No area available for ' + vm.project.selectedCity.CityName, {
                            animation: true,
                            size: 'sm'
                        });
                    } else {
                        if (callBack) {
                            callBack();
                        }
                    }
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Project Type Master");
            });
        }

        function editStudent(row) {
            debugger
            vm.isEditing = true;
            vm.isEditing1 = false;
            vm.isFormOpen = true;
            vm.isTableOpen = false;
            vm.bankDetails = true;

            for (var i in vm.ClassRoomList) {
                if (vm.ClassRoomList[i].ClassId === row.ClassId) {
                    vm.student.selectedClassRoom = vm.ClassRoomList[i]
                }
            }
            for (var i in vm.ProficiencyList) {
                if (vm.ProficiencyList[i].ProficiencyId === row.ProficiencyId) {
                    vm.student.Proficiency = vm.ProficiencyList[i]
                }
            }

            getSectionByClass(row.ClassId, function () {
                for (var i in vm.SectionList) {
                    if (vm.SectionList[i].SectionId === row.SectionId) {
                        vm.student.selectedSection = vm.SectionList[i];
                    }
                }
            });

            for (var i in vm.CountryList) {
                if (vm.CountryList[i].CountryId === row.CountryId) {
                    vm.student.selectedCountry = vm.CountryList[i]
                }
            }

            getStateListByCountryId(row.CountryId, function () {
                for (var i in vm.StateList) {
                    if (vm.StateList[i].StateId === row.StateId) {
                        vm.student.selectedState = vm.StateList[i]
                    }
                }
            });

            getCityByStateId(row.StateId, function () {
                for (var i in vm.CityList) {
                    if (vm.CityList[i].CityId === row.CityId) {
                        vm.student.selectedCity = vm.CityList[i]
                    }
                }
            });

            getAreaByCityId(row.CityId, function () {
                for (var i in vm.AreaList) {
                    if (vm.AreaList[i].AreaId === row.AreaId) {
                        vm.student.selectedArea = vm.AreaList[i]
                    }
                }
            });

            // '/StudentProfilePictures/' + 

            vm.empProfilePic = vm.profilePicUrl = $rootScope.endPoint + row.StdPhotoUrl;
            vm.student.StudentId = row.StudentId
            vm.student.StudentName = row.StudentName
            vm.student.StudentDOB = new Date(row.StudentDOB)
            vm.student.StdGender = row.StdGender
            vm.student.StdCaste = row.StdCaste
            vm.studentAddress = JSON.parse(row.StdAddressLine)
            vm.student.Address1 = vm.studentAddress.Address1
            vm.student.Address2 = vm.studentAddress.Address2
            vm.student.StdReligion = row.StdReligion
            vm.student.StdFatherName = row.StdFatherName
            vm.student.StdCommunity = row.StdCommunity
            vm.student.StdFatherMobileNo = parseInt(row.StdFatherMobileNo);
            vm.student.StdKpostId = row.StdKpostId
            vm.student.StdFatherKpostId = row.StdFatherKpostId
            vm.student.StdMotherName = row.StdMotherName
            vm.student.StdMotherMobileNo = parseInt(row.StdFatherMobileNo);
            vm.student.StdMotherKpostId = row.StdMotherKpostId
            vm.student.StdGuardianName = row.StdGuardianName
            vm.student.StdGuardianMobileNo = parseInt(row.StdGuardianMobileNo);
            vm.student.StdGuardianKpostId = row.StdGuardianKpostId
            vm.student.AccountNo = row.AccountNo
            vm.student.IFSCCode = row.IFSCcode
            vm.student.Branch = row.Branch
            vm.student.MICRCode = row.MICRCode
            vm.student.BankName = row.NameofTheBank
            vm.student.BloodGroup = row.BloodGroup
            vm.student.Aadhaarcardno = row.AadhaarCardNo
            vm.student.Physicallyhandicapted = (row.PhysicallyHandicapped == true) ? 'Y' : 'N'
            vm.student.Eligible = (row.EligibletogetFeeWavier == true) ? 'Y' : 'N'
            vm.student.Participate = (row.ParticipatinginanySports == true) ? 'Y' : 'N'
           

        }

        function SaveStudent(student) {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
           // debugger;
            var Arr = {
                Address1: student.Address1,
                Address2: student.Address2
            };
            var obj = {
                StudentName: student.StudentName,
                StudentDOB: $filter('date')(student.StudentDOB, 'yyyy/MM/dd'),
                StdGender: student.StdGender,
                StdCaste: student.StdCaste,
                StdCommunity: student.StdCommunity,
                ClassId: student.selectedClassRoom.ClassId,
                SectionId: student.selectedSection.SectionId,
                StdAddressLine: JSON.stringify(Arr),
                CountryId: student.selectedCountry.CountryId,
                StateId: student.selectedState.StateId,
                CityId: student.selectedCity.CityId,
                AreaId: student.selectedArea.AreaId,
                StdPinCode: student.selectedArea.Pincode,
                StdReligion: student.StdReligion,
                StdFatherName: student.StdFatherName,
                StdFatherMobileNo: student.StdFatherMobileNo,
                StdKpostId: student.StdKpostId,
                StdFatherKpostId: student.StdFatherKpostId,
                StdMotherName: student.StdMotherName,
                StdMotherMobileNo: student.StdMotherMobileNo,
                StdMotherKpostId: student.StdMotherKpostId,
                StdGuardianName: student.StdGuardianName,
                StdGuardianMobileNo: student.StdGuardianMobileNo,
                StdGuardianKpostId: student.StdGuardianKpostId,
                CreatedBy: loggedUser.UserId,
                //CreatedBy: 1,
                AccountNo: student.AccountNo,
                IFSCcode: student.IFSCCode,
                Branch: student.Branch,
                MICRCode: student.MICRCode,
                NameofTheBank: student.BankName,
                BloodGroup: student.BloodGroup,
                AadhaarCardNo: student.Aadhaarcardno,
                PhysicallyHandicapped: (student.Physicallyhandicapted == ("N" || undefined) ? false : true),
                EligibletogetFeeWavier: (student.Eligible == ("N" || undefined) ? false : true),
                ParticipatinginanySports: (student.Participate == ("N" || undefined) ? false : true),
                LevelofProficiency: student.Proficiency.ProficiencyId.ProficiencyName,
                ProficiencyId: student.Proficiency.ProficiencyId
              
            }

            if (!vm.isEditing) {
                var formData = new FormData()
                formData.append('profilePic', vm.empProfilePic)
                formData.append('data', JSON.stringify(obj))

                StudentService.SaveStudent(formData).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 1)
                            $rootScope.showToaster('success', res.data.Message, "Student Master");
                        if (res.data.Code != 1)
                            $rootScope.showToaster('warning', res.data.Message, "Student Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.student = {};
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Student Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
            else {

                obj.StudentId = student.StudentId,
                    obj.ModifiedBy = loggedUser.UserId,
                    obj.AccountId = student.AccountId
                StudentService.UpdateUnit(obj).then(function (res) {
                    if (res.data.IsSuccess === true) {
                        if (res.data.Code === 3)
                            $rootScope.showToaster('success', res.data.Message, "Student Master");
                        if (res.data.Code != 3)
                            $rootScope.showToaster('warning', res.data.Message, "Student Master");
                        Init();
                        vm.isFormOpen = false;
                        cancel();
                        vm.student = {};
                        vm.isEditing = false;
                    } else {
                        $rootScope.showToaster('error', res.data.Message, "Student Master");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster("Something error...try again");
                });
            }
        }

        // function removeStudent(row) {
        //     var confirm = dialogs.confirm('Confirm',
        //         'Are sure you want to delete current row.', { animation: true, size: 'sm' });
        //     row.Process = 'Delete'
        //     confirm.result.then(function () {

        //     }, function () {

        //     })
        // }

        function removeStudent(row) {
            var confirm = dialogs.confirm('Confirm', 'Are sure you want to delete current row.', {
                animation: true,
                size: 'sm'
            });

            confirm.result.then(function () {
                StudentService.removeStudent(row.StudentId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete  Successfully', "AStudent Master");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete Account Master ", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete Account. If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }
        // Datepicker code 
        vm.today = function () {
            vm.dt = new Date();
        };
        vm.today();

        vm.clear = function () {
            vm.dt = null;
        };

        vm.inlineOptions = {
            customClass: getDayClass,
            minDate: new Date(),
            showWeeks: true
        };

        vm.dateOptions = {
            dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: new Date(2020, 5, 22),
            minDate: new Date(),
            startingDay: 1
        };

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.toggleMin = function () {
            vm.inlineOptions.minDate = vm.inlineOptions.minDate ? null : new Date();
            vm.dateOptions.minDate = vm.inlineOptions.minDate;
        };

        vm.toggleMin();

        vm.open1 = function () {
            vm.popup1.opened = true;
        };

        vm.open2 = function () {
            vm.popup2.opened = true;
            var today = new Date();
            var minAge = 3;

            vm.options = {
                maxDate: new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate())
            }

        };

        vm.open3 = function () {
            vm.popup3.opened = true;
        };

        vm.open4 = function () {
            vm.popup4.opened = true;
        };

        vm.setDate = function (year, month, day) {
            vm.dt = new Date(year, month, day);
        };

        vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        vm.format = vm.formats[0];
        vm.altInputFormats = ['M!/d!/yyyy'];

        vm.popup1 = {
            opened: false
        };

        vm.popup2 = {
            opened: false
        };
        vm.popup3 = {
            opened: false
        };

        vm.popup4 = {
            opened: false
        };

        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date();
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        vm.events = [{
            date: tomorrow,
            status: 'full'
        }, {
            date: afterTomorrow,
            status: 'partially'
        }];

        function getDayClass(data) {
            var date = data.date,
                mode = data.mode;
            if (mode === 'day') {
                var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

                for (var i = 0; i < vm.events.length; i++) {
                    var currentDay = new Date(vm.events[i].date).setHours(0, 0, 0, 0);

                    if (dayToCheck === currentDay) {
                        return vm.events[i].status;
                    }
                }
            }
            return '';
        }
    }
})(); 
(function() {
    'use strict';

    angular
        .module('KPMES.pages.user.login')
        .controller('LoginCtrl', LoginCtrl);

    /** @ngInject */
    function LoginCtrl($rootScope, $state, lodash, dialogs, AuthenticationService, UserService, $window) {
        var vm = this;
        $rootScope.isLogin = true;

        // Properties
        vm.isLoading = false;
        vm.errorList = [];
        // Methods
        vm.login = login;

        activate();

        
        ////////////////

        function activate() {}


        vm.testmethod = function(){
          //  var url = "http://localhost:3000/company"

  


   //  var url = "http://192.168.2.202:2911/company"

         // var url =  $rootScope.BaseUrl+"/company"
            var win = $window.open(url, '_blank');
            win.focus();
        }

        function login() {
            vm.isLoading = true;
            AuthenticationService.login(vm.Username, vm.Password, function(res) {
                vm.errorList = [];
                if (res.status === 200) {
                    vm.isLoading = false;
                    UserService.getUserById($rootScope.userId).then(function(res) {
                        AuthenticationService.setLoggedUserDetails(res.data);
                        
                         var loggedUser = AuthenticationService.getLoggedUserDetails();

                        
                        if (loggedUser.SelectedCompany) {
                             vm.selectedCompany = loggedUser.SelectedCompany;
                            
                        } else {
                            $rootScope.openSelectCompanyModal();
                            
                        }

                        $state.go('dashboard');
                        
                    }, function(err) {
                        AuthenticationService.setLoggedUserDetails(null);
                    });
                    // $state.go('dashboard');
                  
                } else if (res.status === 401) {
                    vm.errorList.push("Invalid Credentials!");
                    vm.isLoading = false;
                } else if (res.status === -1) {
                    vm.errorList.push("Can't connect to server, Try Again!");
                    vm.isLoading = false;
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.user.Register')
        .controller('RegisterCtrl', RegisterCtrl);

    /** @ngInject */
    function RegisterCtrl($rootScope, $state,$window, lodash, dialogs, AuthenticationService, UserService) {
        var vm = this;
        $rootScope.isRegister = true;

        // Properties
        vm.isLoading = false;
        vm.errorList = [];
        // Methods
        vm.login = login;

        activate();

        ////////////////

        function activate() {}
        
        vm.testmethod = function(){

         //   var url = "http://localhost:3000/company?type=reg"
            var url = "http://192.168.2.202:2911/company?type=reg"

           // var url = $rootScope.BaseUrl+"/company?type=reg"
            var win = $window.open(url, '_blank');
            $rootScope.IsMenuClicked = false;
            win.focus();
        }

        



        function login() {
            vm.isLoading = true;
            AuthenticationService.login(vm.Username, vm.Password, function(res) {
                vm.errorList = [];
                if (res.status === 200) {
                    vm.isLoading = false;
                    UserService.getUserById($rootScope.userId).then(function(res) {
                        AuthenticationService.setLoggedUserDetails(res.data);
                        var loggedUser = AuthenticationService.getLoggedUserDetails();
                        if (loggedUser.SelectedCompany) {
                            // vm.selectedCompany = loggedUser.SelectedCompany;
                        } else {
                            $rootScope.openSelectCompanyModal();
                        }
                        
                    }, function(err) {
                        AuthenticationService.setLoggedUserDetails(null);
                    });
                    // $state.go('dashboard');
                    $state.go('dashboard');
                } else if (res.status === 401) {
                    vm.errorList.push("Invalid Credentials!");
                    vm.isLoading = false;
                } else if (res.status === -1) {
                    vm.errorList.push("Can't connect to server, Try Again!");
                    vm.isLoading = false;
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.role')
        .controller('CreateUserCtrl', CreateUserCtrl);

    /** @ngInject */
    function CreateUserCtrl($filter, $scope, $rootScope, $state, $http, lodash, dialogs,
        DepartmentServices, DesignationService, UserService, RoleService, AuthenticationService, EmployeeService) {
        var vm = this;
        // Pagination code
        vm.rowCountOptions = [{
            "value": 5
        }, {
            "value": 10
        }, {
            "value": 25
        }, {
            "value": 50
        }, {
            "value": 100
        }]
        vm.noOfRows = vm.rowCountOptions[1];

        vm.currentPage = 1;
        vm.rembemberCurrentPage = function (num) {
            vm.currentPage = num;
        }
        // End of Pagination code
        $rootScope.isLogin = false;

        // Properties
        vm.isLoading = false;

        vm.isFormOpen = false;
        vm.User = {};
        vm.validUserName = false;
        vm.validUserEmail = false;
        // Methods
        vm.departmentSelectionChanged = departmentSelectionChanged;
        vm.designationSelectionChanged = designationSelectionChanged;
        vm.empSelectionChaged = empSelectionChaged;
        vm.resetForm = resetForm;
        vm.saveUser = saveUser;
        vm.checkUsername = checkUsername;
        vm.checkUserEmail = checkUserEmail;
        vm.isEditing = false;
        vm.selectdep = false;
        vm.selectdes = false;
        vm.selectemp = false;
        vm.form = true;
        vm.isPwd = false;
        vm.isPwd1 = true;
        vm.getApprovedContractor = getApprovedContractor;
        Init();

        ////////////////

        function Init() {
            vm.isLoading = true;
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            DepartmentServices.GetDepartmentByCompanyId(companyId).then(
                function (res) {
                    if (res.status === 200) {
                        vm.DepartmentList = res.data;
                        RoleService.GetActiveRole().then(function (res) {
                            if (res.status === 200) {
                                vm.RoleList = res.data;
                                UserService.getUsersByCompanyId(companyId).then(function (res) {
                                    vm.UserList = res.data;
                                }, function (err) {
                                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                                });
                            } else {
                                $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                            }
                        }, function (err) {
                            $rootScope.showToaster('error', 'Error! Try Again', "Role");
                        });
                    } else {
                        $rootScope.showToaster('error', 'Internal Server Error! Try Again', "Role");
                    }
                },
                function (err) {
                    $rootScope.showToaster('error', "Can't connect the server! Try Again", "Role");
                }
            )
        }

        function departmentSelectionChanged() {
            DesignationService.GetDesigByDepId(vm.selectedDepartment.DepartmentId).then(function (res) {
                if (res.status === 200) {
                    vm.DesignationList = res.data;
                } else {
                    $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                }
            }, function (err) {
                $rootScope.showToaster('error', "Can't connect the server! Try Again", "Create User");
            })
        }

        function designationSelectionChanged() {
            var companyId = AuthenticationService.getLoggedUserDetails().SelectedCompany.CompanyId;
            EmployeeService.getAllEmployees(companyId).then(function (res) {
                vm.EmpList = res.data;
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Create User");
            });
        }

        function getApprovedContractor() {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            UserService.getAllApprovedContractor(loggedUser.UserId).then(function (res) {
                vm.ContractorList = res.data;
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Create User");
            });
        }
        function empSelectionChaged() {

            var user = {}
            if (vm.selectedEmployee != undefined) {
                user.Id = vm.selectedEmployee.EmployeeId,
                user.UserType = 'EMP'
            }
            else {
                user.Id = vm.selectedContractor.ContractorId
                user.UserType = 'CNT'
            }
            UserService.CheckUserAccount(user).then(function (res) {
                if (res.data == true) {
                    if(vm.selectedEmployee != undefined){
                        dialogs.notify('Warning', 'An account has already created for ' + vm.selectedEmployee.FirstName, {
                            animation: true,
                            size: 'sm'
                        });
                    }
                    else{
                        dialogs.notify('Warning', 'An account has already created for ' + vm.selectedContractor.ContractorName, {
                            animation: true,
                            size: 'sm'
                        });
                    }
                   
                    vm.form = true;
                    vm.isPwd = true;
                } else {
                    if(vm.selectedEmployee != undefined)
                    {
                        vm.User.FirstName = vm.selectedEmployee.FirstName;
                        vm.User.LastName = vm.selectedEmployee.LastName;
                    }
                    else{
                        vm.User.FirstName = vm.selectedContractor.ContractorName;                        
                    }
                    
                  
                    vm.form = false;
                    vm.isPwd = false;
                }
                vm.isLoading = false;
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                vm.isLoading = false;
            });


        }

        function checkUserEmail() {
            vm.isLoading = true;
            if (vm.User.EmailId.trim() !== "") {
                UserService.checkUserEmail(vm.User.EmailId).then(function (res) {
                    if (res.status == 200) {
                        vm.validUserEmail = !res.data;
                    } else {
                        vm.validUserEmail = false;
                    }
                    vm.isLoading = false;
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                    vm.isLoading = false;
                });
            } else {
                vm.User.EmailId = "";
                vm.isLoading = false;
            }
        }

        function checkUsername() {
            vm.isLoading = true;
            if (vm.User.Username.trim() !== "") {
                UserService.checkUsername(vm.User.Username).then(function (res) {
                    if (res.status == 200) {
                        vm.validUserName = !res.data;
                    } else {
                        vm.validUserName = false;
                    }
                    vm.isLoading = false;
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                    vm.isLoading = false;
                });
            } else {
                vm.User.Username = "";
                vm.isLoading = false;
            }
        }

        vm.Create = function () {
            vm.selectdep = false;
            vm.selectdes = false;
            vm.selectemp = false
            vm.isEditing = false;
            vm.isFormOpen = true;
            vm.form = true;
        }

        vm.editUser = function (User) {
            vm.isEditing = true;
            vm.isFormOpen = true;
            vm.User = angular.copy(User);
            for (var c in vm.RoleList) {
                if (vm.RoleList[c].RoleId == User.Role.RoleId) {
                    vm.selectedRole = vm.RoleList[c];
                }
            }
            vm.selectdep = true;
            vm.selectdes = true;
            vm.selectemp = true;
            vm.form = false;
            vm.isPwd = true;
        }


        function saveUser() {
            var logggedUser = AuthenticationService.getLoggedUserDetails();
            if (!vm.isEditing) {
                if (vm.selectedContractor != undefined) {
                    var user = {
                        Username: vm.User.Username,
                        FirstName: vm.User.FirstName,
                        LastName: vm.User.LastName,
                        EmailId: vm.User.EmailId,
                        Password: vm.User.Password,
                        RoleId: vm.selectedRole.RoleId,
                        CompanyId: logggedUser.SelectedCompany.CompanyId,
                        CreatedBy: logggedUser.UserId,
                        RefId: vm.selectedContractor.ContractorId
                    };
                    vm.isLoading = true;
                    UserService.createUserContractor(user).then(function (res) {
                        if (res.status === 200) {
                            $rootScope.showToaster('success', 'User Added Successfully', "Create User");
                            vm.isLoading = false;
                            vm.isFormOpen = false;
                            Init();
                            resetForm();
                        } else {
                            $rootScope.showToaster('error', 'Invalid Data', "Create User");
                            vm.isFormOpen = true;
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                        vm.isLoading = false;
                    });
                }
                else {
                    var user = {
                        Username: vm.User.Username,
                        FirstName: vm.User.FirstName,
                        LastName: vm.User.LastName,
                        EmailId: vm.User.EmailId,
                        Password: vm.User.Password,
                        RoleId: vm.selectedRole.RoleId,
                        CompanyId: logggedUser.SelectedCompany.CompanyId,
                        CreatedBy: logggedUser.UserId,
                        RefId: vm.selectedEmployee.EmployeeId
                    };
                    vm.isLoading = true;
                    UserService.createUser(user).then(function (res) {
                        if (res.status === 200) {
                            $rootScope.showToaster('success', 'User Added Successfully', "Create User");
                            vm.isLoading = false;
                            vm.isFormOpen = false;
                            Init();
                            resetForm();
                        } else {
                            $rootScope.showToaster('error', 'Invalid Data', "Create User");
                            vm.isFormOpen = true;
                        }
                    }, function (err) {
                        $rootScope.showToaster('error', 'Error! Try Again', "Create User");
                        vm.isLoading = false;
                    });
                }

            } else {
                vm.isLoading = true;
                var user = {
                    UserId: vm.User.UserId,
                    UserName: vm.User.Username,
                    FirstName: vm.User.FirstName,
                    LastName: vm.User.LastName,
                    EmailId: vm.User.EmailId,
                    RoleId: vm.selectedRole.RoleId,
                    ModifiedBy: logggedUser.UserId
                }
                UserService.UpdateUser(user).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'User Updated Successfully', "Update User");
                        vm.isLoading = false;
                        vm.isFormOpen = false;
                        Init();
                        resetForm();
                    } else {
                        $rootScope.showToaster('error', 'Invalid Data', "Update User");
                        vm.isFormOpen = true;
                    }
                }, function (err) {
                    $rootScope.showToaster('error', 'Error! Try Again', "Update User");
                    vm.isLoading = false;
                });
            }
        }




        vm.removeUser = function (User) {
            var confirm = dialogs.confirm('Confirm',
                'Are sure you want to delete current row.', {
                    animation: true,
                    size: 'sm'
                });

            confirm.result.then(function () {
                UserService.removeUser(User.UserId).then(function (res) {
                    if (res.status === 200) {
                        $rootScope.showToaster('success', 'Delete User Successfully', "User");
                        Init();
                    } else {
                        $rootScope.showToaster('error', "Can't Delete User", {
                            animation: true,
                            size: 'sm'
                        });
                    }
                }, function (err) {
                    $rootScope.showToaster('error', "Can't Delete User. <br> If its not a parent contact your Admin", {
                        animation: true,
                        size: 'sm'
                    });
                });
            }, function () {

            })
        }


        function resetForm() {
            vm.isFormOpen = false;
            vm.User = {};
            vm.selectedDepartment = null;
            vm.selectedDesignation = null;
            vm.selectedEmployee = null;
            vm.selectedRole = null;
            vm.form = false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.role')
        .controller('UserMenuMappingCtrl', UserMenuMappingCtrl);

    /** @ngInject */
    function UserMenuMappingCtrl($scope,$rootScope, $state, $http, lodash, dialogs, UserService) {
        var vm = this;
        $rootScope.isLogin = false;
        $rootScope.isLoading = true;

        // Properties
        vm.errorList = [];
        // Methods
        vm.getUserMenuMapping = getUserMenuMapping;
        vm.selectMenu = selectMenu;
        vm.saveUserMenuMapping = saveUserMenuMapping;

        init();
        ////////////////

          vm.collapseAll = function () {
            $scope.$broadcast('angular-ui-tree:collapse-all');
        };

        vm.expandAll = function () {
            $scope.$broadcast('angular-ui-tree:expand-all');
        };

        function init() { 
            vm.isLoading = true;
            UserService.getAllUsers().then(function (res) {
                if (res.status === 200) {
                    vm.UserList = res.data;
                    $rootScope.isLoading = false;
                } else {
                    $rootScope.isLoading = false;
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function (err) {
                $rootScope.isLoading = false;
                $rootScope.showToaster('error', 'Try Again', "Role");
            });
        }

        function getUserMenuMapping() {
            vm.isLoading = true;
            vm.selectedMenu = {};
            UserService.getUserMenuMapping(vm.selectedUser.UserId).then(function(res) {
                if (res.status === 200) {
                    vm.menuList = res.data;
                    // logic
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function(err) {
                $rootScope.showToaster('error', 'Try Again', "Role");
            })
        }

        function selectMenu(menu) {            
            vm.selectedMenu = menu;
        }

        function saveUserMenuMapping () {
            UserService.saveUserMenuMapping(vm.selectedUser.UserId, vm.menuList).then(function(res) {
                if (res.status === 200 && res.data) {
                    $rootScope.showToaster('success', 'Mapping Successfully Saved', "Role");
                } else {
                    $rootScope.showToaster('error', 'Load Failed! Try Again', "Role");
                }
            }, function(err) {
                $rootScope.showToaster('error', 'Try Again', "Role");
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('KPMES.pages.user')
        .controller('SelectCompanyModalCtrl', SelectCompanyModalCtrl);

    /** @ngInject */
    function SelectCompanyModalCtrl($rootScope, lodash, AuthenticationService, UserService, $uibModalInstance, $state) {
        var vm = this;

        // methods
        vm.closeModal = closeModal;
        vm.companySelectionChanged = companySelectionChanged;
        vm.ok = ok;

        Init();

        ////////////////

        function Init() {
            vm.isLoading = true;
            UserService.getUserCompanies($rootScope.userId).then(function (res) {
                if (res.status === 200) {
                    vm.CompanyList = res.data;
                    var loggedUser = AuthenticationService.getLoggedUserDetails();

                    
                    if (loggedUser.SelectedCompany) {
                        vm.selectedCompany = loggedUser.SelectedCompany;
                    }
                    vm.isLoading = false;
                } else {
                    $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
                    vm.isLoading = false;
                }
            }, function (err) {
                $rootScope.showToaster('error', 'Error! Try Again', "KPMES");
                vm.isLoading = false;
            });
        }

        function closeModal() {
            $uibModalInstance.dismiss('cancel');
        }

        function companySelectionChanged() {
            var loggedUser = AuthenticationService.getLoggedUserDetails();
            loggedUser.SelectedCompany = vm.selectedCompany;
            AuthenticationService.setLoggedUserDetails(loggedUser);
        }

        function ok() {
            var user = {
                UserId: $rootScope.userId,
                CompanyId: vm.selectedCompany.CompanyId
            };

            UserService.UpdateSelectedCompany(user).then(
                function(res) {
                    if(res.status === 200) {
                        if(!res.data)
                            $rootScope.showToaster('error', 'Something wrong, Contact Admin.', "Role");
                    } else {
                        $rootScope.showToaster('error', 'Internal Server Error! Try Again', "Role");
                    }
                }, function(err) {
                    $rootScope.showToaster('error', "Can't connect the server! Try Again", "Role");
                }
            )
            $state.reload();
            $uibModalInstance.close();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('KPMES.pages.user')
        .controller('UserPrivilegeCtrl', UserPrivilegeCtrl);

    /** @ngInject */
    function UserPrivilegeCtrl($rootScope, $state, lodash, dialogs, AuthenticationService, UserService) {
        var vm = this;
        $rootScope.isLogin = false;

        // Properties
        vm.isLoading = false;

        // Methods

        init();

        ////////////////

        function init() {}
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('KPMES.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('KPMES.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('KPMES.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {          
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($rootScope, $scope, $http, $window, dialogs, lodash, baSidebarService) {
    
    //$scope.menuItems = baSidebarService.getMenuItems();
    //$scope.defaultSidebarState = $scope.menuItems[0].stateRef;
    getMenuItems();   
    
    var vm = this;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight = $event.currentTarget.clientHeight;
      var menuTopValue = 50;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });



    $scope.Showgrid = function (item) {

      // if(item.MenuId == 39) {
      //       $rootScope.IsMenuClicked = false;
      //     }
     }
      
  

    // $scope.Showgrid = function (MenuId) {
    //   var RestrictedMenus = [39];
    //   var status = !!(RestrictedMenus.indexOf(MenuId) + 1)
    //   if (status) {
    //     if(MenuId = 39)
    //     {
    //       $rootscope.islogin = false
          
    //     }
    //     // if (MenuId == 87 || MenuId == 89 || MenuId == 90 || MenuId == 91) {
    //     //$rootScope.SellerId = 69;
    //     $rootScope.isLogin = "";
    //   } else {
    //    // $rootScope.SellerId = localStorage.getItem('SellerId');
    //     $rootScope.CompanyName = localStorage.getItem('isLogin');
    //   }
    // }

 
    function getMenuItems() {
      var menuList;

      $http.get($rootScope.endPoint + 'User/GetUserMenuByUserId/' + $rootScope.userId).then(
        function (res) {
          if (res.status === 200) {            
            if (res.data.length < 1) {
              dialogs.notify('Info', 'You have not given access to any menu<br>Contact Your Admin!<br>Logging out.', '');
              $rootScope.logout();
            }            
            $window.localStorage.setItem("userMenus", JSON.stringify(res.data));
            var menuList = getSubMenus(res.data);                        
            $scope.menuItems = menuList;
            $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
          }
        }, function (err) {
        }
      );
    }

    function getSubMenus(menuList) {

      var subMenuList = [];
      for (var i in menuList) {
        var temp = {
          title: menuList[i].MenuName,
          name: menuList[i].MenuName,
          icon: menuList[i].MenuIcon,
          stateRef: menuList[i].MenuUrl,
          order: menuList[i].MenuOrder,
          MenuId: menuList[i].MenuId
        };
        if(menuList[i].SubMenuItems.length > 0) {
          temp.subMenu = getSubMenus(menuList[i].SubMenuItems);
        } else {
          temp.subMenu = null;
        }
        subMenuList.push(temp);
      }

      return subMenuList;
    }
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('KPMES.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('KPMES.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {    
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('KPMES.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('KPMES.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('KPMES.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('KPMES.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('KPMES').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/area/area.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Area</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.areaForm" novalidate=""><fieldset><div class="row"><div class="form-group col-sm-4"><label for="inputCountry" class="control-label"><b>Country Name</b><span class="text-danger">*</span></label><div class=""><ui-select name="areadrpdwn1" ng-required="true" ng-model="vm.area.selectedCountry" theme="bootstrap" style="min-width: 300px;" on-select="vm.getStateListByCountryId(vm.area.selectedCountry.CountryId)"><ui-select-match allow-clear="true" placeholder="Country">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.areaForm.areadrpdwn1.$touched && (vm.area.selectedCountry=== null || vm.area.selectedCountry === undefined)"><span class="text-danger">Country Name is required.</span></div></div></div><div class="form-group col-sm-4"><label for="inputState" class="control-label"><b>State Name</b><span class="text-danger">*</span></label><div class=""><ui-select name="areadrpdwn2" ng-required="true" ng-model="vm.area.selectedState" style="min-width: 300px;" theme="bootstrap" on-select="vm.getCityListByStateId(vm.area.selectedState.StateId)"><ui-select-match allow-clear="true" placeholder="State">{{$select.selected.StateName}}</ui-select-match><ui-select-choices repeat="State in vm.StateList | filter: $select.search"><div ng-bind-html="State.StateName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.areaForm.areadrpdwn2.$touched && (vm.area.selectedState=== null || vm.area.selectedState === undefined)"><span class="text-danger">State Name is required.</span></div></div></div><div class="form-group col-sm-4"><label for="inputCity" class="control-label"><b>City Name</b><span class="text-danger">*</span></label><div class=""><ui-select name="areadrpdwn3" ng-required="true" ng-model="vm.area.selectedCity" style="min-width: 300px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="City">{{$select.selected.CityName}}</ui-select-match><ui-select-choices repeat="City in vm.CityList | filter: $select.search"><div ng-bind-html="City.CityName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.areaForm.areadrpdwn3.$touched && (vm.area.selectedCity=== null || vm.area.selectedCity === undefined)"><span class="text-danger">City Name is required.</span></div></div></div></div><div class="row"><div class="form-group col-sm-4"><label for="inputareaName" class="control-label"><b>Area Name</b><span class="text-danger">*</span></label><div class=""><input type="text" class="form-control" name="name" id="inputareaName" maxlength="50" autocomplete="off" placeholder="Area" ng-model="vm.area.AreaName" required=""><p ng-show="vm.areaForm.$submitted || vm.areaForm.name.$touched"><span ng-show="vm.areaForm.name.$error.maxlength" class="text-danger pull-right">City Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p><p ng-show="vm.areaForm.$submitted || vm.areaForm.name.$touched"><span ng-show="vm.areaForm.name.$error.required" class="text-danger">Area Name is required</span></p></div></div><div class="form-group col-sm-4"><label for="inputPincode" class="control-label"><b>Pincode</b><span class="text-danger">*</span></label><div class=""><input type="text" class="form-control" name="name1" id="inputPincode" maxlength="10" autocomplete="off" placeholder="Pincode" ng-model="vm.area.Pincode" required=""><p ng-show="vm.areaForm.$submitted || vm.areaForm.name1.$touched"><span ng-show="vm.areaForm.name.$error.maxlength" class="text-danger pull-right">Pincode is maximum length are {{ 10 - inputMessage.length + \' Char\' }}</span></p><p ng-show="vm.areaForm.$submitted || vm.areaForm.name1.$touched"><span ng-show="vm.areaForm.name1.$error.required" class="text-danger">Pincode is required</span></p></div></div></div><div class=""><div class="form-group pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveArea(vm.area)" ng-disabled="vm.areaForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Area</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.AreaList" class="table table-striped"><thead><tr><th st-sort="" class="text-center"><strong>S.No</strong></th><th st-sort="AreaName" class="text-center"><strong>Area Name</strong></th><th st-sort="Pincode" class="text-center"><strong>Pincode</strong></th><th st-sort="City.CityName" class="text-center"><strong>City Name</strong></th><th st-sort="State.StateName" class="text-center"><strong>State Name</strong></th><th st-sort="Country.CountryName" class="text-center"><strong>Country Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="AreaName" class="input-sm form-control" placeholder="Area Name" type="text"></th><th><input st-search="Pincode" class="input-sm form-control" placeholder="Pincode" type="text"></th><th><input st-search="City.CityName" class="input-sm form-control" placeholder="City Name" type="text"></th><th><input st-search="State.StateName" class="input-sm form-control" placeholder="State Name" type="text"></th><th><input st-search="Country.CountryName" class="input-sm form-control" placeholder="Country Name" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-left">{{row.AreaName}}</td><td>{{row.Pincode}}</td><td>{{row.City.CityName}}</td><td>{{row.State.StateName}}</td><td>{{row.Country.CountryName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editArea(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeArea(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/city/City.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create City</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.cityForm" novalidate=""><fieldset><div class="form-group"><label for="inputEmail" class="col-lg-2 control-label"><b>Country Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="countrydrpdwn" ng-required="true" ng-model="vm.city.selectedCountry" theme="bootstrap" style="min-width: 300px;" on-select="vm.getStateListByCountryId(vm.city.selectedCountry.CountryId)"><ui-select-match allow-clear="true" placeholder="Country Name">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.cityForm.countrydrpdwn.$touched && (vm.city.selectedCountry=== null || vm.city.selectedCountry === undefined)"><span class="text-danger">Country Name is required.</span></div></div></div><div class="form-group"><label for="inputEmail" class="col-lg-2 control-label"><b>State Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="statedrp" ng-required="true" ng-model="vm.city.selectedState" style="min-width: 300px;" theme="bootstrap" on-select="getCityByStateId(vm.selectedState)"><ui-select-match allow-clear="true" placeholder="State Name">{{$select.selected.StateName}}</ui-select-match><ui-select-choices repeat="State in vm.StateList | filter: $select.search"><div ng-bind-html="State.StateName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.cityForm.statedrp.$touched && (vm.city.selectedState=== null || vm.city.selectedState === undefined)"><div><span class="text-danger">State Name is required.</span></div></div></div></div><div class="form-group"><label for="inputCityName" class="col-lg-2 control-label"><b>City Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="inputCityName" maxlength="50" autocomplete="off" placeholder="City Name" ng-model="vm.city.CityName" required=""><p ng-show="vm.cityForm.$submitted || vm.cityForm.name.$touched"><span ng-show="vm.cityForm.name.$error.required" class="text-danger">City Name is required</span></p><p ng-show="vm.cityForm.$submitted || vm.cityForm.name.$touched"><span ng-show="vm.cityForm.name.$error.maxlength" class="text-danger pull-right">City Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveCity(vm.city)" ng-disabled="vm.cityForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of City</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.CityList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="Country.CountryName"><strong>Country Name</strong></th><th st-sort="State.StateName" class="text-center"><strong>State Name</strong></th><th st-sort="CityName" class="text-center"><strong>City Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="Country.CountryName" class="input-sm form-control" placeholder="Country Name" type="text"></th><th><input st-search="State.StateName" class="input-sm form-control" placeholder="State Name" type="text"></th><th><input st-search="CityName" class="input-sm form-control" placeholder="City Name" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.Country.CountryName}}</td><td>{{row.State.StateName}}</td><td>{{row.CityName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editCity(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeCity(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/company/company.html','<style>\r\n    div.show-image {\r\n        position: relative;\r\n        float: left;\r\n        /*margin: 5px;*/\r\n    }\r\n\r\n    div.show-image:hover img {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    div.show-image:hover input {\r\n        display: block;\r\n    }\r\n\r\n    div.show-image input {\r\n        position: absolute;\r\n        display: none;\r\n    }\r\n\r\n    div.show-image input.update {\r\n        top: 0;\r\n        left: 15px;\r\n    }\r\n\r\n    /*div.show-image input.delete {\r\n        top: 0;\r\n        left: 50%;\r\n    }*/\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" is-open="vm.isFormOpen"><uib-accordion-heading>Institution Setup</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.InstitutionForm" novalidate=""><fieldset><div class="col-lg-6"><div class="form-group"><label for="inputInstitutionName" class="col-lg-4 control-label"><b>Name of the Institution</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="Institution" id="inputDoor" autocomplete="off" placeholder="Name of the Institution" ng-model="vm.Institution.CompanyName" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Institution.$touched"><span ng-show="vm.InstitutionForm.Institution.$error.required" class="text-danger">Institution Name is required</span></p></div></div></div><div class="form-group"><label for="inputAddressLine1" class="col-lg-4 control-label"><b>Date of Establishment</b> <span class="text-danger">*</span></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputDOB" name="inputDOB" class="form-control datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.Institution.DOB" is-open="vm.popup2.opened" datepicker-options="vm.options" close-text="Close" placeholder="dd-MM-yyyy" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open2()"><i class="glyphicon glyphicon-calendar"></i></button></span><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.inputDOB.$touched"><span ng-show="vm.InstitutionForm.inputDOB.$error.required" class="text-danger">Date of Establishment is required</span></p></div></p></div></div><div class="form-group"><label for="inputAddressLine2" class="col-lg-4 control-label"><b>Total institution Land Area</b></label><div class="col-lg-6"><input type="text" class="form-control" name="Inslandarea" id="inputDoor" placeholder="Total institution Land Area" ng-model="vm.Institution.Totallandandarea" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Inslandarea.$touched"><span ng-show="vm.InstitutionForm.Inslandarea.$error.required" class="text-danger">Total Institution Land Area is Required</span></p></div><div class="col-lg-2" style="padding-top: 5px"><span><p>in Acres</p></span></div></div><div class="form-group"><label for="inputAddressLine2" class="col-lg-4 control-label"><b>Your Primary Email ID</b></label><div class="col-lg-8"><input type="Email" class="form-control" disabled="" name="primaryemail" id="inputDoor" placeholder="Your Primary Email ID" ng-model="vm.Institution.PrimaryEmail" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.primaryemail.$touched"><span ng-show="vm.InstitutionForm.primaryemail.$error.required" class="text-danger">Primary Email is Required</span></p></div></div></div><div class="form-group"><label for="inputCountry" class="col-lg-4 control-label"><b>Mobile Number</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="Mobilenumber" id="inputDoor" autocomplete="off" placeholder="Mobile Number" ng-model="vm.Institution.MobileNumber" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Secondaryemail.$touched"><span ng-show="vm.InstitutionForm.Mobilenumber.$error.required" class="text-danger">Mobile Number is Required</span></p></div></div></div><div class="form-group"><label for="inputCountry" class="col-lg-4 control-label"><b>Your secondary Email ID</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="Email" class="form-control" name="Secondaryemail" id="inputDoor" autocomplete="off" placeholder="Your secondary Email ID" ng-model="vm.Institution.ScondayEmail" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Secondaryemail.$touched"><span ng-show="vm.InstitutionForm.Secondaryemail.$error.required" class="text-danger">Secondary Email is Required</span></p></div></div></div><div class="form-group"><label for="inputState" class="col-lg-4 control-label"><b>Landline Phone No</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="Landpno" id="inputDoor" autocomplete="off" placeholder="Landline Phone No" ng-model="vm.Institution.Landlineno" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Landpno.$touched"><span ng-show="vm.InstitutionForm.Landpno.$error.required" class="text-danger">Landline phone Number is Required</span></p></div></div></div><div class="form-group"><label for="inputCity" class="col-lg-4 control-label"><b>Name of the Principal</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="principalname" id="inputDoor" autocomplete="off" placeholder="Name of the Principal" ng-model="vm.Institution.principalname" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.principalname.$touched"><span ng-show="vm.InstitutionForm.principalname.$error.required" class="text-danger">Principal Name is Required</span></p></div></div></div><div class="form-group"><label for="inputArea" class="col-lg-4 control-label"><b>Contact Number</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="contactno" id="inputDoor" autocomplete="off" placeholder="Contact Number" ng-model="vm.Institution.Contactno" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.contactno.$touched"><span ng-show="vm.InstitutionForm.contactno.$error.required" class="text-danger">Contact Number is Required</span></p></div></div></div><div class="form-group"><label for="inputPincode" class="col-lg-4 control-label"><b>Authorized Admin Coordinator</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="Admincoordinator" autocomplete="off" id="inputDoor" placeholder="Authorized Admin Coordinator" ng-model="vm.Institution.Admincoordinator" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Admincoordinator.$touched"><span ng-show="vm.InstitutionForm.Admincoordinator.$error.required" class="text-danger">Authorized Admin Coordinator is Required</span></p></div></div></div><div class="form-group"><label for="inputEmail" class="col-lg-4 control-label"><b>Contact Number</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="contactnumber" id="inputEmail" autocomplete="off" placeholder="Contact Number" ng-model="vm.Institution.Contactnumber" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.contactnumber.$touched"><span ng-show="vm.InstitutionForm.contactnumber.$error.required" class="text-danger">Contact Number is required</span></p></div></div></div><div class="col-lg-6"><div class="form-group"><label for="inputCountry" class="col-lg-4 control-label"><b>Country</b></label><div class="col-lg-8"><ui-select name="countrydrp1" ng-required="true" ng-model="vm.Institution.selectedCountry" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Country">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.countrydrp1.$touched && (vm.Institution.selectedCountry === null || vm.Institution.selectedCountry === undefined)"><span class="text-danger">Country is required.</span></div></div></div><div class="form-group"><label for="inputWebsite" class="col-lg-4 control-label"><b>Type of Educational Institution</b></label><div class="col-lg-8"><ui-select name="Typeofedu" ng-required="true" ng-model="vm.Institution.selectedEducation" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Type of Educational institution">{{$select.selected.NameoftheEducational}}</ui-select-match><ui-select-choices repeat="Educational in vm.EducationList | filter: $select.search"><div ng-bind-html="Educational.NameoftheEducational | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.Typeofedu.$touched && (vm.Institution.selectedEducation=== null ||vm.Institution.selectedEducation=== undefined)"><span class="text-danger">Type of Educational Institution is required.</span></div></div></div><div class="form-group"><label for="inputNatureOfBusiness" class="col-lg-4 control-label"><b>Founder Name</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="Foundername" id="inputWebsite" autocomplete="=off" placeholder="Founder Name" ng-model="vm.Institution.Foundername" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Foundername.$touched"><span ng-show="vm.InstitutionForm.Foundername.$error.required" class="text-danger">Founder Name is required</span></p></div></div><div class="form-group"><label for="inputOrganizationLevelName" class="col-lg-4 control-label"><b>Prefered Languge Software</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="prelang" ng-required="true" ng-model="vm.Institution.Selectedlanguage.Language" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Prefered Languge to use the Software">{{$select.selected.Languagename}}</ui-select-match><ui-select-choices repeat="preferedLanguage in vm.LanguageList | filter: $select.search"><div ng-bind-html="preferedLanguage.Languagename | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.prelang.$touched && (vm.Institution.Selectedlanguage=== null ||vm.Institution.Selectedlanguage=== undefined)"><span class="text-danger">Prefered Languge to use the Software is required.</span></div></div></div><div class="form-group"><label for="inputNumberofstu" class="col-lg-4 control-label"><b>Number of Students</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="Numberofstudents" id="inputWebsite" autocomplete="off" placeholder="Number of Students" ng-model="vm.Institution.NumberofStudents" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Numberofstudents.$touched"><span ng-show="vm.InstitutionForm.Numberofstudents.$error.required" class="text-danger">Number of Students is required</span></p></div></div><div class="form-group"><label for="inputNumberTStaff" class="col-lg-4 control-label"><b>Number of Teaching staff</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="NumberofTeachingStaff" id="inputnumberofteachingstaff" autocomplete="off" placeholder="Number of Teaching Staff" ng-model="vm.Institution.NumberofTeachingStaff" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.NumberofTeachingStaff.$touched"><span ng-show="vm.InstitutionForm.NumberofTeachingStaff.$error.required" class="text-danger">Number of Teaching Staff is required</span></p></div></div><div class="form-group"><label for="inputNumberNTStaff" class="col-lg-4 control-label"><b>Number of Non-Teaching staff</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="number" class="form-control" name="NumberofNTeachingStaff" id="inputnumberofnonteachingstaff" autocomplete="off" placeholder="Number of Non-Teaching Staff" ng-model="vm.Institution.NumberofNonTeachingStaff" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.NumberofNTeachingStaff.$touched"><span ng-show="vm.InstitutionForm.NumberofNTeachingStaff.$error.required" class="text-danger">Number of Non-Staffing is required</span></p></div></div></div></fieldset></form><div class="col-md-6 well well-sm"><form name="vm.AddressForm" class="form-horizontal"><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">REGISTERED OFFICE</h4></div><div class="form-group"><label for="inputAddress1" class="col-lg-4 control-label"><b>AddressLine1</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="AddressLine1" id="inputDoor" autocomplete="off" placeholder="AddressLine1" ng-model="vm.Institution.RegAddress.AddressLine1" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.AddressLine1.$touched"><span ng-show="vm.InstitutionForm.AddressLine1.$error.required" class="text-danger">AddressLine1 is Required</span></p></div></div><div class="form-group"><label for="inputAddressLine1" class="col-lg-4 control-label"><b>AddressLine2</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" class="form-control" name="AddressLine2" id="inputDoor" autocomplete="off" placeholder="Address Line 2" ng-model="vm.Institution.RegAddress.AddressLine2" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.AddressLine2.$touched"><span ng-show="vm.InstitutionForm.AddressLine2.$error.required" class="text-danger">Address Line2 is Required</span></p></div></div><div class="form-group"><label for="inputCountry" class="col-lg-4 control-label"><b>Country</b></label><div class="col-lg-8"><ui-select name="countrydrp" ng-required="true" ng-model="vm.Institution.RegAddress.selectedCountry" theme="bootstrap" style="min-width: 300px;" on-select="vm.getStateListByCountryId(vm.Institution.RegAddress.selectedCountry.CountryId)"><ui-select-match allow-clear="true" placeholder="Country">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.countrydrp.$touched && (vm.Institution.selectedCountry === null || vm.Institution.selectedCountry === undefined)"><span class="text-danger">Country is required.</span></div></div></div><div class="form-group"><label for="inputState" class="col-lg-4 control-label"><b>State</b></label><div class="col-lg-8"><ui-select name="statedrp" ng-required="true" ng-model="vm.Institution.RegAddress.selectedState" theme="bootstrap" style="min-width: 300px;" on-select="vm.getCityListByStateId(vm.Institution.RegAddress.selectedState.StateId)"><ui-select-match allow-clear="true" placeholder="State Name">{{$select.selected.StateName}}</ui-select-match><ui-select-choices repeat="State in vm.StateList | filter: $select.search"><div ng-bind-html="State.StateName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.statedrp.$touched && (vm.Institution.selectedState === null || vm.Institution.selectedState === undefined)"><span class="text-danger">State is required.</span></div></div></div><div class="form-group"><label for="inputWebsite" class="col-lg-4 control-label"><b>City/District</b></label><div class="col-lg-8"><ui-select name="citydrp" ng-required="true" ng-model="vm.Institution.RegAddress.selectedCity" theme="bootstrap" style="min-width: 300px;" on-select="vm.getAreaListByCityId(vm.Institution.RegAddress.selectedCity.CityId)"><ui-select-match allow-clear="true" placeholder="City/District">{{$select.selected.CityName}}</ui-select-match><ui-select-choices repeat="City in vm.CityList | filter: $select.search"><div ng-bind-html="City.CityName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.citydrp.$touched && (vm.Institution.selectedCity === null || vm.Institution.selectedCity === undefined)"><span class="text-danger">City is required.</span></div></div></div><div class="form-group"><label for="inputArea" class="col-lg-4 control-label"><b>Area Name</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="areadrp" ng-required="true" ng-model="vm.Institution.RegAddress.selectedArea" style="min-width: 300px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="Area Name">{{$select.selected.AreaName}}</ui-select-match><ui-select-choices repeat="Area in vm.AreaList | filter: $select.search"><div ng-bind-html="Area.AreaName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.areadrp.$touched && (vm.Institution.selectedArea === null || vm.Institution.selectedArea === undefined)"><span class="text-danger">Area is required.</span></div></div></div><div class="form-group"><label for="inputAddressLine2" class="col-lg-4 control-label"><b>Pincode</b></label><div class="col-lg-8"><input type="text" class="form-control" name="Pincode" id="inputDoor" autocomplete="=off" placeholder="Pincode" disabled="" ng-model="vm.Institution.RegAddress.selectedArea.Pincode" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Pincode.$touched"><span ng-show="vm.InstitutionForm.Pincode.$error.required" class="text-danger">PinCode is Required</span></p></div></div></fieldset></form></div><div class="col-md-6 well well-sm"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">CAMPUS ADDRESS</h4></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.isComAddSameAsPerAdd" ng-change="vm.update()" id="inlineCheckbox04" value="option1"> <span><b>CLICK IF BOTH REGISTERED OFFICE ADDRESS AND CAMPUS ADDRESS ARE SAME</b></span></label><div class="form-group"><label for="inputCompanyName" class="col-lg-4 control-label"><b>Campus Name</b> <span class="text-danger"></span></label><div class="col-lg-8"><input type="text" class="form-control" name="Campusname" id="inputDoor" autocomplete="off" placeholder="Campus Name" ng-model="vm.Institution.CampAddrss.campusname" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Campusname.$touched"><span ng-show="vm.InstitutionForm.Campusname.$error.required" class="text-danger">Campus Name is Required</span></p></div></div><div class="form-group"><label for="inputAddressLine1" class="col-lg-4 control-label"><b>AddressLine1</b> <span class="text-danger"></span></label><div class="col-lg-8"><input type="text" class="form-control" name="AddressLine1" id="inputDoor" autocomplete="off" placeholder="Address Line 1" ng-model="vm.Institution.CampAddrss.AddressLine1" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.AddressLine1.$touched"><span ng-show="vm.InstitutionForm.AddressLine1.$error.required" class="text-danger">Address Line is Required</span></p></div></div><div class="form-group"><label for="inputAddressLine2" class="col-lg-4 control-label"><b>AddressLine2</b></label><div class="col-lg-8"><input type="text" class="form-control" name="AddressLine2" id="inputDoor" autocomplete="off" placeholder="Address Line 2" ng-model="vm.Institution.CampAddrss.AddressLine2" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.AddressLine2.$touched"><span ng-show="vm.InstitutionForm.AddressLine2.$error.required" class="text-danger">Address is Required</span></p></div></div><div class="form-group"><label for="inputCountry" class="col-lg-4 control-label"><b>Country</b></label><div class="col-lg-8"><ui-select name="countrydrp" ng-required="true" ng-model="vm.Institution.CampAddrss.selectedCountry" theme="bootstrap" style="min-width: 300px;" on-select="vm.getStateListByCountryId(vm.Institution.CampAddrss.selectedCountry.CountryId)"><ui-select-match allow-clear="true" placeholder="Country">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.countrydrp.$touched && (vm.company.selectedCountry === null || vm.company.selectedCountry === undefined)"><span class="text-danger">Country is required.</span></div></div></div><div class="form-group"><label for="inputState" class="col-lg-4 control-label"><b>State</b></label><div class="col-lg-8"><ui-select name="statedrp" ng-required="true" ng-model="vm.Institution.CampAddrss.selectedState" theme="bootstrap" style="min-width: 300px;" on-select="vm.getCityListByStateId(vm.Institution.CampAddrss.selectedState.StateId)"><ui-select-match allow-clear="true" placeholder="State Name">{{$select.selected.StateName}}</ui-select-match><ui-select-choices repeat="State in vm.StateList | filter: $select.search"><div ng-bind-html="State.StateName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.statedrp.$touched && (vm.Institution.selectedState === null || vm.Institution.selectedState === undefined)"><span class="text-danger">State is required.</span></div></div></div><div class="form-group"><label for="inputWebsite" class="col-lg-4 control-label"><b>City/District</b></label><div class="col-lg-8"><ui-select name="citydrp" ng-required="true" ng-model="vm.Institution.CampAddrss.selectedCity" theme="bootstrap" style="min-width: 300px;" on-select="vm.getAreaListByCityId(vm.Institution.CampAddrss.selectedCity.CityId)"><ui-select-match allow-clear="true" placeholder="City/District">{{$select.selected.CityName}}</ui-select-match><ui-select-choices repeat="City in vm.CityList | filter: $select.search"><div ng-bind-html="City.CityName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.citydrp.$touched && (vm.Institution.selectedCity === null || vm.Institution.selectedCity === undefined)"><span class="text-danger">City is required.</span></div></div></div><div class="form-group"><label for="inputArea" class="col-lg-4 control-label"><b>Area Name</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="areadrp" ng-required="true" ng-model="vm.Institution.CampAddrss.selectedArea" style="min-width: 300px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="Area Name">{{$select.selected.AreaName}}</ui-select-match><ui-select-choices repeat="Area in vm.AreaList | filter: $select.search"><div ng-bind-html="Area.AreaName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.areadrp.$touched && (vm.Institution.selectedArea === null || vm.Institution.selectedArea === undefined)"><span class="text-danger">Area is required.</span></div></div></div><div class="form-group"><label for="inputAddressLine2" class="col-lg-4 control-label"><b>Pincode</b></label><div class="col-lg-8"><input type="text" class="form-control" name="Pincode" id="inputDoor" autocomplete="=off" placeholder="Pincode" disabled="" ng-model="vm.Institution.CampAddrss.selectedArea.Pincode" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.Pincode.$touched"><span ng-show="vm.InstitutionForm.Pincode.$error.required" class="text-danger">PinCode is Required</span></p></div></div></div></div><br><br><br><div class="form-group col-lg-12"><div class="row"><div class="col-lg-4"><div class="form-group"><label for="inputWeburl" class="col-lg-4 control-label"><b>Website URL</b></label><div class="col-lg-8"><input type="text" class="form-control" name="inputWeburl" id="inputDoor" autocomplete="off" placeholder="Website URL" ng-model="vm.Institution.Websiteurl" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.inputWeburl.$touched"><span ng-show="vm.InstitutionForm.inputWeburl.$error.required" class="text-danger">Website URL is Required</span></p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="inputPANno" class="col-lg-4 control-label"><b>PAN Number</b></label><div class="col-lg-8"><input type="text" class="form-control" name="inputPANno" id="inputDoor" autocomplete="off" placeholder="PAN Number" ng-model="vm.Institution.PANnumber" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.inputPANno.$touched"><span ng-show="vm.InstitutionForm.inputPANno.$error.required" class="text-danger">PAN Number is Required</span></p></div></div></div><div class="col-lg-4"><div class="form-group"><label for="inputTANno" class="col-lg-4 control-label"><b>GST Number</b></label><div class="col-lg-8"><input type="text" class="form-control" name="GSTno" id="inputDoor" autocomplete="off" placeholder="GST Number" ng-model="vm.Institution.TANnumber" required=""><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.GSTno.$touched"><span ng-show="vm.InstitutionForm.GSTno.$error.required" class="text-danger">TAN Number is Required</span></p></div></div></div></div></div><div class="form-group col-lg-12"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" id="myBtn" data-target="#myModal" ng-click="vm.SaveCompany(vm.Institution)" ng-disabled="vm.companyForm.$invalid">SAVE AND PROCEED FOR PAYMANET</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">CANCEL</button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.Reset()">RESET</button></div></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen" ng-if="!$root.isLogin"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Institution</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.CompanyList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="CompanyCode"><strong>Code</strong></th><th class="text-center" st-sort="InstitutionName"><strong>Institution Name</strong></th><th class="text-center" st-sort="City.CityName"><strong>Location</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="CompanyCode" class="input-sm form-control" placeholder="Code" type="text"></th><th><input st-search="InstitutionName" class="input-sm form-control" placeholder="Institution Name" type="text"></th><th><input st-search="City.CityName" class="input-sm form-control" placeholder="Location" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.CompanyCode}}</td><td>{{row.CompanyName}}</td><td>{{row.City.CityName}}</td><td class="text-center" width="150Px"><div><button type="button" ng-click="vm.editCompany(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeCompany(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/company/Popup.html','<form><div class="container well" ng-model="vm.popup"><p></p><h3 style="color: rgb(1, 1, 19) ;fontsize:Bold"><strong>Terms & Condition</strong></h3><p></p><p>Mobile Service: via a supported mobile handset. The Premium Service permits you to store cached content on up to three (3) personal computers, mobile handsets and/or other relevant devices (collectively \u201CDevices\u201D) while your Premium Service subscription is active. You may not transfer copies of cached content to any other device via any means. By using the Mobile Service, you agree to accept the Mobile Terms and to register for the Service as a mobile subscriber. The Premium Service and the Unlimited Service are hereinafter referred to as \u201CPaid Subscriptions\u201D. 3.2 Codes and other Limited Offers If you have purchased a code sold by or on behalf of Spotify for access to the Unlimited Service or Premium Service for the time period indicated on your email, card or paper receipt (\u201CCode\u201D), or if you are accessing the service through some other limited offer which you received or purchased from Spotify (\u201CLimited Offer\u201D), these Agreements apply to your access to the Service. Any separate sets of terms and conditions presented to you along with the Code or other Limited Offer also apply to your access to the Service using the Code or Limited Offer. Subject to any rights you may have under Section 12, Codes are only redeemable in the country where you purchased such Code, not redeemable for cash and may not be returned for a cash refund, exchanged, resold or used to purchase other Codes.</p><h3 style="color: rgb(1, 1, 19);fontsize:Bold">Privacy Policy</h3><strong>Our Privacy Policy Explication<p></p><p>What information We Collect And why we collect it</p><p>How we use that information</p><p>The choices we offer including how to access and update information</p><p>We have tried to keep it as simple sa possible but if you are not fami;iar with tearm with terms like cookies IP address pixel tage and browsers then read adout these key tearms first your privacy matters</p><center><input type="checkbox"> I agree these terms and conditions</center><br><h4 style="color: rgb(1, 1, 19)">Enter the OTP that has been send to your Registered Mobile No<div class="col-lg-8"><input type="text" class="form-control" name="Secondaryemail" id="inputDoor" autocomplete="off" ng-model="vm.popup.VerifyOTP" required=""></div></h4><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.payment()" hidden="vm.popup">Submitand Proceed for Payment</button> <button type="button" class="btn btn-success btn-sm" ng-click="">Payment Details</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></strong></div></form>');
$templateCache.put('app/pages/country/country.html','<div class="row"><uib-accordion><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Country</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.CountryForm" novalidate=""><fieldset><div class="form-group"><label for="inputCountryName" class="col-lg-2 control-label"><b>Country Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="name" class="form-control" name="CountryName" maxlength="50" autocomplete="off" id="inputCountryName" placeholder="Country Name" ng-model="vm.country.CountryName" required=""><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CountryName.$touched"><span ng-show="vm.CountryForm.CountryName.$error.required" class="text-danger">Country Name is required</span></p><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CountryName.$touched"><span ng-show="vm.CountryForm.CountryName.$error.maxlength" class="text-danger pull-right">Country Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p></div><label for="inputCountryCode" class="col-lg-2 control-label"><b>Country Code</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="CountryCode" id="inputCountryCode" autocomplete="off" maxlength="5" placeholder="Country Code" ng-model="vm.country.CountryCode" required=""><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CountryCode.$touched"><span ng-show="vm.CountryForm.CountryCode.$error.required" class="text-danger">Country Code is required</span></p></div></div><div class="form-group"><label for="inputCurrencyName" class="col-lg-2 control-label"><b>Currency Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="name" class="form-control" name="CurrencyName" maxlength="50" autocomplete="off" id="inputCountryName" placeholder="Currency Name" ng-model="vm.country.CurrencyName" required=""><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CurrencyName.$touched"><span ng-show="vm.CountryForm.CurrencyName.$error.required" class="text-danger">Currency Name is required</span></p><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CurrencyName.$touched"><span ng-show="vm.CountryForm.CurrencyName.$error.maxlength" class="text-danger pull-right">Currency Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p></div><label for="inputCurrencyCode" class="col-lg-2 control-label"><b>Currency Code</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="CurrencyCode" id="inputCountryCode" autocomplete="off" maxlength="50" placeholder="Currency Code" ng-model="vm.country.CurrencyCode" required=""><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CurrencyCode.$touched"><span ng-show="vm.CountryForm.CurrencyCode.$error.required" class="text-danger">Currency Code is required</span></p></div></div><div class="form-group"><label for="inputCurrencySymbol" class="col-lg-2 control-label"><b>Currency Symbol</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="name" class="form-control" name="CurrencySymbol" maxlength="50" autocomplete="off" id="inputCountryName" placeholder="Currency Symbol" ng-model="vm.country.CurrencySymbol" required=""><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CurrencySymbol.$touched"><span ng-show="vm.CountryForm.CurrencySymbol.$error.required" class="text-danger">Currency Symbol is required</span></p><p ng-show="vm.CountryForm.$submitted || vm.CountryForm.CurrencySymbol.$touched"><span ng-show="vm.CountryForm.CurrencySymbol.$error.maxlength" class="text-danger pull-right">Currency Symbol is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveCountryNew(vm.country);vm.isFormOpen = false;vm.isTableOpen=true" ng-disabled="vm.CountryForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Country</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.CountryList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="CountryName" class="text-center"><strong>Country Name</strong></th><th st-sort="CountryCode" class="text-center"><strong>Country Code</strong></th><th st-sort="CountryCode" class="text-center"><strong>Currency Name</strong></th><th st-sort="CountryCode" class="text-center"><strong>Currency Code</strong></th><th st-sort="CountryCode" class="text-center"><strong>Currency Symbol</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="CountryName" class="input-sm form-control" placeholder="Country Name" type="text"></td><td><input st-search="CountryCode" class="input-sm form-control" placeholder="Country Code" type="text"></td><td><input st-search="CountryCode" class="input-sm form-control" placeholder="Currency Name" type="text"></td><td><input st-search="CountryCode" class="input-sm form-control" placeholder="Currency Code" type="text"></td><td><input st-search="CountryCode" class="input-sm form-control" placeholder="Currency Symbol" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.CountryName}}</td><td>{{row.CountryCode}}</td><td>{{row.CurrencyName}}</td><td>{{row.CurrencyCode}}</td><td>{{row.CurrencySymbol}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editCountry(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.NewremoveCountry(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<style>\r\n    .w3-grey{\r\n        margin-bottom: 10px;\r\n    }\r\n</style><div class="w3-main"><div class="w3-row-padding w3-margin-bottom"><div class="w3-quarter"><div class="w3-container w3-red w3-padding-16"><div class="w3-left"><i class="fa fa-calendar-check-o w3-xxxlarge"></i></div><div class="w3-right"></div><div class="w3-clear"></div><h4>Student Attendence</h4></div></div><div class="w3-quarter"><div class="w3-container w3-blue w3-padding-16"><div class="w3-left"><i class="fa fa-bar-chart w3-xxxlarge"></i></div><div class="w3-right"></div><div class="w3-clear"></div><h4>Student Performance</h4></div></div><div class="w3-quarter"><div class="w3-container w3-teal w3-padding-16"><div class="w3-left"><i class="fa fa-file-text-o w3-xxxlarge"></i></div><div class="w3-right"></div><div class="w3-clear"></div><h4>Weekly Assignment</h4></div></div><div class="w3-quarter"><div class="w3-container w3-orange w3-text-white w3-padding-16"><div class="w3-left"><i class="fa fa-flag-o w3-xxxlarge"></i></div><div class="w3-right"></div><div class="w3-left"></div><h4>Reports</h4></div></div></div><div class="w3-panel"><div class="w3-row-padding" style="margin:0 -16px"><div class="w3-twothird"><h5>Feeds</h5><table class="w3-table w3-striped w3-white"><tr><td><i class="fa fa-users w3-text-blue w3-large"></i></td><td>Total No of Students in IX - A</td><td><i>25</i></td></tr><tr><td><i class="fa fa-calendar-check-o w3-text-orange w3-large"></i></td><td>No of Students Present Today</td><td><i>21</i></td></tr><tr><td><i class="fa fa-calendar-times-o w3-text-res w3-large"></i></td><td>No of Students Apsent Today</td><td><i>4</i></td></tr><tr><td><i class="fa fa-book w3-text-blue w3-large"></i></td><td>No of Lessons Taught in Science Biology</td><td><i>Unit 1</i></td></tr><tr><td><i class="fa fa-book w3-text-red w3-large"></i></td><td>No of Lessons Taught in Science Physics</td><td><i>Unit 2</i></td></tr><tr><td><i class="fa fa-book w3-text-green w3-large"></i></td><td>No of Lessons Taught in Science Chemistry</td><td><i>Unit 2</i></td></tr><tr><td><i class="fa fa-book w3-text-red w3-large"></i></td><td>No of Lessons Taught in Science Computers</td><td><i>Unit 1</i></td></tr></table></div></div></div><hr><div class="w3-container"><h5><b>Leave Information</b></h5><p>Leave Eligible</p><div class="w3-grey"><div class="w3-container w3-center w3-padding w3-green" style="width:100%">10 Days</div></div><p>Leave Taken</p><div class="w3-grey"><div class="w3-container w3-center w3-padding w3-red" style="width:20%">2 Days</div></div><p>Leave Balence</p><div class="w3-grey"><div class="w3-container w3-center w3-padding w3-orange" style="width:80%">8 Days</div></div></div><hr><br></div>');
$templateCache.put('app/pages/designation/Designation.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Designation</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.desigForm" novalidate=""><fieldset><div class="form-group"><label for="code" class="col-lg-2 control-label"><b>Designation Code</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="code" id="inputDesignationCode" placeholder="Designation Code" aria-autocomplete="off" ng-model="vm.desig.Code" required=""><p ng-show="vm.desigForm.$submitted || vm.desigForm.code.$touched"><span ng-show="vm.desigForm.code.$error.required" class="text-danger">Designation Code is required</span></p></div></div><div class="form-group"><label for="inputCompany" class="col-lg-2 control-label"><b>Company Name <span class="text-danger">*</span></b></label><div class="col-lg-4"><ui-select name="companydrp" ng-required="true" ng-model="vm.desig.selectedCompany" theme="bootstrap" style="min-width: 300px;" on-select="vm.getDepartmentListByCompanyId(vm.desig.selectedCompany.CompanyId)"><ui-select-match allow-clear="true" placeholder="Company Name">{{$select.selected.CompanyName}}</ui-select-match><ui-select-choices repeat="Company in vm.CompanyList | filter: $select.search"><div ng-bind-html="Company.CompanyName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.desigForm.companydrp.$touched && (vm.desig.selectedCompany === null || vm.desig.selectedCompany === undefined)"><span class="text-danger">Company Name is required.</span></div></div></div><div class="form-group"><label for="inputDepartment" class="col-lg-2 control-label"><b>Department Name</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="depdrp" ng-required="true" ng-model="vm.desig.selectedDepartment" style="min-width: 300px;" theme="bootstrap" on-select="vm.departmentSelectionChanged()"><ui-select-match allow-clear="true" placeholder="Department Name">{{$select.selected.DepartmentName}}</ui-select-match><ui-select-choices repeat="Department in vm.DepartmentList | filter: $select.search"><div ng-bind-html="Department.DepartmentName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.desigForm.depdrp.$touched && (vm.desig.selectedDepartment === null || vm.desig.selectedDepartment === undefined)"><span class="text-danger">Department Name is required.</span></div></div></div><div class="form-group"><label for="name" class="col-lg-2 control-label"><b>Designation Name</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="inputDesignationName" placeholder="Designation Name" aria-autocomplete="off" ng-model="vm.desig.DesignationName" required=""><p ng-show="vm.desigForm.$submitted || vm.desigForm.name.$touched"><span ng-show="vm.desigForm.name.$error.required" class="text-danger">Designation Name is required</span></p></div></div><div class="form-group"><label for="inputSuperior" class="col-lg-2 control-label"><b>Reporting To</b></label><div class="col-lg-4"><ui-select name="superiordrp" ng-model="vm.desig.selectedSuperior" style="min-width: 300px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="Reporting To">{{$select.selected.DesignationName}}</ui-select-match><ui-select-choices repeat="Designation in vm.DesignationActiveList"><div ng-bind-html="Designation.DesignationName | highlight: $select.search"></div><small ng-bind-html="Designation.Company.CompanyName | highlight: $select.search"></small>; <small ng-bind-html="Designation.Department.DepartmentName| highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveDesignation(vm.desig)" ng-disabled="vm.desigForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Designation</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i>Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.DesignationList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="Code" class="text-center"><strong>Designation Code</strong></th><th st-sort="DesignationName" class="text-center"><strong>Designation Name</strong></th><th st-sort="SuperiorName" class="text-center"><strong>Reporting To</strong></th><th st-sort="Department.DepartmentName" class="text-center"><strong>Department Name</strong></th><th st-sort="Company.CompanyName" class="text-center"><strong>Company Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><th><input st-search="Code" class="input-sm form-control" placeholder="Designation Code" type="text"></th><th><input st-search="DesignationName" class="input-sm form-control" placeholder="Designation Name" type="text"></th><th><input st-search="SuperiorName" class="input-sm form-control" placeholder="Reporting To" type="text"></th><th><input st-search="Department.DepartmentName" class="input-sm form-control" placeholder="Department Name" type="text"></th><th><input st-search="Company.CompanyName" class="input-sm form-control" placeholder="Company Name" type="text"></th><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.Code}}</td><td>{{row.DesignationName}}</td><td>{{row.SuperiorName}}</td><td>{{row.Department.DepartmentName}}</td><td>{{row.Company.CompanyName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editDesignation(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeDesignation(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/Department/department.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Department</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.departmentForm" novalidate=""><fieldset><div class="form-group"><label for="inputDepartmentCode" class="col-lg-2 control-label"><b>Department Code</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" ng-blur="vm.CheckDepartmentCode()" class="form-control" name="code" id="inputDepartmentCode" placeholder="Department Code" ng-model="vm.dept.Code" autocomplete="off" required=""><p ng-show="vm.departmentForm.$submitted || vm.departmentForm.code.$touched"><span ng-show="vm.departmentForm.code.$error.required" class="text-danger">Department Code is required</span></p><p ng-if="vm.isCheck"><span class="text-danger">This Code is Already Exist !!!</span></p></div></div><div class="form-group"><label for="inputCompanyName" class="col-lg-2 control-label"><b>Company Name</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="companydrpdwn" ng-required="true" ng-model="vm.dept.selectedCompany" theme="bootstrap" style="min-width: 300px;" on-select="vm.companyChanged()"><ui-select-match allow-clear="true" placeholder="Company Name">{{$select.selected.CompanyName}}</ui-select-match><ui-select-choices repeat="Company in vm.CompanyList | filter: $select.search"><div ng-bind-html="Company.CompanyName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.departmentForm.companydrpdwn.$touched && (vm.dept.selectedCompany=== null || vm.dept.selectedCompany === undefined)"><span class="text-danger">Company Name is required.</span></div></div></div><div class="form-group"><label for="inputDepartmentName" class="col-lg-2 control-label"><b>Department Name</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="inputDepartmentName" placeholder="Department Name" ng-model="vm.dept.DepartmentName" autocomplete="off" required=""><p ng-show="vm.departmentForm.$submitted || vm.departmentForm.name.$touched"><span ng-show="vm.departmentForm.name.$error.required" class="text-danger">Department Name is required</span></p></div></div><div class="form-group" data-ng-if="vm.DepartmentActiveList.length > 0"><label for="inputParent" class="col-lg-2 control-label"><b>Parent Department</b></label><div class="col-lg-4"><ui-select name="parentdrpdwn" ng-required="true" ng-model="vm.dept.selectedParent" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Parent Department">{{$select.selected.DepartmentName}}</ui-select-match><ui-select-choices repeat="Department in vm.DepartmentActiveList | filter: $select.search"><div ng-bind-html="Department.DepartmentName | highlight: $select.search"></div><div class="text-muted" ng-bind-html="Department.Company.CompanyName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveDepartment(vm.dept)" ng-disabled="vm.departmentForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Department</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.DepartmentList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort=""><strong>Code</strong></th><th st-sort="DepartmentName" class="text-center"><strong>Department Name</strong></th><th st-sort="ParentName" class="text-center"><strong>Parent Department</strong></th><th st-sort="Company.CompanyName" class="text-center"><strong>Company Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="Code" class="input-sm form-control" placeholder="Department Code" type="text"></th><th><input st-search="DepartmentName" class="input-sm form-control" placeholder="Department Name" type="text"></th><th><input st-search="ParentName" class="input-sm form-control" placeholder="Parent Department" type="text"></th><th><input st-search="Company.CompanyName" class="input-sm form-control" placeholder="Company Name" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.Code}}</td><td>{{row.DepartmentName}}</td><td>{{row.ParentName}}</td><td>{{row.Company.CompanyName}}</td><td width="200px" class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.EditDepartment(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeDepartment(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/directives/multiselect.tmpl.html','<div class="dropdown"><button class="form-control" ng-click="toggleSelect()" ng-disabled="disabled" ng-class="{\'btn-default-focus\': !valid()}"><span class="text-block pull-left">{{header}}</span> <span class="caret pull-right" style="margin: 9px 1px"></span></button><ul class="dropdown-menu"><li><input class="form-control" type="text" ng-model="searchText.label" style="border-radius:5px" autofocus="autofocus" placeholder="Filter"></li><li ng-show="multiple"><button class="btn btn-link btn-sm" ng-click="checkAll()"><i class="fa fa-check" aria-hidden="true"></i> Check all</button> <button class="btn btn-link btn-sm" ng-click="uncheckAll()"><i class="fa fa-times" aria-hidden="true"></i> Uncheck all</button></li><li ng-repeat="i in items | filter:searchText"><a ng-click="select(i); focus()"><i ng-class="{\'fa fa-check\': i.checked, \'icon-empty\': !i.checked}"></i>{{i.label}}</a></li></ul></div>');
$templateCache.put('app/pages/EducationType/educationType.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Type Of Educational</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.TypeofEducationalForm" novalidate=""><fieldset><div class="form-group"><label for="inputTypeofEdu" class="col-lg-4 control-label"><b>Type of Educational</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="TEst" class="form-control" name="contactno" id="inputDoor" autocomplete="off" placeholder="Contact Number" ng-model="vm.Institution.Contactno" required=""><div class="col-xs-6"><p ng-show="vm.InstitutionForm.$submitted || vm.InstitutionForm.contactno.$touched"><span ng-show="vm.InstitutionForm.contactno.$error.required" class="text-danger">Contact Number is Required</span></p></div></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveInstitution(vm.InstitutionIns)" ng-disabled="vm.InstitutionInsForm.$invalid">Submit</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button> s</div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">institution Initiation</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i>Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.DesignationList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="DesignationName" class="text-center"><strong>Institution Funded</strong></th><th st-sort="SuperiorName" class="text-center"><strong>Educational Syllabus</strong></th><th st-sort="Department.DepartmentName" class="text-center"><strong>Medium of instruction</strong></th><th st-sort="Company.CompanyName" class="text-center"><strong>Education System</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><th><input st-search="DesignationName" class="input-sm form-control" placeholder="Institution Funded" type="text"></th><th><input st-search="SuperiorName" class="input-sm form-control" placeholder="Educational Syllabus" type="text"></th><th><input st-search="Department.DepartmentName" class="input-sm form-control" placeholder="Medium of instruction" type="text"></th><th><input st-search="Company.CompanyName" class="input-sm form-control" placeholder="Education System" type="text"></th><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.Code}}</td><td>{{row.InsFundName}}</td><td>{{row.Syllabusname}}</td><td>{{row.Mediumname}</td><td>{{row.eduSystemName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editDesignation(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeDesignation(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div><div ng-if="isLoading" class="overlay"><i class="fa fa-spinner fa-spin text-green" style="font-size:80px"></i></div></div></div>');
$templateCache.put('app/pages/employee/employee.html','<style>\r\n    .datepic {\r\n        height: 34px;\r\n    }\r\n\r\n    .well,\r\n    .input-group {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .form-group label {\r\n        text-align: right;\r\n    }\r\n\r\n    .sto {\r\n        margin-bottom: 20px;\r\n        margin-top: 20px;\r\n    }\r\n</style><div class="panel panel-default" data-ng-if="vm.isFormOpen"><div class="panel-heading"><h3 class="panel-title">Create Staff Details</h3></div><div class="panel-body"><div class="row"><div class="col-md-12 well well-sm"><form name="vm.EmployeeForm" class="form-horizontal" novalidate=""><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">STAFF DETAILS</h4></div><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-6"><div><label for="inputFirstName" class="col-md-4 control-label"><b>First Name</b><span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="iFirstName" id="inputFirstName" class="form-control" placeholder="First Name" autocomplete="off" ng-model="vm.emp.FirstName" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iFirstName.$touched)"><span ng-show="vm.EmployeeForm.iFirstName.$error.required" class="text-danger">First Name is required</span></p></div></div><div><label for="inputLastName" class="col-md-4 control-label"><b>Last Name</b><span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputLastName" id="inputLastName" class="form-control" placeholder="Last Name" autocomplete="off" ng-model="vm.emp.LastName" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputLastName.$touched)"><span ng-show="vm.EmployeeForm.inputLastName.$error.required" class="text-danger">Last Name is required</span></p></div></div><div><label for="inputGender" class="col-md-4 control-label"><b>Gender</b><span class="text-danger">*</span></label><div><input type="radio" name="gender" required="" class="styled" value="M" ng-model="vm.emp.Gender"> <label for="inputGenderM">Male</label> <input type="radio" name="gender" required="" class="styled" value="F" ng-model="vm.emp.Gender"> <label for="inputGenderF">Female</label> <input type="radio" name="gender" required="" class="styled" value="T" ng-model="vm.emp.Gender"> <label for="inputGenderT">Transgender</label></div></div></div><div class="form-group col-md-6"><div class="col-sm-offset-4 col-sm-4"><img ng-src="{{ vm.profilePicUrl }}" height="150px" width="130px"><br><br><input name="file" type="file" data-ng-model="file" custom-on-change="photoChanged" required="" ng-show="!vm.isEditing" ng-hide="vm.isEditing && !vm.isEditingProPic"> <span ng-if="vm.empProfilePic === null || vm.empProfilePic === undefined" class="text-danger">Selecte a profile picture</span></div><button type="button" class="btn btn-sm btn-primary" uib-tooltip="Change Employee Photo" ng-show="vm.isEditing" data-ng-click="vm.editProPic()"><i class="fa fa-edit"></i></button>&nbsp;&nbsp; <button type="button" class="btn btn-sm btn-danger" uib-tooltip="Cancel" ng-hide="!vm.isEditing" data-ng-click="vm.isEditingProPic = false" ng-show="vm.isEditing && vm.isEditingProPic"><i class="fa fa-close"></i></button></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputFathertName" class="col-md-4 control-label"><b>Father Name</b><span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="iFathertName" id="inputFathertName" class="form-control" placeholder="Father Name" autocomplete="off" ng-model="vm.emp.FatherName" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iFathertName.$touched)"><span ng-show="vm.EmployeeForm.iFathertName.$error.required" class="text-danger">Father Name is required</span></p></div><br></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputDOB" class="col-md-4 control-label"><b>Date of Birth</b><span class="text-danger">*</span></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputDOB" name="inputDOB" class="form-control datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.emp.DOB" is-open="vm.popup2.opened" datepicker-options="vm.options" close-text="Close" placeholder="dd-MM-yyyy" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group col-md-6"><label for="inputDOJ" class="col-md-4 control-label"><b>Date of Joining</b><span class="text-danger">*</span></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputDOJ" name="inputDOJ" class="form-control m-b-20 ng-isolate-scope ng-touched ng-dirty ng-valid-date ng-valid datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.emp.DOJ" is-open="vm.popup1.opened" datepicker-options="dateOptions" close-text="Close" placeholder="dd-MM-yyyy" validator="required"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputDepartment" class="col-md-4 control-label"><b>Department</b><span class="text-danger">*</span></label><div class="col-md-8"><ui-select id="inputDepartment" name="inputDepartment" ng-model="vm.emp.selectedDepartment" style="min-width: 300px;" theme="bootstrap" on-select="vm.GetDesignationByDepartmentId(vm.emp.selectedDepartment.DepartmentId)" required=""><ui-select-match placeholder="Department">{{$select.selected.DepartmentName}}</ui-select-match><ui-select-choices repeat="Department in vm.DepartmentList | filter: $select.search"><div ng-bind-html="Department.DepartmentName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group col-md-6"><label for="inputDesignation" class="col-md-4 control-label"><b>Designation</b><span class="text-danger">*</span></label><div class="col-md-8"><ui-select id="inputDesignation" name="inputDesignation" ng-model="vm.emp.selectedDesignation" style="min-width: 300px;" theme="bootstrap" on-select="vm.getReportingToList(vm.emp.selectedDesignation.DesignationId)" required=""><ui-select-match placeholder="Designation">{{$select.selected.DesignationName}}</ui-select-match><ui-select-choices repeat="Designation in vm.DesignationList | filter: $select.search"><div ng-bind-html="Designation.DesignationName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputMaritalStatus" class="col-md-4 control-label"><b>Marital Status</b><span class="text-danger">*</span></label><div><input type="radio" name="MS" required="" class="styled" value="M" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusM">Married</label> <input type="radio" name="MS" required="" class="styled" value="S" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusU">UnMarried</label> <input type="radio" name="MS" required="" class="styled" value="W" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusW">Widow</label></div></div><div class="form-group col-md-6" ng-if="vm.emp.MaritalStatus==\'M\'"><label for="inputSpouseName" class="col-md-4 control-label"><b>Spouse Name</b></label><div class="col-md-8"><input type="text" name="inputSpouseName" id="inputSpouseName" class="form-control" placeholder="Spouse Name" ng-model="vm.emp.SpouseName"><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputSpouseName.$touched)"><span ng-show="vm.inputSpouseName.$error.required" class="text-danger">Spouse Name is required</span></p></div></div><div class="form-group col-md-6"><label for="inputBG" class="col-md-4 control-label"><b>Blood Group</b></label><div class="col-md-8"><input type="text" name="iBG" id="inputBG" class="form-control" placeholder="Blood Group" autocomplete="off" ng-model="vm.emp.BloodGroup"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">Blood Group is required</span></p></div></div><div class="form-group col-md-6" data-ng-if="vm.isReporingToRequried"><label for="inputRT" class="col-md-4 control-label"><b>Reporting To</b><span class="text-danger"></span></label><div class="col-md-8"><ui-select id="inputRT" name="inputRT" ng-model="vm.emp.selectedReportingTo" style="min-width: 300px;" theme="bootstrap"><ui-select-match placeholder="Reporting To">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="Reporting in vm.ReportingtoList | filter: $select.search"><div ng-bind-html="Reporting.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="form-group col-md-6"><label for="inputstaff" class="col-md-4 control-label"><b>Staff Details</b><span class="text-danger">*</span></label><div><input type="radio" name="Teaching" required="" class="styled" value="0" ng-model="vm.emp.staffdetails"> <label for="inputTeaching">Teaching</label> <input type="radio" name="NonTeaching" required="" class="styled" value="1" ng-model="vm.emp.staffdetails"> <label for="inputNonTeaching">Non-Teaching</label></div></div><div class="form-group col-md-6"><label for="inputKpostId" class="col-md-4 control-label"><b>KpostId</b></label><div class="col-md-8"><input type="text" name="iBG" id="inputBG" class="form-control" placeholder="Staff Kpost Id" autocomplete="off" ng-model="vm.emp.KpostId"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">Kpost Id is required</span></p></div></div></div></div></fieldset></form></div><div class="col-md-12 well well-sm"><form name="vm.AddressForm" class="form-horizontal"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">ADDRESS DETAILS</h4></div><div class="col-md-6 well well-sm"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">PERMANANT ADDRESS DETAILS</h4></div><div class="col-md-12"><div class="form-group"><label for="inputAddress1" class="col-md-4 control-label"><b>Address1</b></label><div class="col-md-8"><input type="text" id="inputAddress1" required="" name="inputAddress1" class="form-control" placeholder="Address1" autocomplete="off" ng-model="vm.empPer.EmpAddress.Address1"><br><p ng-if="(vm.AddressForm.$submitted || vm.AddressForm.inputAddress1.$touched)"><span ng-show="vm.AddressForm.inputAddress1.$error.required" class="text-danger">Address1 is required</span></p></div></div><div class="form-group"><label for="inputAddress2" class="col-md-4 control-label"><b>Address2</b></label><div class="col-md-8"><input type="text" id="inputAddress2" name="inputAddress2" class="form-control" placeholder="Address2" autocomplete="off" ng-model="vm.empPer.EmpAddress.Address2"></div></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Area</b></label><div class="col-md-8"><input type="text" id="inputArea" name="inputArea" class="form-control" placeholder="Area" autocomplete="off" ng-model="vm.empPer.EmpAddress.Area"></div></div><div class="form-group"><label for="inputCity" class="col-md-4 control-label"><b>City</b></label><div class="col-md-8"><input type="text" id="inputCity" name="inputCity" class="form-control" placeholder="City" autocomplete="off" ng-model="vm.empPer.EmpAddress.City"></div></div><div class="form-group"><label for="inputState" class="col-md-4 control-label"><b>State</b></label><div class="col-md-8"><input type="text" id="inputState" name="inputState" class="form-control" placeholder="State" autocomplete="off" ng-model="vm.empPer.EmpAddress.State"></div></div><div class="form-group"><label for="inputCountry" class="col-md-4 control-label"><b>Country</b></label><div class="col-md-8"><input type="text" id="inputCountry" name="inputCountry" class="form-control" placeholder="Country" autocomplete="off" ng-model="vm.empPer.EmpAddress.Country"></div></div><div class="form-group"><label for="inputPincode" class="col-md-4 control-label"><b>PinCode</b></label><div class="col-md-8"><input type="text" id="inputPincode" name="inputPincode" class="form-control" placeholder="PinCode" autocomplete="off" ng-model="vm.empPer.EmpAddress.PinCode"></div></div><div class="form-group"><label for="inputEmailId" class="col-md-4 control-label"><b>Email Id</b></label><div class="col-md-8"><input type="text" id="inputEmailId" name="inputEmailId" class="form-control" placeholder="EmailId" autocomplete="off" ng-model="vm.empPer.EmpAddress.EmailId"></div></div><div class="form-group"><label for="inputMobile" class="col-md-4 control-label"><b>MobileNo</b></label><div class="col-md-8"><input type="number" id="inputMobile" name="inputMobile" class="form-control" placeholder="MobileNo" autocomplete="off" ng-model="vm.empPer.EmpAddress.MobileNo"></div></div><div class="form-group"><label for="inputLandlineNo" class="col-md-4 control-label"><b>LandlineNo</b></label><div class="col-md-8"><input type="number" id="inputLandlineNo" name="inputLandlineNo" class="form-control" placeholder="LandlineNo" autocomplete="off" ng-model="vm.empPer.EmpAddress.LandlineNo"></div></div></div></div><div class="col-md-6 well well-sm"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">COMMUNICATION ADDRESS DETAILS</h4></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.isComAddSameAsPerAdd" ng-change="vm.update()" id="inlineCheckbox04" value="option1"> <span><b>Is Same as Permanent Address</b></span></label><div class="col-md-12"><div class="form-group"><label for="inputAddress1" class="col-md-4 control-label"><b>Address 1</b></label><div class="col-md-8"><input type="text" id="inputAddress1" ng-disabled="vm.isComAddSameAsPerAdd" name="inputAddress1" class="form-control" placeholder="Address1" autocomplete="off" ng-model="vm.empCom.EmpAddress.Address1"></div></div><div class="form-group"><label for="inputAddress2" class="col-md-4 control-label"><b>Address 2</b></label><div class="col-md-8"><input type="text" id="inputAddress2" name="inputAddress2" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="Address2" autocomplete="off" ng-model="vm.empCom.EmpAddress.Address2"></div></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Area</b></label><div class="col-md-8"><input type="text" id="inputArea" name="inputArea" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="Area" autocomplete="off" ng-model="vm.empCom.EmpAddress.Area"></div></div><div class="form-group"><label for="inputCity" class="col-md-4 control-label"><b>City</b></label><div class="col-md-8"><input type="text" id="inputCity" name="inputCity" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="City" autocomplete="off" ng-model="vm.empCom.EmpAddress.City"></div></div><div class="form-group"><label for="inputState" class="col-md-4 control-label"><b>State</b></label><div class="col-md-8"><input type="text" id="inputState" name="inputState" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="State" autocomplete="off" ng-model="vm.empCom.EmpAddress.State"></div></div><div class="form-group"><label for="inputCountry" class="col-md-4 control-label"><b>Country</b></label><div class="col-md-8"><input type="text" id="inputCountry" name="inputCountry" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="Country" autocomplete="off" ng-model="vm.empCom.EmpAddress.Country"></div></div><div class="form-group"><label for="inputPincode" class="col-md-4 control-label"><b>PinCode</b></label><div class="col-md-8"><input type="text" id="inputPincode" name="inputPincode" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="PinCode" autocomplete="off" ng-model="vm.empCom.EmpAddress.PinCode"></div></div><div class="form-group"><label for="inputEmailId" class="col-md-4 control-label"><b>EmailId</b></label><div class="col-md-8"><input type="text" id="inputEmailId" name="inputEmailId" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="EmailId" autocomplete="off" ng-model="vm.empCom.EmpAddress.EmailId"></div></div><div class="form-group"><label for="inputMobile" class="col-md-4 control-label"><b>MobileNo</b></label><div class="col-md-8"><input type="number" id="inputMobile" name="inputMobile" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="MobileNo" autocomplete="off" ng-model="vm.empCom.EmpAddress.MobileNo"></div></div><div class="form-group"><label for="inputLandlineNo" class="col-md-4 control-label"><b>LandlineNo</b></label><div class="col-md-8"><input type="number" id="inputLandlineNo" name="inputLandlineNo" ng-disabled="vm.isComAddSameAsPerAdd" class="form-control" placeholder="LandlineNo" autocomplete="off" ng-model="vm.empCom.EmpAddress.LandlineNo"></div></div></div></div></form></div></div><div class="row" style="margin: 10px 0"><div class="col-md-12"><div class="form-group"><div class="pull-right"><button class="btn btn-primary btn-sm" ng-click="vm.SaveEmployee(vm.emp)">Save</button> <button class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button> <button class="btn btn-primary btn-sm" ng-click="vm.GotoAcademicDetails()">Next</button></div></div></div></div><div class="row" data-ng-if="vm.isFormOpen"><div class="col-md-12 well well-sm" data-ng-if="vm.isEditing"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">ACADEMIC DETAILS</h4></div><div class=""><div class="col-md-12"><div class="form-group col-md-6"><label for="inputGraduation" class="col-md-4 control-label"><b>Graduation</b></label><div class="col-md-8"><select class="input-sm" id="inputGraduation" name="inputGraduation" data-ng-model="vm.emp1.Graduation" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="10" selected="selected">10<sup>th</sup></option><option ng-option="" value="12">12<sub>th</sub></option><option ng-option="" value="dimploma">DIMPLOMA</option><option ng-option="" value="UG">UNDER GRADUATION</option><option ng-option="" value="P">POST GRADUATION</option></select></div></div><div class="form-group col-md-6"><label for="inputdegree" class="col-md-4 control-label"><b>Degree</b></label><div class="col-md-8"><input type="text" id="inputdegree" name="inputdegree" class="form-control" placeholder="Degree" autocomplete="off" ng-model="vm.emp1.Degree" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputdegree.$touched)"><span ng-show="vm.EmployeeForm.inputdegree.$error.required" class="text-danger">Degree is required</span></p></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputspecialization" class="col-md-4 control-label"><b>Specialization</b></label><div class="col-md-8"><input type="text" id="inputspecialization" name="inputspecialization" class="form-control" placeholder="Specialization" autocomplete="off" ng-model="vm.emp1.Specialization" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputspecialization.$touched)"><span ng-show="vm.EmployeeForm.inputspecialization.$error.required" class="text-danger">Specialization is required</span></p></div></div><div class="form-group col-md-6"><label for="inputuniversity" class="col-md-4 control-label"><b>University/Institute</b></label><div class="col-md-8"><input type="text" id="inputuniversity" name="inputuniversity" class="form-control" placeholder="University/Institute" autocomplete="off" ng-model="vm.emp1.University"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputPercentage" class="col-md-4 control-label"><b>Percentage</b></label><div class="col-md-8"><input type="number" id="inputPercentage" name="inputPercentage" class="form-control" placeholder="Percentage" autocomplete="off" ng-model="vm.emp1.Percentage"></div></div><div class="form-group col-md-6"><label for="inputYOP" class="col-md-4 control-label"><b>Years of Passing</b></label><div class="col-md-8"><input type="text" id="inputYOP" name="inputYOP" only-digits="" class="form-control" placeholder="Years Of Passing" autocomplete="off" ng-model="vm.emp1.YearsofPassing"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputDocAttachment" class="col-md-4 control-label"><b>DocAttachment</b></label><div class="col-md-8"><input type="file" multiple="" custom-on-change="getGraduationFiles"></div></div><div class="form-group col-md-6"><label for="inputRemarks" class="col-md-4 control-label"><b>Remarks</b></label><div class="col-md-8"><input type="text" id="inputRemarks" name="inputRemarks" class="form-control" placeholder="Remarks" autocomplete="off" ng-model="vm.emp1.Remarks"></div></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddEmployeeAcademic(vm.emp1)">Save</button></div></div></div><table st-table="dispayedrows" st-safe-src="vm.EmployeeAcademicList" class="table table-striped"><thead><tr><th st-sort=""><strong>Graduation</strong></th><th st-sort=""><strong>Degree</strong></th><th st-sort=""><strong>Specialization</strong></th><th st-sort=""><strong>University/Institute</strong></th><th st-sort=""><strong>Percentage</strong></th><th st-sort=""><strong>Years of Passing</strong></th><th st-sort=""><strong>Doc Attached</strong></th><th st-sort=""><strong>Remarks</strong></th><th class="text-center"><em class="fa fa-cog" width="100px"></em></th></tr></thead><tbody><tr ng-repeat="row in dispayedrows"><td>{{row.Graduation}}</td><td>{{row.Degree}}</td><td>{{row.Specialization}}</td><td>{{row.University}}</td><td>{{row.Percentage}}</td><td>{{row.YearofPassing}}</td><td><span class="label label-success" data-ng-if="row.DocAttachment != \'\'">Yes</span> <span class="label label-success" data-ng-if="row.DocAttachment === \'\'">No</span></td><td>{{row.Remarks}}</td><td class="text-center" width="100px"><button type="button" ng-click="vm.RemoveEmployeeAcademic(row)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="noOfRows" colspan="10"></td></tr></tfoot></table></div></div></div><div class="row" data-ng-if="vm.isFormOpen"><div class="col-md-12 well well-sm" data-ng-if="vm.isEditing"><div class="form-group col-md-12"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">EXPERIENCE DETAILS</h4></div></div><div class="form-group col-md-6"><label for="inputOrganization" class="col-md-4 control-label"><b>Organization</b></label><div class="col-md-8"><input type="text" id="inputOrganization" name="inputOrganization" class="form-control" placeholder="Organization" autocomplete="off" ng-model="vm.emp2.Organization"></div></div><div class="form-group col-md-6"><label for="inputDepartment" class="col-md-4 control-label"><b>Department</b></label><div class="col-md-8"><input type="text" id="inputDepartment" name="inputinputDepartmentPhoneNo" class="form-control" placeholder="Department" autocomplete="off" ng-model="vm.emp2.Department"></div></div><div class="form-group col-md-6"><label for="inputDesignation" class="col-md-4 control-label"><b>Designation</b></label><div class="col-md-8"><input type="text" id="inputDesignation" name="inputDesignation" class="form-control" placeholder="Designation" autocomplete="off" ng-model="vm.emp2.Designation"></div></div><div class="form-group col-md-6"><label for="inputFD" class="col-md-4 control-label"><b>From Date</b></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputFD" name="inputFD" class="form-control datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.emp2.FromDate" is-open="vm.popup3.opened" datepicker-options="dateOptions" close-text="Close" placeholder="dd-MM-yyyy"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open3()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group col-md-6"><label for="inputTD" class="col-md-4 control-label"><b>To Date</b></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputTD" name="inputTD" class="form-control datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.emp2.ToDate" is-open="vm.popup4.opened" datepicker-options="dateOptions" close-text="Close" placeholder="dd-MM-yyyy" ng-change="vm.checkErr(vm.emp2.FromDate,vm.emp2.ToDate)"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open4()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><span>{{vm.errMessage}}</span></div><div class="form-group col-md-6"><label for="inputYOE" class="col-md-4 control-label"><b>Years of Experience</b></label><div class="col-md-8"><input type="text" id="inputYOE" name="inputYOE" only-digits="" class="form-control" placeholder="Years of Experience" autocomplete="off" ng-model="vm.emp2.YearsofExperience" ng-readonly=""></div></div><div class="form-group col-md-12" style="padding:0px;"><div class="form-group col-md-6"><label for="inputRemarks" class="col-md-4 control-label"><b>Remarks</b></label><div class="col-md-8"><input type="text" id="inputRemarks" name="inputRemarks" class="form-control" placeholder="Remarks" autocomplete="off" ng-model="vm.emp2.Remarks"></div></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddEmployeeExperience(vm.emp2)">Save</button> <button class="btn btn-primary btn-sm" ng-click="vm.EmployeeAccountDetails = !vm.EmployeeAccountDetails; vm.GotoAccountDetails()">Next</button></div></div></div><table st-table="rows" st-safe-src="vm.EmployeeExperienceList" class="table table-striped"><thead><tr><th st-sort=""><strong>Organization</strong></th><th st-sort=""><strong>Department</strong></th><th st-sort=""><strong>Designation</strong></th><th st-sort=""><strong>From Date</strong></th>s<th st-sort=""><strong>To Date</strong></th><th st-sort=""><strong>Years of Experience</strong></th><th st-sort=""><strong>Remarks</strong></th><th class="text-center"><em class="fa fa-cog" width="100px"></em></th></tr></thead><tbody><tr ng-repeat="row in rows"><td>{{row.Organization}}</td><td>{{row.Department}}</td><td>{{row.Designation}}</td><td>{{row.FromDate | date:\'dd/MM/yyyy\'}}</td><td>{{row.ToDate |date:\'dd/MM/yyyy\'}}</td><td>{{row.YearsofExperience}}</td><td>{{row.Remarks}}</td><td class="text-center" width="100px"><button type="button" ng-click="vm.RemoveEmployeeExp(row.ExperienceId)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="noOfRows" colspan="10"></td></tr></tfoot></table></div></div></div><div ng-if="vm.isLoading" class="overlay text-center"><i class="fa fa-spinner fa-spin text-primary text-center" style="font-size:24px"></i></div></div><div class="panel panel-default" ng-show="vm.EmployeeAccountDetails" data-ng-if="vm.isEditing"><div class="panel-heading"><h3 class="panel-title">Create Staff Account Details</h3></div><div class="panel-body"><div class="row"><div class="col-md-12 well well-sm"><form name="vm.EmployeeForm" class="form-horizontal" novalidate=""><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">BANK DETAILS</h4></div><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-6"><label for="inputAccNo" class="col-md-4 control-label"><b>Account No</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputAccNo" id="inputAccNo" class="form-control" placeholder="Account No" autocomplete="off" ng-model="vm.student.AccountNo" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputAccNo.$touched)"><span ng-show="vm.AccountForm.inputAccNo.$error.required" class="text-danger">Account No is required</span></p></div><br></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputBankname" class="col-md-4 control-label"><b>Name of the Bank</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBankname" id="inputBankname" class="form-control" placeholder="Name of the Bank" autocomplete="off" ng-model="vm.student.BankName" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBankname.$touched)"><span ng-show="vm.AccountForm.inputBankname.$error.required" class="text-danger">Name of the Bank is required</span></p></div></div><div class="form-group col-md-6"><label for="inputIFSCcode" class="col-md-4 control-label"><b>IFSC Code</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputIFSCcode" id="inputIFSCcode" class="form-control" placeholder="IFSC Code" autocomplete="off" ng-model="vm.student.IFSCCode" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputIFSCcode.$touched)"><span ng-show="vm.AccountForm.inputIFSCcode.$error.required" class="text-danger">IFSC Code is required</span></p></div></div><div class="form-group col-md-6"><label for="inputBranch" class="col-md-4 control-label"><b>Branch</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBranch" id="inputBranch" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.student.Branch"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBranch.$touched)"><span ng-show="vm.AccountForm.inputBranch.$error.required" class="text-danger">Branch is required</span></p></div></div><div class="form-group col-md-6"><label for="inputMICR" class="col-md-4 control-label"><b>MICR Code</b></label><div class="col-md-8"><input type="text" name="inputMICR" id="inputMICR" class="form-controsl" placeholder="MICR Code" autocomplete="off" ng-model="vm.student.MICRCode"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputMICR.$touched)"><span ng-show="vm.AccountForm.inputMICR.$error.required" class="text-danger">MICR Code is required</span></p></div></div></div></div></fieldset></form></div><div class="col-md-12 well well-sm" data-ng-if="vm.isEditing"><form name="vm.AddressForm" class="form-horizontal"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">PERSONAL DETAILS</h4></div><div class="col-md-6"><div class="col-md-12"><div class="form-group"><label for="inputBloodGroup" class="col-md-4 control-label"><b>Blood Group</b></label><div class="col-md-8"><input type="text" id="inputBloodGroup" name="inputBloodGroup" class="form-control" placeholder="Blood Group" autocomplete="off" ng-model="vm.student.BloodGroup"></div></div><div class="form-group"><label for="inputAddress2" class="col-md-4 control-label"><b>Aadhaar Card No</b></label><div class="col-md-8"><input type="text" id="inputAddress2" name="inputAddress2" class="form-control" placeholder="Aadhaar Card No" autocomplete="off" ng-model="vm.student.Aadhaarcardno"></div></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are You Physically Handicapped</b></label> <input type="radio" name="Physicallyhandicapted" required="" class="styled" value="Y" ng-model="vm.student.Physicallyhandicapted"> <label for="inputPhysicallyhandicapted">Yes</label> <input type="radio" name="Physicallyhandicapted" required="" class="styled" value="N" ng-model="vm.student.Physicallyhandicapted"> <label for="inputPhysicallyhandicapted">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you Eligible to get Fee Wavier</b></label> <input type="radio" name="Eligible" required="" class="styled" value="Y" ng-model="vm.student.Eligible"> <label for="inputEligible">Yes</label> <input type="radio" name="Eligible" required="" class="styled" value="N" ng-model="vm.student.Eligible"> <label for="inputEligible">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you actively participating in any sports</b></label> <input type="radio" name="Participate" required="" class="styled" value="Y" ng-model="vm.student.Participate"> <label for="inputParticipate">Yes</label> <input type="radio" name="Participate" required="" class="styled" value="N" ng-model="vm.student.Participate"> <label for="inputParticipate">No</label></div></div><div class="form-group"><label for="inputProficiency" class="col-md-4 control-label"><b>Level of Proficiency</b></label><div class="form-group col-md-6"></div><div class="col-md-8"><ui-select name="inputProficiency" ng-required="true" ng-model="vm.student.Proficiency" theme="bootstrap" style="min-width:300px"><ui-select-match allow-clear="true" placeholder="Level of Proficiency">{{$select.selected.ProficiencyName}}</ui-select-match><ui-select-choices repeat="Proficiency in vm.ProficiencyList | filter: $select.search"><div ng-bind-html="Proficiency.ProficiencyName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.inputProficiency.$touched && (vm.InstitutionForm.Proficiency=== null ||vm.Institution.selectedOrganization=== undefined)"><span class="text-danger">Prefered Languge to use the Software is required.</span></div></div></div></div><div class="col-md-6"><div class="col-md-12"><br><br><br><br><br><br><br><br><br><br><div class="form-group" ng-if="vm.student.Physicallyhandicapted"><label for="text" class="col-md-4 control-label" ng-if="vm.student.Physicallyhandicapted == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="Handicapped" id="inputHandicapped" class="form-control" placeholder="Physically Handicapped" autocomplete="off" ng-model="vm.student.Handicapped"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">If So, Specify</span></p></div></div><div class="form-group" ng-if="vm.student.Eligible"><label for="text" class="col-md-4 control-label" ng-if="vm.student.Eligible == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="FeeWavier" id="inputFeeWavier" class="form-control" placeholder="Fee Wavier" autocomplete="off" ng-model="vm.student.FeeWavier"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger"><b>If So, Specify</b></span></p></div></div><div class="form-group" ng-if="vm.student.Participate"><label for="text" class="col-md-4 control-label" ng-if="vm.student.Participate == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="participate" id="inputparticipate" class="form-control" placeholder="participate" autocomplete="off" ng-model="vm.student.participate"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">Branch is required</span></p></div></div></div></div></form></div></div><div class="row" style="margin: 10px 0"><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddBankandPersonalDetails(vm.student)">Save</button> <button class="btn btn-primary btn-sm" ng-click="vm.GotoAreaandlanguagedetails()">Next</button></div></div></div></div></div><div ng-if="vm.isLoading" class="overlay text-center"><i class="fa fa-spinner fa-spin text-primary text-center" style="font-size:24px"></i></div></div><div class="row" data-ng-if="vm.isFormOpen"><div class="col-md-12 well well-sm" ng-show="vm.AreaExpertiseDetails"><div class="form-group col-md-12"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">AREAS OF EXPERTISE</h4></div></div><div class="form-group col-md-4"><label for="inputTc1" class="col-md-4 control-label"><b>Teaching Choice1</b></label></div><div class="form-group col-md-4"><label for="inputLevelField1" class="col-md-4 control-label"><b>Subject/Field</b></label><div class="col-md-8"><input type="text" id="inputLevelField1" name="inputLevelField1" class="form-control" placeholder="Subject and Field" autocomplete="off" ng-model="vm.Areas.Subject1"></div></div><div class="form-group col-md-4"><label for="inputLevel1" class="col-md-4 control-label"><b>Level</b></label><div class="col-md-8"><select class="input-sm" id="inputLevel1" name="inputLevel1" data-ng-model="vm.Areas.Level1" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="KG">Kinder Garden</option><option ng-option="" value="PS">Primary School</option><option ng-option="" value="HS">High School</option><option ng-option="" value="HSS">High Secondary School</option></select></div></div><div class="form-group col-md-4"><label for="inputTc2" class="col-md-4 control-label"><b>Teaching Choice2</b></label></div><div class="form-group col-md-4"><label for="inputLevelField2" class="col-md-4 control-label"><b>Subject/Field</b></label><div class="col-md-8"><input type="text" id="inputLevelField2" name="inputLevelField2" class="form-control" placeholder="Subject and Field" autocomplete="off" ng-model="vm.Areas.Subject2"></div></div><div class="form-group col-md-4"><label for="inputLevel2" class="col-md-4 control-label"><b>Level</b></label><div class="col-md-8"><select class="input-sm" id="inputLevel2" name="inputLevel2" data-ng-model="vm.Areas.Level2" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="KG">Kinder Garden</option><option ng-option="" value="PS">Primary School</option><option ng-option="" value="HS">High School</option><option ng-option="" value="HSS">High Secondary School</option></select></div></div><div class="form-group col-md-4"><label for="inputTc3" class="col-md-4 control-label"><b>Teaching Choice3</b></label></div><div class="form-group col-md-4"><label for="inputLevelField3" class="col-md-4 control-label"><b>Subject/Field</b></label><div class="col-md-8"><input type="text" id="inputLevelField3" name="inputLevelField3" class="form-control" placeholder="Subject and Field" autocomplete="off" ng-model="vm.Areas.Subject3"></div></div><div class="form-group col-md-4"><label for="inputLevel3" class="col-md-4 control-label"><b>Level</b></label><div class="col-md-8"><select class="input-sm" id="inputLevel3" name="inputLevel3" data-ng-model="vm.Areas.Level3" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="KG">Kinder Garden</option><option ng-option="" value="PS">Primary School</option><option ng-option="" value="HS">High School</option><option ng-option="" value="HSS">High Secondary School</option></select></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddStaffAreasofExpertise(vm.Areas)">Save</button></div></div></div></div></div><div class="row" data-ng-if="vm.isFormOpen"><div class="col-md-12 well well-sm" ng-show="vm.LanguagesSpokenDetails"><div class="form-group col-md-12"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">LANGUAGES SPOKEN OTHER THAN ENGLISH</h4></div></div><div class="form-group col-md-6"><label for="inputLanguage1" class="col-md-4 control-label"><b>Language 1</b></label><div class="col-md-8"><input type="text" id="inputLanguage1" name="inputLanguage1" class="form-control" placeholder="Language 1" autocomplete="off" ng-model="vm.Language.Language1"></div></div><div class="form-group col-md-6"><label for="inputpro1" class="col-md-4 control-label"><b>Proficiency</b></label><div class="col-md-8"><select class="input-sm" id="inputpro1" name="inputpro1" data-ng-model="vm.Language.Proficiency1" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="Bg">Beginner</option><option ng-option="" value="Im">Intermediate</option><option ng-option="" value="F">Fluent</option></select></div></div><div class="form-group col-md-6"><label for="inputLanguage2" class="col-md-4 control-label"><b>Language 2</b></label><div class="col-md-8"><input type="text" id="inputLanguage2" name="inputLanguage2" class="form-control" placeholder="Language 2" autocomplete="off" ng-model="vm.Language.Language2"></div></div><div class="form-group col-md-6"><label for="inputpro2" class="col-md-4 control-label"><b>Proficiency</b></label><div class="col-md-8"><select class="input-sm" id="inputpro2" name="inputpro2" data-ng-model="vm.Language.Proficiency2" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="Bg">Beginner</option><option ng-option="" value="Im">Intermediate</option><option ng-option="" value="F">Fluent</option></select></div></div><div class="form-group col-md-6"><label for="inputLanguage3" class="col-md-4 control-label"><b>Language 3</b></label><div class="col-md-8"><input type="text" id="inputLanguage3" name="inputLanguage3" class="form-control" placeholder="Language 3" autocomplete="off" ng-model="vm.Language.Language3"></div></div><div class="form-group col-md-6"><label for="inputPro3" class="col-md-4 control-label"><b>Proficiency</b></label><div class="col-md-8"><select class="input-sm" id="inputPro3" name="inputPro3" data-ng-model="vm.Language.Proficiency3" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="Bg">Beginner</option><option ng-option="" value="Im">Intermediate</option><option ng-option="" value="F">Fluent</option></select></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddStaffLanguageSpoken(vm.Language)">Save</button></div></div></div></div></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class=""><h3 class="panel-title">List Of Staff Details</h3></div></div><div class="panel-body"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.EmployeeList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="FirstName"><strong>First Name</strong></th><th class="text-center" st-sort="LastName"><strong>Last Name</strong></th><th class="text-center" st-sort="Department.DepartmentName"><strong>Department</strong></th><th class="text-center" st-sort="Designation.DesignationName"><strong>Designation</strong></th><th class="text-center" st-sort="DOJ"><strong>Date of Joining</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="FirstName" class="input-sm form-control" placeholder="First Name" type="text"></th><th><input st-search="LastName" class="input-sm form-control" placeholder="Last Name" type="text"></th><th><input st-search="Department.DepartmentName" class="input-sm form-control" placeholder="Department" type="text"></th><th><input st-search="Designation.DesignationName" class="input-sm form-control" placeholder="Designation" type="text"></th><th><input st-search="DOJ" class="input-sm form-control" placeholder="DOJ" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.FirstName}}</td><td>{{row.LastName}}</td><td>{{row.Department.DepartmentName}}</td><td>{{row.Designation.DesignationName}}</td><td>{{row.DOJ | date:\'dd-MM-yyyy\'}}</td><td class="text-center" width="200px"><div><button type="button" ng-click="vm.EditEmployee(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.RemoveEmployee(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/employeeChart/employeeChart.html','<style>\r\n    .Kpmes-org-feed {\r\n        padding: 5px, 10px;\r\n    }\r\n    \r\n    .Kpmes-org-img {\r\n        height: 75px;\r\n        width: 75px;\r\n        padding: 4px;\r\n        border-radius: 50%\r\n    }\r\n    \r\n    .Kpmes-org-body,\r\n    .media-heading {\r\n        color: white;\r\n    }\r\n    \r\n    .google-visualization-orgchart-node {\r\n        text-align: left;\r\n        vertical-align: middle;\r\n        font-family: Cambria, Cochin, Georgia, Times, Times New Roman, serif;\r\n        cursor: default;\r\n        border-radius: 3px;\r\n        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.46), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\r\n        padding: 3px;\r\n        max-width: 285px;\r\n        min-width: 285px;\r\n        border: unset;\r\n        border-radius: 3px;\r\n        height: 80px;\r\n        background-color: rgb(63, 161, 218);\r\n        background: -webkit-gradient(linear, left top, left bottom, from(#3fa1da), to(#3fa1da));\r\n    }\r\n    \r\n    .google-visualization-orgchart-table * {\r\n        padding: 0px;\r\n    }\r\n    \r\n    #chartView table {\r\n        border-collapse: unset;\r\n    }\r\n</style><div id="chartView" style="overflow-x:scroll; border-collapse: none;"><div google-chart="" chart="vm.chart"></div><div id="imageView"></div></div>');
$templateCache.put('app/pages/exercise/exercise.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Exercise</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.ExerciseForm" novalidate=""><fieldset><div class="bs-callout bs-callout" style="border-top-color: #777;border-radius: 3px;padding: 5px;margin: 5px 0; border-top-width: 3px;"><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.exercise.selectedClassRoom" on-select="vm.getSectionByClass(vm.exercise.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ExerciseForm.classRoom.$touched && (vm.exercise.selectedClassRoom===null || vm.exercise.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.exercise.selectedSection" on-select="vm.getSubjectBySection(vm.exercise.selectedClassRoom.ClassId,vm.exercise.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ExerciseForm.section.$touched && (vm.exercise.selectedSection===null || vm.exercise.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.exercise.selectedSubject" on-select="vm.getChapterBySubject(vm.exercise.selectedClassRoom.ClassId,vm.exercise.selectedSection.SectionId,vm.exercise.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject Name">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ExerciseForm.subject.$touched && (vm.exercise.selectedSubject===null || vm.exercise.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.exercise.selectedChapter" on-select="vm.getUnitByChapters(vm.exercise.selectedClassRoom.ClassId,vm.exercise.selectedSection.SectionId,vm.exercise.selectedSubject.SubjectId,vm.exercise.selectedChapter.ChapterId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter Name">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ExerciseForm.Chapter.$touched && (vm.exercise.selectedChapter===null ||vm.exercise.selectedChapter===undefined)"><span class="text-danger">Subject is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="UnitName" class="control-label"><b>Unit Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="UnitName" ng-required="true" ng-model="vm.exercise.selectedUnit" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Unit Name">{{$select.selected.UnitName}}</ui-select-match><ui-select-choices repeat="unit in vm.UnitList | filter: $select.search"><div ng-bind-html="unit.UnitName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.UnitName.$touched && (vm.exercise.selectedUnit===null ||vm.exercise.selectedUnit===undefined)"><span class="text-danger">Unit Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="ExerciseName" class="control-label"><b>Exercise Name</b> <span class="text-danger">*</span></label><div class=""></div><input type="ExerciseName" class="form-control" name="name" id="inputExerciseName" autocomplete="off" placeholder="Exercise Name" ng-model="vm.exercise.ExerciseName" required=""><p ng-show="vm.ExerciseForm.$submitted || vm.ExerciseForm.name.$touched"><span ng-show="vm.ExerciseForm.name.$error.required" class="text-danger">Exercise Name is required</span></p></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveExercise(vm.exercise)" ng-disabled="vm.ExerciseForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Exercise</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.ExerciseList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject Name</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter Name</strong></th><th st-sort="UnitName" class="text-center"><strong>Unit Name</strong></th><th st-sort="ExerciseName" class="text-center"><strong>Exercise Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="StandardName" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="SectionName" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="SubjectName" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="ChapterName" type="text"></td><td><input st-search="UnitName" class="input-sm form-control" placeholder="UnitName" type="text"></td><td><input st-search="ExerciseName" class="input-sm form-control" placeholder="ExerciseName" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center">{{row.UnitName}}</td><td class="text-center">{{row.ExerciseName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editExecise(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeExercise(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div><div ng-if="isLoading" class="overlay"><i class="fa fa-spinner fa-spin text-green" style="font-size:80px"></i></div></div></div></div>');
$templateCache.put('app/pages/institution/institution.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Institution Initiation</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.InstitutionInsForm" novalidate=""><fieldset><div class="form-group"><label for="code" class="col-lg-2 control-label"><b>Institution Type</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="Institutioname" ng-required="true" ng-model="vm.InstitutionIns.selectedInstitutionname" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Type of Educational InstitutionName">{{$select.selected.NameoftheEducational}}</ui-select-match><ui-select-choices repeat="Institution in vm.EducationList | filter: $select.search"><div ng-bind-html="Institution.NameoftheEducational | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.InstitutionInsForm.$submitted || vm.InstitutionInsForm.code.$touched"><span ng-show="vm.InstitutionInsForm.code.$error.required" class="text-danger">Institution Funded is required</span></p></div></div><div class="form-group"><label for="code" class="col-lg-2 control-label"><b>Institution Funded by</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="InstitutionFund" ng-required="true" ng-model="vm.InstitutionIns.selectedInstitutionFund" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Institution Funded by">{{$select.selected.InsFundName}}</ui-select-match><ui-select-choices repeat="InstitutionFund in vm.InstitutionFundList | filter: $select.search"><div ng-bind-html="InstitutionFund.InsFundName | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.InstitutionInsForm.$submitted || vm.InstitutionInsForm.code.$touched"><span ng-show="vm.InstitutionInsForm.code.$error.required" class="text-danger">Institution Funded is required</span></p></div></div><div class="form-group"><label for="inputCompany" class="col-lg-2 control-label"><b>Educational Syllabus</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="EduSyllabus" ng-required="true" ng-model="vm.InstitutionIns.selectedEducationalSyllabus" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Educational Syllabus">{{$select.selected.Syllabusname}}</ui-select-match><ui-select-choices repeat="EducationSyllabus in vm.EduSyllabusList | filter: $select.search"><div ng-bind-html="EducationSyllabus.Syllabusname | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionInsForm.companydrp.$touched && (vm.desig.selectedCompany === null || vm.desig.selectedCompany === undefined)"><span class="text-danger">Educational Syllabus is required.</span></div></div></div><div class="form-group"><label for="code" class="col-lg-2 control-label"><b>Medium of instruction</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="MediumIns" ng-required="true" ng-model="vm.InstitutionIns.selectedMedium" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Medium of instruction">{{$select.selected.Mediumname}}</ui-select-match><ui-select-choices repeat="MediumIns in vm.MediumList | filter: $select.search"><div ng-bind-html="MediumIns.Mediumname | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.desigForm.$submitted || vm.desigForm.code.$touched"><span ng-show="vm.desigForm.code.$error.required" class="text-danger">Medium of instruction is required</span></p></div></div><div class="form-group"><label for="code" class="col-lg-2 control-label"><b>Education System</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="Edusystem" ng-required="true" ng-model="vm.InstitutionIns.selectedEdusystem" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Education System">{{$select.selected.eduSystemName}}</ui-select-match><ui-select-choices repeat="EducationSystem in vm.EducationsystemList | filter: $select.search"><div ng-bind-html="EducationSystem.eduSystemName | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.desigForm.$submitted || vm.desigForm.code.$touched"><span ng-show="vm.desigForm.code.$error.required" class="text-danger">Education System is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveInstitution(vm.InstitutionIns)" ng-disabled="vm.InstitutionInsForm.$invalid">Submit</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.cancel()">Preview</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">institution Initiation</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i>Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.InstitutionInsList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="DesignationName" class="text-center"><strong>Institution Funded</strong></th><th st-sort="SuperiorName" class="text-center"><strong>Educational Syllabus</strong></th><th st-sort="Department.DepartmentName" class="text-center"><strong>Medium of instruction</strong></th><th st-sort="Company.CompanyName" class="text-center"><strong>Education System</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><th><input st-search="DesignationName" class="input-sm form-control" placeholder="Institution Funded" type="text"></th><th><input st-search="SuperiorName" class="input-sm form-control" placeholder="Educational Syllabus" type="text"></th><th><input st-search="Department.DepartmentName" class="input-sm form-control" placeholder="Medium of instruction" type="text"></th><th><input st-search="Company.CompanyName" class="input-sm form-control" placeholder="Education System" type="text"></th><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.Code}}</td><td>{{row.InsFundName}}</td><td>{{row.Syllabusname}}</td><td>{{row.Mediumname}</td><td>{{row.eduSystemName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editDesignation(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeDesignation(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div><div ng-if="isLoading" class="overlay"><i class="fa fa-spinner fa-spin text-green" style="font-size:80px"></i></div></div></div>');
$templateCache.put('app/pages/questionandAnswer/question.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Question</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.QuestionForm" novalidate=""><fieldset><div class="bs-callout bs-callout" style="border-top-color: #777;border-radius: 3px;padding: 5px;margin: 5px 0; border-top-width: 3px;"><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.question.selectedClassRoom" on-select="vm.getSectionByClass(vm.question.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.classRoom.$touched && (vm.question.selectedClassRoom===null || vm.question.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.question.selectedSection" on-select="vm.getSubjectBySection(vm.question.selectedClassRoom.ClassId,vm.question.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.section.$touched && (vm.question.selectedSection===null || vm.question.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.question.selectedSubject" on-select="vm.getChapterBySubject(vm.question.selectedClassRoom.ClassId,vm.question.selectedSection.SectionId,vm.question.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject Name">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.subject.$touched && (vm.question.selectedSubject===null || vm.question.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.question.selectedChapter" on-select="vm.GetAllExerciseByUnit(vm.question.selectedChapter.ChapterId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter Name">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.Chapter.$touched && (vm.question.selectedChapter===null ||vm.question.selectedChapter===undefined)"><span class="text-danger">Subject is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="ExerciseName" class="control-label"><b>Exercise Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="ExerciseName" ng-required="true" ng-model="vm.question.selectedExercise" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Exercise Name">{{$select.selected.ExerciseName}}</ui-select-match><ui-select-choices repeat="exercise in vm.ExerciseList | filter: $select.search"><div ng-bind-html="exercise.ExerciseName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.ExerciseName.$touched && (vm.question.selectedExercise===null ||vm.question.selectedExercise===undefined)"><span class="text-danger">Exercise Name is required.</span></div></div></div></div><div class="bs-callout bs-callout" style="border-top-color: #5bc0de;border-radius: 3px;padding: 5px;margin: 5px 0; border-top-width: 3px;"><h4 class="text-center"><span style="color:#5bc0de">Enter The Question and Answer Details</span></h4><div class="row"><div class="form-group col-md-6"><label for="Questions" class="control-label"><b>Enter the Questions</b> <span class="text-danger">*</span></label><div class=""></div><input type="Questions" class="form-control" name="Questions" id="inputQuestions" autocomplete="off" placeholder="Questions" ng-model="vm.question.Questions" required=""><p ng-show="vm.QuestionForm.$submitted || vm.QuestionForm.Questions.$touched"><span ng-show="vm.QuestionForm.Questions.$error.required" class="text-danger">Exercise Name is required</span></p></div></div><div class="row"><div class="form-group col-md-3"><label for="QuestionTypes" class="control-label"><b>Answer Types</b> <span class="text-danger">*</span></label><div class=""><ui-select name="AnswerTypes" ng-required="true" ng-model="vm.question.selectedQuestionTypes" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Answer Types">{{$select.selected.QuestionTypes}}</ui-select-match><ui-select-choices repeat="Question in vm.QuestionTypesList | filter: $select.search"><div ng-bind-html="Question.QuestionTypes | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.QuestionTypes.$touched && (vm.question.selectedQuestionTypes===null ||vm.question.selectedQuestionTypes===undefined)"><span class="text-danger">AnswerTypes is required.</span></div></div></div><div class="form-group col-md-3" data-ng-if="vm.question.selectedQuestionTypes.QuestionTypes == \'RadioButton\' ||vm.question.selectedQuestionTypes.QuestionTypes == \'CheckBox\'"><label for="Options" class="control-label"><b>Options</b></label><div class=""></div><input type="text" class="form-control" name="Options" value="" autocomplete="off" placeholder="Options" ng-model="vm.question.Options"><div class=""><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SavetheOptions()">Add</button></div><p ng-show="vm.QuestionForm.$submitted || vm.QuestionForm.name.$touched"><span ng-show="vm.QuestionForm.name.$error.required" class="text-danger">Options id required</span></p></div><div class="form-group col-md-3" data-ng-if="vm.question.selectedQuestionTypes.QuestionTypes == \'RadioButton\' ||vm.question.selectedQuestionTypes.QuestionTypes == \'CheckBox\'"><label for="CorrectAnswer" class="control-label"><b>Correct Answers in Options</b> <span class="text-danger">*</span></label><div class=""><ui-select name="SaveAnswerTypes" ng-required="true" ng-model="vm.question.selectedCorrectOption" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Correct Answer in Options">{{$select.selected.Value}}</ui-select-match><ui-select-choices repeat="Options in vm.OptionsList | filter: $select.search"><div ng-bind-html="Options.Value | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.QuestionForm.Value.$touched && (vm.question.Value===null ||vm.question.Value===undefined)"><span class="text-danger">OPtions Correct Answer is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3" data-ng-if="vm.question.selectedQuestionTypes.QuestionTypes == \'TextArea\' ||vm.question.selectedQuestionTypes.QuestionTypes == \'TextBox\'"><label for="CorrectAnswer" class="control-label"><b>Correct Answer</b> <span class="text-danger">*</span></label><div class=""></div><textarea class="form-control" name="Questions" id="inputCorrectAnswer" autocomplete="off" placeholder="Correct Answer" ng-model="vm.question.CorrectAnswer" required="" style="width:250%;height: 100px;margin-top: 10px;"></textarea><p ng-show="vm.QuestionForm.$submitted || vm.QuestionForm.name.$touched"><span ng-show="vm.QuestionForm.name.$error.required" class="text-danger">CorrectAnswer is required</span></p></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveQuestion(vm.question)" ng-disabled="vm.QuestionForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Questions</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.QuestionList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject Name</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter Name</strong></th><th st-sort="UnitName" class="text-center"><strong>Unit Name</strong></th><th st-sort="ExerciseName" class="text-center"><strong>Exercise Name</strong></th><th st-sort="QuestionTypes" class="text-center"><strong>Question Types</strong></th><th st-sort="Questions" class="text-center"><strong>Questions</strong></th><th st-sort="CorrectAnswer" class="text-center"><strong>Correct Answer</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="StandardName" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="SectionName" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="SubjectName" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="ChapterName" type="text"></td><td><input st-search="UnitName" class="input-sm form-control" placeholder="UnitName" type="text"></td><td><input st-search="ExerciseName" class="input-sm form-control" placeholder="Exercise Name" type="text"></td><td><input st-search="QuestionTypes" class="input-sm form-control" placeholder="QuestionT ypes" type="text"></td><td><input st-search="Questions" class="input-sm form-control" placeholder="Questions" type="text"></td><td><input st-search="CorrectAnswer" class="input-sm form-control" placeholder="Correct Answer" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center">{{row.UnitName}}</td><td class="text-center">{{row.ExerciseName}}</td><td class="text-center">{{row.QuestionTypes}}</td><td class="text-center">{{row.Questions}}</td><td class="text-center">{{row.CorrectAnswer}}</td><td class="text-center"><div><button type="button" ng-click="vm.editQuestion(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeQuestion(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div><div ng-if="isLoading" class="overlay"><i class="fa fa-spinner fa-spin text-green" style="font-size:80px"></i></div></div></div></div>');
$templateCache.put('app/pages/role/role.html','<div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Creating Of Role</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.roleForm"><fieldset><div class="form-group"><label for="inputRoleName" class="col-lg-2 control-label">Role Name <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="inputRoleName" placeholder="Role Name" ng-model="vm.role.RoleName" required=""><br><p ng-show="vm.roleForm.$submitted || vm.roleForm.name.$touched"><span ng-show="vm.roleForm.name.$error.required" class="text-danger">Role Name is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveRole(vm.role)" ng-disabled="vm.roleForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List of Role</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.RoleList" class="table table-striped"><thead><tr><th st-sort=""><strong>S.No</strong></th><th st-sort="RoleName" class="text-center"><strong>Role Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="RoleName" class="input-sm form-control" placeholder="Role Name" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.RoleName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editRole(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeRole(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/state/state.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create State</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.stateForm" novalidate=""><fieldset><div class="form-group"><label for="inputEmail" class="col-lg-2 control-label"><b>Country Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="country" ng-required="true" ng-model="vm.state.selectedCountry" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Country Name">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.stateForm.country.$touched && (vm.state.selectedCountry === null || vm.state.selectedCountry === undefined)"><span class="text-danger">Country Name is required.</span></div></div></div><div class="form-group"><label for="inputStateName" class="col-lg-2 control-label"><b>State Name</b><span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="inputStateName" maxlength="50" autocomplete="off" placeholder="State Name" ng-model="vm.state.StateName" required=""><p ng-show="vm.stateForm.$submitted || vm.stateForm.name.$touched"><span ng-show="vm.stateForm.name.$error.maxlength" class="text-danger pull-right">State Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p><p ng-show="vm.stateForm.$submitted || vm.stateForm.name.$touched"><span ng-show="vm.stateForm.name.$error.required" class="text-danger">State Name is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveState()" ng-disabled="vm.stateForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of State</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.StateList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="StateName" class="text-center"><strong>State Name</strong></th><th st-sort="CountryName" class="text-center"><strong>Country Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="StateName" class="input-sm form-control" placeholder="State Name" type="text"></td><td><input st-search="Country.CountryName" class="input-sm form-control" placeholder="Country Name" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.StateName}}</td><td>{{row.Country.CountryName}}</td><td class="text-center"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.editState(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.removeState(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/StudentDetails/studentDetails.html','<style>\r\n    .datepic {\r\n        height: 34px;\r\n    }\r\n\r\n    .well,\r\n    .input-group {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .form-group label {\r\n        text-align: right;\r\n    }\r\n\r\n    .sto {\r\n        margin-bottom: 20px;\r\n        margin-top: 20px;\r\n    }\r\n</style><div class="panel panel-default" data-ng-if="vm.isFormOpen"><div class="panel-heading"><h3 class="panel-title">Create student Account Details</h3></div><div class="panel-body"><div class="row"><div class="col-md-12 well well-sm"><form name="vm.EmployeeForm" class="form-horizontal" novalidate=""><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">BANK DETAILS</h4></div><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-6"><label for="inputAccNo" class="col-md-4 control-label"><b>Account No</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputAccNo" id="inputAccNo" class="form-control" placeholder="Account No" autocomplete="off" ng-model="vm.Account.AccountNo" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputAccNo.$touched)"><span ng-show="vm.AccountForm.inputAccNo.$error.required" class="text-danger">Account No is required</span></p></div><br></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputBankname" class="col-md-4 control-label"><b>Name of the Bank</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBankname" id="inputBankname" class="form-control" placeholder="Name of the Bank" autocomplete="off" ng-model="vm.Account.BankName" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBankname.$touched)"><span ng-show="vm.AccountForm.inputBankname.$error.required" class="text-danger">Name of the Bank is required</span></p></div></div><div class="form-group col-md-6"><label for="inputIFSCcode" class="col-md-4 control-label"><b>IFSC Code</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputIFSCcode" id="inputIFSCcode" class="form-control" placeholder="IFSC Code" autocomplete="off" ng-model="vm.Account.IFSCCode" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputIFSCcode.$touched)"><span ng-show="vm.AccountForm.inputIFSCcode.$error.required" class="text-danger">IFSC Code is required</span></p></div></div><div class="form-group col-md-6"><label for="inputBranch" class="col-md-4 control-label"><b>Branch</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBranch" id="inputBranch" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.Account.Branch"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBranch.$touched)"><span ng-show="vm.AccountForm.inputBranch.$error.required" class="text-danger">Branch is required</span></p></div></div><div class="form-group col-md-6"><label for="inputMICR" class="col-md-4 control-label"><b>MICR Code</b></label><div class="col-md-8"><input type="text" name="inputMICR" id="inputMICR" class="form-control" placeholder="MICR Code" autocomplete="off" ng-model="vm.Account.MICRCode"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputMICR.$touched)"><span ng-show="vm.AccountForm.inputMICR.$error.required" class="text-danger">MICR Code is required</span></p></div></div></div></div></fieldset></form></div><div class="col-md-12 well well-sm"><form name="vm.AddressForm" class="form-horizontal"><div class="col-md-6"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">PERSONAL DETAILS</h4></div><div class="col-md-12"><div class="form-group"><label for="inputBloodGroup" class="col-md-4 control-label"><b>Blood Group</b></label><div class="col-md-8"><input type="text" id="inputBloodGroup" name="inputBloodGroup" class="form-control" placeholder="Blood Group" autocomplete="off" ng-model="vm.Account.BloodGroup"></div></div><div class="form-group"><label for="inputAddress2" class="col-md-4 control-label"><b>Aadhaar Card No</b></label><div class="col-md-8"><input type="text" id="inputAddress2" name="inputAddress2" class="form-control" placeholder="Aadhaar Card No" autocomplete="off" ng-model="vm.empPer.EmpAddress.Address2"></div></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are You Physically Handicapped</b></label> <input type="radio" name="MS" required="" class="styled" value="S" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusU">Yes</label> <input type="radio" name="MS" required="" class="styled" value="W" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusW">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you Eligible to get Fee Wavier</b></label> <input type="radio" name="MS" required="" class="styled" value="S" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusU">Yes</label> <input type="radio" name="MS" required="" class="styled" value="W" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusW">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you actively participating in any sports</b></label> <input type="radio" name="MS" required="" class="styled" value="S" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusU">Yes</label> <input type="radio" name="MS" required="" class="styled" value="W" ng-model="vm.emp.MaritalStatus"> <label for="inputMaritalStatusW">No</label></div></div><div class="form-group"><label for="inputAddress1" class="col-md-4 control-label"><b>Level of Proficiency</b></label><div class="form-group col-md-6"></div><div class="col-md-8"><ui-select name="inputProficiency" ng-required="true" ng-model="vm.Account.Proficiency" theme="bootstrap" style="min-width:300px"><ui-select-match allow-clear="true" placeholder="Level of Proficiency">{{$select.selected.ProficiencyName}}</ui-select-match><ui-select-choices repeat="Proficiency in vm.ProficiencyList | filter: $select.search"><div ng-bind-html="Proficiency.ProficiencyName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.inputProficiency.$touched && (vm.InstitutionForm.Proficiency=== null ||vm.Institution.selectedOrganization=== undefined)"><span class="text-danger">Prefered Languge to use the Software is required.</span></div></div></div></div><div class="col-md-6"><div class="col-md-12"><br><br><br><br><br><br><br><br><br><br><div class="form-group"><label for="inputEmailId" class="col-md-4 control-label"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="iBG" id="inputBG" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.emp.BloodGroup"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">If So, Specify</span></p></div></div><div class="form-group"><label for="inputMobile" class="col-md-4 control-label"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="iBG" id="inputBG" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.emp.BloodGroup"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger"><b>If So, Specify</b></span></p></div></div><div class="form-group"><label for="inputLandlineNo" class="col-md-4 control-label"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="iBG" id="inputBG" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.emp.BloodGroup"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">Branch is required</span></p></div></div></div></div></form></div></div><div class="row" style="margin: 10px 0"><div class="col-md-12"><div class="form-group"><div class="pull-right"><button class="btn btn-primary btn-sm" ng-click="vm.SaveEmployee(vm.emp)">Save</button> <button class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></div><div class="row"><div class="col-md-12 well well-sm" data-ng-if="vm.isEditing"><div class=""><div class="col-md-12"><div class="form-group col-md-6"><label for="inputGraduation" class="col-md-4 control-label">Graduation</label><div class="col-md-8"><select class="input-sm" id="inputGraduation" name="inputGraduation" data-ng-model="vm.emp1.Graduation" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="10" selected="selected">10 <sup>th</sup></option><option ng-option="" value="12">12 <sub>th</sub></option><option ng-option="" value="dimploma">DIMPLOMA</option><option ng-option="" value="UG">UNDER GRADUATION</option><option ng-option="" value="P">POST GRADUATION</option></select></div></div><div class="form-group col-md-6" data-ng-if="vm.emp1.Graduation != 10 && vm.emp1.Graduation != 12"><label for="inputdegree" class="col-md-4 control-label">Degree</label><div class="col-md-8"><input type="text" id="inputdegree" name="inputdegree" class="form-control" placeholder="Degree" autocomplete="off" ng-model="vm.emp1.Degree" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputdegree.$touched)"><span ng-show="vm.EmployeeForm.inputdegree.$error.required" class="text-danger">Degree is required</span></p></div></div></div><div class="col-md-12" data-ng-if="vm.emp1.Graduation != 10 && vm.emp1.Graduation != 12"><div class="form-group col-md-6"><label for="inputspecialization" class="col-md-4 control-label">Specialization</label><div class="col-md-8"><input type="text" id="inputspecialization" name="inputspecialization" class="form-control" placeholder="Specialization" autocomplete="off" ng-model="vm.emp1.Specialization" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputspecialization.$touched)"><span ng-show="vm.EmployeeForm.inputspecialization.$error.required" class="text-danger">Specialization is required</span></p></div></div><div class="form-group col-md-6"><label for="inputuniversity" class="col-md-4 control-label">University/Institute</label><div class="col-md-8"><input type="text" id="inputuniversity" name="inputuniversity" class="form-control" placeholder="University/Institute" autocomplete="off" ng-model="vm.emp1.University"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputPercentage" class="col-md-4 control-label">Percentage</label><div class="col-md-8"><input type="number" id="inputPercentage" name="inputPercentage" class="form-control" placeholder="Percentage" autocomplete="off" ng-model="vm.emp1.Percentage"></div></div><div class="form-group col-md-6"><label for="inputYOP" class="col-md-4 control-label">Years of Passing</label><div class="col-md-8"><input type="text" id="inputYOP" name="inputYOP" only-digits="" class="form-control" placeholder="Years Of Passing" autocomplete="off" ng-model="vm.emp1.YearsofPassing"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputDocAttachment" class="col-md-4 control-label">DocAttachment</label><div class="col-md-8"><input type="file" multiple="" custom-on-change="getGraduationFiles"></div></div><div class="form-group col-md-6"><label for="inputRemarks" class="col-md-4 control-label">Remarks</label><div class="col-md-8"><input type="text" id="inputRemarks" name="inputRemarks" class="form-control" placeholder="Remarks" autocomplete="off" ng-model="vm.emp1.Remarks"></div></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddEmployeeAcademic(vm.emp1)">Add</button></div></div></div><table st-table="dispayedrows" st-safe-src="vm.EmployeeAcademicList" class="table table-striped"><thead><tr><th st-sort=""><strong>Graduation</strong></th><th st-sort=""><strong>Degree</strong></th><th st-sort=""><strong>Specialization</strong></th><th st-sort=""><strong>University/Institute</strong></th><th st-sort=""><strong>Percentage</strong></th><th st-sort=""><strong>Years of Passing</strong></th><th st-sort=""><strong>Doc Attached</strong></th><th st-sort=""><strong>Remarks</strong></th><th class="text-center"><em class="fa fa-cog" width="100px"></em></th></tr></thead><tbody><tr ng-repeat="row in dispayedrows"><td>{{row.Graduation}}</td><td>{{row.Degree}}</td><td>{{row.Specialization}}</td><td>{{row.University}}</td><td>{{row.Percentage}}</td><td>{{row.YearofPassing}}</td><td><span class="label label-success" data-ng-if="row.DocAttachment != \'\'">Yes</span> <span class="label label-success" data-ng-if="row.DocAttachment === \'\'">No</span></td><td>{{row.Remarks}}</td><td class="text-center" width="100px"><button type="button" ng-click="vm.RemoveEmployeeAcademic(row)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="noOfRows" colspan="10"></td></tr></tfoot></table></div></div></div></div><div ng-if="vm.isLoading" class="overlay text-center"><i class="fa fa-spinner fa-spin text-primary text-center" style="font-size:24px"></i></div></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class=""><h3 class="panel-title">STUDENTDETAILS</h3></div></div><div class="panel-body"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.EmployeeList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="FirstName"><strong>First Name</strong></th><th class="text-center" st-sort="LastName"><strong>Last Name</strong></th><th class="text-center" st-sort="Department.DepartmentName"><strong>Department</strong></th><th class="text-center" st-sort="Designation.DesignationName"><strong>Designation</strong></th><th class="text-center" st-sort="DOJ"><strong>Date of Joining</strong></th><th class="text-center" st-sort="ReportingTo"><strong>Reporting To</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="FirstName" class="input-sm form-control" placeholder="First Name" type="text"></th><th><input st-search="LastName" class="input-sm form-control" placeholder="Last Name" type="text"></th><th><input st-search="Department.DepartmentName" class="input-sm form-control" placeholder="Department" type="text"></th><th><input st-search="Designation.DesignationName" class="input-sm form-control" placeholder="Designation" type="text"></th><th><input st-search="DOJ" class="input-sm form-control" placeholder="DOJ" type="text"></th><th><input st-search="ReportingToName" class="input-sm form-control" placeholder="Reporting To" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.FirstName}}</td><td>{{row.LastName}}</td><td>{{row.Department.DepartmentName}}</td><td>{{row.Designation.DesignationName}}</td><td>{{row.DOJ | date:\'dd-MM-yyyy\'}}</td><td>{{row.ReportingToName}}</td><td class="text-center" width="200px"><div><button type="button" data-ng-if="$root.checkPermission(\'Edit\')" ng-click="vm.EditEmployee(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" data-ng-if="$root.checkPermission(\'Delete\')" ng-click="vm.RemoveEmployee(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table><div ng-if="vm.isLoading" class="overlay text-center"><i class="fa fa-spinner fa-spin text-primary text-center" style="font-size:24px"></i></div></div></div></div>');
$templateCache.put('app/pages/test/test.html','');
$templateCache.put('app/pages/Location/locationSetup/locationSetup.html','<style>\r\n    .small {\r\n        height: 22px;\r\n        font-size: 14px;\r\n        padding: 0px 8px;\r\n    }\r\n</style><div class="row"><div class="panel panel-default" data-ng-if="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Create Location Setup</h3></div></div><div class="panel-body"><div class="container-fluid"><form class="form-horizontal" name="vm.locationSetupForm" novalidate=""><fieldset><div class="row"><div class="col-sm-4"><div class="form-group"><label for="inputLocationName"><b>Type of Work Location</b></label><div class=""><input type="text" name="name" class="form-control" autocomplete="off" id="inputLocationName" placeholder="Type of Work Location" ng-model="vm.location.BasicLocation" required=""><p ng-show="vm.locationSetupForm.$submitted || vm.locationSetupForm.name.$touched"><span ng-show="vm.locationSetupForm.name.$error.required" class="text-danger">Basic Location is required</span></p></div></div></div></div><div class="form-group"><label for="inputTierName" class="col-lg-2 control-label"><b>Tier</b></label><div class="col-md-4"><input type="text" class="form-control" name="name" id="inputTierName" placeholder="Tier" ng-model="vm.location.Tier"></div><div class="col-md-2"><button type="submit" class="btn btn-success btn-sm" ng-click="vm.addNewTier()"><strong>+</strong></button></div></div><div class="form-group"><div class="col-md-2"></div><div class="col-md-4"><div class="list-group"><div class="row" data-ng-repeat="tier in vm.tiers" style="padding: 3px 0px; margin: 10px; border-bottom: 1px solid #ccc"><div class="col-sm-2"><span class="label label-default"><b>Tier {{tier.id}}</b></span></div><div class="col-sm-8"><span>{{ tier.tierName }}</span></div><div class="col-sm-2"><button type="button" class="btn btn-danger btn-sm small pull-right" ng-click="vm.removeTier($index)"><strong>-</strong></button></div></div></div></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveLocationSetup(vm.location)" ng-disabled="vm.locationSetupForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></div></div></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List of Location Setup</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.LocationSetupList" class="table table-striped"><thead><tr><th class="text-center"><strong>S.No</strong></th><th class="text-center" st-sort="BasicLocation"><strong>Type of Worklocation</strong></th><th ng-repeat="tier in vm.tierNameList" st-sort=""><strong>{{ tier }}</strong></th><th class="text-center"><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.BasicLocation}}</td><td data-ng-repeat="tierName in vm.tierNameList">{{ row.Tiers[tierName] }}</td><td class="text-center"><div><button type="button" ng-click="vm.editLocationSetup(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeLocationSetup(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/Location/tierSetup/tierSetup.html','<div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">Tier Setup</h3></div><div class="panel-body"><div class="container-fluid"><form class="form-horizontal" name="vm.tiersetupForm"><fieldset><div class="row"><div class="col-sm-4"><div class="form-group"><label for="inputLocation"><b>Type of Worklocation</b></label><div class=""><ui-select name="drpdwn2" ng-required="true" ng-disabled="vm.isAddingTier" ng-model="vm.tier.selectedLocation" style="min-width: 300px;" theme="bootstrap" on-select="vm.getTiersByLocationId(vm.tier.selectedLocation.LocationId, vm.tier.selectedLocation.ProjectId)"><ui-select-match allow-clear="true" placeholder="Type of Worklocation..">{{$select.selected.BasicLocation}}</ui-select-match><ui-select-choices repeat="Location in vm.LocationList | filter: $select.search"><div ng-bind-html="Location.BasicLocation | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.tiersetupForm.drpdwn2.$touched && (vm.tier.selectedLocation=== null || vm.tier.selectedLocation === undefined)"><span class="text-danger">Type of Worklocation is required.</span></div></div></div></div></div></fieldset><br><br><div class="row"><div class="form-group" ng-if="vm.tier.selectedLocation"><ul data-ng-repeat="tier in vm.tierList" data-ng-if="!tier.isHideForm"><div class="col-lg-12"><label for="inputTierValue" class="col-lg-2 control-label" style="margin-left: -40px;"><b>{{tier.TierName}}</b></label><div class="col-lg-4"><ui-select ng-hide="tier.IsAdding" name="drpdwn4" ng-required="true" ng-model="tier.selectedTierValue" theme="bootstrap" on-select="vm.filterTiers(tier)"><ui-select-match allow-clear="true" placeholder="Select Tier Value..">{{$select.selected.TierValue}}</ui-select-match><ui-select-choices repeat="t in tier.Values | filter: $select.search"><div ng-bind-html="t.TierValue | highlight: $select.search"></div></ui-select-choices></ui-select><input type="text" class="form-control" name="name" ng-show="tier.IsAdding" id="inputTierValueName" placeholder="Enter tier Value" autocomplete="off" ng-model="tier.TierValue"></div><div class="col-md-4"><button type="button" data-ng-show="vm.tier.selectedLocation" class="btn btn-success btn-sm" data-ng-disabled="tier.IsAdding && !tier.TierValue" ng-click="vm.saveNewTierValue(tier, vm.TierValue)">{{(tier.IsAdding) ? \'Save\' : \'Add\' }}</button> <button type="button" data-ng-show="tier.IsAdding" class="btn btn-danger btn-sm" ng-click="vm.cancelAdding(tier)">Cancel</button></div></div></ul></div></div></form></div></div></div><div class="row" data-ng-if="vm.tier.selectedLocation && vm.TierSetupList.length > 0"><div class="col-sm-12"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.TierSetupList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="TierName"><strong>{{ vm.currentTier }}</strong></th><th class="text-center"><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center"><span data-ng-hide="row.isEdit">{{ row.TierValue }}</span> <input type="text" class="form-control" data-ng-show="row.isEdit" data-ng-model="row.TierValue" style="max-width: 200px; display:inline-block; text-align: center;"></td><td class="text-center"><div data-ng-if="!row.isEdit"><button type="button" ng-click="row.isEdit = true" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="fa fa-edit"></i></button> <button type="button" ng-click="vm.removeTierSetup(row)" class="btn btn-sm btn-danger" uib-tooltip="Remove"><i class="glyphicon glyphicon-trash"></i></button></div><div data-ng-if="row.isEdit"><button type="button" ng-click="vm.updateTierValue(row)" class="btn btn-sm btn-success" uib-tooltip="Save"><i class="fa fa-save"></i></button> <button type="button" ng-click="row.isEdit = false" class="btn btn-sm btn-danger" uib-tooltip="Cancel"><i class="fa fa-times"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/mapping/classRoomMapping/classRoomMapping.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Class Room Mapping</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.ClassMappingForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.class.selectedClassRoom" on-select="vm.getSectionByClass(vm.class.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ClassMappingForm.classRoom.$touched && (vm.class.selectedClassRoom===null || vm.class.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.class.selectedSection" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ClassMappingForm.section.$touched && (vm.class.selectedSection===null || vm.class.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="LocationName" class="control-label"><b>Location</b> <span class="text-danger">*</span></label><div class=""><ui-select name="location" ng-required="true" ng-model="vm.class.selectedLocation" on-select="vm.getTiersByLocationId(vm.class.selectedLocation.LocationId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Location">{{$select.selected.BasicLocation}}</ui-select-match><ui-select-choices repeat="loc in vm.LocationSetupList | filter: $select.search"><div ng-bind-html="loc.BasicLocation | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.ClassMappingForm.location.$touched && (vm.class.selectedLocation===null || vm.class.selectedLocation===undefined)"><span class="text-danger">Location is required.</span></div></div></div><div class="col-md-3" ng-repeat="tier in vm.tierList" ng-if="vm.class.selectedLocation"><div class="form-group"><label>{{tier.TierName}}</label><div class=""><ui-select name="parentdrpdwn" ng-disabled="vm.type == \'import\'" ng-required="true" ng-model="tier.selectedTierValue" on-select="vm.filterTiers(tier)" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="Select...">{{$select.selected.TierValue}}</ui-select-match><ui-select-choices repeat="t in tier.Values | filter: $select.search"><div ng-bind-html="t.TierValue | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.Saveclass()" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">class Room Mapping</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.AllclassMapList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Location</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Tiers</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard Name" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section Name" type="text"></td><td><input st-search="Location" class="input-sm form-control" placeholder="Subject Name" type="text"></td><td></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.Section Name}}</td><td class="text-center">{{row.BasicLocation}}</td><td class="text-center">{{row.LocationDetails}}</td><td class="text-center"><div><button type="button" ng-click="vm.editclass(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeClass(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/mapping/staffMapping/staffMapping.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Staff Mapping</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.StaffMappingForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputstaff" class="control-label"><b>Staff</b> <span class="text-danger">*</span></label><div class=""><ui-select name="staff" ng-required="true" ng-model="vm.staff.selectedStaff" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Staff Name">{{$select.selected.FirstName}} / {{$select.selected.KpostId}}</ui-select-match><ui-select-choices repeat="staff in vm.EmployeeList | filter: $select.search"><div ng-bind-html="staff.FirstName + \' / \' + staff.KpostId | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.StaffMappingForm.staff.$touched && (vm.staff.selectedStaff===null || vm.staff.selectedStaff===undefined)"><span class="text-danger">Staff Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.staff.selectedClassRoom" on-select="vm.getSectionByClass(vm.staff.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.StaffMappingForm.classRoom.$touched && (vm.staff.selectedClassRoom===null || vm.staff.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.staff.selectedSection" on-select="vm.getSubjectBySection(vm.staff.selectedClassRoom.ClassId,vm.staff.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.StaffMappingForm.section.$touched && (vm.staff.selectedSection===null || vm.staff.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.staff.selectedSubject" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject Name">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.StaffMappingForm.subject.$touched && (vm.staff.selectedSubject===null || vm.staff.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-if="!vm.isEditing" ng-click="vm.AddStaff()" ng-disabled="vm.subjectForm.$invalid">Add</button> <button type="submit" class="btn btn-primary btn-sm" ng-if="vm.isEditing" ng-click="vm.SaveStaff()" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div><div class="row" ng-if="vm.staffMapList.length > 0"><table st-table="displayedCollection1" st-safe-src="vm.staffMapList" class="table table-responsive table-striped"><thead><tr><th st-sort="ClassName" class="text-center"><strong>Staff</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject Name</strong></th><th class="text-center"><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection1"><td class="text-center">{{row.FirstName}}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center"><div><button type="button" ng-click="vm.RemoveStaff(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody></table><br><div class="form-group"><div class="text-center"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveStaff()" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Staff Mapping</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.AllStaffMapList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject Name</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard Name" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section Name" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="SubjectName" type="text"></td><td></td></tr></thead><tbody ng-repeat="(key, value) in displayedCollection | groupBy: \'FirstName\'"><tr class="text-center text-uppercase text-primary"><td colspan="9"><strong>{{key}}</strong></td></tr><tr ng-repeat="row in value"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editStaff(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.RemoveStaffMap(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/mapping/timeTableMapping/timeTableMapping.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Time-Table Mapping</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.timeTableMappingForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.timeTable.selectedClassRoom" on-select="vm.getSectionByClass(vm.timeTable.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.classRoom.$touched && (vm.timeTable.selectedClassRoom===null || vm.timeTable.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.timeTable.selectedSection" on-select="vm.getSubjectBySection(vm.timeTable.selectedClassRoom.ClassId,vm.timeTable.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.section.$touched && (vm.timeTable.selectedSection===null || vm.timeTable.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="ClassTeacherName" class="control-label"><b>Class Teacher Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="firstname" ng-required="true" ng-model="vm.timeTable.selectedClassTeacher" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="First Name">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="emp in vm.EmployeeList | filter: $select.search"><div ng-bind-html="emp.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.firstname.$touched && (vm.timeTable.selectedClassTeacher===null || vm.timeTable.selectedClassTeacher===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectTeacherName" class="control-label"><b>Subject Teacher Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Sname" ng-required="true" ng-model="vm.timeTable.selectedSubjectTeacher" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="First Name">{{$select.selected.FirstName}}</ui-select-match><ui-select-choices repeat="emp in vm.EmployeeList | filter: $select.search"><div ng-bind-html="emp.FirstName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.Sname.$touched && (vm.timeTable.selectedSubjectTeacher===null || vm.timeTable.selectedSubjectTeacher===undefined)"><span class="text-danger">Subject is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.timeTable.selectedSubject" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject Name">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.subject.$touched && (vm.timeTable.selectedSubject===null || vm.timeTable.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="DayName" class="control-label"><b>Day</b> <span class="text-danger">*</span></label><div class=""><ui-select name="day" ng-required="true" ng-model="vm.timeTable.selectedDay" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Day">{{$select.selected.Day}}</ui-select-match><ui-select-choices repeat="day in vm.DayList | filter: $select.search"><div ng-bind-html="day.Day | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.day.$touched && (vm.timeTable.selectedDay===null || vm.timeTable.selectedDay===undefined)"><span class="text-danger">Day required.</span></div></div></div><div class="form-group col-md-3"><label for="PeriodName" class="control-label"><b>Period</b> <span class="text-danger">*</span></label><div class=""><ui-select name="period" ng-required="true" ng-model="vm.timeTable.selectedPeriod" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Period">{{$select.selected.Period}}</ui-select-match><ui-select-choices repeat="period in vm.PeriodList | filter: $select.search"><div ng-bind-html="period.Period | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.timeTableMappingForm.period.$touched && (vm.timeTable.selectedPeriod===null || vm.timeTable.selectedPeriod===undefined)"><span class="text-danger">Period required.</span></div></div></div></div></fieldset></form></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SavetimeTable()" ng-disabled="vm.timeTableMappingForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Time Table Mapping</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.AllStaffTimeTableList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="" class="text-center"><strong>Class Teacher</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject Name</strong></th><th st-sort="Day" class="text-center"><strong>Day</strong></th><th st-sort="Period" class="text-center"><strong>Period</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="StandardName" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="SectionName" type="text"></td><td><input st-search="ClassTeacherName" class="input-sm form-control" placeholder="ClassTeacherName" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="SubjectName" type="text"></td><td><input st-search="Day" class="input-sm form-control" placeholder="Day" type="text"></td><td></td><td></td></tr></thead><tbody ng-repeat="(key, value) in displayedCollection | groupBy: \'SubjectTeacherName\'"><tr class="text-center text-uppercase text-primary"><td colspan="9"><strong>{{key}}</strong></td></tr><tr ng-repeat="row in value"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.ClassTeacherName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.Day}}</td><td class="text-center">{{row.PeriodName}}</td><td class="text-center"><div><button type="button" ng-click="vm.edittimeTable(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.RemoveTimeTableMap(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/chapters/chapters.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Chapters</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.chaptersForm" novalidate=""><fieldset><div class="form-group"><label for="inputclass" class="col-lg-2 control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="classRoom" ng-required="true" ng-model="vm.chapters.selectedClassRoom" on-select="vm.getSectionByClass(vm.chapters.selectedClassRoom)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.chaptersForm.classRoom.$touched && (vm.chapters.selectedClassRoom===null || vm.chapters.selectedClassRoom===undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group"><label for="SectionName" class="col-lg-2 control-label"><b>Section</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="section" ng-required="true" ng-model="vm.chapters.selectedSection" on-select="vm.getSubjectBySection(vm.chapters.selectedClassRoom.ClassId,vm.chapters.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.chaptersForm.section.$touched && (vm.chapters.selectedSection===null || vm.chapters.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group"><label for="SubjectName" class="col-lg-2 control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="subject" ng-required="true" ng-model="vm.chapters.selectedSubject" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.chaptersForm.subject.$touched && (vm.chapters.selectedSubject===null || vm.chapters.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group" ng-if="vm.IsTermAvailable"><label for="Term" class="col-lg-2 control-label"><b>Term</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="Term" ng-required="true" ng-model="vm.chapters.selectedTerm" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Term">{{$select.selected.TermName}}</ui-select-match><ui-select-choices repeat="term in vm.TermsList | filter: $select.search"><div ng-bind-html="term.TermName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.chaptersForm.Term.$touched && (vm.chapters.selectedTerm===null || vm.chapters.selectedTerm===undefined)"><span class="text-danger">Term is required.</span></div></div></div><div class="form-group"><label for="ChapterName" class="col-lg-2 control-label"><b>Chapter / Unit</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="ChapterName" class="form-control" name="name" id="inputChapterName" autocomplete="off" placeholder="Chapter" ng-model="vm.chapters.ChapterName" required=""><p ng-show="vm.chaptersForm.$submitted || vm.chaptersForm.name.$touched"><span ng-show="vm.chaptersForm.name.$error.required" class="text-danger">Chapter / Unit is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveChapter(vm.chapters)" ng-disabled="vm.chaptersForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Chapters</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.ChapterList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="TermName" class="text-center"><strong>Term</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter / Unit</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="TermName" class="input-sm form-control" placeholder="TermName" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="Chapter" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.TermName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editChapter(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeChapter(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/classRoom/classRoom.html','<div class="row"><uib-accordion><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Standard</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.ClassRoomForm" novalidate=""><fieldset><div class="col-md-6"><div class="form-group"><label for="inputClassRoomName" class="col-lg-4 control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class="col-lg-8"><input type="name" class="form-control" name="name" autocomplete="off" id="inputClassRoomName" placeholder="Standard" ng-model="vm.ClassRoom.ClassName" required=""><p ng-show="vm.ClassRoomForm.$submitted || vm.ClassRoomForm.name.$touched"><span ng-show="vm.ClassRoomForm.name.$error.required" class="text-danger">Standard is required</span></p><p ng-show="vm.ClassRoomForm.$submitted || vm.ClassRoomForm.name.$touched"><span ng-show="vm.ClassRoomForm.name.$error.maxlength" class="text-danger pull-right">ClassRoom Name is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p></div></div><div class="form-group"><label for="inputClassRoomTerm" class="col-lg-4 control-label"><b>Term Activation</b></label><div class="col-lg-8"><input type="checkbox" id="inputClassRoomTerm" ng-model="vm.ClassRoom.IsTermAvailable"></div></div><div class="form-group"><div class="pull-right"><button type="button" class="btn btn-primary btn-sm" ng-click="vm.SaveClassRoom(vm.ClassRoom);vm.isFormOpen = false;vm.isTableOpen=true" ng-disabled="vm.ClassRoomForm.$invalid">Save</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></fieldset></form></div></uib-accordion-group></uib-accordion></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Standard</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.ClassRoomList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="Standard" class="text-center"><strong>Standard</strong></th><th st-sort="TermActivated" class="text-center"><strong>Term Activated</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="TermActivated" class="input-sm form-control" placeholder="Term Activated" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center"><span ng-if="row.IsTermAvailable == 1">Yes</span><span ng-if="row.IsTermAvailable == 0">No</span></td><td class="text-center"><div><button type="button" ng-click="vm.editClass(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeClass(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/masters/CreateLinkText/createlinktext.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create a Link Content</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.unitForm" novalidate=""><fieldset><fieldset ng-disabled="vm.radioDisable"><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.CreateLinkunit.selectedClassRoom" on-select="vm.getSectionByClass(vm.CreateLinkunit.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classRoom.$touched && (vm.CreateLinkunit.selectedClassRoom===null || vm.CreateLinkunit.selectedClassRoom===undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.CreateLinkunit.selectedSection" on-select="vm.getSubjectBySection(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.section.$touched && (vm.CreateLinkunit.selectedSection===null || vm.CreateLinkunit.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.CreateLinkunit.selectedSubject" on-select="vm.getChapterBySubject(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId,vm.CreateLinkunit.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.subject.$touched && (vm.CreateLinkunit.selectedSubject===null || vm.CreateLinkunit.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter / Unit</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.CreateLinkunit.selectedChapter" on-select="vm.getUnitByChapters(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId,vm.CreateLinkunit.selectedSubject.SubjectId,vm.CreateLinkunit.selectedChapter.ChapterId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.CreateLinkunit.selectedChapter===null ||vm.CreateLinkunit.selectedChapter===undefined)"><span class="text-danger">Chapter / Unit is required.</span></div></div></div></div></fieldset><div class="row"><div class="form-group col-md-3"><label for="UnitName" class="control-label"><b>Session</b> <span class="text-danger">*</span></label><div class=""><ui-select name="UnitName" ng-required="true" ng-model="vm.CreateLinkunit.selectedUnit" theme="bootstrap" style="min-width: 300px;" on-select="vm.setPathIds()" ng-disabled="vm.radioDisable"><ui-select-match allow-clear="true" placeholder="Session">{{$select.selected.UnitName}}</ui-select-match><ui-select-choices repeat="unit in vm.UnitList | filter: $select.search"><div ng-bind-html="unit.UnitName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.UnitName.$touched && (vm.CreateLinkunit.selectedUnit===null ||vm.CreateLinkunit.selectedUnit===undefined)"><span class="text-danger">Session is required.</span></div></div></div><div class="form-group col-md-3" ng-if="vm.Type == \'P\'"><label for="Linkword" class="control-label"><b>Links Word</b></label><div class=""><input type="Linkword" class="form-control" name="Linkword" id="inputLinkword" autocomplete="off" placeholder="Link Word" ng-model="vm.CreateLinkunit.LinksWord" required=""><p ng-show="vm.unitForm.$submitted || vm.unitForm.Linkword.$touched"><span ng-show="vm.unitForm.Linkword.$error.required" class="text-danger">Links Word is required</span></p></div></div><div class="form-group col-md-3"><label for="Note"><b>Content Type</b></label><div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.Type" id="inlineRadio2" value="A" ng-disabled="vm.radioDisable"> <span><b>Upload Files</b></span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.Type" id="inlineRadio3" value="P" ng-disabled="vm.radioDisable"> <span><b>Create Content</b></span></label></div></div></div></div><div class="row"><div class="col-md-12" style="padding:0px;" ng-if="vm.Type == \'P\'"><div class="col-md-12"><div class="col-md-6"><div class="row"><div class="col-md-10"><table st-table="displayedCollection1" ng-if="vm.DocList.length > 0" st-safe-src="vm.DocList" class="table table-responsive table-striped"><thead><tr><th st-sort="FileName" class="text-center"><strong>File Name</strong></th><th></th><th st-sort="FileUrl" class="text-center"><strong>File Url</strong></th><th class="text-center"><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection1"><td class="text-center">{{row.FileName}}</td><td class="text-center">{{row.Refname}}</td><td class="text-center"><div id="copy">{{row.FilePath}}</div></td><td class="text-center"><button type="button" ng-click="vm.removeFile(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div><div class="col-md-12"><div class="from-group"><div id="ng-app" class="ng-scope"><label class="demo-editor"></label><div class="lighter"><div class="col-lg-10" text-angular="" ng-model="vm.CreateLinkunit.PostContent" name="demo-editor" ta-text-editor-class="clearfix border-around" ta-html-editor-class="border-around"></div></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveUnitLink(vm.CreateLinkunit)" ng-disabled="vm.unitForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div><div class="col-md-12" ng-if="vm.Type == \'A\'"><div class="form-group col-md-3"><label for="Filetype" class="control-label"><b>Upload File Types</b></label><div class=""><ui-select name="File" ng-model="vm.CreateLinkunit.selectedFileType" theme="bootstrap" style="min-width: 300px;" ng-disabled="vm.radioDisable"><ui-select-match allow-clear="true" placeholder="File Type">{{$select.selected.FileTypeName}}</ui-select-match><ui-select-choices repeat="FileType in vm.FileTypeList | filter: $select.search"><div ng-bind-html="FileType.FileTypeName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.File.$touched && (vm.CreateLinkunit.selectedFileType===null ||vm.CreateLinkunit.selectedFileType===undefined)"><span class="text-danger">Upload File Types is required.</span></div></div></div><div class="form-group col-md-3" ng-if="vm.ShowCreateBtn"><label for="Filetype" class="control-label"><b>File Upload</b></label><div class=""><input type="file" class="form-group" custom-on-change="fileChanged"></div></div><div class="form-group col-md-3"><label for="ivName" class="control-label"><b>Video Title</b></label><div class=""><input type="ivName" class="form-control" name="VideoTitle" id="inputTitleName" autocomplete="off" placeholder="Video Title" ng-model="vm.CreateLinkunit.LinksWord"><div ng-if="vm.unitForm.VideoTitle.$touched && (vm.CreateLinkunit.LinksWord===null ||vm.CreateLinkunit.LinksWord===undefined)"><span class="text-danger">Video Title is required.</span></div></div></div><div class="form-group col-md-3"><button type="submit" ng-click="vm.SaveUploadLinks()" ng-if="vm.ShowCreateBtn" class="btn btn-primary btn-sm" style="margin-top:35px;">Create</button> <button type="submit" class="btn btn-primary btn-sm" style="margin-top:35px;" ng-if="vm.ShowUpdateBtn" ng-click="vm.LinksUpdate();">Update</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()" style="margin-top:35px;">Cancel</button></div></div><div class="row"><div class="col-md-10"><table st-table="displayedCollection1" ng-if="vm.VideoLinks.length > 0" st-safe-src="vm.VideoLinks" class="table table-responsive table-striped"><thead><tr><th st-sort="FileName" class="text-center"><strong>File Name</strong></th><th st-sort="FileUrl" class="text-center"><strong>File Url</strong></th><th class="text-center"><strong>Action</strong></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection1"><td class="text-center">{{row.FileName}}</td><td class="text-center">{{row.Refname}}</td><td class="text-center"><div id="copy">{{row.FilePath}}</div></td><td class="text-center"><button type="button" ng-click="vm.removeFile(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Link Contents</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><div class="col-md-12"><table st-table="displayedCollection" st-safe-src="vm.UnitLinkList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter / Unit</strong></th><th st-sort="UnitName" class="text-center"><strong>Session</strong></th><th st-sort="LinksWord" class="text-center"><strong>Links Word</strong></th><th st-sort="UnitName" class="text-center"><strong>Link Path</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="Chapter" type="text"></td><td><input st-search="UnitName" class="input-sm form-control" placeholder="Unit" type="text"></td><td><input st-search="LinksWord" class="input-sm form-control" placeholder="LinksWord" type="text"></td><td><input st-search="LinkPath" class="input-sm form-control" placeholder="LinkPath" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center">{{row.UnitName}}</td><td class="text-center">{{row.LinksWord}}</td><td class="text-center">{{ $root.endPoint + row.LinkHtmlPath}}</td><td class="text-center"><button type="button" ng-click="vm.editLinkUnit(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeLinkUnit(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/masters/exercise/exercise.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Exercise</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.chaptersForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.unit.selectedClassRoom" on-select="vm.getSectionByClass(vm.unit.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classRoom.$touched && (vm.unit.selectedClassRoom===null || vm.unit.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.unit.selectedSection" on-select="vm.getSubjectBySection(vm.unit.selectedClassRoom.ClassId,vm.unit.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.section.$touched && (vm.unit.selectedSection===null || vm.unit.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.unit.selectedSubject" on-select="vm.getChapterBySubject(vm.unit.selectedClassRoom.ClassId,vm.unit.selectedSection.SectionId,vm.unit.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.subject.$touched && (vm.unit.selectedSubject===null || vm.unit.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter / Unit</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.unit.selectedChapter" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.unit.selectedChapter===null ||vm.unit.selectedChapter===undefined)"><span class="text-danger">Chapter / Unit is required.</span></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveChapter(vm.chapters)" ng-disabled="vm.chaptersForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Chapters</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.ChapterList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="TermName" class="text-center"><strong>Term</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter / Unit</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="TermName" class="input-sm form-control" placeholder="TermName" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="Chapter" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.TermName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editChapter(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeChapter(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/MapVideos/MapVideos.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><div class="panel panel-default" style="" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Create a Link Content</h3></div></div><div class="container-fluid panel-body"><form class="form-horizontal" name="vm.unitForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.CreateLinkunit.selectedClassRoom" on-select="vm.getSectionByClass(vm.CreateLinkunit.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classRoom.$touched && (vm.CreateLinkunit.selectedClassRoom===null || vm.CreateLinkunit.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.CreateLinkunit.selectedSection" on-select="vm.getSubjectBySection(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.section.$touched && (vm.CreateLinkunit.selectedSection===null || vm.CreateLinkunit.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.CreateLinkunit.selectedSubject" on-select="vm.getChapterBySubject(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId,vm.CreateLinkunit.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject Name">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.subject.$touched && (vm.CreateLinkunit.selectedSubject===null || vm.CreateLinkunit.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter Name / Unit Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.CreateLinkunit.selectedChapter" on-select="vm.getUnitByChapters(vm.CreateLinkunit.selectedClassRoom.ClassId,vm.CreateLinkunit.selectedSection.SectionId,vm.CreateLinkunit.selectedSubject.SubjectId,vm.CreateLinkunit.selectedChapter.ChapterId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter Name">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.CreateLinkunit.selectedChapter===null ||vm.CreateLinkunit.selectedChapter===undefined)"><span class="text-danger">Chapter Name / Unit Name is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="UnitName" class="control-label"><b>Session Name</b> <span class="text-danger">*</span></label><div class=""><ui-select name="UnitName" ng-required="true" ng-model="vm.CreateLinkunit.selectedUnit" theme="bootstrap" style="min-width: 300px;" on-select="vm.GetVideoLinksByUnitId(vm.CreateLinkunit.selectedUnit.UnitId)"><ui-select-match allow-clear="true" placeholder="session Name">{{$select.selected.UnitName}}</ui-select-match><ui-select-choices repeat="unit in vm.UnitList | filter: $select.search"><div ng-bind-html="unit.UnitName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.UnitName.$touched && (vm.CreateLinkunit.selectedUnit===null ||vm.CreateLinkunit.selectedUnit===undefined)"><span class="text-danger">session Name is required.</span></div></div></div><div class="form-group col-md-9" ng-if="vm.CreateLinkunit.selectedUnit !=\'\'" style="padding:0px;"><div class="form-group col-md-4"><label for="Videotype" class="control-label"><b>Other Teacher Suggestion</b> <span class="text-danger"></span></label><div class=""><ui-select name="VideoType" ng-model="vm.mapvideo.selectedVideoType" theme="bootstrap" style="min-width: 300px;" on-select="vm.GetTitleName(vm.CreateLinkunit.selectedUnit.UnitId)"><ui-select-match allow-clear="true" placeholder="Video Typename">{{$select.selected.VideoTypename}}</ui-select-match><ui-select-choices repeat="VideoType in vm.VideoLinksList | filter: $select.search"><div ng-bind-html="VideoType.VideoTypename | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.VideoType.$touched && (vm.mapvideo.selectedVideoType===null ||vm.mapvideo.selectedVideoType===undefined)"><span class="text-danger">Video Type is required.</span></div></div></div><div class="form-group col-md-4"><label for="Title" class="control-label"><b>Title Name</b></label><div class=""><ui-select name="TitelName" ng-required="true" ng-model="vm.mapvideo.TitleName" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Title Name">{{$select.selected.LinksWord}}</ui-select-match><ui-select-choices repeat="unit in vm.AllTitleNameList | filter: $select.search"><div ng-bind-html="unit.LinksWord | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.unitForm.$submitted || vm.unitForm.TitelName.$touched"><span ng-show="vm.unitForm.TitelName.$error.required" class="text-danger">Title Name is required</span></p></div></div><br><button type="submit" ng-click="vm.SaveVideoLinksUnit(vm.mapvideo)" class="btn btn-primary btn-sm" style="margin-top:18px;margin-left:10px;">Add</button></div></div><div class="col-md-12"></div><div class="row" ng-if="vm.AllVideoLinksList.length > 0"><div class="col-sm-6"></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.AllVideoLinksList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Video Type</strong></th><th st-sort="ClassName" class="text-center"><strong>Title Name</strong></th><th st-sort="SectionName" class="text-center"><strong>Url Link</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="VideoTypename" class="input-sm form-control" placeholder="Video Type" type="text"></td><td><input st-search="LinksWord" class="input-sm form-control" placeholder="Title Name" type="text"></td><td><input st-search="LinkHtmlPath" class="input-sm form-control" placeholder="Url Link" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.VideoTypename}}</td><td class="text-center">{{row.LinksWord}}</td><td class="text-center">{{ $root.endPoint + row.LinkHtmlPath}}</td><td class="text-center"><div><button type="button" ng-click="vm.DeleteVideoLink(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></fieldset></form></div></div></div>');
$templateCache.put('app/pages/masters/section/section.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Section</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.sectionForm" novalidate=""><fieldset><div class="form-group"><label for="inputclass" class="col-lg-2 control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="classRoom" ng-required="true" ng-model="vm.section.selectedClassRoom" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.sectionForm.classRoom.$touched && (vm.section.selectedClassRoom === null || vm.section.selectedClassRoom === undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group"><label for="SectionName" class="col-lg-2 control-label"><b>Section</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="text" class="form-control" name="name" id="SectionName" autocomplete="off" placeholder="Section" ng-model="vm.section.SectionName" required=""><p ng-show="vm.sectionForm.$submitted || vm.sectionForm.name.$touched"><span ng-show="vm.sectionForm.name.$error.maxlength" class="text-danger pull-right">Section is maximum length are {{ 50 - inputMessage.length + \' Char\' }}</span></p><p ng-show="vm.sectionForm.$submitted || vm.sectionForm.name.$touched"><span ng-show="vm.sectionForm.name.$error.required" class="text-danger">Section is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveSection(vm.section)" ng-disabled="vm.sectionForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Section</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.SectionList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editSection(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeSection(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/subject/subject.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Subject</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.subjectForm" novalidate=""><fieldset><div class="form-group"><label for="inputclass" class="col-lg-2 control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="classRoom" ng-required="true" ng-model="vm.subject.selectedClassRoom" on-select="vm.getSectionByClass(vm.subject.selectedClassRoom)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.subjectForm.classRoom.$touched && (vm.subject.selectedClassRoom=== null || vm.subject.selectedClassRoom === undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group"><label for="SectionName" class="col-lg-2 control-label"><b>Section</b> <span class="text-danger">*</span></label><div class="col-lg-4"><ui-select name="section" ng-required="true" ng-model="vm.subject.selectedSection" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.subjectForm.section.$touched && (vm.subject.selectedSection === null || vm.subject.selectedSection === undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group"><label for="SubjectName" class="col-lg-2 control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class="col-lg-4"><input type="SubjectName" class="form-control" name="name" id="inputSubjectName" autocomplete="off" placeholder="Subject Name" ng-model="vm.subject.SubjectName" required=""><p ng-show="vm.subjectForm.$submitted || vm.subjectForm.name.$touched"><span ng-show="vm.subjectForm.name.$error.required" class="text-danger">Subject is required</span></p></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveSubject1(vm.subject)" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Subject</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.SubjectList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editSubject(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeSubject(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/Term/Term.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Subject Term Image</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.subjectForm" novalidate=""><fieldset><div class="col-md-6"><div class="form-group"><label for="inputclass" class="col-lg-4 control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="classRoom" ng-required="true" ng-model="vm.subject.selectedClassRoom" on-select="vm.getSectionByClass(vm.subject.selectedClassRoom)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.subjectForm.classRoom.$touched && (vm.subject.selectedClassRoom=== null || vm.subject.selectedClassRoom === undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group"><label for="SectionName" class="col-lg-4 control-label"><b>Section</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="section" ng-required="true" ng-model="vm.subject.selectedSection" on-select="vm.getSubjectBySection(vm.subject.selectedClassRoom.ClassId,vm.subject.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.subjectForm.section.$touched && (vm.subject.selectedSection === null || vm.subject.selectedSection === undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group"><label for="SubjectName" class="col-lg-4 control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="subject" ng-required="true" ng-model="vm.subject.selectedSubject" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.subjectForm.subject.$touched && (vm.subject.selectedSubject===null || vm.subject.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group" ng-if="vm.IsTermAvailable"><label for="Term" class="col-lg-4 control-label"><b>Term</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="Term" ng-required="true" ng-model="vm.subject.selectedTerm" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Term">{{$select.selected.TermName}}</ui-select-match><ui-select-choices repeat="term in vm.TermsList | filter: $select.search"><div ng-bind-html="term.TermName | highlight: $select.search"></div></ui-select-choices></ui-select><p ng-show="vm.subjectForm.$submitted || vm.subject.selectedTerm.$touched"><span ng-show="vm.subject.selectedTerm.$error.required" class="text-danger">Term is required</span></p></div></div></div><div class="col-md-6"><div class="col-sm-offset-4 col-sm-4"><img ng-src="{{ vm.profilePicUrl }}" height="150px" width="130px"><br><br><input name="file" type="file" data-ng-model="file" custom-on-change="photoChanged" ng-show="!vm.isEditing" ng-hide="vm.isEditing && !vm.isEditingProPic"></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button type="button" class="btn btn-sm btn-primary" uib-tooltip="Change Student Photo" ng-show="vm.isEditing" data-ng-click="vm.editProPic()"><i class="fa fa-edit"></i></button>&nbsp;&nbsp; <button type="button" class="btn btn-sm btn-danger" uib-tooltip="Cancel" ng-hide="!vm.isEditing" data-ng-click="vm.isEditingProPic = false" ng-show="vm.isEditing && vm.isEditingProPic"><i class="fa fa-close"></i></button></div><div class=""><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveSubject(vm.subject)" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Subject</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.TermImgList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="Term" class="text-center"><strong>Term</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="Term" class="input-sm form-control" placeholder="Term" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.TermName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editSubject(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeSubject(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/TermActivation/TermActivation.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><div class="panel panel-default" style="overflow-x:scroll"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Term Activate</h3></div></div><div class="panel-body table-responsive" style="min-height:600px;"><div class="row"><div class="col-sm-6"><div class="form-group"><label for="Term" class="col-lg-4 control-label"><b>Term</b> <span class="text-danger">*</span></label><div class="col-lg-8"><ui-select name="Term" ng-required="true" ng-model="vm.selectedTerm" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Term">{{$select.selected.TermName}}</ui-select-match><ui-select-choices repeat="term in vm.TermsList | filter: $select.search"><div ng-bind-html="term.TermName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="(vm.selectedTerm===null || vm.selectedTerm===undefined)"><span class="text-danger">Term is required.</span></div></div><div class="col-md-12" ng-if="vm.currentTerm != undefine" style="padding-top: 42px;"><h5>Current Activated Term - {{ vm.currentTerm}}</h5></div></div></div><div class="col-sm-6"><div class="form-group"><div class=""><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.saveTermActivity(vm.selectedTerm)" ng-disabled="vm.subjectForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/masters/timetable/timetable.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Timetable</uib-accordion-heading></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">Create Timetable</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-md-12"><form class="form-horizontal" name="vm.unitForm" novalidate=""><fieldset ng-disabled="vm.radioDisable"><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.CreateTimeTable.selectedClassRoom" on-select="vm.getSectionByClass(vm.CreateTimeTable.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classRoom.$touched && (vm.CreateTimeTable.selectedClassRoom===null || vm.CreateTimeTable.selectedClassRoom===undefined)"><span class="text-danger">Standard is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.CreateTimeTable.selectedSection" on-select="vm.getSubjectBySection(vm.CreateTimeTable.selectedClassRoom.ClassId,vm.CreateTimeTable.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.section.$touched && (vm.CreateTimeTable.selectedSection===null || vm.CreateTimeTable.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="inputDOB" class="control-label"><b>Date</b><span class="text-danger">*</span></label><div><p class="input-group" ng-disabled="vm.CreateTimeTable.selectedSection"><input type="text" id="inputDOJ" name="inputDOJ" class="form-control m-b-20 ng-isolate-scope ng-touched ng-dirty ng-valid-date ng-valid datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.CreateTimeTable.date" is-open="vm.popup1.opened" datepicker-options="dateOptions" close-text="Close" placeholder="dd-MM-yyyy" validator="required" ng-change="vm.GetTimeTable()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Time</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classTiming" ng-required="true" ng-model="vm.CreateTimeTable.selectedTime" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Time">{{$select.selected.ClassTimings}}</ui-select-match><ui-select-choices repeat="time in vm.Classtiming | filter: $select.search"><div ng-bind-html="time.ClassTimings | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classTiming.$touched && (vm.CreateTimeTable.selectedTime===null || vm.CreateTimeTable.selectedTime===undefined)"><span class="text-danger">Time is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.CreateTimeTable.selectedSubject" on-select="vm.getChapterBySubject(vm.CreateTimeTable.selectedClassRoom.ClassId,vm.CreateTimeTable.selectedSection.SectionId,vm.CreateTimeTable.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.subject.$touched && (vm.CreateTimeTable.selectedSubject===null || vm.CreateTimeTable.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter / Unit</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.CreateTimeTable.selectedChapter" on-select="vm.getUnitByChapters(vm.CreateTimeTable.selectedClassRoom.ClassId,vm.CreateTimeTable.selectedSection.SectionId,vm.CreateTimeTable.selectedSubject.SubjectId,vm.CreateTimeTable.selectedChapter.ChapterId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.CreateTimeTable.selectedChapter===null ||vm.CreateTimeTable.selectedChapter===undefined)"><span class="text-danger">Chapter / Unit is required.</span></div></div></div><div class="form-group col-md-3"><label for="UnitName" class="control-label"><b>Session</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Session" ng-required="true" ng-model="vm.CreateTimeTable.selectedSession" theme="bootstrap" style="min-width: 300px;" ng-disabled="vm.radioDisable"><ui-select-match allow-clear="true" placeholder="Session">{{$select.selected.UnitName}}</ui-select-match><ui-select-choices repeat="unit in vm.UnitList | filter: $select.search"><div ng-bind-html="unit.UnitName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Session.$touched && (vm.CreateTimeTable.selectedSession===null ||vm.CreateTimeTable.selectedSession===undefined)"><span class="text-danger">Session is required.</span></div></div></div><div class="form-group col-md-3"><label for="TeacherName" class="control-label"><b>Teacher</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Teacher" ng-required="true" ng-model="vm.CreateTimeTable.selectedTeacher" theme="bootstrap" style="min-width: 300px;" ng-disabled="vm.radioDisable"><ui-select-match allow-clear="true" placeholder="Session">{{$select.selected.StaffName}}</ui-select-match><ui-select-choices repeat="teacher in vm.TeachersList | filter: $select.search"><div ng-bind-html="teacher.StaffName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Session.$touched && (vm.CreateTimeTable.selectedSession===null ||vm.CreateTimeTable.selectedSession===undefined)"><span class="text-danger">Session is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="Location" class="control-label"><b>Location</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Location" ng-required="true" ng-model="vm.CreateTimeTable.selectedLocation" theme="bootstrap" style="min-width: 300px;" ng-disabled="vm.radioDisable"><ui-select-match allow-clear="true" placeholder="Location">{{$select.selected.LocationName}}</ui-select-match><ui-select-choices repeat="location in vm.Location | filter: $select.search"><div ng-bind-html="location.LocationName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Location.$touched && (vm.CreateTimeTable.selectedLocation===null ||vm.CreateTimeTable.selectedLocation===undefined)"><span class="text-danger">Location is required.</span></div></div></div></div><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveTimeTable(vm.CreateTimeTable)" ng-disabled="vm.unitForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></fieldset></form><div class="col-sm-6"></div><div class="col-sm-6" ng-if="vm.TimetableList"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table ng-if="vm.TimetableList" st-table="displayedCollection" st-safe-src="vm.TimetableList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassTimings" class="text-center"><strong>Class Timing</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter / Unit</strong></th><th st-sort="UnitName" class="text-center"><strong>Session</strong></th><th st-sort="EmployeeName" class="text-center"><strong>Teacher Name</strong></th><th st-sort="LocationName" class="text-center"><strong>Location</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassTimings" class="input-sm form-control" placeholder="Class Time" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="Chapter" type="text"></td><td><input st-search="UnitName" class="input-sm form-control" placeholder="Unit" type="text"></td><td><input st-search="EmployeeName" class="input-sm form-control" placeholder="Teacher" type="text"></td><td><input st-search="LocationName" class="input-sm form-control" placeholder="Location" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassTimings}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center">{{row.UnitName}}</td><td class="text-center">{{row.EmployeeName}}</td><td class="text-center">{{row.LocationName}}</td><td class="text-center"><button type="button" ng-click="vm.removeTimetable(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div></div>');
$templateCache.put('app/pages/masters/unit/unit.html','<style>\r\n    .grid {\r\n        width: 100%;\r\n        height: 250px;\r\n    }\r\n</style><div class="row"><uib-accordion close-others="true"><uib-accordion-group class="panel-default" data-ng-if="vm.isFormOpen" is-open="vm.isFormOpen"><uib-accordion-heading>Create Contents</uib-accordion-heading><div class="container-fluid"><form class="form-horizontal" name="vm.unitForm" novalidate=""><fieldset><div class="row"><div class="form-group col-md-3"><label for="inputclass" class="control-label"><b>Standard</b> <span class="text-danger">*</span></label><div class=""><ui-select name="classRoom" ng-required="true" ng-model="vm.unit.selectedClassRoom" on-select="vm.getSectionByClass(vm.unit.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Standard">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.classRoom.$touched && (vm.unit.selectedClassRoom===null || vm.unit.selectedClassRoom===undefined)"><span class="text-danger">Standard Name is required.</span></div></div></div><div class="form-group col-md-3"><label for="SectionName" class="control-label"><b>Section</b> <span class="text-danger">*</span></label><div class=""><ui-select name="section" ng-required="true" ng-model="vm.unit.selectedSection" on-select="vm.getSubjectBySection(vm.unit.selectedClassRoom.ClassId,vm.unit.selectedSection.SectionId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Section">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.section.$touched && (vm.unit.selectedSection===null || vm.unit.selectedSection===undefined)"><span class="text-danger">Section is required.</span></div></div></div><div class="form-group col-md-3"><label for="SubjectName" class="control-label"><b>Subject</b> <span class="text-danger">*</span></label><div class=""><ui-select name="subject" ng-required="true" ng-model="vm.unit.selectedSubject" on-select="vm.getChapterBySubject(vm.unit.selectedClassRoom.ClassId,vm.unit.selectedSection.SectionId,vm.unit.selectedSubject.SubjectId)" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Subject">{{$select.selected.SubjectName}}</ui-select-match><ui-select-choices repeat="sec in vm.SubjectList | filter: $select.search"><div ng-bind-html="sec.SubjectName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.subject.$touched && (vm.unit.selectedSubject===null || vm.unit.selectedSubject===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><div class="form-group col-md-3"><label for="ChapterName" class="control-label"><b>Chapter / Unit</b> <span class="text-danger">*</span></label><div class=""><ui-select name="Chapter" ng-required="true" ng-model="vm.unit.selectedChapter" on-select="vm.setPathIds()" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Chapter">{{$select.selected.ChapterName}}</ui-select-match><ui-select-choices repeat="sec in vm.ChapterList | filter: $select.search"><div ng-bind-html="sec.ChapterName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.unit.selectedChapter===null ||vm.unit.selectedChapter===undefined)"><span class="text-danger">Chapter / Unit is required.</span></div></div></div></div><div class="row"><div class="form-group col-md-3"><label for="UnitName" class="control-label"><b>Session</b> <span class="text-danger">*</span></label><div class=""><input type="UnitName" class="form-control" name="name" id="inputUnitName" autocomplete="off" placeholder="Session" ng-model="vm.unit.UnitName" required=""><p ng-show="vm.unitForm.$submitted || vm.unitForm.name.$touched"><span ng-show="vm.unitForm.name.$error.required" class="text-danger">Session is required</span></p></div></div><div class="form-group col-md-3"><label for="Note"><b>Content Type</b></label><div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.Type" id="inlineRadio2" value="A"> <span><b>Assignment</b></span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.Type" id="inlineRadio3" value="P" ng-click="vm.CopyFiles()"> <span><b>Create Content</b></span></label></div></div></div></div><div class="row"><div ng-if="vm.Type === \'P\'"><div class="row"><div ng-if="vm.Type === \'P\'"></div></div><div class="col-md-12"><div class="from-group"><div id="ng-app" class="ng-scope"><label class="demo-editor"></label><div class="lighter"><div class="col-lg-10" text-angular="" ng-model="vm.unit.PostContent" name="demo-editor" ta-text-editor-class="clearfix border-around" ta-html-editor-class="border-around"></div></div></div></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.SaveUnit(vm.unit)" ng-disabled="vm.unitForm.$invalid">Save</button> <button type="reset" class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></div></div></fieldset></form></div></uib-accordion-group></uib-accordion><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class="col-xs-6"><h3 class="panel-title">List Of Contents</h3></div></div><div class="panel-body table-responsive"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.UnitList" class="table table-responsive table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th st-sort="ClassName" class="text-center"><strong>Standard</strong></th><th st-sort="SectionName" class="text-center"><strong>Section</strong></th><th st-sort="SubjetcName" class="text-center"><strong>Subject</strong></th><th st-sort="ChapterName" class="text-center"><strong>Chapter / Unit</strong></th><th st-sort="UnitName" class="text-center"><strong>Session</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><td></td><td><input st-search="ClassName" class="input-sm form-control" placeholder="Standard" type="text"></td><td><input st-search="SectionName" class="input-sm form-control" placeholder="Section" type="text"></td><td><input st-search="SubjectName" class="input-sm form-control" placeholder="Subject" type="text"></td><td><input st-search="ChapterName" class="input-sm form-control" placeholder="Chapter" type="text"></td><td><input st-search="UnitName" class="input-sm form-control" placeholder="Unit" type="text"></td><td></td></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center">{{row.ClassName}}</td><td class="text-center">{{row.SectionName}}</td><td class="text-center">{{row.SubjectName}}</td><td class="text-center">{{row.ChapterName}}</td><td class="text-center">{{row.UnitName}}</td><td class="text-center"><div><button type="button" class="btn btn-primary" value="Preview" ng-click="vm.OpenWindow(row.HtmlPath)"><i class="fa fa-search-plus"></i></button> <button type="button" ng-click="vm.editUnit(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeUnit(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div><div class="col-nd-12"><div id="container1" ng-show="popup==1"><p class="close_btn" style="color:red;font-weight:bold;font-size: 20px;" ng-click="popup=2">X</p><div id="con"><div id="sec1" style="column-count:2;" compile="res"></div></div><button class="btn_download down" onclick="download()">Download</button></div></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div></div>');
$templateCache.put('app/pages/masters/unitmodal/unitmodal.html','<form name="form" role="form"><div class="modal-header bg-info"><h4 class="modal-title" style="color:aliceblue;">Unit Modal <button type="button" class="close" ng-click="vm.CloseModalWindow()" data-dismiss="modal">&times;</button></h4></div><div class="modal-body"><div class="row"><div class="" ng-if="vm.ThumbNail"><label>ThumbNail Image</label> <input type="file" class="form-group" custom-on-change="ThumbNail" ng-model="vm.Thumbnailimage"><br></div><div class=""><label>FileUpload</label> <input type="file" class="form-group" custom-on-change="fileChanged" ng-model="vm.FileUpload"><br><input type="button" class="btn btn-primary" ng-click="vm.saveFile()" value="Add"></div></div><div class="modal-footer"><button class="btn btn-primary" type="submit" ng-click="vm.ok()" data-ng-disabled="vm.upload">OK</button></div><div ng-if="vm.isLoading" class="overlay"><i class="fa fa-spinner fa-spin text-green" style="font-size:50px"></i></div></div></form>');
$templateCache.put('app/pages/masters/unitmultipleupload/multipleupload.html','<form name="form" role="form"><div class="modal-header bg-info"><h4 class="modal-title" style="color:aliceblue;">Multiple File Upload<button type="button" class="close" ng-click="vm.CloseModalWindow()" data-dismiss="modal">&times;</button></h4></div><div class="modal-body"><div class="row"><div class="form-group col-md-3"><label for="Mutilplefilename" class="control-label"><b></b></label><div class=""><ui-select name="Mutilplefilename" ng-required="true" ng-model="vm.Multiple.selectedFile" theme="bootstrap" style="min-width: 300px;"><ui-select-match allow-clear="true" placeholder="Multiple Files upload">{{$select.selected.MultiplefileName}}</ui-select-match><ui-select-choices repeat="Multiple in vm.Multiplelist | filter: $select.search"><div ng-bind-html="Multiple.MultiplefileName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.unitForm.Chapter.$touched && (vm.unit.selectedChapter===null ||vm.unit.selectedChapter===undefined)"><span class="text-danger">Subject is required.</span></div></div></div><br><br><br><br><br><br><label><b>FileUpload</b></label> <input type="file" class="form-group" custom-on-change="AddMultiFile"><br></div><input type="button" class="btn btn-primary" ng-click="vm.saveFile()" value="Add"></div><div class="modal-footer"><button class="btn btn-primary" type="submit" ng-click="vm.ok()" data-ng-disabled="form.$invalid">OK</button></div></form>');
$templateCache.put('app/pages/role/roleMenuMapping/roleMenuMapping.html','<div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">ROLE MENU PRIVILEGE</h3></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-md-10"><form role="form"><div class="form-group"><label for="">Select Role</label><ui-select ng-model="vm.selectedRole" theme="bootstrap" style="max-width: 300px;" on-select="vm.getRoleMenuMapping()"><ui-select-match placeholder="Select a Role">{{$select.selected.RoleName || $select.selected}}</ui-select-match><ui-select-choices repeat="role in vm.RoleList | propsFilter: {RoleName: $select.search}"><div class="text-message" ng-bind-html="role.RoleName"></div></ui-select-choices></ui-select></div></form></div><div class="col-lg-2 col-md-2"><button class="btn btn-sm btn-primary" data-ng-click="vm.saveRoleMenuMapping()">Save</button></div></div><div class="container-fluid" data-ng-if="vm.selectedRole && vm.menuList.length > 0"><div class="row"><div class="col-sm-12"><button ng-click="vm.expandAll()" class="btn btn-sm btn-primary">Expand all</button> <button ng-click="vm.collapseAll()" class="btn btn-sm btn-primary">Collapse all</button></div></div><div class="row"><div class=""><div ui-tree="" id="tree-root" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="vm.menuList" ng-click="vm.select()"><li ng-repeat="node in vm.menuList" ui-tree-node="" ng-include="\'nodes_renderer.html\'"></li></ol></div></div></div></div></div></div><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content"> <a class="btn btn-success btn-xs" ng-if="node.SubMenuItems && node.SubMenuItems.length > 0" data-nodrag ng-click="toggle(this)"> <span class="glyphicon" ng-class="{\'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed}"></span> </a> <input type="checkbox" value="" data-ng-model="node.IsSelected" ng-checking= /> {{node.MenuName}} <div class="list-group-item" style="margin-left: 50px" data-ng-if="node.MenuAction.length > 0"> <ul class="list-inline"> <li class="list-inline-item" data-ng-repeat="action in node.MenuAction"> <div class="checkbox"> <label> <input type="checkbox" value="" data-ng-model="action.IsSelected"/> {{ action.ActionName }} </label> </div> </li> </ul> </div> </div> <ol ui-tree-nodes="" ng-model="node.SubMenuItems" ng-class="{hidden: collapsed}"> <li ng-repeat="node in node.SubMenuItems" ui-tree-node ng-include="\'nodes_renderer.html\'"> </li> </ol></script>');
$templateCache.put('app/pages/role/roleMenuMapping/roleMenuMapping_bk.html','<div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Role Menu Mapping</h3></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-md-10"><form role="form"><div class="form-group"><label for="">Select Role</label><ui-select ng-model="vm.selectedRole" theme="bootstrap" style="max-width: 300px;" on-select="vm.getRoleMenuMapping()"><ui-select-match placeholder="Role">{{$select.selected.RoleName || $select.selected}}</ui-select-match><ui-select-choices repeat="role in vm.RoleList | propsFilter: {RoleName: $select.search}"><div class="text-message" ng-bind-html="role.RoleName"></div></ui-select-choices></ui-select></div></form></div><div class="col-lg-2 col-md-2"><button class="btn btn-primary" data-ng-click="vm.saveRoleMenuMapping()">Save</button></div></div><div class="container-fluid" data-ng-if="vm.selectedRole && vm.menuList.length > 0"><br><div class="row"><div class="col-lg-6 col-md-6"><h4>Menus</h4><div ui-tree=""><ol ui-tree-nodes="" ng-model="vm.menuList" id="tree-root"><li ng-repeat="node in vm.menuList" ui-tree-node="" ng-include="\'nodes_renderer.html\'"></li></ol></div></div><div class="col-lg-6 col-md-6"><h4>Actions</h4><ul class="list-group"><li class="list-group-item" data-ng-repeat="action in vm.selectedMenu.MenuAction"><div class="checkbox"><label><input type="checkbox" value="" data-ng-model="action.ActionState"> {{ action.ActionName }}</label></div></li></ul></div></div></div></div></div><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle> <div class="checkbox" data-ng-click="vm.selectMenu(node)"> <label> <input type="checkbox" value="" data-ng-model="node.CheckState" /> {{ node.MenuName }} </label> </div> </div> <ol ui-tree-nodes="" ng-model="node.SubMenuItems"> <li ng-repeat="node in node.SubMenuItems" ui-tree-node ng-include="\'nodes_renderer.html\'"> </li> </ol></script>');
$templateCache.put('app/pages/student/studentRegistration/studentRegistration.html','<style>\r\n    .datepic {\r\n        height: 34px;\r\n    }\r\n\r\n    .well,\r\n    .input-group {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    .form-group label {\r\n        text-align: right;\r\n    }\r\n\r\n    .sto {\r\n        margin-bottom: 20px;\r\n        margin-top: 20px;\r\n    }\r\n</style><div class="panel panel-default" data-ng-if="vm.isFormOpen"><div class="panel-heading"><h3 class="panel-title"><b>Create Student Details</b></h3></div><div class="panel-body"><div class="row"><div class="col-md-12 well well-sm"><form name="vm.StudentForm" class="form-horizontal" novalidate=""><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">STUDENT DETAILS</h4></div><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-4"><div><label for="inputName" class="col-md-4 control-label"><b>Name</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="iName" id="inputFirstName" class="form-control" placeholder="Student Name" autocomplete="off" ng-model="vm.student.StudentName" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.iName.$touched)"><span ng-show="vm.StudentForm.iName.$error.required" class="text-danger">Name is required</span></p></div></div><div><label for="inputFathertName" class="col-md-4 control-label"><b>Father Name</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="iFathertName" id="inputFathertName" class="form-control" placeholder="Father Name" autocomplete="off" ng-model="vm.student.StdFatherName" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.iFathertName.$touched)"><span ng-show="vm.StudentForm.iFathertName.$error.required" class="text-danger">Father Name is required</span></p></div><br></div><div><label for="inputMotherName" class="col-md-4 control-label"><b>Mother Name</b></label><div class="col-md-8"><input type="text" name="iMothertName" id="inputMotherName" class="form-control" placeholder="Mother Name" autocomplete="off" ng-model="vm.student.StdMotherName" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.iMothertName.$touched)"><span ng-show="vm.StudentForm.iMothertName.$error.required" class="text-danger">Mother Name is required</span></p></div><br></div><div><label for="inputGuardainName" class="col-md-4 control-label"><b>Guardian Name</b></label><div class="col-md-8"><input type="text" name="inputGuardainName" id="inputGuardainName" class="form-control" placeholder="Guardian Name" autocomplete="off" ng-model="vm.student.StdGuardianName" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputGuardainName.$touched)"><span ng-show="vm.StudentForm.inputGuardainName.$error.required" class="text-danger">Mother Name is required</span></p></div></div><div><label for="inputClass" class="col-md-4 control-label"><b>Class</b></label><div class="col-md-8"><ui-select name="classRoom" ng-required="true" ng-model="vm.student.selectedClassRoom" on-select="vm.getSectionByClass(vm.student.selectedClassRoom.ClassId)" theme="bootstrap" style="min-width: 200px;"><ui-select-match allow-clear="true" placeholder="Class Room Name">{{$select.selected.ClassName}}</ui-select-match><ui-select-choices repeat="class in vm.ClassRoomList | filter: $select.search"><div ng-bind-html="class.ClassName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.classRoom.$touched && (vm.student.selectedClassRoom=== null ||vm.student.selectedClassRoom=== undefined)"><span class="text-danger">Class is required.</span></div></div></div><div><label for="inputLastName" class="col-md-4 control-label"><b>Section</b></label><div class="col-md-8"><ui-select name="section" ng-required="true" ng-model="vm.student.selectedSection" theme="bootstrap" style="min-width: 200px;"><ui-select-match allow-clear="true" placeholder="Section Name">{{$select.selected.SectionName}}</ui-select-match><ui-select-choices repeat="sec in vm.SectionList | filter: $select.search"><div ng-bind-html="sec.SectionName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.section.$touched && (vm.student.selectedSection=== null ||vm.student.selectedSection=== undefined)"><span class="text-danger">Section is required.</span></div></div></div><div><label for="inputCountry" class="col-md-4 control-label"><b>Country</b></label><div class="col-md-8"><ui-select name="countrydrpdwn" ng-required="true" ng-model="vm.student.selectedCountry" theme="bootstrap" style="min-width: 200px;" on-select="vm.getStateListByCountryId(vm.student.selectedCountry.CountryId)"><ui-select-match allow-clear="true" placeholder="Country Name">{{$select.selected.CountryName}}</ui-select-match><ui-select-choices repeat="Country in vm.CountryList | filter: $select.search"><div ng-bind-html="Country.CountryName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.countrydrpdwn.$touched && (vm.student.selectedCountry=== null ||vm.student.selectedCountry=== undefined)"><span class="text-danger">Coutry is required.</span></div></div></div><div><label for="inputStudentName" class="col-md-4 control-label"><b>State</b></label><div class="col-md-8"><ui-select name="statedrp" ng-required="true" ng-model="vm.student.selectedState" style="min-width: 200px;" theme="bootstrap" on-select="vm.getCityByStateId(vm.student.selectedState.StateId)"><ui-select-match allow-clear="true" placeholder="State Name">{{$select.selected.StateName}}</ui-select-match><ui-select-choices repeat="State in vm.StateList | filter: $select.search"><div ng-bind-html="State.StateName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.statedrp.$touched && (vm.student.selectedState=== null ||vm.student.selectedState=== undefined)"><span class="text-danger">State is required.</span></div></div></div><div><label for="inputCity" class="col-md-4 control-label"><b>City</b></label><div class="col-md-8"><ui-select name="Citydrp" ng-required="true" ng-model="vm.student.selectedCity" on-select="vm.getAreaByCityId(vm.student.selectedCity.CityId)" style="min-width: 200px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="City Name">{{$select.selected.CityName}}</ui-select-match><ui-select-choices repeat="city in vm.CityList | filter: $select.search"><div ng-bind-html="city.CityName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.Citydrp.$touched && (vm.student.selectedCity=== null ||vm.student.selectedCity=== undefined)"><span class="text-danger">City is required.</span></div></div></div><div><label for="inputArea" class="col-md-4 control-label"><b>Area</b></label><div class="col-md-8"><ui-select name="Areadrp" ng-required="true" ng-model="vm.student.selectedArea" style="min-width: 200px;" theme="bootstrap"><ui-select-match allow-clear="true" placeholder="Area Name">{{$select.selected.AreaName}}</ui-select-match><ui-select-choices repeat="area in vm.AreaList | filter: $select.search"><div ng-bind-html="area.AreaName | highlight: $select.search"></div></ui-select-choices></ui-select><br><div ng-if="vm.StudentForm.Areadrp.$touched && (vm.student.selectedArea=== null ||vm.student.selectedArea=== undefined)"><span class="text-danger">Area is required.</span></div></div></div><div><label for="inputPincode" class="col-md-4 control-label"><b>PinCode</b></label><div class="col-md-8"><input type="text" name="inputPincode" id="inputPincode" class="form-control" disabled="" autocomplete="off" ng-model="vm.student.selectedArea.Pincode" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputPincode.$touched)"><span ng-show="vm.StudentForm.inputPincode.$error.required" class="text-danger">Pincode is required</span></p></div></div></div><div class="form-group col-md-4"><div><label for="inputDOB" class="col-md-4 control-label"><b>Date Of Birth</b> <span class="text-danger">*</span></label><div class="col-md-8"><p class="input-group"><input type="text" id="inputDOB" name="inputDOB" class="form-control datepic" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.student.StudentDOB" is-open="vm.popup2.opened" datepicker-options="vm.options" close-text="Close" placeholder="dd-MM-yyyy" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><br><div ng-if="vm.StudentForm.inputDOB.$touched && (vm.student.StudentDOB=== null ||vm.student.StudentDOB=== undefined)"><span class="text-danger">DataBirth is required.</span></div></div></div><div><label for="inputSID" class="col-md-4 control-label"><b>S.KPOST ID</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputSID" id="inputSID" class="form-control" placeholder="Student KPOST ID" autocomplete="off" ng-model="vm.student.StdKpostId" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputSID.$touched)"><span ng-show="vm.StudentForm.inputSID.$error.required" class="text-danger">Student KPOST ID is required</span></p></div></div><div><label for="inputFID" class="col-md-4 control-label"><b>F.KPOST ID</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputFID" id="inputFID" class="form-control" placeholder="Fathers KPOST ID" autocomplete="off" ng-model="vm.student.StdFatherKpostId" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputFID.$touched)"><span ng-show="vm.StudentForm.inputFID.$error.required" class="text-danger">Father KPOST ID is required</span></p></div></div><div><label for="inputMID" class="col-md-4 control-label"><b>M.KPOST ID</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputMID" id="inputMID" class="form-control" placeholder="Mother\'s KPOST Name" autocomplete="off" ng-model="vm.student.StdMotherKpostId" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputMID.$touched)"><span ng-show="vm.StudentForm.inputMID.$error.required" class="text-danger">Mothers KPOST ID is required</span></p></div></div><div><label for="inputGID" class="col-md-4 control-label"><b>G.KPOST ID</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputGID" id="inputGID" class="form-control" placeholder="Guardian\'s KPOST ID" autocomplete="off" ng-model="vm.student.StdGuardianKpostId" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputGID.$touched)"><span ng-show="vm.StudentForm.inputGID.$error.required" class="text-danger">Guardian KPOST ID is required</span></p></div></div><div><label for="inputAddress1" class="col-md-4 control-label"><b>Address1</b> <span class="text-danger">*</span></label><div class="col-md-8"><textarea class="form-control" placeholder="Address1" autocomplete="off" ng-model="vm.student.Address1"></textarea><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.Address1.$touched)"><span ng-show="vm.StudentForm.Address1.$error.required" class="text-danger">Guardian KPOST ID is required</span></p></div></div><div><label for="inputAddress2" class="col-md-4 control-label"><b>Address2</b> <span class="text-danger">*</span></label><div class="col-md-8"><textarea class="form-control" placeholder="Address2" autocomplete="off" ng-model="vm.student.Address2"></textarea></div></div><div><label for="inputReligion" class="col-md-4 control-label"><b>Religion</b></label><div class="col-md-8"><input type="text" name="inputReligion" id="inputReligion" class="form-control" placeholder="Religion" autocomplete="off" ng-model="vm.student.StdReligion" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputReligion.$touched)"><span ng-show="vm.StudentForm.inputReligion.$error.required" class="text-danger">Religion is required</span></p></div></div><div><label for="inputCaste" class="col-md-4 control-label"><b>Caste</b></label><div class="col-md-8"><input type="text" name="inputCaste" id="inputCaste" class="form-control" placeholder="Caste" autocomplete="off" ng-model="vm.student.StdCaste" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputCaste.$touched)"><span ng-show="vm.StudentForm.inputCaste.$error.required" class="text-danger">Catse is required</span></p></div></div><div><label for="inputCommunity" class="col-md-4 control-label"><b>Community</b></label><div class="col-md-8"><input type="text" name="inputCommunity" id="inputCommunity" class="form-control" placeholder="Community" autocomplete="off" ng-model="vm.student.StdCommunity" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputCommunity.$touched)"><span ng-show="vm.StudentForm.inputCommunity.$error.required" class="text-danger">Community is required</span></p></div></div></div><div class="form-group col-md-4"><div><label for="inputGender" class="col-md-4 control-label"><b>Gender</b> <span class="text-danger">*</span></label><div><input type="radio" name="gender" required="" class="styled" value="M" ng-model="vm.student.StdGender"> <label for="inputGenderM">Male</label> <input type="radio" name="gender" required="" class="styled" value="F" ng-model="vm.student.StdGender"> <label for="inputGenderF">Female</label></div><br></div><div><label for="inputFMobile" class="col-md-4 control-label"><b>F.MobileNo</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="number" name="inputFMobile" id="inputFMobile" class="form-control" placeholder="Father\'s Mobile No" autocomplete="off" ng-model="vm.student.StdFatherMobileNo" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputFMobile.$touched)"><span ng-show="vm.StudentForm.inputFMobile.$error.required" class="text-danger">Father Mobile Number is required</span></p></div></div><div><label for="inputMMobile" class="col-md-4 control-label"><b>M.MobileNo</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="number" name="inputMMobile" id="inputMMobile" class="form-control" placeholder="Mother\'s Mobile Name" autocomplete="off" ng-model="vm.student.StdMotherMobileNo" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputMMobile.$touched)"><span ng-show="vm.StudentForm.inputMMobile.$error.required" class="text-danger">Mother Mobile Number is required</span></p></div></div><div><label for="inputGMobile" class="col-md-4 control-label"><b>G.MobileNo</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="number" name="inputGMobile" id="inputGMobile" class="form-control" placeholder="Guardian\'s Mobile Name" autocomplete="off" ng-model="vm.student.StdGuardianMobileNo" required=""><br><p ng-if="(vm.StudentForm.$submitted || vm.StudentForm.inputGMobile.$touched)"><span ng-show="vm.StudentForm.inputGMobile.$error.required" class="text-danger">Guardian Mobile Number is required</span></p></div></div><div class="col-sm-offset-4 col-sm-4"><img ng-src="{{ vm.profilePicUrl }}" height="150px" width="130px"><br><br><input name="file" type="file" data-ng-model="file" custom-on-change="photoChanged" required="" ng-show="!vm.isEditing" ng-hide="vm.isEditing && !vm.isEditingProPic"></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <button type="button" class="btn btn-sm btn-primary" uib-tooltip="Change Student Photo" ng-show="vm.isEditing" data-ng-click="vm.editProPic()"><i class="fa fa-edit"></i></button>&nbsp;&nbsp; <button type="button" class="btn btn-sm btn-danger" uib-tooltip="Cancel" ng-hide="!vm.isEditing" data-ng-click="vm.isEditingProPic = false" ng-show="vm.isEditing && vm.isEditingProPic"><i class="fa fa-close"></i></button></div></div></div></fieldset></form></div></div><div class="row" style="margin: 10px 0"><div class="col-md-12"><div class="form-group"><div class="pull-right"><button class="btn btn-primary btn-sm" ng-click="vm.GotoStudentAccountDetails()">Next</button> <button class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></div></div></div><div class="panel panel-default" data-ng-if="vm.isFormOpen" ng-show="vm.bankDetails"><div class="panel-heading"><h3 class="panel-title">Create student Account Details</h3></div><div class="panel-body"><div class="row"><div class="col-md-12 well well-sm"><form name="vm.EmployeeForm" class="form-horizontal" novalidate=""><fieldset><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">BANK DETAILS</h4></div><div class="col-md-12"><div class="col-md-12"><div class="form-group col-md-6"><label for="inputAccNo" class="col-md-4 control-label"><b>Account No</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputAccNo" id="inputAccNo" class="form-control" placeholder="Account No" autocomplete="off" ng-model="vm.student.AccountNo" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputAccNo.$touched)"><span ng-show="vm.AccountForm.inputAccNo.$error.required" class="text-danger">Account No is required</span></p></div><br></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputBankname" class="col-md-4 control-label"><b>Name of the Bank</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBankname" id="inputBankname" class="form-control" placeholder="Name of the Bank" autocomplete="off" ng-model="vm.student.BankName" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBankname.$touched)"><span ng-show="vm.AccountForm.inputBankname.$error.required" class="text-danger">Name of the Bank is required</span></p></div></div><div class="form-group col-md-6"><label for="inputIFSCcode" class="col-md-4 control-label"><b>IFSC Code</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputIFSCcode" id="inputIFSCcode" class="form-control" placeholder="IFSC Code" autocomplete="off" ng-model="vm.student.IFSCCode" required=""><br><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputIFSCcode.$touched)"><span ng-show="vm.AccountForm.inputIFSCcode.$error.required" class="text-danger">IFSC Code is required</span></p></div></div><div class="form-group col-md-6"><label for="inputBranch" class="col-md-4 control-label"><b>Branch</b> <span class="text-danger">*</span></label><div class="col-md-8"><input type="text" name="inputBranch" id="inputBranch" class="form-control" placeholder="Branch" autocomplete="off" ng-model="vm.student.Branch"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputBranch.$touched)"><span ng-show="vm.AccountForm.inputBranch.$error.required" class="text-danger">Branch is required</span></p></div></div><div class="form-group col-md-6"><label for="inputMICR" class="col-md-4 control-label"><b>MICR Code</b></label><div class="col-md-8"><input type="text" name="inputMICR" id="inputMICR" class="form-control" placeholder="MICR Code" autocomplete="off" ng-model="vm.student.MICRCode"><p ng-if="(vm.AccountForm.$submitted || vm.AccountForm.inputMICR.$touched)"><span ng-show="vm.AccountForm.inputMICR.$error.required" class="text-danger">MICR Code is required</span></p></div></div></div></div></fieldset></form></div><div class="col-md-12 well well-sm"><form name="vm.AddressForm" class="form-horizontal"><div class="col-md-6"><div class="col-lg-12"><h4 class="text-primary text-center" style="font-weight:bold">PERSONAL DETAILS</h4></div><div class="col-md-12"><div class="form-group"><label for="inputBloodGroup" class="col-md-4 control-label"><b>Blood Group</b></label><div class="col-md-8"><input type="text" id="inputBloodGroup" name="inputBloodGroup" class="form-control" placeholder="Blood Group" autocomplete="off" ng-model="vm.student.BloodGroup"></div></div><div class="form-group"><label for="inputAddress2" class="col-md-4 control-label"><b>Aadhaar Card No</b></label><div class="col-md-8"><input type="text" id="inputAddress2" name="inputAddress2" class="form-control" placeholder="Aadhaar Card No" autocomplete="off" ng-model="vm.student.Aadhaarcardno"></div></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are You Physically Handicapped</b></label> <input type="radio" name="Physicallyhandicapted" required="" class="styled" value="Y" ng-model="vm.student.Physicallyhandicapted"> <label for="inputPhysicallyhandicapted">Yes</label> <input type="radio" name="Physicallyhandicapted" required="" class="styled" value="N" ng-model="vm.student.Physicallyhandicapted"> <label for="inputPhysicallyhandicapted">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you Eligible to get Fee Wavier</b></label> <input type="radio" name="Eligible" required="" class="styled" value="Y" ng-model="vm.student.Eligible"> <label for="inputEligible">Yes</label> <input type="radio" name="Eligible" required="" class="styled" value="N" ng-model="vm.student.Eligible"> <label for="inputEligible">No</label></div><div class="form-group"><label for="inputArea" class="col-md-4 control-label"><b>Are you actively participating in any sports</b></label> <input type="radio" name="Participate" required="" class="styled" value="Y" ng-model="vm.student.Participate"> <label for="inputParticipate">Yes</label> <input type="radio" name="Participate" required="" class="styled" value="N" ng-model="vm.student.Participate"> <label for="inputParticipate">No</label></div></div><div class="form-group"><label for="inputProficiency" class="col-md-4 control-label"><b>Level of Proficiency</b></label><div class="form-group col-md-6"></div><div class="col-md-8"><ui-select name="inputProficiency" ng-required="true" ng-model="vm.student.Proficiency" theme="bootstrap" style="min-width:300px"><ui-select-match allow-clear="true" placeholder="Level of Proficiency">{{$select.selected.ProficiencyName}}</ui-select-match><ui-select-choices repeat="Proficiency in vm.ProficiencyList | filter: $select.search"><div ng-bind-html="Proficiency.ProficiencyName | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-if="vm.InstitutionForm.inputProficiency.$touched && (vm.InstitutionForm.Proficiency=== null ||vm.Institution.selectedOrganization=== undefined)"><span class="text-danger">Prefered Languge to use the Software is required.</span></div></div></div></div><div class="col-md-6"><div class="col-md-12"><br><br><br><br><br><br><br><br><br><br><div class="form-group" ng-if="vm.student.Physicallyhandicapted"><label for="text" class="col-md-4 control-label" ng-show="vm.student.Physicallyhandicapted == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="Handicapped" id="inputHandicapped" class="form-control" placeholder="Physically Handicapped" autocomplete="off" ng-model="vm.student.Handicapped"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">If So, Specify</span></p></div></div><div class="form-group" ng-if="vm.student.Eligible"><label for="text" class="col-md-4 control-label" ng-if="vm.student.Eligible == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="FeeWavier" id="inputFeeWavier" class="form-control" placeholder="Fee Wavier" autocomplete="off" ng-model="vm.student.FeeWavier"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger"><b>If So, Specify</b></span></p></div></div><div class="form-group" ng-if="vm.student.Participate"><label for="text" class="col-md-4 control-label" ng-if="vm.student.Participate == \'Yes\'"><b>If So, Specify</b></label><div class="col-md-8"><input type="text" name="participate" id="inputparticipate" class="form-control" placeholder="participate" autocomplete="off" ng-model="vm.student.participate"><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.iBG.$touched)"><span ng-show="vm.EmployeeForm.iBG.$error.required" class="text-danger">Branch is required</span></p></div></div></div></div></form></div></div><div class="row" style="margin: 10px 0"><div class="col-md-12"><div class="form-group"><div class="pull-right"><button class="btn btn-primary btn-sm" ng-click="vm.SaveStudent(vm.student)">Save</button> <button class="btn btn-primary btn-sm" ng-click="vm.Save">Next</button> <button class="btn btn-danger btn-sm" ng-click="vm.cancel()">Cancel</button></div></div></div></div><div class="row"><div class="col-md-12 well well-sm" data-ng-if="vm.isEditing1"><div class=""><div class="col-md-12"><div class="form-group col-md-6"><label for="inputGraduation" class="col-md-4 control-label">Graduation</label><div class="col-md-8"><select class="input-sm" id="inputGraduation" name="inputGraduation" data-ng-model="vm.emp1.Graduation" ng-dropdown="" convert-to-number="" style="width:100%"><option ng-option="" value="10" selected="selected">10 <sup>th</sup></option><option ng-option="" value="12">12 <sub>th</sub></option><option ng-option="" value="dimploma">DIMPLOMA</option><option ng-option="" value="UG">UNDER GRADUATION</option><option ng-option="" value="P">POST GRADUATION</option></select></div></div><div class="form-group col-md-6" data-ng-if="vm.emp1.Graduation != 10 && vm.emp1.Graduation != 12"><label for="inputdegree" class="col-md-4 control-label">Degree</label><div class="col-md-8"><input type="text" id="inputdegree" name="inputdegree" class="form-control" placeholder="Degree" autocomplete="off" ng-model="vm.emp1.Degree" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputdegree.$touched)"><span ng-show="vm.EmployeeForm.inputdegree.$error.required" class="text-danger">Degree is required</span></p></div></div></div><div class="col-md-12" data-ng-if="vm.emp1.Graduation != 10 && vm.emp1.Graduation != 12"><div class="form-group col-md-6"><label for="inputspecialization" class="col-md-4 control-label">Specialization</label><div class="col-md-8"><input type="text" id="inputspecialization" name="inputspecialization" class="form-control" placeholder="Specialization" autocomplete="off" ng-model="vm.emp1.Specialization" required=""><br><p ng-if="(vm.EmployeeForm.$submitted || vm.EmployeeForm.inputspecialization.$touched)"><span ng-show="vm.EmployeeForm.inputspecialization.$error.required" class="text-danger">Specialization is required</span></p></div></div><div class="form-group col-md-6"><label for="inputuniversity" class="col-md-4 control-label">University/Institute</label><div class="col-md-8"><input type="text" id="inputuniversity" name="inputuniversity" class="form-control" placeholder="University/Institute" autocomplete="off" ng-model="vm.emp1.University"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputPercentage" class="col-md-4 control-label">Percentage</label><div class="col-md-8"><input type="number" id="inputPercentage" name="inputPercentage" class="form-control" placeholder="Percentage" autocomplete="off" ng-model="vm.emp1.Percentage"></div></div><div class="form-group col-md-6"><label for="inputYOP" class="col-md-4 control-label">Years of Passing</label><div class="col-md-8"><input type="text" id="inputYOP" name="inputYOP" only-digits="" class="form-control" placeholder="Years Of Passing" autocomplete="off" ng-model="vm.emp1.YearsofPassing"></div></div></div><div class="col-md-12"><div class="form-group col-md-6"><label for="inputDocAttachment" class="col-md-4 control-label">DocAttachment</label><div class="col-md-8"><input type="file" multiple="" custom-on-change="getGraduationFiles"></div></div><div class="form-group col-md-6"><label for="inputRemarks" class="col-md-4 control-label">Remarks</label><div class="col-md-8"><input type="text" id="inputRemarks" name="inputRemarks" class="form-control" placeholder="Remarks" autocomplete="off" ng-model="vm.emp1.Remarks"></div></div></div><div class="col-md-12"><div class="form-group"><div class="pull-right"><button type="Add" class="btn btn-primary btn-sm" ng-click="vm.AddEmployeeAcademic(vm.emp1)">Add</button></div></div></div><table st-table="dispayedrows" st-safe-src="vm.EmployeeAcademicList" class="table table-striped"><thead><tr><th st-sort=""><strong>Graduation</strong></th><th st-sort=""><strong>Degree</strong></th><th st-sort=""><strong>Specialization</strong></th><th st-sort=""><strong>University/Institute</strong></th><th st-sort=""><strong>Percentage</strong></th><th st-sort=""><strong>Years of Passing</strong></th><th st-sort=""><strong>Doc Attached</strong></th><th st-sort=""><strong>Remarks</strong></th><th class="text-center"><em class="fa fa-cog" width="100px"></em></th></tr></thead><tbody><tr ng-repeat="row in dispayedrows"><td>{{row.Graduation}}</td><td>{{row.Degree}}</td><td>{{row.Specialization}}</td><td>{{row.University}}</td><td>{{row.Percentage}}</td><td>{{row.YearofPassing}}</td><td><span class="label label-success" data-ng-if="row.DocAttachment != \'\'">Yes</span> <span class="label label-success" data-ng-if="row.DocAttachment === \'\'">No</span></td><td>{{row.Remarks}}</td><td class="text-center" width="100px"><button type="button" ng-click="vm.RemoveEmployeeAcademic(row)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-items-by-page="noOfRows" colspan="10"></td></tr></tfoot></table></div></div></div></div></div><div class="panel panel-default" style="overflow-x:scroll" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><div class=""><h3 class="panel-title">List Of Students</h3></div></div><div class="panel-body"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.StudentList" class="table table-striped"><thead><tr><th class="text-center" st-sort=""><strong>S.No</strong></th><th class="text-center" st-sort="StudentName"><strong>Name</strong></th><th class="text-center" st-sort="StdGender"><strong>Family Detail</strong></th><th class="text-center" st-sort="ClassName"><strong>KPost ID</strong></th><th class="text-center" st-sort="SectionName"><strong>Class Details</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="Name" class="input-sm form-control" placeholder="Name" type="text"></th><th><input st-search="Gender" class="input-sm form-control" placeholder="Gender" type="text"></th><th><input st-search="StdGender" class="input-sm form-control" placeholder="Gender" type="text"></th><th><input st-search="ClassName" class="input-sm form-control" placeholder="Class Name" type="text"></th><th><input st-search="SectionName" class="input-sm form-control" placeholder="Section Name" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td class="text-center"><div><small><strong>Name :</strong> {{row.StudentName}}</small><br><small><strong>Gender :</strong> {{row.StdGender}}</small><br><small><strong>DOB :</strong> {{row.StudentDOB | date:\'dd/MM/yyyy\'}}</small></div></td><td class="text-center"><div><small><strong>Father\'s Name :</strong> {{row.StdFatherName}}</small><br><small><strong>Mother\'s Name :</strong> {{row.StdMotherName}}</small><br><small><strong>Guardian\'s Name :</strong> {{row.StdGuardianName}}</small></div></td><td class="text-center"><div><small><strong>Father\'s ID:</strong> {{row.StdFatherKpostId}}</small><br><small><strong>Mother\'s ID :</strong> {{row.StdMotherKpostId}}</small><br><small><strong>Guardian\'s ID :</strong> {{row.StdGuardianKpostId}}</small></div></td><td class="text-center"><div><small><strong>Class:</strong> {{row.ClassName}}</small><br><small><strong>Section :</strong> {{row.SectionName}}</small></div></td><td class="text-center" width="200px"><div><button type="button" ng-click="vm.editStudent(row)" class="btn btn-sm btn-primary" uib-tooltip="Edit"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeStudent(row)" class="btn btn-sm btn-danger" uib-tooltip="Delete"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/user/login/login.html','<style>\r\n    body {\r\n        /* background-image: url(\'http://www.katbook.in/img/banner_gallery4.jpg\') !important; */\r\n        background-image: url(\'assets/img/banner_gallery4.jpg\') !important;\r\n        /*height: 100% !important;*/\r\n        background-position: center !important;\r\n        background-repeat: no-repeat !important;\r\n        background-size: cover !important;\r\n    }\r\n    html {\r\n        height: 100%;\r\n    }\r\n\r\n    body {\r\n        min-height: 100%;\r\n    }\r\n    .auth-container{\r\n        padding-top:0px; \r\n    }\r\n    .btn-auth{\r\n       background: #3f51b5;\r\n    border-color: #3f51b5;\r\n    height: 36px;\r\n    font-size: 14px;\r\n    padding: 7px 20px;\r\n    }\r\n    .input-group-addon{\r\n        background:#fff;\r\n    }\r\n</style><div class="auth-container"><div class="outer"><div class="middle"><div class="col-md-6"><div class="inner"><main class="auth-main"><div class="auth-block"><div class="row text-center"><img ng-src="assets/img/katbooklogo.png" style="width:180px;"><br><br></div><h1><b>Sign in</b></h1><form class="form-horizontal" data-ng-submit="vm.login()"><div class="form-group"><ul style="list-style: none; padding: 0;"><li style="color: rgb(255, 255, 255)" class="text-center" data-ng-repeat="err in vm.errorList">{{ err }}</li></ul></div><div class="form-group"><label for="login" class="sr-only">Username or Email</label><div class="input-group"><div class="input-group-addon"><i class="fa fa-user"></i></div><input type="text" class="form-control" id="login" name="login" placeholder="Username/Email" data-ng-model="vm.Username" value="" tabindex="1"></div></div><div class="form-groups"><label for="password" class="sr-only">Password</label><div class="input-group"><div class="input-group-addon"><i class="fa fa-lock"></i></div><input type="password" class="form-control" id="password" name="password" placeholder="Password" data-ng-model="vm.Password" value="" tabindex="2"></div></div><div class="form-group"><button type="submit" class="btn btn-auth btn-sm pull-right"><span data-ng-show="vm.isLoading">Logging in...</span> <span data-ng-hide="vm.isLoading"><i class="ion-log-in"></i> Login</span></button> <a href="" class="forgot-pass pull-left" style="color:#fff">Forgot password?</a></div></form></div></main></div></div></div></div></div>');
$templateCache.put('app/pages/user/register/register.html','<style>\r\n\r\n/*login page*/\r\n.banner img\r\n{\r\n\twidth:100%;\r\nheight:300px;\r\npadding:0px;\r\n}\r\n.login_form\r\n{\r\n\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    width: 500px;\r\n    margin: 0 auto;\r\n    height: 250px;\r\n    box-shadow: #eaeaea 7px 7px;\r\n    margin-top:8%;\r\n}\r\n.logtag\r\n{\r\n\ttext-align:center;\r\n\tfont-size:15px;\r\n\tfont-family:\'Roboto\';\r\n\ttext-transform:uppercase;\r\n\tcolor:#753239;\r\n\tfont-weight:800;\r\n\tpadding:10px;\r\n}\r\n\r\n.login_name input\r\n{\r\n\ttext-align:center;\r\n\twidth:400px;\r\n\tpadding:7px;\r\n\tborder:1px solid #e5e5e5;\r\n\tborder-radius:5px;\r\n}\r\n\r\n.login_pass input\r\n{\r\n\ttext-align:center;\r\n\twidth:400px;\r\n\tpadding:7px;\r\n\tborder:1px solid #e5e5e5;\r\n\tborder-radius:5px;\r\n}\r\n.login_btn input\r\n{\r\n\ttext-align:center;\r\n\twidth:400px;\r\n\tpadding:7px;\r\n\tmargin-top:10px;\r\n\tborder:1px solid #e5e5e5;\r\n\tborder-radius:5px;\r\n\tbackground-color:#833a33;\r\n\tcolor:#fff;\r\n\tfont-size:15px;\r\n\tfont-weight:800;\r\n\ttext-decoration:none;\r\n}\r\n.login_btn a input:hover\r\n{\r\n\tbackground-color:#ffffcc;\r\n\tcolor:#833a33;\r\n\tcursor:pointer;\r\n\tborder:2px solid #833a33;\r\n\t\r\n}\r\n\r\n/*login page*/\r\n/*header*/\r\n.header1\r\n{\r\n\r\nwidth: 100%;\r\nheight:63px;\r\ncolor: #fff;\r\nbackground: linear-gradient(to left,#04b9ed,#fff); /* Standard syntax */\r\nz-index:999999;\r\nborder-bottom:1px solid#f2f2f2;\r\n}\r\n.reg\r\n{\r\n\t    position: absolute;\r\n    top:658px;\r\n     right:25%;\r\n    font-size: 17px;\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n    border: 1px solid;\r\n    padding: 5px;\r\n    width: 262px;\r\n    text-align: center;\r\n\tborder-radius:8px;\r\n\tcolor:#09f !important;\r\n}\r\nbanner1\r\n{\r\n\twidth:100% !important;\r\n\theight:100% !important;\r\n}\r\n.banner1 img\r\n{\r\n\twidth:100%;\r\nheight:100%;\r\npadding:0px;\r\n}\r\n.bodyclass\r\n{\r\n\tbackground:url(../image/b4.png);\r\n\tbackground-size:cover;\r\n}\r\n.header\r\n{\r\n\r\nwidth: 100%;\r\nheight: 63px;\r\ncolor: #fff;\r\nbackground: -moz-linear-gradient(left, red, #8b2b2b, orange);\r\nbackground: linear-gradient(to left, red, #8b2b2b, orange); /* Standard syntax */\r\nz-index:999999;\r\n}\r\n\r\n.sprofile\r\n{\r\n    width: 51px;\r\n    border-radius: 66px;\r\n    height: 44px;\r\n    padding: 0px;\r\n\tfloat:right;\r\n}\r\n.right_end\r\n{\r\n\tpadding-top:5px;\r\n}\r\n\r\n.kpostlogo\r\n{\r\n\tmax-width:100px;\r\n\tmax-height:65px;\r\n\tpadding:4px;\r\n}\r\n/*header end*/\r\n/*left.html*/\r\n.leftpan\r\n{\r\nwidth: 250px;\r\ntop: 50px;\r\nleft: 0px;\r\nposition: absolute;\r\nbottom:0px;\r\nbackground: #fff;\r\noverflow-y:auto; \r\ncursor:pointer;\r\nborder-right:1px solid #eaeaea;\r\n}\r\n.grp_title{\r\n\twidth: 100%;\r\n\t background-color:#D8B98B;\r\n\t color:#000;\r\n\t font-size:13px;\r\n\t font-weight:700;\r\n\t text-align:center;\r\n\t padding:10px;\r\n\t border-bottom:1px solid #eee;\r\n\t margin-bottom:0px;\r\n\t\r\n}\r\n.grp_title2{\r\n\twidth: 100%;\r\n\t background-color:#D8B98B;\r\n\t color:#000;\r\n\t font-size:13px;\r\n\t font-weight:700;\r\n\t text-align:center;\r\n\t padding:10px;\r\n\t border-bottom:1px solid #eee;\r\n\t margin-bottom:0px;\r\n\t\r\n}\r\n.phy_grp1 p\r\n{\r\n\t    border-bottom: 1px solid #eee;\r\n\t\tborder-right:1px solid #e1e1e1;\r\n\t\tpadding:5px;\r\n\t\tdisplay:block;\r\n}\r\n.proimg {\r\n    width: 50px;\r\n    border-radius:66px;\r\n    height: 50px;\r\n    border: 1px solid #ccc;\r\n    margin-right: 6px;\r\n}\r\n.middlepan\r\n{\r\n\r\n    position: absolute;\r\n    left: 249px;\r\n    top: 50px;\r\n    right: 300px;\r\n    overflow: hidden;\r\n    bottom: 0px;\r\n\tborder-right:1px solid #e1e1e1;\r\n\t\toverflow-y:auto;\r\n}\r\n\r\n/*left.html*/\r\n\r\n/*heading tags*/\r\nh1\r\n{\r\n\tcolor:#fff;\r\n\tfont-weight:700;\r\n\ttext-transform:uppercase;\r\n\tfont-size:21px;\r\n\ttext-align:center;\r\n\tmargin-top:10px;\r\n\t\r\n}\r\nh2\r\n{\r\n\t\r\n\t\r\n\tcolor:#030303;\r\n\tfont-weight:700;\r\n\ttext-transform:uppercase;\r\n\tfont-size:18px;\r\n\ttext-align:center;\r\n\tmargin-top:20px !important;\r\n\t\r\n}\r\nh3\r\n{\r\n\t\r\n\twidth: 100%;\r\n\t background-color:#D8B98B;\r\n\t color:#000;\r\n\t font-size:13px;\r\n\t font-weight:700;\r\n\t text-align:center;\r\n\t padding:10px;\r\n\t border-bottom:1px solid #eee;\r\n\t margin-bottom:0px;\r\n\t margin-top:0px !important;\r\n}\r\n\r\nh4\r\n{\r\n\tcolor:#09f;\r\n\tfont-weight:700;\r\n\ttext-transform:uppercase;\r\n\tfont-size:16px;\r\n\ttext-align:center;\r\n\t\r\n}\r\nh5\r\n{\r\n\tcolor:#900;\r\n\tfont-weight:700;\r\n\ttext-transform:uppercase;\r\n\tfont-size:15px;\r\n\ttext-align:center;\r\n}\r\n\r\nh6\r\n{\r\n\tmargin-bottom:10px;\r\n\tcolor:#F00;\r\n\tfont-weight:700;\r\n\tfont-size:10px;\r\n\ttext-align:center;\r\n}\r\n\r\n\t\r\n/*heading tags*/\r\n/*center.html*/\r\n.menuicon\r\n{\r\n\twidth:20px;\r\n\theight:15px;\r\n\tdisplay:none;\r\n}\r\n.sub_right li {\r\n    float: left;\r\n    padding: 5px;\r\n    border: 1px solid #ccc;\r\n    margin: 5px;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    text-align: center;\r\n    width: 135px;\r\n\tlist-style:none;\r\n}\r\n.sub_right\r\n{\r\n\tfloat:right;\r\n}\r\n.subhead {\r\n    background-color: #f5f4f4;\r\n}\r\n.goog-te-gadget-simple\r\n{\r\n\tbackground: none !important;\r\nborder: none !important;\r\npadding: 0px !important;\r\n}\r\n.goog-te-gadget-simple .goog-te-menu-value span\r\n{\r\n\tcolor:#000;\r\n\tfont-size:13px !important;\r\n\t\r\n}\r\n.goog-te-gadget-icon\r\n{\r\n\tdisplay:none;\r\n}\r\n  \r\n  .goog-te-banner-frame{\r\n\r\n\r\n\t  display:none !important;\r\n  }\r\n  .note {\r\n\tborder:1px solid gray;\r\n\twidth:200px;\r\n\theight:200px;\r\n\tpadding:4px;\r\n\tfont-size:85%;\r\n\tbackground:#FFFFCC;\r\n\t-moz-box-shadow:2px 2px 2px #999999;\r\n\t-webkit-box-shadow:2px 2px 2px #999999;\r\n\tbox-shadow:2px 2px 2px #999999;\r\n\tposition:absolute;\r\n\tright:290px;\r\n\ttop: 81%;\r\n\tz-index:99999;\r\n\t\r\n}\r\n\r\n.noteclose\r\n{\r\n\tposition:absolute;\r\n\tfont-weight:bold;\r\n\tright:300px;\r\n\ttop: 81%;\r\n\tz-index:99999;\r\n\tcursor:pointer;\r\n}\r\np a{\r\n\tcolor:#00C !important;\r\n\tfont-size:12px;\r\n\ttext-align:center;\r\n\tmargin:8px;\r\n\tfont-weight: 600;\r\n\t\r\n}\r\np{\r\n\ttext-align:justify;\r\n\tfont-size:15px;\r\n\tfont-family:\'Roboto\';\r\n\tcolor:#000;\r\n}\r\n.figimg img\r\n{\r\n\ttext-align:center;\r\n}\r\n.footer_div {\r\n    position: relative;\r\n    top: 49px;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.footer_span_img {\r\n    width: 48px;\r\n    padding-top: 5px;\r\n    padding: 12px;\r\n    border-right: 3px solid #fff;\r\n}\r\n.footer\r\n{\r\n\tbottom:0px;\r\n\tleft:0PX;\r\n\tright:0px;\r\n\t/*border: 1px solid #ccc;*/\r\n\t\tpadding: 25px;\r\n\tcolor:#000 !important;\r\n\tborder-radius:5px;\r\n\tbox-shadow:#eaeaea 5px 5px 10px 10px;\r\n\tborder-top: 2px solid #ccc;\r\n\tborder-bottom: 2px solid #ccc;\r\n\ttop:10px;\r\n}\r\n.f_1\r\n{\r\n\t\r\n\tborder:1px solid #ccc;\r\n\tborder-radius:6px;\r\n\tbox-shadow:#eaeaea 5px 5px;\r\n\tpadding:15px 0px !important;\r\n\ttext-align:center !important;\r\n\t\r\n}\r\n.f_2\r\n{\r\n\tborder:1px solid #ccc;\r\n\tborder-radius:6px;\r\n\tbox-shadow:#eaeaea 7px 7px;\r\n\tpadding:15px 0px !important;\r\n\ttext-align:center !important;\r\n}\r\n.f_3\r\n{\r\n\tborder:1px solid #ccc;\r\n\tborder-radius:6px;\r\n\tbox-shadow:#eaeaea 7px 7px;\r\n\tpadding:15px 0px !important;\r\n\ttext-align:center !important;\r\n}\r\n\t\r\n\r\n\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  -webkit-box-sizing: border-box;\r\n  -moz-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n}\r\n\r\n\r\nul { list-style-type: none; }\r\n\r\na {\r\n  color: #b63b4d;\r\n  text-decoration: none;\r\n}\r\n\r\n/** =======================\r\n * Contenedor Principal\r\n ===========================*/\r\n\r\n\r\nh1 {\r\n  color: #FFF;\r\n  font-size: 24px;\r\n  font-weight: 400;\r\n  text-align: center;\r\n  /*margin-top: 80px;*/\r\n}\r\n\r\nh1 a {\r\n  color: #c12c42;\r\n  font-size: 16px;\r\n}\r\n\r\n.accordion {\r\n  width: 100%;\r\n \r\n /* margin: 30px auto 20px;*/\r\n  background: #FFF;\r\n  -webkit-border-radius: 4px;\r\n  -moz-border-radius: 4px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.accordion .link {\r\n  cursor: pointer;\r\n  display: block;\r\n  padding: 15px 15px 15px 42px;\r\n  color: #4D4D4D;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  border-bottom: 1px solid #eaeaea;\r\n  position: relative;\r\n  -webkit-transition: all 0.4s ease;\r\n  -o-transition: all 0.4s ease;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.accordion li:last-child .link { border-bottom: 0; }\r\n\r\n.accordion li i {\r\n  position: absolute;\r\n  top: 16px;\r\n  left: 12px;\r\n  font-size: 18px;\r\n  color: #595959;\r\n  -webkit-transition: all 0.4s ease;\r\n  -o-transition: all 0.4s ease;\r\n  transition: all 0.4s ease;\r\n}\r\n\r\n.accordion li i.fa-chevron-down {\r\n  right: 12px;\r\n  left: auto;\r\n  font-size: 16px;\r\n}\r\n\r\n.accordion li.open .link { color: #b63b4d; }\r\n\r\n.accordion li.open i { color: #b63b4d; }\r\n\r\n.accordion li.open i.fa-chevron-down {\r\n  -webkit-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  -o-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/**\r\n * Submenu\r\n -----------------------------*/\r\n\r\n\r\n.submenu {\r\n \r\n  background: #fff;\r\n  font-size: 14px;\r\n}\r\n\r\n.submenu li { border: 1px solid #eee;}\r\n\r\n.submenu a {\r\n  display: block;\r\n  text-decoration: none;\r\n color: #030303 !important;\r\n  padding: 12px;\r\n  text-align:left !important;\r\n  /*padding-left: 42px;*/\r\n  -webkit-transition: all 0.25s ease;\r\n  -o-transition: all 0.25s ease;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.submenu a:hover {\r\n \r\n background: #eee;\r\n  color: #4d4d4d !important;\r\n  font-weight:700;\r\n}\r\n\r\n\r\n\r\n\r\n.rightpan\r\n{\r\n    position: absolute;\r\n    top: 50px;\r\n    right: 0px;\r\n    bottom: 0px;\r\n    width: 300px;\r\n\tborder-left:1px solid #eee;\r\n    /*background: #eee;*/\r\n}\r\n.chap_tit\r\n{\r\n\twidth: 100%;\r\n\tborder: none;\r\n\tbackground:#D8B98B;\r\n\t color:#030303 !important;\r\n\t text-align:center;\r\n\t padding:6px;\r\n\t height:33px;\r\n\t font-weight:700;\r\n\t\r\n}\r\n.righttopdiv\r\n{\r\nposition: absolute;\r\nwidth: 100%;\r\ntop: 0px;\r\nheight:50%;\r\noverflow-y: scroll;\r\nborder-bottom:1px solid #eee;\r\noverflow-x:hidden !important;\r\n}\r\n\r\n\r\n.chap_click\r\n{\r\n\tfloat:right;\r\n}\r\n.sub_tit\r\n{\r\n\twidth: 100%;\r\n\tborder: none;\r\n\tbackground:#FFCF75;\r\n\t color:#030303 !important;\r\n\t text-align:center;\r\n\t padding:6px;\r\n\t height:33px;\r\n\t font-weight:700;\r\n\t display:none;\r\n\t\r\n}\r\n.sub_click\r\n{\r\n\tfloat:right;\r\n}\r\n\r\n\r\n.rightbottomdiv{\r\n    position: absolute;\r\n    bottom: 0px;\r\n    height: 50%;\r\n    width:100%;\r\n    overflow-x:hidden;\r\n    overflow-y:auto;\r\n    border-bottom: 1px solid #ccc;\r\n\tborder-top: 1px solid #ccc;\r\n\t/*padding-top:5px;*/\r\n\t\r\n}\r\n\r\n.video_tit\r\n{\r\n\twidth: 100%;\r\n\tborder: none;\r\n\tbackground:#D8B98B;\r\n\t color:#030303 !important;\r\n\t text-align:center;\r\n\t padding:6px;\r\n\t height:33px;\r\n\t font-weight:700;\r\n\t\r\n\t\r\n}\r\n.class1_videosdiv video\r\n{\r\n\tpadding:10px;\r\n\tborder:1px solid #eaeaea;\r\n\t\r\n}\r\n.class2_videosdiv video\r\n{\r\n\tpadding:10px;\r\n\tborder:1px solid #eaeaea;\r\n\t}\r\n/*time start*/\r\n/*time line start*/\r\nmain-timeline{\r\n    overflow: hidden;\r\n    position: relative;\r\n    padding: 60px 0;\r\n}\r\n.main-timeline:before{\r\n    content: "";\r\n    width: 1px;\r\n    height: 100%;\r\n    background: #cfcdcd;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n}\r\n.main-timeline .timeline{\r\n    width: 50%;\r\n    clear: both;\r\n    position: relative;\r\n}\r\n.main-timeline .timeline:before,\r\n.main-timeline .timeline:after{\r\n    content: "";\r\n    display: block;\r\n    clear: both;\r\n}\r\n.main-timeline .timeline:first-child:before,\r\n.main-timeline .timeline:last-child:before{\r\n    content: "";\r\n    width: 11px;\r\n    height: 11px;\r\n    background: #cfcdcd;\r\n    box-sizing: content-box;\r\n    border: 5px solid #fff;\r\n    box-shadow: 0 0 0 2px #cfcdcd;\r\n    position: absolute;\r\n    top: -54px;\r\n    right: -11px;\r\n    transform: rotate(45deg);\r\n}\r\n.main-timeline .timeline:last-child:before{\r\n    top: auto;\r\n    bottom: -54px;\r\n}\r\n.main-timeline .timeline:last-child:nth-child(even):before{\r\n    right: auto;\r\n    left: -11px;\r\n}\r\n.main-timeline .timeline-icon{\r\n    width: 24px;\r\n    height: 24px;\r\n    background: #fff;\r\n    border: 1px solid #cfcdcd;\r\n    position: absolute;\r\n    top: 17px;\r\n    right: -13px;\r\n    z-index: 1;\r\n    transform: rotate(45deg);\r\n}\r\n.main-timeline .timeline-icon:before{\r\n    content: "";\r\n    display: block;\r\n    width: 15px;\r\n    height: 15px;\r\n    background: #fff;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    transition: background-color 0.2s ease 0s;\r\n}\r\n.main-timeline .timeline:hover .timeline-icon:before{ background: #ca337c; }\r\n.main-timeline .timeline-content{\r\n    width: 85%;\r\n    padding: 18px 30px;\r\n    background: #fff;\r\n    text-align: right;\r\n    float: left;\r\n    border: 1px solid transparent;\r\n    position: relative;\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.main-timeline .timeline:hover .timeline-content{\r\n    border: 1px solid #cfcdcd;\r\n\tborder-radius:5px;\r\n\tbox-shadow:#eaeaea 9px 9px;\r\n}\r\n.main-timeline .timeline-content:before{\r\n    content: "";\r\n    display: block;\r\n    width: 14px;\r\n    height: 14px;\r\n    background: #fff;\r\n    border: 1px solid #cfcdcd;\r\n    position: absolute;\r\n    top: 21px;\r\n    right: -7.3px;\r\n    transform: rotate(45deg);\r\n    transition: all 0.2s ease 0s;\r\n}\r\n.main-timeline .timeline:hover .timeline-content:before{\r\n    background: #ca337c;\r\n    border-color: #ca337c;\r\n\t\r\n}\r\n.main-timeline .timeline-content:after{\r\n    content: "";\r\n    width: 11%;\r\n    height: 1px;\r\n    background: #cfcdcd;\r\n    position: absolute;\r\n    top: 28px;\r\n    right: -14%;\r\n}\r\n.main-timeline .date{\r\n    display: block;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    color: #ca337c;\r\n    margin: 0 0 8px;\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.main-timeline .timeline:hover .date{ color: #444; }\r\n.main-timeline .title{\r\n    font-size: 18px;\r\n    color: #444;\r\n    margin-top: 0;\r\n    transition: all 0.3s ease 0s;\r\n}\r\n.main-timeline .timeline:hover .title{ color: #ca337c; }\r\n.main-timeline .description{\r\n    font-size: 16px;\r\n    color: #777;\r\n    line-height: 28px;\r\n    margin-top: 8px;\r\n}\r\n.main-timeline .timeline:nth-child(2n),\r\n.main-timeline .timeline:nth-child(2n) .timeline-content{\r\n    float: right;\r\n    text-align: left;\r\n}\r\n.main-timeline .timeline:nth-child(2n) .timeline-icon{\r\n    right: 0;\r\n    left: -12px;\r\n}\r\n.main-timeline .timeline:nth-child(2n) .timeline-content:before{ left: -7.3px; }\r\n.main-timeline .timeline:nth-child(2n) .timeline-content:after{ left: -14%; }\r\n@media only screen and (max-width: 767px){\r\n    .main-timeline{ padding-left: 20px; }\r\n    .main-timeline:before{ left: 20px; }\r\n    .main-timeline .timeline{ width: 100%; }\r\n    .main-timeline .timeline,\r\n    .main-timeline .timeline-content{\r\n        float: right;\r\n        text-align: left;\r\n    }\r\n    .main-timeline .timeline:first-child:before,\r\n    .main-timeline .timeline:last-child:nth-child(odd):before{\r\n        right: auto;\r\n        left: -11px;\r\n    }\r\n    .main-timeline .timeline-icon{\r\n        right: 0;\r\n        left: -12px;\r\n    }\r\n    .main-timeline .timeline-content:before{ left: -7.3px; }\r\n    .main-timeline .timeline-content:after{ left: -14%; }\r\n}\r\n/*time line end*/\r\n.container\r\n{\r\n\twidth:100%;\r\n}\r\n.tline\r\n{\r\nwidth:100%;\r\npadding:10px;\r\nposition:absolute;\r\ntop:58%;\r\n\r\n}\r\n.timeline-content .date a\r\n{\r\n\tcolor:#ca337c !important;\r\n\ttext-transform:uppercase !important\r\n}\r\n.timeline-content .date a:hover\r\n{\r\n\tcolor:#444 !important;\r\n\r\n}\r\n.kedlogo\r\n{\r\n    width: 60px;\r\n    height: 50px;\r\n    padding: 3px;\r\n\r\n}\r\n\r\n\r\n/*timeline end*/\r\n\r\n</style><div class="maindiv"><div class="col-md-12" style="padding:0px;"><div class="header1"><div class="col-md-1 logo"><img class="kedlogo" ng-src="assets/img/kpstedu1.png"></div></div></div><div class="col-md-12" style="padding:0px;"><img class="bodyclass" ng-src="assets/img/b4.png"> <span class="reg"><a href="instreg.html">Register for Kpost EDU</a></span></div><div style="clear:both;"></div><div class="form-group"><a target="_blank" class="btn btn-success btn-sm pull-left" type="button" ng-click="vm.testmethod()">Register</a></div></div>');
$templateCache.put('app/pages/user/userCreation/createUser.html','<div class="panel panel-default animated fadeInDownBig" data-ng-if="vm.isFormOpen"><div class="panel-heading"><h3 class="panel-title">User Account Creation</h3></div><div class="panel-body"><form name="form" class="form-horizontal" novalidate=""><fieldset><div class="center"><div class="form-group"><label for="userType" class="col-lg-2 control-label"><b>User Type</b></label><div class="col-lg-8"><div class="col-sm-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.user.UserType" id="inlineRadio1" value="EMP"> <span><b>Employee</b></span></label></div><div class="col-sm-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" ng-model="vm.user.UserType" ng-click="vm.getApprovedContractor()" id="inlineRadio" value="CON"> <span><b>Contractor</b></span></label></div></div></div></div><div class="row" ng-if="vm.user.UserType === \'EMP\'"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="dep" class="col-lg-4 control-label"><b>Select Department</b></label><div class="col-lg-8"><ui-select name="dep" ng-disabled="vm.selectdep" ng-model="vm.selectedDepartment" theme="bootstrap" autofocus="" on-select="vm.departmentSelectionChanged()"><ui-select-match allow-clear="true" placeholder="Select a Department">{{$select.selected.DepartmentName || $select.selected}}</ui-select-match><ui-select-choices repeat="department in vm.DepartmentList | propsFilter: {DepartmentName: $select.search}"><div class="text-message" ng-bind-html="department.DepartmentName"></div></ui-select-choices></ui-select></div></div></div><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="desig" class="col-lg-4 control-label">Select Designation</label><div class="col-lg-8"><ui-select name="desig" ng-disabled="vm.selectdes" ng-model="vm.selectedDesignation" theme="bootstrap" on-select="vm.designationSelectionChanged()"><ui-select-match allow-clear="true" placeholder="Select a Designation">{{$select.selected.DesignationName || $select.selected}}</ui-select-match><ui-select-choices repeat="designation in vm.DesignationList | propsFilter: {DesignationName: $select.search}"><div class="text-message" ng-bind-html="designation.DesignationName"></div></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-if="vm.user.UserType === \'EMP\'"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="emp" class="col-lg-4 control-label">Select Employee</label><div class="col-lg-8"><ui-select name="emp" ng-disabled="vm.selectemp" ng-model="vm.selectedEmployee" theme="bootstrap" on-select="vm.empSelectionChaged()"><ui-select-match allow-clear="true" placeholder="Select a Employee">{{$select.selected.FirstName || $select.selected}}</ui-select-match><ui-select-choices repeat="emp in vm.EmpList | propsFilter: {FirstName: $select.search, EmployeeCode: $select.search}"><div class="text-message" ng-bind-html="emp.FirstName + \' \' + emp.LastName"></div></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-if="vm.user.UserType === \'CON\'"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="contractor" class="col-lg-4 control-label">Select Contractor</label><div class="col-lg-8"><ui-select name="contractor" ng-model="vm.selectedContractor" theme="bootstrap" on-select="vm.empSelectionChaged()"><ui-select-match allow-clear="true" placeholder="Select a Contractor">{{$select.selected.ContractorName }}</ui-select-match><ui-select-choices repeat="contractor in vm.ContractorList | filter: $select.search"><div class="text-message" ng-bind-html="contractor.ContractorName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><hr><div class="row"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="username" class="col-lg-4 control-label">Username<span class="text-danger">*</span></label><div class="col-lg-8"><input type="text" ng-disabled="vm.form" data-ng-model="vm.User.Username" class="form-control" id="username" name="username" placeholder="User Name" required="" ng-blur="vm.checkUsername()"> <span class="text-danger" ng-show="form.username.$touched && !form.username.$error.required && !vm.validUserName">Username already taken</span><br><span class="text-danger" ng-show="form.username.$touched && form.username.$error.required">Username is Required</span></div></div><div class="form-group"><label for="pwd" class="col-lg-4 control-label">Password<span class="text-danger">*</span></label><div class="col-lg-8" ng-if="!vm.isPwd"><input ng-disabled="vm.form" type="password" data-ng-model="vm.User.Password" data-ng-minlength="6" class="form-control" id="pwd" name="pwd" placeholder="Password" required=""><div><span class="text-danger" ng-show="form.pwd.$touched && form.pwd.$error.required">Password is Required</span> <span class="text-danger" ng-show="form.pwd.$touched && form.pwd.$error.minlength">Password must have atleast 6 characters</span></div></div><div class="col-lg-8" ng-if="vm.isPwd"><input type="password" ng-disabled="vm.isPwd1" data-ng-model="vm.User.Password" class="form-control" id="pwd" name="pwd" placeholder="Password"></div></div><div class="form-group"><label for="rePwd" class="col-lg-4 control-label">Confirm Password<span class="text-danger">*</span></label><div class="col-lg-8" ng-if="!vm.isPwd"><input ng-disabled="vm.form" type="password" data-ng-model="vm.RePwd" class="form-control" id="rePwd" name="rePwd" compare-to="vm.User.Password" placeholder="Confirm Password" required=""><div ng-show="form.rePwd.$touched"><span class="text-danger" ng-show="form.rePwd.$error.compareTo">Password did not match</span> <span class="text-danger" ng-show="form.rePwd.$error.required">Password is Required</span></div></div><div class="col-lg-8" ng-if="vm.isPwd"><input ng-disabled="vm.isPwd1" type="password" data-ng-model="vm.RePwd" class="form-control" id="rePwd" name="rePwd" compare-to="vm.User.Password" placeholder="Confirm Password"></div></div></div></div><hr><div class="row"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="firstName" class="col-lg-4 control-label">First Name<span class="text-danger">*</span></label><div class="col-lg-8"><input ng-disabled="vm.form" type="text" data-ng-model="vm.User.FirstName" class="form-control" id="firstName" name="firstName" placeholder="First Name" required=""></div></div></div><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="lastName" class="col-lg-4 control-label">Last Name</label><div class="col-lg-8"><input ng-disabled="vm.form" type="text" data-ng-model="vm.User.LastName" class="form-control" id="lastName" name="lastName" placeholder="Last Name"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="email" class="col-lg-4 control-label">Official Email<span class="text-danger">*</span></label><div class="col-lg-8"><input ng-disabled="vm.form" type="email" data-ng-model="vm.User.EmailId" class="form-control" id="email" name="email" placeholder="Official Email" required="" ng-blur="vm.checkUserEmail()"> <span class="text-danger" ng-show="form.email.$touched && !form.email.$error.email && !form.email.$error.required && !vm.validUserEmail">EmailId registred already</span><br><span class="text-danger" ng-show="form.email.$touched && form.email.$error.required">Email required</span> <span class="text-danger" ng-show="form.email.$touched && form.email.$error.email">Invalid Email address</span></div></div></div><div class="col-lg-6 col-md-6 col-sm-9"><div class="form-group"><label for="role" class="col-lg-4 control-label">Role Name<span class="text-danger">*</span></label><div class="col-lg-8"><ui-select ng-disabled="vm.form" name="role" ng-model="vm.selectedRole" theme="bootstrap" autofocus=""><ui-select-match allow-clear="true" placeholder="Select a Role">{{$select.selected.RoleName || $select.selected}}</ui-select-match><ui-select-choices repeat="role in vm.RoleList | propsFilter: {RoleName: $select.search}"><div class="text-message" ng-bind-html="role.RoleName"></div></ui-select-choices></ui-select><span class="text-danger" ng-show="form.role.$touched && (vm.selectedRole === null || vm.selectedRole === undefined)">Please select a Role.</span></div></div></div></div><div class="row"><div class="col-lg-12"><div class="pull-right"><button ng-if="!vm.selectdes" data-ng-disabled="form.$invalid || !vm.validUserName || !vm.validUserEmail" data-ng-click="vm.saveUser()" class="btn btn-primary btn-sm">Save</button> <button ng-if="vm.selectdes" data-ng-disabled="form.$invalid || !vm.validUserName || !vm.validUserEmail" data-ng-click="vm.saveUser()" class="btn btn-primary btn-sm">Save</button> <button data-ng-click="vm.resetForm()" class="btn btn-danger btn-sm">Cancel</button></div></div></div></fieldset></form></div></div><div class="panel panel-default" data-ng-hide="vm.isFormOpen"><div class="panel-heading"><h3 class="panel-title">List of User Account</h3></div><div class="panel-body"><div class="row"><div class="col-sm-6"><button type="button" class="btn btn-link" ng-click="vm.Create()"><i class="fa fa-plus"></i> Add</button></div><div class="col-sm-6"><div class="pull-right"><label>No of Rows:</label><select class="input" data-ng-model="vm.noOfRows" data-ng-options="opt as opt.value for opt in vm.rowCountOptions track by opt.value"></select></div></div><table st-table="displayedCollection" st-safe-src="vm.UserList" class="table table-striped"><thead><tr><th><strong>S.No</strong></th><th st-sort="FullName"><strong>Name</strong></th><th st-sort="EmailId"><strong>Email</strong></th><th st-sort="Role.RoleName"><strong>Role</strong></th><th class="text-center"><strong>Action</strong></th></tr><tr><th></th><th><input st-search="{{FirstName + LastName}}" class="input-sm form-control" placeholder="Name" type="text"></th><th><input st-search="EmailId" class="input-sm form-control" placeholder="Email" type="text"></th><th><input st-search="Role.RoleName" class="input-sm form-control" placeholder="RoleName" type="text"></th><th></th></tr></thead><tbody><tr ng-repeat="row in displayedCollection"><td>{{ ($index + 1) + (vm.noOfRows.value * (vm.currentPage - 1)) }}</td><td>{{row.FirstName + " " + row.LastName}}</td><td>{{row.EmailId}}</td><td>{{row.Role.RoleName}}</td><td class="text-center"><div><button type="button" ng-click="vm.editUser(row)" class="btn btn-sm btn-primary"><i class="glyphicon glyphicon-edit"></i></button> <button type="button" ng-click="vm.removeUser(row)" class="btn btn-sm btn-danger"><i class="glyphicon glyphicon-trash"></i></button></div></td></tr></tbody><tfoot><tr><td class="text-center" st-pagination="" st-page-change="vm.rembemberCurrentPage(newPage)" st-items-by-page="vm.noOfRows.value" colspan="10"></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/user/userMenuMapping/userMenuMapping.html','<div class="panel panel-default"><div class="panel-heading"><h3 class="panel-title">USER MENU PRIVILEGE</h3></div><div class="panel-body"><div class="row"><div class="col-lg-10 col-md-10"><form role="form"><div class="form-group"><label for="">Select User</label><ui-select ng-model="vm.selectedUser" theme="bootstrap" style="max-width: 300px;" on-select="vm.getUserMenuMapping()"><ui-select-match placeholder="Select a User">{{$select.selected.FirstName || $select.selected}}</ui-select-match><ui-select-choices repeat="user in vm.UserList | propsFilter: {FirstName: $select.search, Username: $select.search}"><div class="text-message" ng-bind-html="user.FirstName"></div><div><small>Company : <span ng-bind-html="user.Company.CompanyName"></span></small></div><div><small>Email : <span ng-bind-html="user.EmailId"></span></small></div></ui-select-choices></ui-select></div></form></div><div class="col-lg-2 col-md-2"><button class="btn btn-sm btn-primary" data-ng-click="vm.saveUserMenuMapping()">Save</button></div></div><div class="container-fluid" data-ng-if="vm.selectedUser && vm.menuList.length > 0"><div class="row"><div class="col-sm-12"><button ng-click="vm.expandAll()" class="btn btn-sm btn-primary">Expand all</button> <button ng-click="vm.collapseAll()" class="btn btn-sm btn-primary">Collapse all</button></div></div><div class="row"><div class=""><div ui-tree="" id="tree-root" data-drag-enabled="false"><ol ui-tree-nodes="" ng-model="vm.menuList"><li ng-repeat="node in vm.menuList" ui-tree-node="" ng-include="\'nodes_renderer.html\'"></li></ol></div></div></div></div></div></div><script type="text/ng-template" id="nodes_renderer.html"><div ui-tree-handle class="tree-node tree-node-content"> <a class="btn btn-success btn-xs" ng-if="node.SubMenuItems && node.SubMenuItems.length > 0" data-nodrag ng-click="toggle(this)"> <span class="glyphicon" ng-class="{\'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed}"></span> </a> <input type="checkbox" value="" data-ng-model="node.IsSelected" /> {{node.MenuName}} <div class="list-group-item" style="margin-left: 50px" data-ng-if="node.MenuAction.length > 0"> <ul class="list-inline"> <li class="list-inline-item" data-ng-repeat="action in node.MenuAction"> <div class="checkbox"> <label> <input type="checkbox" value="" data-ng-model="action.IsSelected"/> {{ action.ActionName }} </label> </div> </li> </ul> </div> </div> <ol ui-tree-nodes="" ng-model="node.SubMenuItems" ng-class="{hidden: collapsed}"> <li ng-repeat="node in node.SubMenuItems" ui-tree-node ng-include="\'nodes_renderer.html\'"> </li> </ol></script>');
$templateCache.put('app/pages/user/userModals/selectCompanyModal.html','<div class="modal-header bg-info"><h4 class="modal-title" style="color:aliceblue;">Select Company</h4></div><div class="modal-body"><form name="form" role="form"><div class="form-group" style="color: #fff"><ui-select name="company" ng-required="true" ng-model="vm.selectedCompany" theme="bootstrap" on-select="vm.companySelectionChanged()"><ui-select-match allow-clear="true" placeholder="Select Company">{{$select.selected.CompanyName}}</ui-select-match><ui-select-choices repeat="company in vm.CompanyList | filter: $select.search"><div ng-bind-html="company.CompanyName + \' - \' + company.CompanyCode | highlight: $select.search"></div></ui-select-choices></ui-select><div data-ng-show="form.$invalid" style="margin-top: 10px"><span class="text-danger" data-ng-show="form.company.$touched && (vm.selectedCompany === null || vm.selectedCompany === undefined)">You must select a company</span></div></div></form></div><div class="modal-footer"><button class="btn btn-primary" type="button" ng-click="vm.ok()" data-ng-disabled="form.$invalid">OK</button></div>');
$templateCache.put('app/pages/user/userPrivilege/userPrivilege.html','<div class="panel panel-default"><div class="panel-body">Basic panel example</div></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar_bk.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.SubMenuItems}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.MenuUrl || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.SubMenuItems" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.MenuName }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.SubMenuItems" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.MenuName }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.SubMenuItems"></b></a><ul ng-if="::item.SubMenuItems" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenuitems=""><li ng-repeat="subitem in ::item.SubMenuItems" ng-class="::{\'with-sub-menu\': subitem.SubMenuItems}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.SubMenuItems" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-SubMenuItems-link"><span>{{ ::subitem.MenuName }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.SubMenuItems"></b></a><ul ng-if="::subitem.SubMenuItems" class="al-sidebar-sublist subitem-SubMenuItems-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenuitems=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.SubMenuItems" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.MenuName }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.MenuUrl || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.MenuName }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.SubMenuItems && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.MenuName }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.SubMenuItems && !subitem.disabled)" ui-state="subitem.MenuUrl || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.MenuName}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-primary active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><ul class="breadcrumb al-breadcrumb"><li><a ui-sref="dashboard" ng-if="!$last" href="#">Home</a></li><li ng-if="activePageTitle !== \'Home\'">{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" ng-class="{\'scrolled\': scrolled}"><div class="row"><div class="col-xs-2 fullUserName"><div class="row"><div class="col-xs-8"><a href="#/dashboard" class="al-logo clearfix"><img ng-src="assets/img/katbooklogo.png" style="width: 140px;height: 37px;padding-left:15px;margin:5px 0px;"></a></div><div class="col-xs-4"><a href="" class="collapse-menu-link fa fa-align-justify" ba-sidebar-toggle-menu=""></a></div></div></div><div class="col-xs-2 shortUserName"><div class="row"><div class="col-xs-4"><a href="" class="collapse-menu-link fa fa-align-justify" ba-sidebar-toggle-menu=""></a></div></div></div><div class="col-xs-8 text-center"><form class="form-inline" role="form" style="line-height: 45px"><div class="form-group"><label for="project" style="color: white; font-size: 16px;font-weight: 500">{{ $root.selectedCompanyName }}</label></div></form></div><div class="col-xs-2 pull-right"><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><span class="fullUserName" style="line-height: 25px; color:white;">{{$root.userName}} <i class="fa fa-caret-down"></i></span> <span class="shortUserName" style="line-height: 25px; color:white;">{{ $root.userName.charAt(0) | uppercase }} <i class="fa fa-caret-down"></i></span></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><a href="" class="signout" data-ng-click="$root.logout()"><i class="fa fa-power-off"></i>Logout</a></li></ul></div></div></div></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);